webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whichPalette */
/* harmony export (immutable) */ __webpack_exports__["b"] = getPalette;
/* harmony export (immutable) */ __webpack_exports__["a"] = getColor;
var Palettes = {
  PAL_ALTI: [[0, 0, 0, 255, 255], [250, 0, 85, 255, 255], [500, 0, 170, 255, 255], [750, 0, 255, 255, 255], [1000, 3, 230, 175, 255], [1250, 5, 204, 95, 255], [1500, 8, 179, 15, 255], [1750, 88, 204, 10, 255], [2000, 168, 228, 5, 255], [2250, 248, 253, 0, 255], [2500, 255, 228, 0, 255], [2750, 255, 198, 0, 255], [3000, 255, 168, 0, 255], [3250, 255, 115, 0, 255], [3500, 255, 60, 0, 255], [3750, 255, 5, 0, 255], [4000, 204, 0, 41, 255], [4250, 148, 0, 87, 255]],
  PAL_THERMIQUES: [[0, 255, 255, 255, 255], [0.5, 255, 247, 172, 255], [1, 255, 231, 0, 255], [1.5, 202, 222, 45, 255], [2, 101, 214, 0, 255], [2.5, 0, 255, 181, 255], [3, 0, 208, 255, 255], [3.5, 0, 128, 255, 255], [4, 0, 0, 255, 255], [4.5, 128, 0, 255, 255], [5, 255, 0, 255, 255], [5.5, 255, 0, 128, 255], [6, 255, 0, 0, 255], [6.5, 128, 0, 0, 255], [7, 0, 0, 0, 255]],
  PAL_BSRATIO: [[0, 165, 0, 38, 255], [1, 215, 48, 39, 255], [2, 244, 109, 67, 255], [3, 253, 174, 97, 255], [4, 254, 224, 139, 255], [5, 217, 239, 139, 255], [6, 166, 217, 106, 255], [7, 102, 189, 99, 255], [8, 26, 152, 80, 255], [9, 0, 104, 55, 255]],
  PAL_WIND: [[0, 255, 255, 255, 255], [0.92, 0, 255, 255, 255], [1.86, 3, 230, 175, 255], [2.78, 5, 204, 95, 255], [3.69, 8, 179, 15, 255], [4.64, 88, 204, 10, 255], [5.56, 168, 228, 5, 255], [6.47, 248, 253, 0, 255], [7.42, 255, 228, 0, 255], [8.33, 255, 198, 0, 255], [9.25, 255, 168, 0, 255], [10.19, 255, 115, 0, 255], [11.11, 255, 60, 0, 255], [12.03, 255, 5, 0, 255], [12.97, 204, 0, 41, 255], [13.89, 148, 0, 87, 255]],
  PAL_CAPE: [[0, 255, 255, 255, 255], [500, 255, 255, 172, 255], [1000, 255, 255, 0, 255], [1500, 255, 206, 0, 255], [2000, 255, 100, 0, 255], [2500, 255, 0, 0, 255], [3000, 255, 0, 255, 255], [3500, 128, 0, 128, 255], [4000, 0, 0, 255, 255], [4500, 0, 0, 128, 255], [5000, 0, 0, 0, 255]],
  PAL_CFRAC: [
  /* [0, 82, 81, 115, 255],
  [10, 99, 98, 129, 255],
  [20, 116, 115, 143, 255],
  [30, 113, 113, 157, 255],
  [40, 151, 150, 171, 255],
  [50, 168, 168, 185, 255],
  [60, 185, 185, 199, 255],
  [70, 203, 203, 213, 255],
  [80, 220, 220, 227, 255],
  [90, 237, 237, 241, 255],
  [100, 255, 255, 255, 255] */
  [0, 204, 204, 204, 255], [10, 189, 198, 209, 255], [20, 172, 189, 214, 255], [30, 156, 181, 219, 255], [40, 136, 172, 224, 255], [50, 116, 161, 229, 255], [60, 97, 152, 235, 255], [70, 72, 139, 240, 255], [80, 51, 129, 245, 255], [90, 26, 116, 250, 255], [100, 0, 102, 255, 255]],
  PAL_TEMP: [[0, 0, 0, 255, 255], [2.5, 0, 85, 255, 255], [5, 0, 170, 255, 255], [7.5, 0, 255, 255, 255], [10, 3, 230, 175, 255], [12.5, 5, 204, 95, 255], [15, 8, 179, 15, 255], [17.5, 88, 204, 10, 255], [20, 168, 228, 5, 255], [22.5, 248, 253, 0, 255], [25, 255, 228, 0, 255], [27.5, 255, 198, 0, 255], [30, 255, 168, 0, 255], [32.5, 255, 115, 0, 255], [35, 255, 60, 0, 255], [37.5, 255, 5, 0, 255], [40, 204, 0, 41, 255]],
  PAL_CONVERGENCE: [[-2.5, 165, 0, 38, 255], [-2, 215, 48, 39, 255], [-1.5, 244, 109, 67, 255], [-1, 253, 174, 97, 255], [-0.5, 254, 224, 139, 255], [0, 217, 239, 139, 255], [0.5, 166, 217, 106, 255], [1, 102, 189, 99, 255], [1.5, 26, 152, 80, 255], [2, 0, 104, 55, 255]],
  PAL_CBASE: [[-1, 220, 220, 220, 255], [0.1, 0, 0, 255, 255], [250, 0, 85, 255, 255], [500, 0, 170, 255, 255], [750, 0, 255, 255, 255], [1000, 3, 230, 175, 255], [1250, 5, 204, 95, 255], [1500, 8, 179, 15, 255], [1750, 88, 204, 10, 255], [2000, 168, 228, 5, 255], [2250, 248, 253, 0, 255], [2500, 255, 228, 0, 255], [2750, 255, 198, 0, 255], [3000, 255, 168, 0, 255], [3250, 255, 115, 0, 255], [3500, 255, 60, 0, 255], [3750, 255, 5, 0, 255], [4000, 204, 0, 41, 255], [4250, 148, 0, 87, 255]],
  PAL_RAIN: [[0, 204, 204, 204, 255], [0.1, 170, 255, 255, 255], [1, 85, 213, 255, 255], [2, 42, 170, 255, 255], [5, 42, 127, 255, 255], [10, 0, 85, 192, 255], [15, 0, 42, 192, 255], [20, 170, 0, 127, 255]],
  PAL_ALTI_CB: [[-250, 255, 255, 255, 255], [0.1, 255, 255, 217, 255], [500, 237, 248, 217, 255], [1000, 199, 233, 180, 255], [1500, 127, 205, 187, 255], [2000, 65, 182, 196, 255], [2500, 29, 145, 192, 255], [3000, 34, 94, 168, 255], [3500, 37, 52, 148, 255], [4000, 8, 29, 88, 255], [4500, 0, 0, 0, 255]],
  PAL_THERMIQUES_CB: [[0, 255, 255, 255, 255], [0.5, 255, 255, 204, 255], [1, 255, 237, 160, 255], [1.5, 254, 217, 118, 255], [2, 254, 178, 76, 255], [2.5, 253, 141, 60, 255], [3, 252, 78, 42, 255], [3.5, 227, 26, 28, 255], [4, 177, 0, 38, 255], [4.5, 0, 0, 0, 255]],
  PAL_BSRATIO_CB: [[0, 142, 1, 82, 255], [1, 197, 27, 125, 255], [2, 222, 119, 174, 255], [3, 241, 182, 218, 255], [4, 253, 224, 239, 255], [5, 230, 245, 208, 255], [6, 184, 225, 134, 255], [7, 127, 188, 65, 255], [8, 77, 146, 33, 255], [9, 39, 100, 25, 255]],
  PAL_WIND_CB: [[0, 255, 255, 255, 255], [1.39, 255, 255, 217, 255], [2.78, 237, 248, 177, 255], [4.17, 199, 233, 180, 255], [5.56, 127, 205, 187, 255], [6.94, 65, 182, 196, 255], [8.33, 29, 145, 192, 255], [9.72, 34, 94, 168, 255], [11.1, 12, 44, 132, 255], [12.5, 0, 0, 0, 255]],
  PAL_PRESS: [[995, 0, 0, 255, 255], [997, 0, 85, 255, 255], [999, 0, 170, 255, 255], [1001, 0, 255, 255, 255], [1003, 3, 230, 175, 255], [1005, 5, 204, 95, 255], [1007, 8, 179, 15, 255], [1009, 88, 204, 10, 255], [1011, 168, 228, 5, 255], [1013, 248, 253, 0, 255], [1015, 255, 228, 0, 255], [1017, 255, 198, 0, 255], [1019, 255, 168, 0, 255], [1021, 255, 115, 0, 255], [1023, 255, 60, 0, 255], [1025, 255, 5, 0, 255], [1027, 204, 0, 41, 255], [1029, 148, 0, 87, 255]]
};

function whichPalette(p) {
  p = p.toUpperCase();
  var c = void 0;
  if (p === 'TER') {
    c = 'PAL_ALTI';
  } else if (p === 'WSTAR') {
    c = 'PAL_THERMIQUES';
  } else if (p === 'BSRATIO') {
    c = 'PAL_BSRATIO';
  } else if (p === 'PBLTOP') {
    c = 'PAL_ALTI';
  } else if (p === 'HCRIT') {
    c = 'PAL_ALTI';
  } else if (p === 'WINDBLAVG') {
    c = 'PAL_WIND';
  } else if (p === 'WINDBLTOP') {
    c = 'PAL_WIND';
  } else if (p === 'WINDSFC') {
    c = 'PAL_WIND';
  } else if (p === 'WIND1000') {
    c = 'PAL_WIND';
  } else if (p === 'WIND2000') {
    c = 'PAL_WIND';
  } else if (p === 'WIND3000') {
    c = 'PAL_WIND';
  } else if (p === 'WIND4000') {
    c = 'PAL_WIND';
  } else if (p === 'BLWINDSHEAR') {
    c = 'PAL_WIND';
  } else if (p === 'CAPE2D') {
    c = 'PAL_CAPE';
  } else if (p === 'CFRACL') {
    c = 'PAL_CFRAC';
  } else if (p === 'CFRACM') {
    c = 'PAL_CFRAC';
  } else if (p === 'CFRACH') {
    c = 'PAL_CFRAC';
  } else if (p === 'CFRACTOT') {
    c = 'PAL_CFRAC';
  } else if (p === 'CFRACALTI') {
    c = 'PAL_CFRAC';
  } else if (p === 'BLCLOUDPCT') {
    c = 'PAL_CFRAC';
  } else if (p === 'PBLH') {
    c = 'PAL_ALTI';
  } else if (p === 'TC2') {
    c = 'PAL_TEMP';
  } else if (p === 'TD2') {
    c = 'PAL_TEMP';
  } else if (p === 'TEMPALTI') {
    c = 'PAL_TEMP';
  } else if (p === 'WBLMAXMIN') {
    c = 'PAL_CONVERGENCE';
  } else if (p === 'WSFC10') {
    c = 'PAL_CONVERGENCE';
  } else if (p === 'WSFC30') {
    c = 'PAL_CONVERGENCE';
  } else if (p === 'ZSFCLCLMASK') {
    c = 'PAL_CBASE';
  } else if (p === 'ZBLCLMASK') {
    c = 'PAL_CBASE';
  } else if (p === 'RAINTOT') {
    c = 'PAL_RAIN';
  } else if (p === 'SLP') {
    c = 'PAL_PRESS';
  }
  return c;
}

function getPalette(name) {
  return Palettes[name];
}

function getColor(val, pal) {
  var i = void 0;

  var max = Palettes[pal].length - 1;

  for (i = 0; i < max; i++) {
    if (val < Palettes[pal][i + 1][0]) break;
  }

  // if (val-pal[cx][i-1][0] < pal[cx][i][0]-val) i--;

  return {
    r: Palettes[pal][i][1],
    g: Palettes[pal][i][2],
    b: Palettes[pal][i][3],
    a: Palettes[pal][i][4] / 255
  };
}

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (f, c, pxRatio) {
  c.save();
  c.translate(f.x - f.s / 2, f.y - f.s / 2);
  c.rotate(f.a);
  c.beginPath();
  c.moveTo(0, -f.s);
  c.lineTo(0, 0.3 * f.s);
  c.moveTo(-0.3 * f.s, -0.2 * f.s);
  c.lineTo(0, 0.3 * f.s);
  c.lineTo(0.3 * f.s, -0.2 * f.s);
  c.lineWidth = f.w + pxRatio;
  c.strokeStyle = 'black';
  c.stroke();
  c.beginPath();
  c.moveTo(0, -f.s);
  c.lineTo(0, 0.3 * f.s);
  c.moveTo(-0.3 * f.s, -0.2 * f.s);
  c.lineTo(0, 0.3 * f.s);
  c.lineTo(0.3 * f.s, -0.2 * f.s);
  c.lineWidth = f.w;
  c.strokeStyle = f.color;
  c.stroke();
  c.restore();
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fa_storage_src_memory_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fa_storage_src_memory_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fa_storage_src_memory_js__);



var allowedStorages = ['state', '_canWriteToLocalStorage', 'ga:clientId', 'cacheUrl', 'counter', '@@'];

function isLocalStorageSupported() {
  var item = 'localStoragePollyfill';
  try {
    localStorage.setItem(item, item);
    localStorage.removeItem(item);
    return true;
  } catch (e) {
    return false;
  }
}

var nativeStorage = new __WEBPACK_IMPORTED_MODULE_1_fa_storage_src_memory_js___default.a();

nativeStorage._setItem = nativeStorage.setItem;
nativeStorage._getItem = nativeStorage.getItem;
nativeStorage._removeItem = nativeStorage.removeItem;
nativeStorage._clear = nativeStorage.clear;

var storageOperations = [];
var updateNativeStorage = function updateNativeStorage(action, key, item) {
  var error = function error(e) {
    throw e;
  };
  // alert(`updateNativeStorage ${action} ${key} ${item}`) // eslint-disable-line
  storageOperations.push({ action: action, key: key, item: item });
  var update = function update() {
    // alert('updateNative '+ storageOperations.length) // eslint-disable-line
    if (storageOperations.length === 0) return;

    var _storageOperations$po = storageOperations.pop(),
        action = _storageOperations$po.action,
        key = _storageOperations$po.key,
        item = _storageOperations$po.item;

    switch (action) {
      case 'setItem':
        window.NativeStorage.setItem(key, item, update, error);
        break;
      case 'removeItem':
        window.NativeStorage.remove(key, update, error);
        break;
      case 'clear':
        window.NativeStorage.clear(update, error);
        break;
      default:
        throw new Error('unknown storage action');
    }
  };
  update();
};

nativeStorage.setItem = function (key, item) {
  if (allowedStorages.indexOf(key) === -1) console.error('attempted to write to unknown key: \'' + key + '\'');
  updateNativeStorage('setItem', key, item);
  return nativeStorage._setItem(key, item);
};
nativeStorage.getItem = function (key) {
  return nativeStorage._getItem(key);
};
nativeStorage.removeItem = function (key) {
  updateNativeStorage('removeItem', key);
  return nativeStorage._removeItem(key);
};
nativeStorage.clear = function () {
  updateNativeStorage('clear');
  return nativeStorage._clear();
};

nativeStorage._init = function (err, callback) {
  window.NativeStorage.keys(function (keys) {
    var sync = function sync() {
      if (keys.length === 0) return callback();
      var key = keys.pop();
      if (allowedStorages.indexOf(key) === -1) return sync();
      window.NativeStorage.getItem(key, function (item) {
        // alert('item ' + key + ' ' + typeof item)  // eslint-disable-line
        nativeStorage._setItem(key, item);
        sync();
      }, err);
    };
    sync();
  }, err);
};

var storage = {};

var initCordova = function initCordova(err, callback) {
  storage = nativeStorage;
  nativeStorage._init(err, function () {
    // transfert form old storage
    __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys___default()(window.localStorage).forEach(function (key) {
      return storage.setItem(key, window.localStorage[key]);
    });
    window.localStorage.clear();
    // alert('_init ok') // eslint-disable-line
    callback();
  });
};

var initBrowser = function initBrowser(err, callback) {
  // eslint-disable-line
  if (isLocalStorageSupported()) {
    storage = window.localStorage;
  } else {
    var iOS = /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(navigator.userAgent);
    var errorMessage = 'Votre naviguateur bloque la sauvegarde locale (cookies). Les favoris et la mémorisation des paramètres ne fonctionneront pas.\n\nYour navigator denies local storage (cookies). Favorites and settings persistence will not work.';
    var iOSMessage = '';
    if (iOS) {
      iOSMessage = '\n\n(Settings / Réglages -> Safari ->  Cookies)';
    }
    alert(errorMessage + iOSMessage); // eslint-disable-line no-alert
    storage = new __WEBPACK_IMPORTED_MODULE_1_fa_storage_src_memory_js___default.a();
  }

  callback();
};

var initStorage = function initStorage(err, callback) {
  if ('cordova' in window) {
    initCordova(err, callback);
  } else {
    initBrowser(err, callback);
  }
};

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(344),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js_plugins_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_shim__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animation_frame_polyfill__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animation_frame_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_animation_frame_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_storage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_orientationchangeend__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_orientationchangeend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_orientationchangeend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locale__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resources_http__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_app_template__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_app_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__routes_app_template__);



// Raven must me initialized before the other modules
window.Raven.addPlugin(__WEBPACK_IMPORTED_MODULE_1_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();

 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars



__WEBPACK_IMPORTED_MODULE_5_orientationchangeend__({}).on('orientationchangeend', function () {
  window.dispatchEvent(new Event('resize'));
});

// import FastClick from 'fastclick'
// FastClick.attach(document.body)

window.promptAsync = function (content, callback) {
  var result = window.prompt(content); // eslint-disable-line no-alert
  callback(result);
};

window.confirmAsync = function (content, callback) {
  var result = window.confirm(content); // eslint-disable-line no-alert
  callback(result);
};

window.openLink = function (url) {
  window.open(url);
};

var loadCachedApp = function loadCachedApp() {
  if (!('cordova' in window)) return false;
  var cacheUrl = __WEBPACK_IMPORTED_MODULE_4__assets_storage__["a" /* storage */].getItem('cacheUrl');
  var currentLocation = window.location.href.replace(/\/?#.*/, '');
  // alert(cacheUrl) // eslint-disable-line
  // alert(currentLocation) // eslint-disable-line
  if (cacheUrl !== null && cacheUrl !== currentLocation) {
    window.location.replace(cacheUrl);
    return true;
  }
  return false;
};

window.portalLink = function (endpoint) {
  var link = '';
  var locale = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.language;
  if (['fr', 'de', 'it', 'es', 'nl'].indexOf(locale) === -1) {
    link = 'https://portal.meteo-parapente.com/' + endpoint;
  } else {
    link = 'https://portal.meteo-parapente.com/' + locale + '/' + endpoint;
  }
  return link; // + '?from=' + encodeURIComponent(document.location.href)
};









var launchApp = function launchApp() {
  if (loadCachedApp()) return;

  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: 'mtopara2-app',
    components: { App: __WEBPACK_IMPORTED_MODULE_11__routes_app_template___default.a },
    render: function render(h) {
      return h('app');
    },
    router: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routes__["a" /* default */])(),
    locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__locale__["a" /* default */])(),
    http: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__resources_http__["a" /* default */])(),
    store: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */])(),
    filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__filters__["a" /* default */])()
  });

  window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];
};

if (window.location.hostname === 'meteo-parapente.com' || window.location.hostname === 'www.meteo-parapente.com' || window.location.hostname === 'dev.meteo-parapente.com' || window.location.port === '3000') {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_storage__["b" /* initStorage */])(function (e) {
    throw e;
  }, launchApp);
} else {
  document.addEventListener('deviceready', function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_storage__["b" /* initStorage */])(console.error, launchApp);
  });
  var script = document.createElement('script');
  script.src = 'cordova.js';
  var firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_helpers_typeof__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_helpers_typeof__);

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = (function ($pgettext, mapReady) {
  var g = this;
  var p = window;

  function q(a) {
    return void 0 !== a;
  }

  function aa(a) {
    var b = typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_helpers_typeof___default()(a);
    if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";
        if (a instanceof Object) return b;
        var c = Object.prototype.toString.call(a);
        if ("[object Window]" == c) return "object";
        if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
        if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
  }

  function ba(a) {
    return "array" == aa(a);
  }

  function ca(a) {
    var b = aa(a);
    return "array" == b || "object" == b && "number" == typeof a.length;
  }

  function t(a) {
    return "string" == typeof a;
  }

  function da(a) {
    var b = typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_helpers_typeof___default()(a);
    return "object" == b && null != a || "function" == b;
  }
  var ea = "closure_uid_" + (1E9 * Math.random() >>> 0),
      fa = 0;

  function ga(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }

  function ha(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);
      return function () {
        var c = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c, d);
        return a.apply(b, c);
      };
    }
    return function () {
      return a.apply(b, arguments);
    };
  }

  function u(a, b, c) {
    u = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ga : ha;
    return u.apply(null, arguments);
  }

  function v(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function () {
      var b = c.slice();
      b.push.apply(b, arguments);
      return a.apply(this, b);
    };
  }
  var ia = Date.now || function () {
    return +new Date();
  };

  function w(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.A = b.prototype;
    a.prototype = new c();
    a.prototype.constructor = a;
    a.sc = function (a, c, f) {
      for (var h = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
        h[k - 2] = arguments[k];
      }return b.prototype[c].apply(a, h);
    };
  };
  var ja;
  var ka = String.prototype.trim ? function (a) {
    return a.trim();
  } : function (a) {
    return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
  };

  function la(a) {
    if (!ma.test(a)) return a;-1 != a.indexOf("\x26") && (a = a.replace(na, "\x26amp;"));-1 != a.indexOf("\x3c") && (a = a.replace(oa, "\x26lt;"));-1 != a.indexOf("\x3e") && (a = a.replace(pa, "\x26gt;"));-1 != a.indexOf('"') && (a = a.replace(qa, "\x26quot;"));-1 != a.indexOf("'") && (a = a.replace(ra, "\x26#39;"));-1 != a.indexOf("\x00") && (a = a.replace(sa, "\x26#0;"));
    return a;
  }
  var na = /&/g,
      oa = /</g,
      pa = />/g,
      qa = /"/g,
      ra = /'/g,
      sa = /\x00/g,
      ma = /[\x00&<>"']/,
      ta = String.prototype.repeat ? function (a, b) {
    return a.repeat(b);
  } : function (a, b) {
    return Array(b + 1).join(a);
  };

  function ua(a, b, c) {
    a = q(c) ? a.toFixed(c) : String(a);
    c = a.indexOf(".");-1 == c && (c = a.length);
    return ta("0", Math.max(0, b - c)) + a;
  }

  function va(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }

  function wa(a) {
    return String(a).replace(/\-([a-z])/g, function (a, c) {
      return c.toUpperCase();
    });
  }

  function xa(a) {
    var b = t(void 0) ? "undefined".replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08") : "\\s";
    return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function (a, b, e) {
      return b + e.toUpperCase();
    });
  };
  var ya = Array.prototype.indexOf ? function (a, b, c) {
    return Array.prototype.indexOf.call(a, b, c);
  } : function (a, b, c) {
    c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
    if (t(a)) return t(b) && 1 == b.length ? a.indexOf(b, c) : -1;
    for (; c < a.length; c++) {
      if (c in a && a[c] === b) return c;
    }return -1;
  },
      x = Array.prototype.forEach ? function (a, b, c) {
    Array.prototype.forEach.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = t(a) ? a.split("") : a, f = 0; f < d; f++) {
      f in e && b.call(c, e[f], f, a);
    }
  },
      za = Array.prototype.filter ? function (a, b, c) {
    return Array.prototype.filter.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = [], f = 0, h = t(a) ? a.split("") : a, k = 0; k < d; k++) {
      if (k in h) {
        var l = h[k];
        b.call(c, l, k, a) && (e[f++] = l);
      }
    }return e;
  },
      z = Array.prototype.map ? function (a, b, c) {
    return Array.prototype.map.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = Array(d), f = t(a) ? a.split("") : a, h = 0; h < d; h++) {
      h in f && (e[h] = b.call(c, f[h], h, a));
    }return e;
  },
      Aa = Array.prototype.reduce ? function (a, b, c, d) {
    d && (b = u(b, d));
    return Array.prototype.reduce.call(a, b, c);
  } : function (a, b, c, d) {
    var e = c;
    x(a, function (c, h) {
      e = b.call(d, e, c, h, a);
    });
    return e;
  };

  function Ba(a, b) {
    return 0 <= ya(a, b);
  }

  function Ca(a, b) {
    var c = ya(a, b),
        d;
    (d = 0 <= c) && Array.prototype.splice.call(a, c, 1);
    return d;
  }

  function Da(a) {
    return Array.prototype.concat.apply(Array.prototype, arguments);
  }

  function Ea(a) {
    var b = a.length;
    if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++) {
        c[d] = a[d];
      }return c;
    }
    return [];
  }

  function Fa(a, b, c, d) {
    return Array.prototype.splice.apply(a, Ga(arguments, 1));
  }

  function Ga(a, b, c) {
    return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
  }

  function Ha(a, b) {
    a.sort(b || Ia);
  }

  function Ia(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function Ja(a) {
    for (var b = [], c = 0; c < a; c++) {
      b[c] = "";
    }return b;
  };

  function Ka(a, b, c) {
    for (var d in a) {
      b.call(c, a[d], d, a);
    }
  }

  function La(a) {
    var b = Ma;
    return null !== b && a in b;
  }

  function A(a, b, c) {
    b in a || (a[b] = c);
  }
  var Na = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

  function Oa(a, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];
      for (c in d) {
        a[c] = d[c];
      }for (var f = 0; f < Na.length; f++) {
        c = Na[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
      }
    }
  };

  function Pa() {
    return function () {
      return 1;
    };
  };

  function Qa(a, b) {
    var c = a % b;
    return 0 > c * b ? c + b : c;
  };

  function Ra(a, b) {
    this.b = {};
    this.a = [];
    this.g = this.c = 0;
    var c = arguments.length;
    if (1 < c) {
      if (c % 2) throw Error("Uneven number of arguments");
      for (var d = 0; d < c; d += 2) {
        this.da(arguments[d], arguments[d + 1]);
      }
    } else if (a) {
      var e;
      if (a instanceof Ra) e = a.na(), d = a.ha();else {
        var c = [],
            f = 0;
        for (e in a) {
          c[f++] = e;
        }e = c;
        c = [];
        f = 0;
        for (d in a) {
          c[f++] = a[d];
        }d = c;
      }
      for (c = 0; c < e.length; c++) {
        this.da(e[c], d[c]);
      }
    }
  }
  g = Ra.prototype;
  g.ha = function () {
    Sa(this);
    for (var a = [], b = 0; b < this.a.length; b++) {
      a.push(this.b[this.a[b]]);
    }return a;
  };
  g.na = function () {
    Sa(this);
    return this.a.concat();
  };
  g.isEmpty = function () {
    return 0 == this.c;
  };
  g.clear = function () {
    this.b = {};
    this.g = this.c = this.a.length = 0;
  };

  function Sa(a) {
    if (a.c != a.a.length) {
      for (var b = 0, c = 0; b < a.a.length;) {
        var d = a.a[b];
        Ta(a.b, d) && (a.a[c++] = d);
        b++;
      }
      a.a.length = c;
    }
    if (a.c != a.a.length) {
      for (var e = {}, c = b = 0; b < a.a.length;) {
        d = a.a[b], Ta(e, d) || (a.a[c++] = d, e[d] = 1), b++;
      }a.a.length = c;
    }
  }

  function Ua(a, b) {
    return Ta(a.b, b) ? a.b[b] : void 0;
  }
  g.da = function (a, b) {
    Ta(this.b, a) || (this.c++, this.a.push(a), this.g++);
    this.b[a] = b;
  };
  g.forEach = function (a, b) {
    for (var c = this.na(), d = 0; d < c.length; d++) {
      var e = c[d];
      a.call(b, Ua(this, e), e, this);
    }
  };
  g.clone = function () {
    return new Ra(this);
  };

  function Ta(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  };
  var Va = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;

  function Wa(a, b) {
    if (a) for (var c = a.split("\x26"), d = 0; d < c.length; d++) {
      var e = c[d].indexOf("\x3d"),
          f = null,
          h = null;
      0 <= e ? (f = c[d].substring(0, e), h = c[d].substring(e + 1)) : f = c[d];
      b(f, h ? decodeURIComponent(h.replace(/\+/g, " ")) : "");
    }
  };

  function B(a, b) {
    this.g = this.m = this.c = "";
    this.j = null;
    this.h = this.o = "";
    this.a = this.v = !1;
    var c;
    if (a instanceof B) this.a = q(b) ? b : a.a, Xa(this, a.c), c = a.m, Ya(this), this.m = c, c = a.g, Ya(this), this.g = c, Za(this, a.j), this.setPath(a.getPath()), $a(this, a.b.clone()), c = a.h, Ya(this), this.h = c;else if (a && (c = String(a).match(Va))) {
      this.a = !!b;
      Xa(this, c[1] || "", !0);
      var d = c[2] || "";
      Ya(this);
      this.m = ab(d);
      d = c[3] || "";
      Ya(this);
      this.g = ab(d, !0);
      Za(this, c[4]);
      this.setPath(c[5] || "", !0);
      $a(this, c[6] || "", !0);
      c = c[7] || "";
      Ya(this);
      this.h = ab(c);
    } else this.a = !!b, this.b = new bb(null, 0, this.a);
  }
  B.prototype.toString = function () {
    var a = [],
        b = this.c;
    b && a.push(cb(b, db, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.m) && a.push(cb(b, db, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.j, null != c && a.push(":", String(c));
    if (c = this.getPath()) this.g && "/" != c.charAt(0) && a.push("/"), a.push(cb(c, "/" == c.charAt(0) ? eb : fb, !0));
    (c = this.b.toString()) && a.push("?", c);
    (c = this.h) && a.push("#", cb(c, gb));
    return a.join("");
  };
  B.prototype.clone = function () {
    return new B(this);
  };

  function Xa(a, b, c) {
    Ya(a);
    a.c = c ? ab(b, !0) : b;
    a.c && (a.c = a.c.replace(/:$/, ""));
  }

  function Za(a, b) {
    Ya(a);
    if (b) {
      b = Number(b);
      if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
      a.j = b;
    } else a.j = null;
  }
  B.prototype.getPath = function () {
    return this.o;
  };
  B.prototype.setPath = function (a, b) {
    Ya(this);
    this.o = b ? ab(a, !0) : a;
    return this;
  };

  function $a(a, b, c) {
    Ya(a);
    b instanceof bb ? (a.b = b, hb(a.b, a.a)) : (c || (b = cb(b, ib)), a.b = new bb(b, 0, a.a));
  }

  function Ya(a) {
    if (a.v) throw Error("Tried to modify a read-only Uri");
  }

  function ab(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
  }

  function cb(a, b, c) {
    return t(a) ? (a = encodeURI(a).replace(b, jb), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
  }

  function jb(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
  }
  var db = /[#\/\?@]/g,
      fb = /[\#\?:]/g,
      eb = /[\#\?]/g,
      ib = /[\#\?@]/g,
      gb = /#/g;

  function bb(a, b, c) {
    this.b = this.a = null;
    this.c = a || null;
    this.g = !!c;
  }

  function kb(a) {
    a.a || (a.a = new Ra(), a.b = 0, a.c && Wa(a.c, function (b, c) {
      var d = decodeURIComponent(b.replace(/\+/g, " "));
      kb(a);
      a.c = null;
      var d = lb(a, d),
          e = Ua(a.a, d);
      e || a.a.da(d, e = []);
      e.push(c);
      a.b = a.b + 1;
    }));
  }

  function mb(a, b) {
    kb(a);
    b = lb(a, b);
    if (Ta(a.a.b, b)) {
      a.c = null;
      a.b = a.b - Ua(a.a, b).length;
      var c = a.a;
      Ta(c.b, b) && (delete c.b[b], c.c--, c.g++, c.a.length > 2 * c.c && Sa(c));
    }
  }
  g = bb.prototype;
  g.clear = function () {
    this.a = this.c = null;
    this.b = 0;
  };
  g.isEmpty = function () {
    kb(this);
    return 0 == this.b;
  };

  function C(a, b) {
    kb(a);
    b = lb(a, b);
    return Ta(a.a.b, b);
  }
  g.na = function () {
    kb(this);
    for (var a = this.a.ha(), b = this.a.na(), c = [], d = 0; d < b.length; d++) {
      for (var e = a[d], f = 0; f < e.length; f++) {
        c.push(b[d]);
      }
    }return c;
  };
  g.ha = function (a) {
    kb(this);
    var b = [];
    if (t(a)) C(this, a) && (b = Da(b, Ua(this.a, lb(this, a))));else {
      a = this.a.ha();
      for (var c = 0; c < a.length; c++) {
        b = Da(b, a[c]);
      }
    }
    return b;
  };

  function D(a, b, c) {
    kb(a);
    a.c = null;
    b = lb(a, b);
    C(a, b) && (a.b = a.b - Ua(a.a, b).length);
    a.a.da(b, [c]);
    a.b = a.b + 1;
  }

  function nb(a, b) {
    var c = b ? a.ha(b) : [];
    return 0 < c.length ? String(c[0]) : void 0;
  }
  g.toString = function () {
    if (this.c) return this.c;
    if (!this.a) return "";
    for (var a = [], b = this.a.na(), c = 0; c < b.length; c++) {
      for (var d = b[c], e = encodeURIComponent(String(d)), d = this.ha(d), f = 0; f < d.length; f++) {
        var h = e;
        "" !== d[f] && (h += "\x3d" + encodeURIComponent(String(d[f])));
        a.push(h);
      }
    }return this.c = a.join("\x26");
  };
  g.clone = function () {
    var a = new bb();
    a.c = this.c;
    this.a && (a.a = this.a.clone(), a.b = this.b);
    return a;
  };

  function lb(a, b) {
    var c = String(b);
    a.g && (c = c.toLowerCase());
    return c;
  }

  function hb(a, b) {
    b && !a.g && (kb(a), a.c = null, a.a.forEach(function (a, b) {
      var e = b.toLowerCase();
      b != e && (mb(this, b), mb(this, e), 0 < a.length && (this.c = null, this.a.da(lb(this, e), Ea(a)), this.b = this.b + a.length));
    }, a));
    a.g = b;
  };

  function ob(a) {
    this.a = a;
  }
  var pb = /\s*;\s*/;

  function qb(a, b, c, d, e, f) {
    if (/[;=\s]/.test(b)) throw Error('Invalid cookie name "' + b + '"');
    if (/[;\r\n]/.test(c)) throw Error('Invalid cookie value "' + c + '"');
    q(d) || (d = -1);
    f = f ? ";domain\x3d" + f : "";
    e = e ? ";path\x3d" + e : "";
    d = 0 > d ? "" : 0 == d ? ";expires\x3d" + new Date(1970, 1, 1).toUTCString() : ";expires\x3d" + new Date(ia() + 1E3 * d).toUTCString();
    a.a.cookie = b + "\x3d" + c + f + e + d + "";
  }

  function rb(a) {
    for (var b = a + "\x3d", c = (sb.a.cookie || "").split(pb), d = 0, e; e = c[d]; d++) {
      if (0 == e.lastIndexOf(b, 0)) return e.substr(b.length);
      if (e == a) return "";
    }
  }
  ob.prototype.na = function () {
    return tb(this).keys;
  };
  ob.prototype.ha = function () {
    return tb(this).values;
  };
  ob.prototype.isEmpty = function () {
    return !this.a.cookie;
  };
  ob.prototype.clear = function () {
    for (var a = tb(this).keys, b = a.length - 1; 0 <= b; b--) {
      qb(this, a[b], "", 0, void 0, void 0);
    }
  };

  function tb(a) {
    a = (a.a.cookie || "").split(pb);
    for (var b = [], c = [], d, e, f = 0; e = a[f]; f++) {
      d = e.indexOf("\x3d"), -1 == d ? (b.push(""), c.push(e)) : (b.push(e.substring(0, d)), c.push(e.substring(d + 1)));
    }return {
      keys: b,
      values: c
    };
  }
  var sb = new ob(document);
  sb.b = 3950;
  new google.maps.Size(256, 256);
  new google.maps.Size(256, 256);
  var wb = {
    alt: "XContest",
    getTileUrl: function getTileUrl(a, b) {
      return "http://maps.pgweb.cz/elev/" + b + "/" + a.x + "/" + a.y;
    },
    maxZoom: 16,
    minZoom: 0,
    name: "XContest",
    tileSize: new google.maps.Size(256, 256)
  };
  function EmptyMap() {
    this.tileSize = new google.maps.Size(256, 256);
    this.name = "empty";
    this.alt = "empty";
    this.maxZoom = 19;
    this.getTile = function () {
      return "";
    };
  };

  function xb(a, b) {
    var c = Array.prototype.slice.call(arguments),
        d = c.shift();
    if ("undefined" == typeof d) throw Error("[goog.string.format] Template required");
    return d.replace(/%([0\-\ \+]*)(\d+)?(\.(\d+))?([%sfdiu])/g, function (a, b, d, k, l, n, m, r) {
      if ("%" == n) return "%";
      var y = c.shift();
      if ("undefined" == typeof y) throw Error("[goog.string.format] Not enough arguments");
      arguments[0] = y;
      return yb[n].apply(null, arguments);
    });
  }
  var yb = {
    s: function s(a, b, c) {
      return isNaN(c) || "" == c || a.length >= Number(c) ? a : a = -1 < b.indexOf("-", 0) ? a + ta(" ", Number(c) - a.length) : ta(" ", Number(c) - a.length) + a;
    },
    f: function f(a, b, c, d, e) {
      d = a.toString();
      isNaN(e) || "" == e || (d = parseFloat(a).toFixed(e));
      var f;
      f = 0 > Number(a) ? "-" : 0 <= b.indexOf("+") ? "+" : 0 <= b.indexOf(" ") ? " " : "";
      0 <= Number(a) && (d = f + d);
      if (isNaN(c) || d.length >= Number(c)) return d;
      d = isNaN(e) ? Math.abs(a).toString() : Math.abs(a).toFixed(e);
      a = Number(c) - d.length - f.length;
      return d = 0 <= b.indexOf("-", 0) ? f + d + ta(" ", a) : f + ta(0 <= b.indexOf("0", 0) ? "0" : " ", a) + d;
    },
    d: function d(a, b, c, _d, e, f, h, k) {
      return yb.f(parseInt(a, 10), b, c, _d, 0, f, h, k);
    }
  };
  yb.i = yb.d;
  yb.u = yb.d;

  function zb(a, b, c, d) {
    return [(d * a).toFixed(b), c];
  }
  var Ab = v(zb, 1 / .3048, 0, "\u2032"),
      Bb = v(zb, .001, 1, "km"),
      Cb = v(zb, 3.6, 1, "km/h"),
      Db = v(zb, 1, 0, "m"),
      Eb = v(zb, 1 / 1609.344, 1, "miles"),
      Fb = v(zb, 3600 / 1609.344, 1, "mph");

  function Gb(a, b) {
    var c = Math.abs(Math.round(6E4 * a));
    return [[Math.floor(c / 6E4), "\xB0"], [(c % 6E4 / 1E3).toFixed(3), "\u2032"], [b.charAt(0 > a ? 1 : 0), ""]];
  }

  function Hb(a, b) {
    var c = Math.abs(60 * a);
    return [[xb("%s%d:%05.3f", b.charAt(0 > a ? 1 : 0), Math.floor(c / 60), c % 60), ""]];
  }
  var Ib = [Db, Ab],
      Jb = ["meters", "feet"],
      Kb = [function (a, b) {
    return [[Math.abs(a).toFixed(5), "\xB0"], [b.charAt(0 > a ? 1 : 0), ""]];
  }, Gb, function (a, b) {
    var c = Math.abs(Math.round(3600 * a));
    return [[Math.floor(c / 3600), "\xB0"], [Math.floor(c / 60 % 60), "\u2032"], [Math.floor(c % 60), "\u2033"], [b.charAt(0 > a ? 1 : 0), ""]];
  }, Hb, function (a, b) {
    var c = Math.abs(3600 * a);
    return [[xb("%s%d:%02d:%05.2f", b.charAt(0 > a ? 1 : 0), Math.floor(c / 3600), Math.floor(c / 60 % 60), c % 60), ""]];
  }],
      Lb = ["ddd.ddddd\xB0", "ddd\xB0 mm.mmm\u2032", "ddd\xB0 mm\u2032 ss\u2033", "dd:mm.mmm", "dd:mm:ss.ss"],
      Mb = [Bb, Eb],
      Nb = ["kilometres", "miles"];

  function Ob(a, b) {
    this.a = a;
    this.b = b;
  };

  function Pb(a) {
    var b, c;
    this.a = a.length;
    this.g = Array(this.a * (this.a - 1) / 2);
    var d = 0;
    for (c = 1; c < this.a; ++c) {
      for (b = 0; b < c; ++b) {
        this.g[d++] = google.maps.geometry.spherical.computeDistanceBetween(a[b], a[c], 6371E3);
      }
    }this.j = Array(this.a - 1);
    for (b = 0; b < this.a - 1; ++b) {
      this.j[b] = Qb(this, b, b + 1);
    }this.h = Math.max.apply(null, this.j);
    this.b = this.c = null;
  }

  function Rb(a) {
    var b;
    if (null === a.c) {
      var c = Array(2 * a.a);
      c[0] = 0;
      c[1] = 0;
      for (b = 1; b < a.a; ++b) {
        Sb(a, b, 0, b, c[2 * (b - 1)], c[2 * (b - 1) + 1] - a.h, c, 2 * b);
      }a.c = c;
    }
    if (null === a.b) {
      c = Array(2 * a.a);
      Sb(a, 0, 1, a.a, a.a - 1, 0, c, 0);
      for (b = 1; b < a.a - 1; ++b) {
        Sb(a, b, b + 1, a.a, c[2 * (b - 1)], c[2 * (b - 1) + 1] - a.h, c, 2 * b);
      }c[2 * (a.a - 1)] = a.a - 1;
      c[2 * (a.a - 1) + 1] = 0;
      a.b = c;
    }
  }

  function Tb(a, b, c) {
    a = Math.floor(c / a.h);
    return 0 < a ? b + a : b + 1;
  }

  function Ub(a, b, c) {
    return b < c ? a.g[b + c * (c - 1) / 2] : b == c ? 0 : a.g[b * (b - 1) / 2 + c];
  }

  function Sb(a, b, c, d, e, f, h, k) {
    var l;
    for (l = c; l < d;) {
      c = Ub(a, b, l), c > f ? (f = c, e = l, ++l) : l = Tb(a, l, f - c);
    }h[k] = e;
    h[k + 1] = f;
  }

  function Qb(a, b, c) {
    return a.g[b + c * (c - 1) / 2];
  };

  function Vb() {}
  Vb.prototype.oa = function (a) {
    var b = Array(a),
        c;
    for (c = 0; c < a; ++c) {
      b[c] = c + 1 + "";
    }return b;
  };

  function Wb(a) {
    this.distance = a.distance || 0;
    this.ua = a.ua || null;
    this.J = a.J || [];
    this.$ = a.$ || 1;
    this.name = a.name || "";
    this.ia = a.ia || null;
    this.ja = a.ja || 0;
    this.a = this.distance * this.$ / 1E3;
  }

  function Xb(a, b, c, d, e, f, h, k, l) {
    var n = l[2],
        m = f.length;
    f = k[0] + k[1] + k[2];
    d = c = d ? c : c * f;
    var r = null,
        y,
        ub,
        vb;
    for (ub = l[0]; 0 <= ub; --ub) {
      for (vb = n; vb < m; ++vb) {
        y = Ub(h, ub, vb), y <= d && (d = y, r = [ub, l[0], l[1], l[2], vb]);
      }
    }if (null === r) return null;
    if (q(b) && .28 <= Math.min.apply(null, k) / f) a = b, b = "Yassen triangle", h = 3;else if (q(a)) b = "Flat triangle", h = 2;else return null;
    return new Wb({
      distance: e ? f - d : f,
      ua: l,
      J: r,
      $: a,
      name: b,
      ia: c,
      ja: h
    });
  }

  function Yb(a, b, c, d, e, f) {
    b = b.length;
    if (0 === d || 2 == b) {
      b = d = Array(2);
      b[0] = b[1] = -1;
      var h = -Infinity,
          k,
          l;
      for (l = 0; l < c.a - 1; ++l) {
        k = h;
        for (var n = void 0, m = void 0, r = -1, m = l + 1; m < c.a;) {
          n = Ub(c, l, m), n > k ? (k = n, r = m, ++m) : m = Tb(c, m, k - n);
        }k = [r, k];-1 != k[0] && (b[0] = l, b[1] = k[0], h = k[1]);
      }
      c = h;
    } else if (1 == d || 3 == b) {
      b = d = Array(3);
      Rb(c);
      b[0] = b[1] = b[2] = -1;
      h = -Infinity;
      for (k = 1; k < c.a - 1;) {
        l = c.c[2 * k + 1] + c.b[2 * k + 1], l > h ? (b[0] = c.c[2 * k], b[1] = k, b[2] = c.b[2 * k], h = l, ++k) : k = Tb(c, k, (h - l) / 2);
      }c = h;
    } else if (2 == d || 4 == b) {
      b = d = Array(4);
      Rb(c);
      b[0] = b[1] = b[2] = b[3] = -1;
      h = -Infinity;
      for (n = 1; n < c.a - 2; ++n) {
        for (k = c.c[2 * n + 1], m = n + 1; m < c.a - 1;) {
          l = k + Qb(c, n, m) + c.b[2 * m + 1], l > h ? (h = l, b[0] = c.c[2 * n], b[1] = n, b[2] = m, b[3] = c.b[2 * m], ++m) : m = Tb(c, m, (h - l) / 2);
        }
      }c = h;
    } else if (3 == d || 5 == b) {
      b = d = Array(5);
      Rb(c);
      b[0] = b[1] = b[2] = b[3] = b[4] = -1;
      for (var h = -Infinity, y, m = 1; m < c.a - 3; ++m) {
        for (k = c.c[2 * m + 1], r = m + 1; r < c.a - 2; ++r) {
          for (n = Qb(c, m, r), y = r + 1; y < c.a - 1;) {
            l = k + n + Qb(c, r, y) + c.b[2 * y + 1], l > h ? (h = l, b[0] = c.c[2 * m], b[1] = m, b[2] = r, b[3] = y, b[4] = c.b[2 * y], ++y) : y = Tb(c, y, (h - l) / 2);
          }
        }
      }c = h;
    } else d = [], c = 0;
    a.push(new Wb({
      distance: c,
      J: d,
      $: e(c),
      name: f
    }));
  }

  function Zb(a, b, c, d, e) {
    var f = b.length,
        h,
        k,
        l,
        n = Array(3),
        m;
    for (h = 0; h < f - 2; ++h) {
      for (k = h + 1; k < f - 1; ++k) {
        if (n[0] = Ub(c, h, k), q(d) && (m = d(b, c, n, [h, k]), null === m || a.push(m)), q(e)) for (l = k + 1; l < f; ++l) {
          n[1] = Ub(c, k, l), n[2] = Ub(c, l, h), m = e(b, c, n, [h, k, l]), null === m || a.push(m);
        }
      }
    }
  };

  function E(a, b, c, d, e, f, h) {
    this.c = a;
    this.b = b;
    this.g = v(Xb, c, d, e, f, h);
  }
  w(E, Vb);
  g = E.prototype;
  g.getId = function () {
    return this.b;
  };
  g.oa = function (a) {
    var b,
        c = Array(a);
    c[0] = "SP";
    for (b = 1; b < a - 1; ++b) {
      c[b] = "TP" + b;
    }c[a - 1] = "KB";
    return c;
  };
  g.W = function () {
    return this.c;
  };
  g.rc = function () {
    return 1;
  };
  g.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 3, this.rc, "Open distance");
    Zb(c, a, b, void 0, this.g);
    return c;
  };

  function $b() {
    E.call(this, "Switzerland (XContest)", "ch", 1.2, 1.3, .2, !1, !0);
  }
  w($b, E);
  $b.prototype.a = function () {
    return 1.2;
  };
  $b.prototype.P = function (a, b) {
    var c = $b.A.P.call(this, a, b);
    Yb(c, a, b, 0, this.a, "Free distance");
    return c;
  };

  function ac() {
    E.call(this, "XContest", "xcontest", 1.2, 1.4, .2, !1, !0);
    this.a = v(Xb, 1.4, 1.6, .05, !1, !0);
  }
  w(ac, E);
  ac.prototype.P = function (a, b) {
    var c = ac.A.P.call(this, a, b);
    Zb(c, a, b, void 0, this.a);
    return c;
  };
  var bc = new E("Australia (XContest)", "au", 1.4, 1.8, .2, !1, !0),
      cc = new E("Canada (XContest)", "ca", 1.2, 1.4, .05, !1, !0),
      dc = new $b(),
      ec = new E("Chile (XContest)", "cl", 2, 3, .2, !1, !0),
      fc = new E("Czech Republic (XContest)", "cz", 1.8, 2.2, .05, !1, !0),
      gc = new E("Spain (XContest)", "es", 1.5, 2, .2, !1, !0),
      hc = new E("Finland (XContest)", "fi", 1.2, 1.4, .2, !1, !0),
      ic = new E("Hungary (XContest)", "hu", 1.8, 2, 800, !0, !0),
      jc = new E("Lithuania (XContest)", "lt", 1.5, 2, .2, !1, !0),
      kc = new E("Slovakia (XContest)", "sk", 1.8, 2.2, .05, !1, !0),
      lc = new ac();

  function mc() {
    this.a = v(Xb, 1.2, 1.4, 3E3, !0, !1);
    this.b = v(Xb, 1.2, 1.4, .05, !1, !0);
  }
  w(mc, Vb);
  g = mc.prototype;
  g.getId = function () {
    return "fr";
  };
  g.oa = function (a) {
    var b,
        c = Array(a);
    c[0] = "BD";
    for (b = 1; b < a - 1; ++b) {
      c[b] = "B" + b;
    }c[a - 1] = "BA";
    return c;
  };
  g.W = function () {
    return "France (Coupe F\xE9d\xE9rale de Distance)";
  };
  g.oc = function (a) {
    return 15E3 > a ? 0 : 1;
  };
  g.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 2, this.oc, "Distance libre");
    Zb(c, a, b, void 0, this.a);
    Zb(c, a, b, void 0, this.b);
    return c;
  };
  var nc = new mc();

  function oc() {}
  w(oc, Vb);
  oc.prototype.getId = function () {
    return "free";
  };
  oc.prototype.W = function () {
    return "Free flight";
  };
  oc.prototype.P = function (a, b) {
    var c,
        d = a.length,
        e = 0;
    for (c = 0; c < d - 1; ++c) {
      e += Qb(b, c, c + 1);
    }var f = Array(d);
    for (c = 0; c < d; ++c) {
      f[c] = c;
    }return [new Wb({
      distance: e,
      J: f,
      $: 1,
      name: "Free flight"
    })];
  };
  var pc = new oc();

  function qc() {
    this.a = v(Xb, 1.75, 2, .2, !1, !0);
  }
  w(qc, Vb);
  qc.prototype.getId = function () {
    return "leonardo";
  };
  qc.prototype.W = function () {
    return "Leonardo";
  };
  qc.prototype.b = function () {
    return 1.5;
  };
  qc.prototype.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 3, this.b, "Open distance");
    Zb(c, a, b, void 0, this.a);
    return c;
  };
  var F = new qc();

  function rc() {
    this.a = v(Xb, void 0, 1.6, .08, !1, !0);
    this.b = v(Xb, 1.2, void 0, .2, !1, !0);
  }
  w(rc, Vb);
  g = rc.prototype;
  g.getId = function () {
    return "mx";
  };
  g.oa = function (a) {
    var b,
        c = Array(a);
    c[0] = "SP";
    for (b = 1; b < a - 1; ++b) {
      c[b] = "TP" + b;
    }c[a - 1] = "KB";
    return c;
  };
  g.W = function () {
    return "Mexico (XContest)";
  };
  g.pc = function () {
    return 1;
  };
  g.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 3, this.pc, "Open distance");
    Zb(c, a, b, void 0, this.a);
    Zb(c, a, b, void 0, this.b);
    return c;
  };
  var sc = new rc();

  function tc() {}
  w(tc, Vb);
  tc.prototype.getId = function () {
    return "open";
  };
  tc.prototype.W = function () {
    return "Open distance";
  };
  tc.prototype.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 0, Pa(), "Open distance");
    return c;
  };
  var uc = new tc();

  function vc(a, b) {
    this.b = a;
    this.a = b;
    this.c = v(Xb, 1.25, 1.5, .2, !1, !0);
  }
  w(vc, Vb);
  g = vc.prototype;
  g.getId = function () {
    return this.a;
  };
  g.oa = function (a) {
    var b,
        c = Array(a);
    c[0] = "SP";
    for (b = 1; b < a - 1; ++b) {
      c[b] = "TP" + b;
    }c[a - 1] = "KB";
    return c;
  };
  g.W = function () {
    return this.b;
  };
  g.qc = function () {
    return 1;
  };
  g.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 3, this.qc, "Open distance");
    Zb(c, a, b, void 0, this.c);
    return c;
  };
  var wc = new vc("Poland (XCCompetitions)", "pl");

  function xc(a, b, c) {
    var d = null,
        e = -Infinity,
        f = -Infinity;
    b = b.length;
    var h, k, l, n, m, r;
    for (k = 0; k < b - 1; ++k) {
      for (l = k; l < b - 1; ++l) {
        for (m = l + 1; m < b; ++m) {
          for (n = Ub(c, l, m), r = m; r < b; ++r) {
            h = Ub(c, k, r), 800 < h || (h = 2 * n - h, h > f && (d = [k, l, m, r], e = n, f = h));
          }
        }
      }
    }return null === d ? null : new Wb({
      distance: f,
      J: d,
      $: a(2 * e),
      name: "Out and return",
      ia: 800,
      ja: 1
    });
  }

  function yc(a, b, c, d, e, f) {
    var h = f[0],
        k = f[2],
        l = c.length,
        n = e[0] + e[1] + e[2],
        m = Math.min.apply(null, e) / n;
    if (.28 <= m) b = a(n), e = "Yassen triangle", a = 3;else if (.45 >= m) {
      a = z([zc(c[f[0]], c[f[1]], c[f[2]]), zc(c[f[1]], c[f[2]], c[f[0]]), zc(c[f[2]], c[f[0]], c[f[1]])], Math.abs);
      if (.15 > Math.min.apply(null, a) / Math.max.apply(null, e)) return null;
      b = b(n);
      e = "Flat triangle";
      a = 2;
    } else return null;
    c = Infinity;
    var m = null,
        r,
        y;
    for (r = h; 0 <= r; --r) {
      for (y = k; y < l; ++y) {
        h = Ub(d, r, y), h < c && 800 > h && (c = h, m = [r, f[0], f[1], f[2], y]);
      }
    }return null === m ? null : new Wb({
      distance: n - c,
      ua: f,
      J: m,
      $: b,
      name: e,
      ia: 800,
      ja: a
    });
  }

  function Ac() {
    this.a = v(xc, this.Ia);
    this.b = v(yc, this.Qa, this.Ia);
  }
  w(Ac, Vb);
  Ac.prototype.oa = function (a) {
    var b,
        c = Array(a);
    c[0] = "Start";
    for (b = 1; b < a - 1; ++b) {
      c[b] = "TP" + b;
    }c[a - 1] = "Finish";
    return c;
  };
  Ac.prototype.P = function (a, b) {
    var c = [];
    Yb(c, a, b, 3, this.Ta, "Open distance");
    Zb(c, a, b, this.a, this.b);
    return c;
  };

  function Bc() {
    Ac.call(this);
  }
  w(Bc, Ac);
  g = Bc.prototype;
  g.getId = function () {
    return "ukc";
  };
  g.W = function () {
    return "United Kingdom (XC League, Club)";
  };
  g.Qa = function (a) {
    return 5E3 > a ? 0 : 15E3 > a ? 1.5 : 35E3 > a ? 1.7 : 2;
  };
  g.Ia = function (a) {
    return 5E3 > a ? 0 : 15E3 > a ? 1.2 : 35E3 > a ? 1.3 : 1.7;
  };
  g.Ta = function (a) {
    return 5E3 > a ? 0 : 1;
  };
  var Cc = new Bc();

  function Dc() {
    Ac.call(this);
  }
  w(Dc, Ac);
  g = Dc.prototype;
  g.getId = function () {
    return "uki";
  };
  g.W = function () {
    return "United Kingdom (XC League, International)";
  };
  g.Qa = function (a) {
    return 25E3 > a ? 0 : 1.5;
  };
  g.Ia = function (a) {
    return 35E3 > a ? 0 : 1.2;
  };
  g.Ta = function (a) {
    return 1E4 > a ? 0 : 1;
  };
  var Ec = new Dc();

  function Fc() {
    Ac.call(this);
  }
  w(Fc, Ac);
  g = Fc.prototype;
  g.getId = function () {
    return "uk";
  };
  g.W = function () {
    return "United Kingdom (XC League, National)";
  };
  g.Qa = function (a) {
    return 15E3 > a ? 0 : 25E3 > a ? 1.7 : 2;
  };
  g.Ia = function (a) {
    return 15E3 > a ? 0 : 35E3 > a ? 1.3 : 1.7;
  };
  g.Ta = function (a) {
    return 1E4 > a ? 0 : 1;
  };
  var Gc = new Fc();
  var Hc = [uc, pc, F, lc, bc, cc, ec, fc, hc, nc, ic, jc, sc, wc, kc, gc, dc, Cc, Gc, Ec];

  function Ic(a, b, c) {
    0 > c ? c += 1 : 1 < c && --c;
    return 1 > 6 * c ? a + 6 * (b - a) * c : 1 > 2 * c ? b : 2 > 3 * c ? a + (b - a) * (2 / 3 - c) * 6 : a;
  }

  function Jc(a) {
    return 1 == a.length ? "0" + a : a;
  }

  function Kc(a) {
    var b,
        c = a[1];
    b = a[2];
    var d = 0,
        e = 0,
        f = 0;
    a = a[0] / 360;
    if (0 == c) d = e = f = 255 * b;else var h = f = 0,
        h = .5 > b ? b * (1 + c) : b + c - c * b,
        f = 2 * b - h,
        d = 255 * Ic(f, h, a + 1 / 3),
        e = 255 * Ic(f, h, a),
        f = 255 * Ic(f, h, a - 1 / 3);
    b = [Math.round(d), Math.round(e), Math.round(f)];
    d = b[0];
    c = b[1];
    b = b[2];
    d = Number(d);
    c = Number(c);
    b = Number(b);
    if (d != (d & 255) || c != (c & 255) || b != (b & 255)) throw Error('"(' + d + "," + c + "," + b + '") is not a valid RGB color');
    d = Jc(d.toString(16));
    c = Jc(c.toString(16));
    b = Jc(b.toString(16));
    return "#" + d + c + b;
  };

  function Lc(a) {
    var b = a.type;
    if (!q(b)) return null;
    switch (b.toLowerCase()) {
      case "checkbox":
      case "radio":
        return a.checked ? a.value : null;
      case "select-one":
        return b = a.selectedIndex, 0 <= b ? a.options[b].value : null;
      case "select-multiple":
        for (var b = [], c, d = 0; c = a.options[d]; d++) {
          c.selected && b.push(c.value);
        }return b.length ? b : null;
      default:
        return q(a.value) ? a.value : null;
    }
  };
  var Mc;
  a: {
    var Nc = p.navigator;
    if (Nc) {
      var Oc = Nc.userAgent;
      if (Oc) {
        Mc = Oc;
        break a;
      }
    }
    Mc = "";
  }

  function G(a) {
    return -1 != Mc.indexOf(a);
  };
  var Pc = G("Opera") || G("OPR"),
      H = G("Trident") || G("MSIE"),
      Qc = G("Edge"),
      Rc = G("Gecko") && !(-1 != Mc.toLowerCase().indexOf("webkit") && !G("Edge")) && !(G("Trident") || G("MSIE")) && !G("Edge"),
      Sc = -1 != Mc.toLowerCase().indexOf("webkit") && !G("Edge"),
      Tc = G("Macintosh"),
      Uc = G("Windows"),
      Vc = G("Linux") || G("CrOS");

  function Wc() {
    var a = Mc;
    if (Rc) return (/rv\:([^\);]+)(\)|;)/.exec(a)
    );
    if (Qc) return (/Edge\/([\d\.]+)/.exec(a)
    );
    if (H) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
    );
    if (Sc) return (/WebKit\/(\S+)/.exec(a)
    );
  }

  function Xc() {
    var a = p.document;
    return a ? a.documentMode : void 0;
  }
  var Yc = function () {
    if (Pc && p.opera) {
      var a;
      var b = p.opera.version;
      try {
        a = b();
      } catch (c) {
        a = b;
      }
      return a;
    }
    a = "";
    (b = Wc()) && (a = b ? b[1] : "");
    return H && (b = Xc(), b > parseFloat(a)) ? String(b) : a;
  }(),
      Zc = {};

  function I(a) {
    var b;
    if (!(b = Zc[a])) {
      b = 0;
      for (var c = ka(String(Yc)).split("."), d = ka(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
        var h = c[f] || "",
            k = d[f] || "",
            l = RegExp("(\\d*)(\\D*)", "g"),
            n = RegExp("(\\d*)(\\D*)", "g");
        do {
          var m = l.exec(h) || ["", "", ""],
              r = n.exec(k) || ["", "", ""];
          if (0 == m[0].length && 0 == r[0].length) break;
          b = va(0 == m[1].length ? 0 : parseInt(m[1], 10), 0 == r[1].length ? 0 : parseInt(r[1], 10)) || va(0 == m[2].length, 0 == r[2].length) || va(m[2], r[2]);
        } while (0 == b);
      }
      b = Zc[a] = 0 <= b;
    }
    return b;
  }
  var $c = p.document,
      ad = $c && H ? Xc() || ("CSS1Compat" == $c.compatMode ? parseInt(Yc, 10) : 5) : void 0;
  var bd = !H || 9 <= Number(ad),
      cd = !H || 9 <= Number(ad),
      dd = H && !I("9");
  !Sc || I("528");
  Rc && I("1.9b") || H && I("8") || Pc && I("9.5") || Sc && I("528");
  Rc && !I("8") || H && I("9");

  function ed() {
    0 != fd && (gd[this[ea] || (this[ea] = ++fa)] = this);
    this.o = this.o;
    this.m = this.m;
  }
  var fd = 0,
      gd = {};
  ed.prototype.o = !1;
  ed.prototype.wa = function () {
    return this.o;
  };
  ed.prototype.Z = function () {
    if (!this.o && (this.o = !0, this.C(), 0 != fd)) {
      var a = this[ea] || (this[ea] = ++fa);
      delete gd[a];
    }
  };
  ed.prototype.C = function () {
    if (this.m) for (; this.m.length;) {
      this.m.shift()();
    }
  };

  function hd(a) {
    a && "function" == typeof a.Z && a.Z();
  };

  function id(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.j = !1;
    this.gb = !0;
  }
  id.prototype.h = function () {
    this.j = !0;
  };
  id.prototype.b = function () {
    this.gb = !1;
  };

  function jd(a) {
    a.b();
  };

  function kd(a) {
    kd[" "](a);
    return a;
  }
  kd[" "] = function () {};

  function ld(a, b) {
    id.call(this, a ? a.type : "");
    this.a = this.target = null;
    this.o = this.clientY = this.clientX = 0;
    this.B = this.v = !1;
    this.c = null;
    if (a) {
      this.type = a.type;
      var c = a.changedTouches ? a.changedTouches[0] : null;
      this.target = a.target || a.srcElement;
      this.a = b;
      var d = a.relatedTarget;
      if (d && Rc) try {
        kd(d.nodeName);
      } catch (e) {}
      null === c ? (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY) : (this.clientX = void 0 !== c.clientX ? c.clientX : c.pageX, this.clientY = void 0 !== c.clientY ? c.clientY : c.pageY);
      this.o = a.keyCode || 0;
      this.v = a.ctrlKey;
      this.B = a.shiftKey;
      this.c = a;
      a.defaultPrevented && this.b();
    }
  }
  w(ld, id);
  var md = [1, 4, 2];
  ld.prototype.h = function () {
    ld.A.h.call(this);
    this.c.stopPropagation ? this.c.stopPropagation() : this.c.cancelBubble = !0;
  };
  ld.prototype.b = function () {
    ld.A.b.call(this);
    var a = this.c;
    if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, dd) try {
      if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
  };
  var nd = !H || 9 <= Number(ad),
      od = !Rc && !H || H && 9 <= Number(ad) || Rc && I("1.9.1");
  H && I("9");

  function pd() {
    this.b = "";
  }
  pd.prototype.a = function () {
    return this.b;
  };

  function qd(a) {
    var b = new pd();
    b.b = a;
    return b;
  }
  qd("");

  function rd() {
    this.c = "";
    this.g = sd;
  }
  rd.prototype.a = function () {
    return this.c;
  };
  rd.prototype.b = function () {
    return 1;
  };
  var sd = {};

  function td() {
    this.c = "";
    this.g = ud;
  }
  td.prototype.a = function () {
    return this.c;
  };
  td.prototype.b = function () {
    return 1;
  };
  var ud = {};

  function vd() {
    this.c = "";
    this.h = wd;
    this.g = null;
  }
  vd.prototype.b = function () {
    return this.g;
  };
  vd.prototype.a = function () {
    return this.c;
  };

  function xd(a) {
    return a instanceof vd && a.constructor === vd && a.h === wd ? a.c : "type_error:SafeHtml";
  }
  var wd = {};

  function yd(a) {
    var b = new vd();
    b.c = a;
    b.g = 0;
    return b;
  }
  yd("\x3c!DOCTYPE html\x3e");
  var zd = yd("");
  yd("\x3cbr\x3e");

  function J(a, b) {
    this.x = q(a) ? a : 0;
    this.y = q(b) ? b : 0;
  }
  J.prototype.clone = function () {
    return new J(this.x, this.y);
  };
  J.prototype.ceil = function () {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  };
  J.prototype.floor = function () {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  };
  J.prototype.round = function () {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  };

  function Ad(a, b) {
    this.width = a;
    this.height = b;
  }
  g = Ad.prototype;
  g.clone = function () {
    return new Ad(this.width, this.height);
  };
  g.tb = function () {
    return this.width * this.height;
  };
  g.isEmpty = function () {
    return !this.tb();
  };
  g.ceil = function () {
    this.width = Math.ceil(this.width);
    this.height = Math.ceil(this.height);
    return this;
  };
  g.floor = function () {
    this.width = Math.floor(this.width);
    this.height = Math.floor(this.height);
    return this;
  };
  g.round = function () {
    this.width = Math.round(this.width);
    this.height = Math.round(this.height);
    return this;
  };

  function Bd(a) {
    return a ? new Cd(Dd(a)) : ja || (ja = new Cd());
  }

  function K(a, b) {
    var c = b || document,
        d = null;
    c.getElementsByClassName ? d = c.getElementsByClassName(a)[0] : c.querySelectorAll && c.querySelector ? d = c.querySelector("." + a) : d = Ed(a, b)[0];
    return d || null;
  }

  function Ed(a, b) {
    var c, d, e, f;
    c = document;
    c = b || c;
    if (c.querySelectorAll && c.querySelector && a) return c.querySelectorAll("" + (a ? "." + a : ""));
    if (a && c.getElementsByClassName) {
      var h = c.getElementsByClassName(a);
      return h;
    }
    h = c.getElementsByTagName("*");
    if (a) {
      f = {};
      for (d = e = 0; c = h[d]; d++) {
        var k = c.className;
        "function" == typeof k.split && Ba(k.split(/\s+/), a) && (f[e++] = c);
      }
      f.length = e;
      return f;
    }
    return h;
  }

  function Fd(a, b) {
    Ka(b, function (b, d) {
      "style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : Gd.hasOwnProperty(d) ? a.setAttribute(Gd[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b;
    });
  }
  var Gd = {
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    colspan: "colSpan",
    frameborder: "frameBorder",
    height: "height",
    maxlength: "maxLength",
    role: "role",
    rowspan: "rowSpan",
    type: "type",
    usemap: "useMap",
    valign: "vAlign",
    width: "width"
  };

  function Hd(a) {
    a = a.document.documentElement;
    return new Ad(a.clientWidth, a.clientHeight);
  }

  function Id(a) {
    return a ? Jd(a) : window;
  }

  function Jd(a) {
    return a.parentWindow || a.defaultView;
  }

  function Kd(a, b, c) {
    return Ld(document, arguments);
  }

  function Ld(a, b) {
    var c = b[0],
        d = b[1];
    if (!nd && d && (d.name || d.type)) {
      c = ["\x3c", c];
      d.name && c.push(' name\x3d"', la(d.name), '"');
      if (d.type) {
        c.push(' type\x3d"', la(d.type), '"');
        var e = {};
        Oa(e, d);
        delete e.type;
        d = e;
      }
      c.push("\x3e");
      c = c.join("");
    }
    c = a.createElement(c);
    d && (t(d) ? c.className = d : ba(d) ? c.className = d.join(" ") : Fd(c, d));
    2 < b.length && Md(a, c, b, 2);
    return c;
  }

  function Md(a, b, c, d) {
    function e(c) {
      c && b.appendChild(t(c) ? a.createTextNode(c) : c);
    }
    for (; d < c.length; d++) {
      var f = c[d];
      !ca(f) || da(f) && 0 < f.nodeType ? e(f) : x(Nd(f) ? Ea(f) : f, e);
    }
  }

  function Od(a, b) {
    Md(Dd(a), a, arguments, 1);
  }

  function Pd(a) {
    return a && a.parentNode ? a.parentNode.removeChild(a) : null;
  }

  function Dd(a) {
    return 9 == a.nodeType ? a : a.ownerDocument || a.document;
  }

  function Qd(a, b) {
    if ("textContent" in a) a.textContent = b;else if (3 == a.nodeType) a.data = b;else if (a.firstChild && 3 == a.firstChild.nodeType) {
      for (; a.lastChild != a.firstChild;) {
        a.removeChild(a.lastChild);
      }a.firstChild.data = b;
    } else {
      for (var c; c = a.firstChild;) {
        a.removeChild(c);
      }a.appendChild(Dd(a).createTextNode(String(b)));
    }
  }

  function Nd(a) {
    if (a && "number" == typeof a.length) {
      if (da(a)) return "function" == typeof a.item || "string" == typeof a.item;
      if ("function" == aa(a)) return "function" == typeof a.item;
    }
    return !1;
  }

  function Cd(a) {
    this.a = a || p.document || document;
  }
  Cd.prototype.w = function (a) {
    return t(a) ? this.a.getElementById(a) : a;
  };
  Cd.prototype.b = function (a, b, c) {
    return Ld(this.a, arguments);
  };

  function Rd(a) {
    var b = a.a;
    a = b.scrollingElement ? b.scrollingElement : Sc ? b.body || b.documentElement : b.documentElement;
    b = Jd(b);
    return H && I("10") && b.pageYOffset != a.scrollTop ? new J(a.scrollLeft, a.scrollTop) : new J(b.pageXOffset || a.scrollLeft, b.pageYOffset || a.scrollTop);
  }
  Cd.prototype.c = Pd;

  function Sd(a) {
    return od && void 0 != a.children ? a.children : za(a.childNodes, function (a) {
      return 1 == a.nodeType;
    });
  }
  Cd.prototype.contains = function (a, b) {
    if (!a || !b) return !1;
    if (a.contains && 1 == b.nodeType) return a == b || a.contains(b);
    if ("undefined" != typeof a.compareDocumentPosition) return a == b || Boolean(a.compareDocumentPosition(b) & 16);
    for (; b && a != b;) {
      b = b.parentNode;
    }return b == a;
  };
  var Td = "closure_listenable_" + (1E6 * Math.random() | 0);

  function Ud(a) {
    return !(!a || !a[Td]);
  }
  var Vd = 0;

  function Wd(a, b, c, d, e) {
    this.listener = a;
    this.a = null;
    this.src = b;
    this.type = c;
    this.za = !!d;
    this.Ga = e;
    this.key = ++Vd;
    this.pa = this.ya = !1;
  }

  function Xd(a) {
    a.pa = !0;
    a.listener = null;
    a.a = null;
    a.src = null;
    a.Ga = null;
  };

  function Yd(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
  }

  function Zd(a, b, c, d, e, f) {
    var h = b.toString();
    b = a.a[h];
    b || (b = a.a[h] = [], a.b++);
    var k = $d(b, c, e, f);-1 < k ? (a = b[k], d || (a.ya = !1)) : (a = new Wd(c, a.src, h, !!e, f), a.ya = d, b.push(a));
    return a;
  }

  function ae(a, b) {
    var c = b.type;
    c in a.a && Ca(a.a[c], b) && (Xd(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
  }

  function be(a, b, c, d, e) {
    a = a.a[b.toString()];
    b = -1;
    a && (b = $d(a, c, d, e));
    return -1 < b ? a[b] : null;
  }

  function $d(a, b, c, d) {
    for (var e = 0; e < a.length; ++e) {
      var f = a[e];
      if (!f.pa && f.listener == b && f.za == !!c && f.Ga == d) return e;
    }
    return -1;
  };
  var ce = "closure_lm_" + (1E6 * Math.random() | 0),
      de = {},
      ee = 0;

  function L(a, b, c, d, e) {
    if (ba(b)) {
      for (var f = 0; f < b.length; f++) {
        L(a, b[f], c, d, e);
      }return null;
    }
    c = fe(c);
    return Ud(a) ? a.D(b, c, d, e) : ge(a, b, c, !1, d, e);
  }

  function ge(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = !!e,
        k = he(a);
    k || (a[ce] = k = new Yd(a));
    c = Zd(k, b, c, d, e, f);
    if (c.a) return c;
    d = ie();
    c.a = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) a.addEventListener(b.toString(), d, h);else if (a.attachEvent) a.attachEvent(je(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");
    ee++;
    return c;
  }

  function ie() {
    var a = ke,
        b = cd ? function (c) {
      return a.call(b.src, b.listener, c);
    } : function (c) {
      c = a.call(b.src, b.listener, c);
      if (!c) return c;
    };
    return b;
  }

  function le(a, b, c, d, e) {
    if (ba(b)) for (var f = 0; f < b.length; f++) {
      le(a, b[f], c, d, e);
    } else c = fe(c), Ud(a) ? Zd(a.g, String(b), c, !0, d, e) : ge(a, b, c, !0, d, e);
  }

  function me(a, b, c, d, e) {
    if (ba(b)) for (var f = 0; f < b.length; f++) {
      me(a, b[f], c, d, e);
    } else c = fe(c), Ud(a) ? a.Ja(b, c, d, e) : a && (a = he(a)) && (b = be(a, b, c, !!d, e)) && ne(b);
  }

  function ne(a) {
    if ("number" != typeof a && a && !a.pa) {
      var b = a.src;
      if (Ud(b)) ae(b.g, a);else {
        var c = a.type,
            d = a.a;
        b.removeEventListener ? b.removeEventListener(c, d, a.za) : b.detachEvent && b.detachEvent(je(c), d);
        ee--;
        (c = he(b)) ? (ae(c, a), 0 == c.b && (c.src = null, b[ce] = null)) : Xd(a);
      }
    }
  }

  function je(a) {
    return a in de ? de[a] : de[a] = "on" + a;
  }

  function oe(a, b, c, d) {
    var e = !0;
    if (a = he(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
      var f = b[a];
      f && f.za == c && !f.pa && (f = pe(f, d), e = e && !1 !== f);
    }
    return e;
  }

  function pe(a, b) {
    var c = a.listener,
        d = a.Ga || a.src;
    a.ya && ne(a);
    return c.call(d, b);
  }

  function ke(a, b) {
    if (a.pa) return !0;
    if (!cd) {
      var c;
      if (!(c = b)) a: {
        c = ["window", "event"];
        for (var d = p, e; e = c.shift();) {
          if (null != d[e]) d = d[e];else {
            c = null;
            break a;
          }
        }c = d;
      }
      e = c;
      c = new ld(e, this);
      d = !0;
      if (!(0 > e.keyCode || void 0 != e.returnValue)) {
        a: {
          var f = !1;
          if (0 == e.keyCode) try {
            e.keyCode = -1;
            break a;
          } catch (l) {
            f = !0;
          }
          if (f || void 0 == e.returnValue) e.returnValue = !0;
        }
        e = [];
        for (f = c.a; f; f = f.parentNode) {
          e.push(f);
        }for (var f = a.type, h = e.length - 1; !c.j && 0 <= h; h--) {
          c.a = e[h];
          var k = oe(e[h], f, !0, c),
              d = d && k;
        }
        for (h = 0; !c.j && h < e.length; h++) {
          c.a = e[h], k = oe(e[h], f, !1, c), d = d && k;
        }
      }
      return d;
    }
    return pe(a, new ld(b, this));
  }

  function he(a) {
    a = a[ce];
    return a instanceof Yd ? a : null;
  }
  var qe = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

  function fe(a) {
    if ("function" == aa(a)) return a;
    a[qe] || (a[qe] = function (b) {
      return a.handleEvent(b);
    });
    return a[qe];
  };

  function re(a) {
    ed.call(this);
    this.b = a;
    this.a = {};
  }
  w(re, ed);
  var se = [];
  re.prototype.D = function (a, b, c, d) {
    ba(b) || (b && (se[0] = b.toString()), b = se);
    for (var e = 0; e < b.length; e++) {
      var f = L(a, b[e], c || this.handleEvent, d || !1, this.b || this);
      if (!f) break;
      this.a[f.key] = f;
    }
    return this;
  };
  re.prototype.Ja = function (a, b, c, d, e) {
    if (ba(b)) for (var f = 0; f < b.length; f++) {
      this.Ja(a, b[f], c, d, e);
    } else c = c || this.handleEvent, e = e || this.b || this, c = fe(c), d = !!d, b = Ud(a) ? be(a.g, String(b), c, d, e) : a ? (a = he(a)) ? be(a, b, c, d, e) : null : null, b && (ne(b), delete this.a[b.key]);
    return this;
  };

  function te(a) {
    Ka(a.a, function (a, c) {
      this.a.hasOwnProperty(c) && ne(a);
    }, a);
    a.a = {};
  }
  re.prototype.C = function () {
    re.A.C.call(this);
    te(this);
  };
  re.prototype.handleEvent = function () {
    throw Error("EventHandler.handleEvent not implemented");
  };

  function M() {
    ed.call(this);
    this.g = new Yd(this);
    this.Ka = this;
    this.X = null;
  }
  w(M, ed);
  M.prototype[Td] = !0;
  g = M.prototype;
  g.Va = function (a) {
    this.X = a;
  };
  g.removeEventListener = function (a, b, c, d) {
    me(this, a, b, c, d);
  };

  function N(a, b) {
    var c,
        d = a.X;
    if (d) for (c = []; d; d = d.X) {
      c.push(d);
    }var d = a.Ka,
        e = b,
        f = e.type || e;
    if (t(e)) e = new id(e, d);else if (e instanceof id) e.target = e.target || d;else {
      var h = e,
          e = new id(f, d);
      Oa(e, h);
    }
    var h = !0,
        k;
    if (c) for (var l = c.length - 1; !e.j && 0 <= l; l--) {
      k = e.a = c[l], h = ue(k, f, !0, e) && h;
    }e.j || (k = e.a = d, h = ue(k, f, !0, e) && h, e.j || (h = ue(k, f, !1, e) && h));
    if (c) for (l = 0; !e.j && l < c.length; l++) {
      k = e.a = c[l], h = ue(k, f, !1, e) && h;
    }return h;
  }
  g.C = function () {
    M.A.C.call(this);
    if (this.g) {
      var a = this.g,
          b = 0,
          c;
      for (c in a.a) {
        for (var d = a.a[c], e = 0; e < d.length; e++) {
          ++b, Xd(d[e]);
        }delete a.a[c];
        a.b--;
      }
    }
    this.X = null;
  };
  g.D = function (a, b, c, d) {
    return Zd(this.g, String(a), b, !1, c, d);
  };
  g.Ja = function (a, b, c, d) {
    var e;
    e = this.g;
    a = String(a).toString();
    if (a in e.a) {
      var f = e.a[a];
      b = $d(f, b, c, d);-1 < b ? (Xd(f[b]), Array.prototype.splice.call(f, b, 1), 0 == f.length && (delete e.a[a], e.b--), e = !0) : e = !1;
    } else e = !1;
    return e;
  };

  function ue(a, b, c, d) {
    b = a.g.a[String(b)];
    if (!b) return !0;
    b = b.concat();
    for (var e = !0, f = 0; f < b.length; ++f) {
      var h = b[f];
      if (h && !h.pa && h.za == c) {
        var k = h.listener,
            l = h.Ga || h.src;
        h.ya && ae(a.g, h);
        e = !1 !== k.call(l, d) && e;
      }
    }
    return e && 0 != d.gb;
  };

  function ve(a, b) {
    M.call(this);
    this.a = new re(this);
    var c = a;
    b && (c = Dd(a));
    this.a.D(c, "dragenter", this.Gb);
    c != a && this.a.D(c, "dragover", this.Hb);
    this.a.D(a, "dragover", this.Mb);
    this.a.D(a, "drop", this.Nb);
  }
  w(ve, M);
  g = ve.prototype;
  g.ta = !1;
  g.C = function () {
    ve.A.C.call(this);
    this.a.Z();
  };
  g.Gb = function (a) {
    var b = a.c.dataTransfer;
    (this.ta = !(!b || !(b.types && (Ba(b.types, "Files") || Ba(b.types, "public.file-url")) || b.files && 0 < b.files.length))) && a.b();
  };
  g.Hb = function (a) {
    this.ta && (a.b(), a.c.dataTransfer.dropEffect = "none");
  };
  g.Mb = function (a) {
    if (this.ta) {
      a.b();
      a.h();
      a = a.c.dataTransfer;
      try {
        a.effectAllowed = "all";
      } catch (b) {}
      a.dropEffect = "copy";
    }
  };
  g.Nb = function (a) {
    this.ta && (a.b(), a.h(), a = new ld(a.c), a.type = "drop", N(this, a));
  };
  var we = p.JSON.stringify;
  var xe = {},
      ye = {},
      ze = {};

  function O() {
    throw Error("Do not instantiate directly");
  }
  O.prototype.ba = null;
  O.prototype.getContent = function () {
    return this.content;
  };
  O.prototype.toString = function () {
    return this.content;
  };

  function Ae(a, b, c) {
    a.innerHTML = Be(b(c || Ce, void 0, void 0));
  }

  function De(a, b, c, d) {
    d = d || Bd();
    a = Be(a(b || Ce, void 0, c));
    c = d.a;
    b = c.createElement("DIV");
    H ? (b.innerHTML = "\x3cbr\x3e" + a, b.removeChild(b.firstChild)) : b.innerHTML = a;
    if (1 == b.childNodes.length) a = b.removeChild(b.firstChild);else for (a = c.createDocumentFragment(); b.firstChild;) {
      a.appendChild(b.firstChild);
    }return a;
  }

  function Be(a) {
    if (!da(a)) return String(a);
    if (a instanceof O) {
      if (a.T === xe) return a.getContent();
      if (a.T === ze) return la(a.getContent());
    }
    return "zSoyz";
  }
  var Ce = {};
  var Ee;

  function Fe(a, b) {
    b ? a.setAttribute("role", b) : a.removeAttribute("role");
  }

  function Ge(a, b, c) {
    ba(c) && (c = c.join(" "));
    var d = "aria-" + b;
    "" === c || void 0 == c ? (Ee || (Ee = {
      atomic: !1,
      autocomplete: "none",
      dropeffect: "none",
      haspopup: !1,
      live: "off",
      multiline: !1,
      multiselectable: !1,
      orientation: "vertical",
      readonly: !1,
      relevant: "additions text",
      required: !1,
      sort: "none",
      busy: !1,
      disabled: !1,
      hidden: !1,
      invalid: "false"
    }), c = Ee, b in c ? a.setAttribute(d, c[b]) : a.removeAttribute(d)) : a.setAttribute(d, c);
  };

  function He(a) {
    if (a.classList) return a.classList;
    a = a.className;
    return t(a) && a.match(/\S+/g) || [];
  }

  function Ie(a, b) {
    return a.classList ? a.classList.contains(b) : Ba(He(a), b);
  }

  function Je(a, b) {
    if (a.classList) x(b, function (b) {
      a.classList ? a.classList.add(b) : Ie(a, b) || (a.className += 0 < a.className.length ? " " + b : b);
    });else {
      var c = {};
      x(He(a), function (a) {
        c[a] = !0;
      });
      x(b, function (a) {
        c[a] = !0;
      });
      a.className = "";
      for (var d in c) {
        a.className += 0 < a.className.length ? " " + d : d;
      }
    }
  }

  function Ke(a, b) {
    a.classList ? a.classList.remove(b) : Ie(a, b) && (a.className = za(He(a), function (a) {
      return a != b;
    }).join(" "));
  }

  function Le(a, b) {
    a.classList ? x(b, function (b) {
      Ke(a, b);
    }) : a.className = za(He(a), function (a) {
      return !Ba(b, a);
    }).join(" ");
  };

  function Me(a, b, c, d) {
    this.top = a;
    this.right = b;
    this.bottom = c;
    this.left = d;
  }
  g = Me.prototype;
  g.clone = function () {
    return new Me(this.top, this.right, this.bottom, this.left);
  };
  g.contains = function (a) {
    return this && a ? a instanceof Me ? a.left >= this.left && a.right <= this.right && a.top >= this.top && a.bottom <= this.bottom : a.x >= this.left && a.x <= this.right && a.y >= this.top && a.y <= this.bottom : !1;
  };
  g.ceil = function () {
    this.top = Math.ceil(this.top);
    this.right = Math.ceil(this.right);
    this.bottom = Math.ceil(this.bottom);
    this.left = Math.ceil(this.left);
    return this;
  };
  g.floor = function () {
    this.top = Math.floor(this.top);
    this.right = Math.floor(this.right);
    this.bottom = Math.floor(this.bottom);
    this.left = Math.floor(this.left);
    return this;
  };
  g.round = function () {
    this.top = Math.round(this.top);
    this.right = Math.round(this.right);
    this.bottom = Math.round(this.bottom);
    this.left = Math.round(this.left);
    return this;
  };

  function Ne(a, b, c, d) {
    this.left = a;
    this.top = b;
    this.width = c;
    this.height = d;
  }
  g = Ne.prototype;
  g.clone = function () {
    return new Ne(this.left, this.top, this.width, this.height);
  };
  g.contains = function (a) {
    return a instanceof Ne ? this.left <= a.left && this.left + this.width >= a.left + a.width && this.top <= a.top && this.top + this.height >= a.top + a.height : a.x >= this.left && a.x <= this.left + this.width && a.y >= this.top && a.y <= this.top + this.height;
  };
  g.distance = function (a) {
    var b = a.x < this.left ? this.left - a.x : Math.max(a.x - (this.left + this.width), 0);
    a = a.y < this.top ? this.top - a.y : Math.max(a.y - (this.top + this.height), 0);
    return Math.sqrt(b * b + a * a);
  };
  g.getCenter = function () {
    return new J(this.left + this.width / 2, this.top + this.height / 2);
  };
  g.ceil = function () {
    this.left = Math.ceil(this.left);
    this.top = Math.ceil(this.top);
    this.width = Math.ceil(this.width);
    this.height = Math.ceil(this.height);
    return this;
  };
  g.floor = function () {
    this.left = Math.floor(this.left);
    this.top = Math.floor(this.top);
    this.width = Math.floor(this.width);
    this.height = Math.floor(this.height);
    return this;
  };
  g.round = function () {
    this.left = Math.round(this.left);
    this.top = Math.round(this.top);
    this.width = Math.round(this.width);
    this.height = Math.round(this.height);
    return this;
  };

  function Oe(a, b, c) {
    var d = Pe[c];
    if (!d) {
      var e = wa(c),
          d = e;
      void 0 === a.style[e] && (e = (Sc ? "Webkit" : Rc ? "Moz" : H ? "ms" : Pc ? "O" : null) + xa(e), void 0 !== a.style[e] && (d = e));
      Pe[c] = d;
    }(c = d) && (a.style[c] = b);
  }
  var Pe = {};

  function Qe(a, b) {
    var c = Dd(a);
    return c.defaultView && c.defaultView.getComputedStyle && (c = c.defaultView.getComputedStyle(a, null)) ? c[b] || c.getPropertyValue(b) || "" : "";
  }

  function Re(a, b) {
    return Qe(a, b) || (a.currentStyle ? a.currentStyle[b] : null) || a.style && a.style[b];
  }

  function Se(a, b, c) {
    var d;
    b instanceof J ? (d = b.x, b = b.y) : (d = b, b = c);
    a.style.left = Te(d, !1);
    a.style.top = Te(b, !1);
  }

  function Ue(a) {
    var b;
    try {
      b = a.getBoundingClientRect();
    } catch (c) {
      return {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      };
    }
    H && a.ownerDocument.body && (a = a.ownerDocument, b.left -= a.documentElement.clientLeft + a.body.clientLeft, b.top -= a.documentElement.clientTop + a.body.clientTop);
    return b;
  }

  function Ve(a, b) {
    var c = We(a),
        d = We(b);
    return new J(c.x - d.x, c.y - d.y);
  }

  function We(a) {
    if (1 == a.nodeType) return a = Ue(a), new J(a.left, a.top);
    a = a.changedTouches ? a.changedTouches[0] : a;
    return new J(a.clientX, a.clientY);
  }

  function Xe(a, b, c) {
    if (b instanceof Ad) c = b.height, b = b.width;else if (void 0 == c) throw Error("missing height argument");
    a.style.width = Te(b, !0);
    a.style.height = Te(c, !0);
  }

  function Te(a, b) {
    "number" == typeof a && (a = (b ? Math.round(a) : a) + "px");
    return a;
  }

  function Ye(a) {
    var b = Ze;
    if ("none" != Re(a, "display")) return b(a);
    var c = a.style,
        d = c.display,
        e = c.visibility,
        f = c.position;
    c.visibility = "hidden";
    c.position = "absolute";
    c.display = "inline";
    a = b(a);
    c.display = d;
    c.position = f;
    c.visibility = e;
    return a;
  }

  function Ze(a) {
    var b = a.offsetWidth,
        c = a.offsetHeight,
        d = Sc && !b && !c;
    return q(b) && !d || !a.getBoundingClientRect ? new Ad(b, c) : (a = Ue(a), new Ad(a.right - a.left, a.bottom - a.top));
  }

  function $e(a, b) {
    var c = a.style;
    "opacity" in c ? c.opacity = b : "MozOpacity" in c ? c.MozOpacity = b : "filter" in c && (c.filter = "" === b ? "" : "alpha(opacity\x3d" + 100 * Number(b) + ")");
  }

  function P(a, b) {
    a.style.display = b ? "" : "none";
  }

  function af(a) {
    return "rtl" == Re(a, "direction");
  }
  var bf = {
    thin: 2,
    medium: 4,
    thick: 6
  };

  function cf(a, b) {
    if ("none" == (a.currentStyle ? a.currentStyle[b + "Style"] : null)) return 0;
    var c = a.currentStyle ? a.currentStyle[b + "Width"] : null,
        d;
    if (c in bf) d = bf[c];else if (/^\d+px?$/.test(c)) d = parseInt(c, 10);else {
      d = a.style.left;
      var e = a.runtimeStyle.left;
      a.runtimeStyle.left = a.currentStyle.left;
      a.style.left = c;
      c = a.style.pixelLeft;
      a.style.left = d;
      a.runtimeStyle.left = e;
      d = c;
    }
    return d;
  }

  function df(a) {
    if (H && !(9 <= Number(ad))) {
      var b = cf(a, "borderLeft"),
          c = cf(a, "borderRight"),
          d = cf(a, "borderTop");
      a = cf(a, "borderBottom");
      return new Me(d, c, a, b);
    }
    b = Qe(a, "borderLeftWidth");
    c = Qe(a, "borderRightWidth");
    d = Qe(a, "borderTopWidth");
    a = Qe(a, "borderBottomWidth");
    return new Me(parseFloat(d), parseFloat(c), parseFloat(a), parseFloat(b));
  };

  function ef(a, b, c) {
    M.call(this);
    this.target = a;
    this.B = b || a;
    this.v = c || new Ne(NaN, NaN, NaN, NaN);
    this.j = Dd(a);
    this.a = new re(this);
    a = v(hd, this.a);
    this.o ? a.call(void 0) : (this.m || (this.m = []), this.m.push(q(void 0) ? u(a, void 0) : a));
    this.h = this.c = this.fa = this.Y = this.clientY = this.clientX = 0;
    this.K = !0;
    this.b = !1;
    this.O = !0;
    this.M = 0;
    this.F = this.ra = !1;
    L(this.B, ["touchstart", "mousedown"], this.hb, !1, this);
  }
  w(ef, M);
  var ff = p.document && p.document.documentElement && !!p.document.documentElement.setCapture;
  g = ef.prototype;
  g.C = function () {
    ef.A.C.call(this);
    me(this.B, ["touchstart", "mousedown"], this.hb, !1, this);
    te(this.a);
    ff && this.j.releaseCapture();
    this.B = this.target = null;
  };

  function gf(a) {
    q(a.L) || (a.L = af(a.target));
    return a.L;
  }
  g.hb = function (a) {
    var b = "mousedown" == a.type;
    if (!this.K || this.b || b && (!(bd ? 0 == a.c.button : "click" == a.type || a.c.button & md[0]) || Sc && Tc && a.v)) N(this, "earlycancel");else {
      if (0 == this.M) {
        if (N(this, new hf("start", this, a.clientX, a.clientY))) this.b = !0, this.O && a.b();else return;
      } else this.O && a.b();
      var b = this.j,
          c = b.documentElement,
          d = !ff;
      this.a.D(b, ["touchmove", "mousemove"], this.yb, d);
      this.a.D(b, ["touchend", "mouseup"], this.Ba, d);
      ff ? (c.setCapture(!1), this.a.D(c, "losecapture", this.Ba)) : this.a.D(Id(b), "blur", this.Ba);
      H && this.ra && this.a.D(b, "dragstart", jd);
      this.sa && this.a.D(this.sa, "scroll", this.$b, d);
      this.clientX = this.Y = a.clientX;
      this.clientY = this.fa = a.clientY;
      this.F ? (a = this.target, b = a.offsetLeft, c = a.offsetParent, c || "fixed" != Re(a, "position") || (c = Dd(a).documentElement), c ? (Rc ? (d = df(c), b += d.left) : 8 <= Number(ad) && !(9 <= Number(ad)) && (d = df(c), b -= d.left), a = af(c) ? c.clientWidth - (b + a.offsetWidth) : b) : a = b) : a = this.target.offsetLeft;
      this.c = a;
      this.h = this.target.offsetTop;
      this.H = Rd(Bd(this.j));
    }
  };
  g.Ba = function (a) {
    te(this.a);
    ff && this.j.releaseCapture();
    this.b ? (this.b = !1, N(this, new hf("end", this, a.clientX, a.clientY, 0, jf(this, this.c), kf(this, this.h)))) : N(this, "earlycancel");
  };
  g.yb = function (a) {
    if (this.K) {
      var b = (this.F && gf(this) ? -1 : 1) * (a.clientX - this.clientX),
          c = a.clientY - this.clientY;
      this.clientX = a.clientX;
      this.clientY = a.clientY;
      if (!this.b) {
        var d = this.Y - this.clientX,
            e = this.fa - this.clientY;
        if (d * d + e * e > this.M) if (N(this, new hf("start", this, a.clientX, a.clientY))) this.b = !0;else {
          this.wa() || this.Ba(a);
          return;
        }
      }
      c = lf(this, b, c);
      b = c.x;
      c = c.y;
      this.b && N(this, new hf("beforedrag", this, a.clientX, a.clientY, 0, b, c)) && (mf(this, a, b, c), a.b());
    }
  };

  function lf(a, b, c) {
    var d = Rd(Bd(a.j));
    b += d.x - a.H.x;
    c += d.y - a.H.y;
    a.H = d;
    a.c += b;
    a.h += c;
    return new J(jf(a, a.c), kf(a, a.h));
  }
  g.$b = function (a) {
    var b = lf(this, 0, 0);
    a.clientX = this.clientX;
    a.clientY = this.clientY;
    mf(this, a, b.x, b.y);
  };

  function mf(a, b, c, d) {
    a.F && gf(a) ? a.target.style.right = c + "px" : a.target.style.left = c + "px";
    a.target.style.top = d + "px";
    N(a, new hf("drag", a, b.clientX, b.clientY, 0, c, d));
  }

  function jf(a, b) {
    var c = a.v,
        d = isNaN(c.left) ? null : c.left,
        c = isNaN(c.width) ? 0 : c.width;
    return Math.min(null != d ? d + c : Infinity, Math.max(null != d ? d : -Infinity, b));
  }

  function kf(a, b) {
    var c = a.v,
        d = isNaN(c.top) ? null : c.top,
        c = isNaN(c.height) ? 0 : c.height;
    return Math.min(null != d ? d + c : Infinity, Math.max(null != d ? d : -Infinity, b));
  }

  function hf(a, b, c, d, e, f, h) {
    id.call(this, a);
    this.clientX = c;
    this.clientY = d;
    this.left = q(f) ? f : b.c;
    this.top = q(h) ? h : b.h;
  }
  w(hf, id);

  function nf(a, b) {
    if ("function" == aa(a)) b && (a = u(a, b));else if (a && "function" == typeof a.handleEvent) a = u(a.handleEvent, a);else throw Error("Invalid listener argument");
    2147483647 < Number(0) || p.setTimeout(a, 0);
  };
  var of = H ? 'javascript:""' : "about:blank";

  function pf(a) {
    M.call(this);
    this.a = a;
    a = H ? "focusout" : "blur";
    this.b = L(this.a, H ? "focusin" : "focus", this, !H);
    this.c = L(this.a, a, this, !H);
  }
  w(pf, M);
  pf.prototype.handleEvent = function (a) {
    var b = new ld(a.c);
    b.type = "focusin" == a.type || "focus" == a.type ? "focusin" : "focusout";
    N(this, b);
  };
  pf.prototype.C = function () {
    pf.A.C.call(this);
    ne(this.b);
    ne(this.c);
    delete this.a;
  };

  function qf() {}
  qf.b = function () {
    return qf.a ? qf.a : qf.a = new qf();
  };
  qf.prototype.a = 0;

  function rf(a) {
    M.call(this);
    this.a = a || Bd();
    this.Y = null;
    this.V = !1;
    this.b = null;
    this.h = void 0;
    this.M = this.O = this.v = null;
    this.sa = !1;
  }
  w(rf, M);
  g = rf.prototype;
  g.zb = qf.b();
  g.getId = function () {
    return this.Y || (this.Y = ":" + (this.zb.a++).toString(36));
  };
  g.w = function () {
    return this.b;
  };

  function sf(a) {
    a.h || (a.h = new re(a));
    return a.h;
  }
  g.Va = function (a) {
    if (this.v && this.v != a) throw Error("Method not supported");
    rf.A.Va.call(this, a);
  };
  g.va = function () {
    this.b = this.a.a.createElement("DIV");
  };

  function tf(a) {
    if (a.V) throw Error("Component already rendered");
    a.b || a.va();
    a.a.a.body.appendChild(a.b);
    a.v && !a.v.V || a.ma();
  }
  g.ma = function () {
    this.V = !0;
    uf(this, function (a) {
      !a.V && a.w() && a.ma();
    });
  };
  g.ga = function () {
    uf(this, function (a) {
      a.V && a.ga();
    });
    this.h && te(this.h);
    this.V = !1;
  };
  g.C = function () {
    this.V && this.ga();
    this.h && (this.h.Z(), delete this.h);
    uf(this, function (a) {
      a.Z();
    });
    !this.sa && this.b && Pd(this.b);
    this.v = this.b = this.M = this.O = null;
    rf.A.C.call(this);
  };
  g.U = function () {
    return this.b;
  };

  function uf(a, b) {
    a.O && x(a.O, b, void 0);
  }
  g.removeChild = function (a, b) {
    if (a) {
      var c = t(a) ? a : a.getId(),
          d;
      this.M && c ? (d = this.M, d = (null !== d && c in d ? d[c] : void 0) || null) : d = null;
      a = d;
      if (c && a) {
        d = this.M;
        c in d && delete d[c];
        Ca(this.O, a);
        b && (a.ga(), a.b && Pd(a.b));
        c = a;
        if (null == c) throw Error("Unable to set parent component");
        c.v = null;
        rf.A.Va.call(c, null);
      }
    }
    if (!a) throw Error("Child is not in parent component");
    return a;
  };

  function vf(a, b) {
    this.c = a;
    this.b = b;
  };

  function wf(a, b) {
    rf.call(this, b);
    this.ra = !!a;
    this.B = null;
  }
  w(wf, rf);
  g = wf.prototype;
  g.Ra = null;
  g.la = !1;
  g.N = null;
  g.G = null;
  g.R = null;
  g.Ma = !1;
  g.Da = function () {
    return "goog-modalpopup";
  };
  g.Ca = function () {
    return this.N;
  };
  g.va = function () {
    wf.A.va.call(this);
    var a = this.w(),
        b = ka(this.Da()).split(" ");
    Je(a, b);
    a.tabIndex = 0;
    P(a, !1);
    this.ra && !this.G && (a = this.a, b = t(void 0) ? qd(void 0).a() : "", this.G = a.b("iframe", {
      frameborder: 0,
      style: "border:0;vertical-align:bottom;" + b,
      src: of
    }), this.G.className = this.Da() + "-bg", P(this.G, !1), $e(this.G, 0));
    this.N || (this.N = this.a.b("DIV", this.Da() + "-bg"), P(this.N, !1));
    this.R || (this.R = this.a.a.createElement("SPAN"), P(this.R, !1), this.R.tabIndex = 0, this.R.style.position = "absolute");
  };
  g.fb = function () {
    this.Ma = !1;
  };
  g.ma = function () {
    if (this.G) {
      var a = this.w();
      a.parentNode && a.parentNode.insertBefore(this.G, a);
    }
    a = this.w();
    a.parentNode && a.parentNode.insertBefore(this.N, a);
    wf.A.ma.call(this);
    a = this.w();
    a.parentNode && a.parentNode.insertBefore(this.R, a.nextSibling);
    this.Ra = new pf(this.a.a);
    sf(this).D(this.Ra, "focusin", this.Pb);
    xf(this, !1);
  };
  g.ga = function () {
    this.la && this.I(!1);
    hd(this.Ra);
    wf.A.ga.call(this);
    Pd(this.G);
    Pd(this.N);
    Pd(this.R);
  };
  g.I = function (a) {
    if (a != this.la) if (this.F && this.F.stop(), this.L && this.L.stop(), this.H && this.H.stop(), this.K && this.K.stop(), this.V && xf(this, a), a) {
      if (N(this, "beforeshow")) {
        try {
          this.B = this.a.a.activeElement;
        } catch (e) {}
        this.Ua();
        var b = Id(this.a.a) || window;
        if ("fixed" == Re(this.w(), "position")) var c = a = 0;else c = Rd(this.a), a = c.x, c = c.y;
        var d = Ye(this.w()),
            b = Hd(b || window);
        a = Math.max(a + b.width / 2 - d.width / 2, 0);
        c = Math.max(c + b.height / 2 - d.height / 2, 0);
        Se(this.w(), a, c);
        Se(this.R, a, c);
        sf(this).D(Jd(this.a.a), "resize", this.Ua);
        yf(this, !0);
        this.$a();
        this.la = !0;
        this.F && this.L ? (le(this.F, "end", this.Fa, !1, this), this.L.play(), this.F.play()) : this.Fa();
      }
    } else if (N(this, "beforehide")) {
      sf(this).Ja(Jd(this.a.a), "resize", this.Ua);
      this.la = !1;
      this.H && this.K ? (le(this.H, "end", this.Ea, !1, this), this.K.play(), this.H.play()) : this.Ea();
      a: {
        try {
          c = this.a;
          d = c.a.body;
          b = c.a.activeElement || d;
          if (!this.B || this.B == d) {
            this.B = null;
            break a;
          }(b == d || c.contains(this.w(), b)) && this.B.focus();
        } catch (e) {}
        this.B = null;
      }
    }
  };

  function xf(a, b) {
    a.fa || (a.fa = new vf(a.b, a.a));
    var c = a.fa;
    if (b) {
      c.a || (c.a = []);
      for (var d = Sd(c.b.a.body), e = 0; e < d.length; e++) {
        var f = d[e],
            h;
        if (h = f != c.c) h = f.getAttribute("aria-hidden"), h = !(null == h || void 0 == h ? 0 : String(h));
        h && (Ge(f, "hidden", !0), c.a.push(f));
      }
    } else if (c.a) {
      for (e = 0; e < c.a.length; e++) {
        c.a[e].removeAttribute("aria-hidden");
      }c.a = null;
    }
  }

  function yf(a, b) {
    a.G && P(a.G, b);
    a.N && P(a.N, b);
    P(a.w(), b);
    P(a.R, b);
  }
  g.Fa = function () {
    N(this, "show");
  };
  g.Ea = function () {
    yf(this, !1);
    N(this, "hide");
  };
  g.Ua = function () {
    this.G && P(this.G, !1);
    this.N && P(this.N, !1);
    var a = this.a.a,
        b = Hd(Id(a) || window || window),
        c = Math.max(b.width, Math.max(a.body.scrollWidth, a.documentElement.scrollWidth)),
        a = Math.max(b.height, Math.max(a.body.scrollHeight, a.documentElement.scrollHeight));
    this.G && (P(this.G, !0), Xe(this.G, c, a));
    this.N && (P(this.N, !0), Xe(this.N, c, a));
  };
  g.Pb = function (a) {
    this.Ma ? this.fb() : a.target == this.R && nf(this.$a, this);
  };
  g.$a = function () {
    try {
      H && this.a.a.body.focus(), this.w().focus();
    } catch (a) {}
  };
  g.C = function () {
    hd(this.F);
    this.F = null;
    hd(this.H);
    this.H = null;
    hd(this.L);
    this.L = null;
    hd(this.K);
    this.K = null;
    wf.A.C.call(this);
  };

  function Q(a, b, c) {
    wf.call(this, b, c);
    this.j = a || "xc-modal-dialog";
    this.c = R(R(new S(), zf, !0), Af, !1, !0);
  }
  w(Q, wf);
  g = Q.prototype;
  g.wb = !0;
  g.ab = !0;
  g.bb = !0;
  g.vb = !0;
  g.La = .5;
  g.Wa = "";
  g.Aa = null;
  g.ca = null;
  g.ub = !1;
  g.qa = null;
  g.ka = null;
  g.ib = null;
  g.aa = null;
  g.Oa = null;
  g.S = null;
  g.eb = "dialog";
  g.Da = function () {
    return this.j;
  };
  g.setTitle = function (a) {
    this.Wa = a;
    this.ka && Qd(this.ka, a);
  };
  g.getTitle = function () {
    return this.Wa;
  };
  g.getContent = function () {
    return null != this.Aa ? xd(this.Aa) : "";
  };
  g.U = function () {
    this.w() || tf(this);
    return this.Oa;
  };
  g.Ca = function () {
    this.w() || tf(this);
    return Q.A.Ca.call(this);
  };

  function Bf(a, b) {
    var c = ka(a.j + "-title-draggable").split(" ");
    a.w() && (b ? Je(a.qa, c) : Le(a.qa, c));
    b && !a.ca ? (a.ca = new ef(a.w(), a.qa), Je(a.qa, c), L(a.ca, "start", a.jc, !1, a)) : !b && a.ca && (a.ca.Z(), a.ca = null);
  }
  g.va = function () {
    Q.A.va.call(this);
    var a = this.w(),
        b = this.a;
    this.qa = b.b("DIV", this.j + "-title", this.ka = b.b("SPAN", {
      className: this.j + "-title-text",
      id: this.getId()
    }, this.Wa), this.aa = b.b("SPAN", this.j + "-title-close"));
    Od(a, this.qa, this.Oa = b.b("DIV", this.j + "-content"), this.S = b.b("DIV", this.j + "-buttons"));
    Fe(this.ka, "heading");
    Fe(this.aa, "button");
    this.aa.tabIndex = 0;
    Ge(this.aa, "label", Cf);
    this.ib = this.ka.id;
    Fe(a, this.eb);
    Ge(a, "labelledby", this.ib || "");
    this.Aa && (this.Oa.innerHTML = xd(this.Aa));
    P(this.aa, this.ab);
    this.c && (a = this.c, a.ea = this.S, Df(a));
    P(this.S, !!this.c);
    this.La = this.La;
    this.w() && (a = this.Ca()) && $e(a, this.La);
  };
  g.ma = function () {
    Q.A.ma.call(this);
    sf(this).D(this.w(), "keydown", this.cb).D(this.w(), "keypress", this.cb);
    sf(this).D(this.S, "click", this.Eb);
    Bf(this, this.vb);
    sf(this).D(this.aa, "click", this.fc);
    var a = this.w();
    Fe(a, this.eb);
    "" !== this.ka.id && Ge(a, "labelledby", this.ka.id);
    if (!this.bb) {
      this.bb = !1;
      if (this.V) {
        var a = this.a,
            b = this.Ca();
        a.c(this.G);
        a.c(b);
      }
      this.la && xf(this, !1);
    }
  };
  g.ga = function () {
    this.la && this.I(!1);
    Bf(this, !1);
    Q.A.ga.call(this);
  };
  g.I = function (a) {
    a != this.la && (this.V || tf(this), Q.A.I.call(this, a));
  };
  g.Fa = function () {
    Q.A.Fa.call(this);
    N(this, Ef);
  };
  g.Ea = function () {
    Q.A.Ea.call(this);
    N(this, Ff);
    this.ub && this.Z();
  };
  g.jc = function () {
    var a = this.a.a,
        b = Hd(Id(a) || window || window),
        c = Math.max(a.body.scrollWidth, b.width),
        a = Math.max(a.body.scrollHeight, b.height),
        d = Ye(this.w());
    "fixed" == Re(this.w(), "position") ? this.ca.v = new Ne(0, 0, Math.max(0, b.width - d.width), Math.max(0, b.height - d.height)) || new Ne(NaN, NaN, NaN, NaN) : this.ca.v = new Ne(0, 0, c - d.width, a - d.height) || new Ne(NaN, NaN, NaN, NaN);
  };
  g.fc = function () {
    Gf(this);
  };

  function Gf(a) {
    if (a.ab) {
      var b = a.c,
          c = b && b.Na;
      c ? N(a, new Hf(c, Ua(b, c))) && a.I(!1) : a.I(!1);
    }
  }
  g.C = function () {
    this.S = this.aa = null;
    Q.A.C.call(this);
  };

  function If(a, b) {
    a.c = b;
    if (a.S) {
      if (a.c) {
        var c = a.c;
        c.ea = a.S;
        Df(c);
      } else a.S.innerHTML = xd(zd);
      P(a.S, !!a.c);
    }
  }
  g.Eb = function (a) {
    a: {
      for (a = a.target; null != a && a != this.S;) {
        if ("BUTTON" == a.tagName) break a;
        a = a.parentNode;
      }
      a = null;
    }
    a && !a.disabled && (a = a.name, N(this, new Hf(a, Ua(this.c, a))) && this.I(!1));
  };
  g.cb = function (a) {
    var b = !1,
        c = !1,
        d = this.c,
        e = a.target;
    if ("keydown" == a.type) {
      if (this.wb && 27 == a.o) {
        var f = d && d.Na,
            e = "SELECT" == e.tagName && !e.disabled;
        f && !e ? (c = !0, b = N(this, new Hf(f, Ua(d, f)))) : e || (b = !0);
      } else {
        if (9 == a.o && a.B && e == this.w()) {
          this.Ma = !0;
          try {
            this.R.focus();
          } catch (m) {}
          nf(this.fb, this);
        }
      }
    } else if (13 == a.o) {
      if ("BUTTON" == e.tagName && !e.disabled) f = e.name;else if (e == this.aa) Gf(this);else if (d) {
        var h = d.Pa,
            k;
        if (k = h) a: {
          k = d.ea.getElementsByTagName("BUTTON");
          for (var l = 0, n; n = k[l]; l++) {
            if (n.name == h || n.id == h) {
              k = n;
              break a;
            }
          }k = null;
        }
        e = ("TEXTAREA" == e.tagName || "SELECT" == e.tagName || "A" == e.tagName) && !e.disabled;
        !k || k.disabled || e || (f = h);
      }
      f && d && (c = !0, b = N(this, new Hf(f, String(Ua(d, f)))));
    } else e == this.aa && 32 == a.o && Gf(this);
    if (b || c) a.h(), a.b();
    b && this.I(!1);
  };

  function Hf(a, b) {
    this.type = Jf;
    this.key = a;
    this.caption = b;
  }
  w(Hf, id);
  var Jf = "dialogselect",
      Ff = "afterhide",
      Ef = "aftershow";

  function S(a) {
    a || Bd();
    Ra.call(this);
  }
  w(S, Ra);
  g = S.prototype;
  g.xb = "goog-buttonset";
  g.Pa = null;
  g.ea = null;
  g.Na = null;
  g.da = function (a, b, c, d) {
    Ra.prototype.da.call(this, a, b);
    c && (this.Pa = a);
    d && (this.Na = a);
    return this;
  };

  function R(a, b, c, d) {
    return a.da(b.key, b.caption, c, d);
  }

  function Df(a) {
    if (a.ea) {
      a.ea.innerHTML = xd(zd);
      var b = Bd(a.ea);
      a.forEach(function (a, d) {
        var e = b.b("BUTTON", {
          name: d
        }, a);
        d == this.Pa && (e.className = this.xb + "-default");
        this.ea.appendChild(e);
      }, a);
    }
  }
  g.w = function () {
    return this.ea;
  };
  var Cf = "Close",
      zf = {
    key: "ok",
    caption: $pgettext('general', 'OK')
  },
      Af = {
    key: "cancel",
    caption: $pgettext('general', 'Cancel')
  },
      Kf = {
    key: "yes",
    caption: $pgettext('general', 'Yes')
  },
      Lf = {
    key: "no",
    caption: $pgettext('general', 'No')
  },
      Mf = {
    key: "save",
    caption: $pgettext('general', 'Save')
  },
      Nf = {
    key: "continue",
    caption: $pgettext('general', 'Continue')
  };
  "undefined" != typeof document && (R(new S(), zf, !0, !0), R(R(new S(), zf, !0), Af, !1, !0), R(R(new S(), Kf, !0), Lf, !1, !0), R(R(R(new S(), Kf), Lf, !0), Af, !1, !0), R(R(R(new S(), Nf), Mf), Af, !0, !0));
  var Of = /^B\d{13}[NS]\d{8}[EW][AV]\d{10}/gm,
      Pf = /^B\d{6}(\d\d)(\d{5})([NS])(\d{3})(\d{5})([EW])[AV]\d{10}$/;

  function Qf(a) {
    var b = [];
    a = a.match(Of);
    x(a, function (a) {
      a = Pf.exec(a);
      if (null !== a) {
        var d = parseInt(a[1], 10) + parseInt(a[2], 10) / 6E4;
        "S" == a[3] && (d = -d);
        var e = parseInt(a[4], 10) + parseInt(a[5], 10) / 6E4;
        "W" == a[6] && (e = -e);
        b.push(new google.maps.LatLng(d, e));
      }
    });
    return b;
  };
  H && I(8);

  function Rf(a) {
    if (null != a) switch (a.ba) {
      case 1:
        return 1;
      case -1:
        return -1;
      case 0:
        return 0;
    }
    return null;
  }

  function Sf() {
    O.call(this);
  }
  w(Sf, O);
  Sf.prototype.T = xe;

  function T(a) {
    return null != a && a.T === xe ? a : a instanceof vd ? Tf(xd(a), a.b()) : Tf(la(String(String(a))), Rf(a));
  }

  function Uf() {
    O.call(this);
  }
  w(Uf, O);
  Uf.prototype.T = {};
  Uf.prototype.ba = 1;

  function Vf() {
    O.call(this);
  }
  w(Vf, O);
  Vf.prototype.T = ye;
  Vf.prototype.ba = 1;

  function Wf() {
    O.call(this);
  }
  w(Wf, O);
  Wf.prototype.T = {};
  Wf.prototype.ba = 1;

  function Xf() {
    O.call(this);
  }
  w(Xf, O);
  Xf.prototype.T = {};
  Xf.prototype.ba = 1;

  function Yf() {
    O.call(this);
  }
  w(Yf, O);
  Yf.prototype.T = {};
  Yf.prototype.ba = 1;

  function Zf(a) {
    function b(a) {
      this.content = a;
    }
    b.prototype = a.prototype;
    return function (a) {
      return new b(String(a));
    };
  }
  var Tf = function (a) {
    function b(a) {
      this.content = a;
    }
    b.prototype = a.prototype;
    return function (a, d) {
      var e = new b(String(a));
      void 0 !== d && (e.ba = d);
      return e;
    };
  }(Sf);
  Zf(Uf);
  var $f = Zf(Vf);
  Zf(Wf);
  Zf(Xf);
  Zf(Yf);
  (function (a) {
    function b(a) {
      this.content = a;
    }
    b.prototype = a.prototype;
    return function (a, d) {
      var e = String(a);
      if (!e) return "";
      e = new b(e);
      void 0 !== d && (e.ba = d);
      return e;
    };
  })(Sf);

  function U(a) {
    null != a && a.T === xe ? (a = a.getContent(), a = String(a).replace(ag, "").replace(bg, "\x26lt;"), a = String(a).replace(cg, dg)) : a = la(String(a));
    return a;
  }
  var eg = /['()]/g;

  function fg(a) {
    return "%" + a.charCodeAt(0).toString(16);
  }

  function gg(a) {
    null != a && a.T === ye ? a = String(a).replace(hg, ig) : a instanceof rd ? (a = a instanceof rd && a.constructor === rd && a.g === sd ? a.c : "type_error:SafeUrl", a = String(a).replace(hg, ig)) : a instanceof td ? (a = a instanceof td && a.constructor === td && a.g === ud ? a.c : "type_error:TrustedResourceUrl", a = String(a).replace(hg, ig)) : (a = String(a), a = jg.test(a) ? a.replace(hg, ig) : "#zSoyz");
    return a;
  }
  var kg = {
    "\x00": "\x26#0;",
    "\t": "\x26#9;",
    "\n": "\x26#10;",
    "\x0B": "\x26#11;",
    "\f": "\x26#12;",
    "\r": "\x26#13;",
    " ": "\x26#32;",
    '"': "\x26quot;",
    "\x26": "\x26amp;",
    "'": "\x26#39;",
    "-": "\x26#45;",
    "/": "\x26#47;",
    "\x3c": "\x26lt;",
    "\x3d": "\x26#61;",
    "\x3e": "\x26gt;",
    "`": "\x26#96;",
    "\x85": "\x26#133;",
    "\xA0": "\x26#160;",
    "\u2028": "\x26#8232;",
    "\u2029": "\x26#8233;"
  };

  function dg(a) {
    return kg[a];
  }
  var lg = {
    "\x00": "%00",
    "\x01": "%01",
    "\x02": "%02",
    "\x03": "%03",
    "\x04": "%04",
    "\x05": "%05",
    "\x06": "%06",
    "\x07": "%07",
    "\b": "%08",
    "\t": "%09",
    "\n": "%0A",
    "\x0B": "%0B",
    "\f": "%0C",
    "\r": "%0D",
    "\x0E": "%0E",
    "\x0F": "%0F",
    "\x10": "%10",
    "\x11": "%11",
    "\x12": "%12",
    "\x13": "%13",
    "\x14": "%14",
    "\x15": "%15",
    "\x16": "%16",
    "\x17": "%17",
    "\x18": "%18",
    "\x19": "%19",
    "\x1A": "%1A",
    "\x1B": "%1B",
    "\x1C": "%1C",
    "\x1D": "%1D",
    "\x1E": "%1E",
    "\x1F": "%1F",
    " ": "%20",
    '"': "%22",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "\x3c": "%3C",
    "\x3e": "%3E",
    "\\": "%5C",
    "{": "%7B",
    "}": "%7D",
    "\x7F": "%7F",
    "\x85": "%C2%85",
    "\xA0": "%C2%A0",
    "\u2028": "%E2%80%A8",
    "\u2029": "%E2%80%A9",
    "\uFF01": "%EF%BC%81",
    "\uFF03": "%EF%BC%83",
    "\uFF04": "%EF%BC%84",
    "\uFF06": "%EF%BC%86",
    "\uFF07": "%EF%BC%87",
    "\uFF08": "%EF%BC%88",
    "\uFF09": "%EF%BC%89",
    "\uFF0A": "%EF%BC%8A",
    "\uFF0B": "%EF%BC%8B",
    "\uFF0C": "%EF%BC%8C",
    "\uFF0F": "%EF%BC%8F",
    "\uFF1A": "%EF%BC%9A",
    "\uFF1B": "%EF%BC%9B",
    "\uFF1D": "%EF%BC%9D",
    "\uFF1F": "%EF%BC%9F",
    "\uFF20": "%EF%BC%A0",
    "\uFF3B": "%EF%BC%BB",
    "\uFF3D": "%EF%BC%BD"
  };

  function ig(a) {
    return lg[a];
  }
  var cg = /[\x00\x22\x27\x3c\x3e]/g,
      hg = /[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,
      jg = /^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,
      ag = /<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,
      bg = /</g;

  function V(a) {
    google.maps.MVCObject.call(this);
    this.a = new google.maps.FusionTablesLayer({
      suppressInfoWindows: !0
    });
    google.maps.event.addListener(this.a, "click", u(function (a) {
      var c;
      c = De(mg, {
        row: a.row
      }, void 0, new Cd(void 0));
      new google.maps.InfoWindow({
        content: c,
        position: a.latLng
      }).open(this.a.getMap());
    }, this));
    this.a.bindTo("map", this);
    this.setValues(a);
  }
  w(V, google.maps.MVCObject);
  V.prototype.b = function () {
    ng(this);
  };
  V.prototype.fillOpacity_changed = V.prototype.b;
  V.prototype.g = function () {
    ng(this);
  };
  V.prototype.strokeOpacity_changed = V.prototype.g;
  V.prototype.h = function () {
    og(this);
  };
  V.prototype.tableId_changed = V.prototype.h;
  V.prototype.c = function () {
    og(this);
  };
  V.prototype.airspace_changed = V.prototype.c;

  function og(a) {
    var b = {
      select: "geometry"
    };
    b.from = "" + a.get("tableId");
    var c = a.get("airspace");
    q(c) && 0 < c ? b.where = "floor_m \x3c\x3d " + Math.ceil(c) : 0 === c && (b.where = "floor_m \x3c 0");
    a.a.setOptions({
      query: b
    });
  }

  function ng(a) {
    var b = [{
      polygonOptions: {
        fillOpacity: a.get("fillOpacity"),
        strokeOpacity: a.get("strokeOpacity")
      }
    }];
    a.a.setOptions({
      styles: b
    });
  };

  function pg(a) {
    return [a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  var qg = Array(256),
      rg,
      sg,
      tg;
  for (tg = 0; 256 > tg; ++tg) {
    rg = tg;
    for (sg = 0; 8 > sg; ++sg) {
      rg = rg & 1 ? 3988292384 ^ rg >>> 1 : rg >>> 1;
    }qg[tg] = 0 > rg ? 4294967296 + rg : rg;
  }

  function ug(a, b) {
    var c = q(b) ? b : 4294967295,
        d,
        e = a.length;
    for (d = 0; d < e; ++d) {
      c = qg[(c ^ a[d]) & 255] ^ c >>> 8;
    }return c;
  }

  function vg(a, b) {
    var c = ug(a),
        c = ug(b, c) ^ 4294967295;
    return String.fromCharCode.apply(null, [].concat(pg(b.length), a, b, pg(0 > c ? 4294967296 + c : c)));
  }

  function wg(a) {
    if (q(a.toDataURL)) {
      var b = a.toDataURL();
      if ("data:," != b) return b;
    }
    var c = a.getContext("2d").getImageData(0, 0, a.width, a.height);
    a = vg([73, 72, 68, 82], [].concat(pg(c.width), pg(c.height), [8, 6, 0, 0, 0]));
    var b = [q(void 0) ? void 0 : 0],
        d = Array.prototype.slice.call(c.data),
        e = c.height,
        c = 4 * c.width,
        f = Array(2 * e),
        h;
    for (h = 0; h < e; ++h) {
      f[2 * h] = b, f[2 * h + 1] = d.slice(h * c, (h + 1) * c);
    }b = Array.prototype.concat.apply([], f);
    d = Math.floor(b.length / 32768);
    c = b.length % 32768;
    0 === c && (--d, c = 0 === b.length ? 0 : 32768);
    e = Array(2 * d + 3);
    for (f = 0; f < d; ++f) {
      e[2 * f] = [0, 0, 128, 255, 127], e[2 * f + 1] = b.slice(32678 * f, 32768 * (f + 1));
    }e[2 * d] = [1, c & 255, c >> 8, ~c & 255, ~c >> 8 & 255];
    e[2 * d + 1] = b.slice(32768 * d);
    var c = 1,
        f = 0,
        k = b.length;
    for (h = 0; h < k; ++h) {
      c = (c + b[h]) % 65521, f = (f + c) % 65521;
    }e[2 * d + 2] = pg(65536 * f + c);
    return "data:image/png;base64," + window.btoa("\x89PNG\r\n\x1A\n" + a + vg([73, 68, 65, 84], [].concat([120, 1], Array.prototype.concat.apply([], e))) + vg([73, 69, 78, 68], []));
  };

  function xg(a, b) {
    var c = b || {};
    c.draggable = !0;
    c.flat = !0;
    c.raiseOnDrag = !1;
    google.maps.Marker.call(this, c);
    this.a = !1;
    this.bindTo("icon", this, "iconOut");
    this.bindTo("iconOver", a);
    this.bindTo("shape", a);
    this.bindTo("zIndex", a);
    google.maps.event.addListener(this, "mouseout", u(this.b, this));
    google.maps.event.addListener(this, "mouseover", u(this.c, this));
    google.maps.event.addListener(this, "dblclick", u(a.Tb, a, this));
    google.maps.event.addListener(this, "dragstart", u(a.Wb, a, this));
  }
  w(xg, google.maps.Marker);
  xg.prototype.Z = function () {
    this.a || (this.unbindAll(), this.setMap(null), google.maps.event.clearInstanceListeners(this), this.a = !0);
  };
  xg.prototype.wa = function () {
    return this.a;
  };
  xg.prototype.b = function () {
    this.bindTo("icon", this, "iconOut");
  };
  xg.prototype.c = function () {
    this.bindTo("icon", this, "iconOver");
  };

  function W(a, b) {
    google.maps.MVCObject.call(this);
    this.v = !1;
    this.b = -1;
    this.h = null;
    this.a = [];
    this.m = !1;
    this.c = a;
    this.c.bindTo("clickable", this);
    this.c.bindTo("fillColor", this);
    this.c.bindTo("fillOpacity", this);
    this.c.bindTo("geodesic", this);
    this.c.bindTo("map", this);
    this.c.bindTo("strokeColor", this);
    this.c.bindTo("strokeOpacity", this);
    this.c.bindTo("strokeWeight", this);
    this.c.bindTo("zIndex", this);
    this.g = null;
    this.set("moveIconOut", {
      anchor: new google.maps.Point(15.5, 15.5),
      size: new google.maps.Size(31, 31),
      url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAABmJLR0QA/wD/AP+gvaeTAAACu0lEQVRIicXXT2hUVxQG8N9kXpDJRDQVZiwlVtctGFoKggo22BYEg5tQmIVNKlGo0FLaQnGhiLgq3VgIBSGLVHAjbawIbUNJCYZ0MZkJiBuxne78kzaYgpFknEwXM0PHSeZPxpD54G7ePed837v33Pu+R/MI+ulF8AI1msPrdN/np7fo3mzu0A1OLzM7xmmENpP8pTnG8iTn+BFdzRRpq3ywjT2dxBCuljTMge28CtvpHuZgDY5wJ7Ft7KlLnuPJHYaTXPyMNxGtCOl4j76AHATk3uUoOirioh+yd5Izt/lmC4s1BP6vdJKzOVJLzGQYGSURI47wAD0LTC2WjQWmBuhBOEZ8lESGkSVmcqQmOavGSj6HIXqWmMmTzJPMkp5nYrBwtOLYucaID9I7z0SWdCl3iZmhgrCGEc0wUkaeGudzq5e2EpGbfLJMqpSbYcTqrauNKySypNdBvEpAlvQoiXURQ4z4PBNF4shaMXmO1BIwz2/FXlk3wsd5uxpxkTxZIz9SzG+s0crQMVBoklitoDrkECvWqbtlIXR9zZG7fLvAtDpL1gB5/F9+/4vvRulXuAmfu4rDe3nlGkMP+H6Z2TzJxQ0iX2S6dFz/5vrPfLqP3QhC/fRe4osdvNzOs1LWU7IdHMPDItFRnKtDBudD3CgjH4vQXprMEvzD/Y/5qqVvXh7Ykj1fC5ve7ZVo2Tlv7Q23GXf7KjNRRHQ/hwNyASuHSIzzUQMCIjc5+Q4ftLMSkDvIYVW+amvuxxCvvc/J0uQKbTvY9Yg/ZwuOZCs6K0Z0kDdOcGoLkTbyCmp3PuRWigd1hBcEtczJdBLLcHWaC9U83D0ul8xCnuQ9Lqvi4X7lyz+40lDjNehe+0pWKUt6mL4aJau612bRNccPRd9+3Ub59gbxeJrxLMEUv+Bxk3WaQyv/1diAv9T/AHJoJzXJQF33AAAAAElFTkSuQmCC"
    });
    this.set("iconOver", {
      anchor: new google.maps.Point(15.5, 15.5),
      size: new google.maps.Size(31, 31),
      url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAABmJLR0QA/wD/AP+gvaeTAAACOElEQVRIic3XvU+TURQG8J+F6iJaI25KomjiYOwgwU03BhMWTMRENzEpCYaPuIlOjMY/gJ0YWcSIMWHS3UQkqCQGFnEyKFAoCLSvQ1tTSukHNNQnOct5zz3Pvfc993ywdzSeYRGN+/CxNxzl8RSpCE8Omrv+PgsBQRe/ED5I8tufWQ4IvhJHZ1W81jEcIoaG3WzamAoIstLGVBGXDSFidQyXJA8Re0fyKWuXeI7WPJOWV6zkko+xgpY8u9bzjDwiMUEynD5QSTQMkggIkmyNE+9gNkwPIs2MLrCZYC0rC2w2M4pImJ4OZseJJ9kKCAZJKHCThwqxX2Bkhs4QdVndPBvXWZjjmRx9DpLnGHjPydMczipTJC/y4ht3yjk5XH2z/WpTfSzjSol1l7tZSpHKrh1PB2T+ryuOm8xWSFxwAx3MVUQMYXq+86ePJUR3Mbuxiz7azeI8G0d4UDE5Imf5UYQYPhT5Fs2sj1RK3JKJ3t4SdsXIoTfjJ/8Z7kAYndf4NEr8N5vo3yd5/xJbE6x2MC2dCbel4kgDA3f5+ZF4NkrXWK8G+RrrWZ8zLPeweIIhnNLE0mTO0yhC3p4hKyXtu5FnZZJUUzqQHa/Rybf1ATX554Vw4NGej5q989pmuNzc3psuDuXm9uh+c/uOqlbmBqKVVLX/rp4fWCezAyFib0kOFenhxvJ6uJdFeriHrL4ut4erafdaJjqnM337l3RA3aqW43JQ35WZWO7VYGL5N6sdq8GsRhWm1L+mJ24Us5n1HwAAAABJRU5ErkJggg\x3d\x3d"
    });
    this.set("shape", {
      coords: [15.5, 15.5, 15.5],
      type: "circle"
    });
    this.o = Array(64);
    var c;
    for (c = 0; 64 > c; ++c) {
      this.o[c] = yg(2 * Math.PI * c / 64);
    }this.setValues(b);
  }
  w(W, google.maps.MVCObject);

  function zg(a, b) {
    var c = a.getPath();
    if (null != c) {
      var d = a.get("editable");
      c.push(b);
      var e = 2 * c.getLength();
      a.a[e - 3].setPosition(google.maps.geometry.spherical.interpolate(a.getPosition(c, (e - 4) / 2), b, .5));
      d && a.a[e - 3].bindTo("map", a);
      var f;
      f = new xg(a, {
        position: b
      });
      d && f.bindTo("map", a);
      Ag(a, f, 0);
      a.a.push(f);
      f = new xg(a, {
        position: google.maps.geometry.spherical.interpolate(b, a.getPosition(c, 0), .5)
      });
      a.a.push(f);
      Ag(a, f, 1);
      Bg(a, c, e - 3);
      Cg(a, !0);
    }
  }
  W.prototype.Z = function () {
    this.v || (this.unbindAll(), this.set("map", null), x(this.a, hd), google.maps.event.clearInstanceListeners(this));
  };
  W.prototype.j = function () {
    var a = this.getPath();
    if (null != a) {
      var b = this.get("editable"),
          c = 2 * a.getLength();
      x(this.a, function (a, e) {
        b && (e != c - 1 || this.c instanceof google.maps.Polygon) ? a.bindTo("map", this) : (a.unbind("map"), a.setMap(null));
      }, this);
    }
  };
  W.prototype.editable_changed = W.prototype.j;

  function Dg(a) {
    var b = new google.maps.LatLngBounds();
    a = a.getPath();
    null != a && x(a.getArray(), b.extend, b);
    return b;
  }
  W.prototype.getPath = function () {
    return this.c.getPath();
  };
  W.prototype.getPosition = function (a, b) {
    return a.getAt(b);
  };
  W.prototype.B = function () {
    var a = this.get("map");
    null === a ? (this.unbind("projection"), this.set("projection", null)) : this.bindTo("projection", a);
  };
  W.prototype.map_changed = W.prototype.B;
  g = W.prototype;
  g.Ub = function (a) {
    var b = this.getPath();
    if (0 == this.b % 2) {
      var c = b.getLength(),
          d = 2 * c;
      b.setAt(this.b / 2, a.latLng);
      this.a[(this.b + d - 1) % d].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(b, (this.b + d - 2) / 2 % c), a.latLng, .5));
      Bg(this, b, (this.b + d - 1) % d);
      this.a[(this.b + 1) % d].setPosition(google.maps.geometry.spherical.interpolate(a.latLng, this.getPosition(b, (this.b + 2) / 2 % c), .5));
      Bg(this, b, (this.b + 1) % d);
    } else b.setAt((this.b + 1) / 2, a.latLng);
  };
  g.Vb = function (a) {
    google.maps.event.removeListener(this.h);
    this.h = null;
    if (1 == this.b % 2) {
      var b;
      b = this.a[this.b];
      Ag(this, b, 0);
      var c = this.getPath();
      if (null == c) return;
      var d = c.getLength();
      b = new xg(this, {
        position: google.maps.geometry.spherical.interpolate(this.getPosition(c, (this.b - 1) / 2), a.latLng, .5)
      });
      Ag(this, b, 1);
      b.bindTo("map", this);
      Fa(this.a, this.b, 0, b);
      b = new xg(this, {
        position: google.maps.geometry.spherical.interpolate(a.latLng, this.getPosition(c, (this.b + 3) / 2 % d), .5)
      });
      Ag(this, b, 1);
      b.bindTo("map", this);
      Fa(this.a, this.b + 2, 0, b);
      Bg(this, c, this.b);
      Bg(this, c, this.b + 2);
    }
    this.b = -1;
  };
  g.Wb = function (a) {
    var b = this.getPath();
    null != b && (this.b = ya(this.a, a), 1 == this.b % 2 && b.insertAt((this.b + 1) / 2, a.getPosition()), this.h = google.maps.event.addListener(a, "drag", u(this.Ub, this)), google.maps.event.addListenerOnce(a, "dragend", u(this.Vb, this)), Cg(this, !0));
  };
  g.Tb = function (a) {
    a = ya(this.a, a);
    if (0 == a % 2) {
      var b = this.getPath(),
          c = b.getLength();
      if (this.c instanceof google.maps.Polygon) {
        if (4 > c) return;
      } else if (3 > c) return;
      var d = 2 * c;
      0 === a ? (this.a[d - 1].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(b, c - 1), this.getPosition(b, 1), .5)), c = Fa(this.a, 0, 2), b.removeAt(0), Bg(this, b, 1), Bg(this, b, d - 3)) : (this.a[a + 1].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(b, (a - 2) / 2), this.getPosition(b, (a + 2) / 2 % c), .5)), c = Fa(this.a, a - 1, 2), b.removeAt(a / 2), Bg(this, b, a - 1), Bg(this, b, (a + 1) % (d - 2)));
      x(c, hd);
    }
  };
  g.hc = function () {
    this.g = this.get("projection");
    var a = this.getPath();
    if (null !== this.g && null != a) {
      var b = 2 * a.getLength(),
          c;
      for (c = 1; c < b; c += 2) {
        Bg(this, a, c);
      }
    }
  };
  W.prototype.projection_changed = W.prototype.hc;
  W.prototype.setAt = function (a, b) {
    var c = this.getPath(),
        d = c.getLength(),
        e = 2 * d;
    c.setAt(a, b);
    this.a[(2 * a + e - 1) % e].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(c, (2 * a + e - 2) / 2 % d), b, .5));
    this.a[2 * a].setPosition(b);
    this.a[(2 * a + 1) % e].setPosition(google.maps.geometry.spherical.interpolate(b, this.getPosition(c, (a + 1) % d), .5));
  };

  function Cg(a, b) {
    b && !a.m && google.maps.event.trigger(a, "first_modified");
    a.m = b;
  }
  W.prototype.setPath = function (a) {
    this.c.setPath(a);
    x(this.a, hd);
    a = this.getPath();
    if (null != a) {
      var b = a.getLength(),
          c = 2 * b,
          d,
          e,
          f;
      this.a = Array(c);
      for (d = 0; d < c; ++d) {
        0 == d % 2 ? f = this.getPosition(a, d / 2) : f = google.maps.geometry.spherical.interpolate(this.getPosition(a, (d - 1) / 2), this.getPosition(a, (d + 1) / 2 % b), .5), e = new xg(this, {
          position: f
        }), this.a[d] = e, 0 === d % 2 ? Ag(this, e, 0) : (Ag(this, e, 1), Bg(this, a, d));
      }this.j();
    } else this.a = [];
  };

  function Ag(a, b, c) {
    0 == c ? b.bindTo("iconOut", a, "moveIconOut") : b.unbind("iconOut");
  }

  function Eg(a, b) {
    var c = 0;
    x(a.a, function (a, e) {
      0 === e % 2 || null !== this.b && this.b == e ? (a.getTitle() != b[c] && a.setTitle(b[c]), c += 1) : "" !== a.getTitle() && a.setTitle("");
    }, a);
  }

  function Bg(a, b, c) {
    if (null != a.g) {
      var d = b.getLength(),
          e = a.g.fromLatLngToPoint(a.getPosition(b, (c - 1) / 2));
      b = a.g.fromLatLngToPoint(a.getPosition(b, (c + 1) / 2 % d));
      e = a.o[Math.floor(64 * (Math.atan2(b.y - e.y, b.x - e.x) + Math.PI) / (2 * Math.PI) + .5) % 64];
      a.a[c].get("iconOut") != e && a.a[c].set("iconOut", e);
    }
  }

  function yg(a) {
    var b = Kd("canvas", {
      height: 31,
      width: 31
    }),
        c = b.getContext("2d"),
        d = [new J(-1, 0), new J(1, 1), new J(.5, 0), new J(1, -1)],
        e = Math.cos(a),
        f = Math.sin(a);
    c.beginPath();
    x(d, function (a, b) {
      var d = 15.5 + 7 * (a.x * e - a.y * f),
          n = 15.5 + 7 * (a.x * f + a.y * e);
      0 === b ? c.moveTo(d, n) : c.lineTo(d, n);
    });
    c.closePath();
    c.fillStyle = "#ff0000"; // fleche
    c.fill();
    return {
      anchor: new google.maps.Point(16, 16),
      size: new google.maps.Size(31, 31),
      url: wg(b)
    };
  }

  function Fg(a) {
    W.call(this, new google.maps.Polyline(), a);
  }
  w(Fg, W);

  function Gg(a, b) {
    M.call(this);
    var c = this.a = a,
        c = da(c) && 1 == c.nodeType ? this.a : this.a ? this.a.body : null;
    this.j = !!c && af(c);
    this.b = L(this.a, Rc ? "DOMMouseScroll" : "mousewheel", this, b);
  }
  w(Gg, M);
  Gg.prototype.handleEvent = function (a) {
    var b = 0,
        c = 0,
        d = 0;
    a = a.c;
    if ("mousewheel" == a.type) {
      c = 1;
      if (H || Sc && (Uc || I("532.0"))) c = 40;
      d = Hg(-a.wheelDelta, c);
      q(a.wheelDeltaX) ? (b = Hg(-a.wheelDeltaX, c), c = Hg(-a.wheelDeltaY, c)) : c = d;
    } else d = a.detail, 100 < d ? d = 3 : -100 > d && (d = -3), q(a.axis) && a.axis === a.HORIZONTAL_AXIS ? b = d : c = d;
    "number" == typeof this.c && (b = Math.min(Math.max(b, -this.c), this.c));
    "number" == typeof this.h && (c = Math.min(Math.max(c, -this.h), this.h));
    this.j && (b = -b);
    b = new Ig(d, a, b, c);
    N(this, b);
  };

  function Hg(a, b) {
    return Sc && (Tc || Vc) && 0 != a % b ? a : a / b;
  }
  Gg.prototype.C = function () {
    Gg.A.C.call(this);
    ne(this.b);
    this.b = null;
  };

  function Ig(a, b, c, d) {
    ld.call(this, b);
    this.type = "mousewheel";
    this.detail = a;
    this.m = c;
    this.g = d;
  }
  w(Ig, ld);
  var Jg = function () {
    var a = [{
      innerHTML: "Skyways",
      t: "all",
      jb: "skyways"
    }];
    x(["January", "April", "July", "October"], function (b) {
      x(["04", "07", "10"], function (c) {
        a.push({
          innerHTML: b + "\x3cbr\x3esunrise +" + parseInt(c, 10) + "h",
          t: b.substr(0, 3) + "_" + c,
          jb: "thermals"
        });
      });
    });
    return a;
  }();

  function X(a, b) {
    google.maps.MVCObject.call(this);
    this.O = a;
    this.a = K("control_airspace", a);
    L(this.a, "click", this.Cb, !1, this);
    L(new Gg(this.a), "mousewheel", this.Db, !1, this);
    L(this.a, "mousemove", v(this.Ha, this.a));
    this.j = K("control_distance", a);
    this.b = K("control_duration", a);
    L(this.b, "click", this.Kb, !1, this);
    L(new Gg(this.b), "mousewheel", this.Lb, !1, this);
    L(this.b, "mousemove", v(this.Ha, this.b));
    this.F = K("control_collapse", a);
    this.o = K("control_expand", a);
    this.v = K("control_multiplier", a);
    this.B = K("control_points", a);
    this.c = K("control_speed", a);
    L(this.c, "click", this.bc, !1, this);
    L(new Gg(this.c), "mousewheel", this.cc, !1, this);
    L(this.c, "mousemove", v(this.Ha, this.c));
    this.g = K("control_thermals", a);
    L(this.g, "click", this.dc, !1, this);
    L(new Gg(this.g), "mousewheel", this.ec, !1, this);
    L(this.g, "mousemove", v(this.Ha, this.g));
    this.m = -1;
    x([this.j, this.v, this.B], u(function (a) {
      L(a, "click", this.ra, !1, this);
    }, this));
    L(this.F, "click", v(this.h, 0), !1, this);
    L(this.o, "click", v(this.h, 1), !1, this);
    /Android|iPad|iPhone|iPod/.test(Mc) ? this.h(0) : this.h(1);
    var c = b || {};
    A(c, "airspace", 0);
    A(c, "altitudeUnit", Db);
    A(c, "distance", 0);
    A(c, "distanceUnit", Bb);
    A(c, "constraint", new Ob(null, 2E4 / 3600));
    A(c, "flownDistance", 0);
    A(c, "multiplier", 1);
    A(c, "points", 0);
    A(c, "speedUnit", Cb);
    A(c, "thermals", -1);
    this.setValues(c);
  }
  w(X, google.maps.MVCObject);
  X.prototype.sa = function () {
    Kg(this);
  };
  X.prototype.airspace_changed = X.prototype.sa;
  X.prototype.H = function () {
    Kg(this);
  };
  X.prototype.altitudeUnit_changed = X.prototype.H;
  X.prototype.K = function () {
    Lg(this);
  };
  X.prototype.constraint_changed = X.prototype.K;
  X.prototype.M = function () {
    Mg(this);
  };
  X.prototype.distance_changed = X.prototype.M;
  X.prototype.L = function () {
    Mg(this);
  };
  X.prototype.distanceUnit_changed = X.prototype.L;
  X.prototype.X = function () {
    Lg(this);
  };
  X.prototype.flownDistance_changed = X.prototype.X;
  X.prototype.Y = function () {
    var a = this.get("multiplier");
    Qd(this.v.children[1], "\xD7" + a.toString());
  };
  X.prototype.multiplier_changed = X.prototype.Y;
  X.prototype.wa = function () {
    var a = this.get("name");
    Qd(this.j.children[0], a);
  };
  X.prototype.name_changed = X.prototype.wa;

  function Ng(a, b, c) {
    var d;
    d = a.get("altitudeUnit") === Ab ? .3048 * (c ? 100 : 500) : c ? 50 : 250;
    c = a.get("airspace");
    b = Og(c, b, d);
    b = Math.min(Math.max(b, 0), 9999);
    b != c && a.set("airspace", b);
  }

  function Pg(a, b, c) {
    c = 60 * (c ? 5 : 15);
    var d = a.get("constraint"),
        e;
    null === d.a ? (e = a.get("flownDistance"), e = null === d.a ? e / d.b : d.a) : e = d.a;
    e = Og(e, b, c);
    e < c && (e = c);
    e != d.a && (d.a = e, d.b = null, a.notify("constraint"));
  }

  function Qg(a, b, c) {
    c = a.get("speedUnit") === Fb ? (c ? 160.9344 : 1609.344) / 3600 : (c ? 100 : 1E3) / 3600;
    var d = a.get("constraint"),
        e;
    null === d.b ? (e = a.get("flownDistance"), e = null === d.b ? e / d.a : d.b) : e = d.b;
    e = Og(e, b, c);
    e < c && (e = c);
    e != d.b && (d.a = null, d.b = e, a.notify("constraint"));
  }

  function Rg(a, b) {
    var c = a.get("thermals");
    a.set("thermals", Qa(c + 1 + b, Jg.length + 1) - 1);
  }
  g = X.prototype;
  g.Cb = function (a) {
    a = Ve(a, this.a).x / Ye(this.a).width;
    Ng(this, .5 <= a, !1);
  };
  g.Db = function (a) {
    a.b();
    0 !== a.g ? Ng(this, 0 > a.g, !1) : 0 !== a.m && Ng(this, 0 < a.m, !0);
  };
  g.Ha = function (a, b) {
    var c = Ve(b, a).x / Ye(a).width;
    if (t("cursor")) Oe(a, .5 > c ? "s-resize" : "n-resize", "cursor");else for (var d in "cursor") {
      Oe(a, "cursor"[d], d);
    }
  };
  g.Kb = function (a) {
    a = Ve(a, this.b).x / Ye(this.b).width;
    Pg(this, .5 <= a, !1);
  };
  g.Lb = function (a) {
    a.b();
    0 !== a.g ? Pg(this, 0 > a.g, !1) : 0 !== a.m && Pg(this, 0 < a.m, !0);
  };
  g.bc = function (a) {
    a = Ve(a, this.c).x / Ye(this.c).width;
    Qg(this, .5 <= a, !1);
  };
  g.cc = function (a) {
    a.b();
    0 !== a.g ? Qg(this, 0 > a.g, !1) : 0 !== a.m && Qg(this, 0 < a.m, !0);
  };
  g.dc = function (a) {
    a = Ve(a, this.g).x / Ye(this.g).width;
    Rg(this, .5 <= a ? 1 : -1);
  };
  g.ec = function (a) {
    a.b();
    0 !== a.g && Rg(this, 0 < a.g ? -1 : 1);
  };
  g.ic = function () {
    var a = this.get("points").toFixed(1).split(".", 2),
        b = this.B.children[1].children;
    Qd(b[0], a[0]);
    Qd(b[1], "." + a[1]);
  };
  X.prototype.points_changed = X.prototype.ic;
  X.prototype.h = function (a, b) {
    q(b) && b.h();
    if (this.m != a) {
      var c = 1 == a,
          d = this.O.children,
          d = Ga(d, 1, d.length - 1);
      x(d, function (a) {
        P(a, c);
      });
      P(this.o, !c);
      this.m = a;
    }
  };
  X.prototype.fa = function () {
    Lg(this);
  };
  X.prototype.speedUnit_changed = X.prototype.fa;
  X.prototype.Ka = function () {
    Sg(this);
  };
  X.prototype.thermals_changed = X.prototype.Ka;
  X.prototype.ra = function (a) {
    a.h();
    0 == this.m ? this.h(1) : this.h(0);
  };

  function Kg(a) {
    var b = a.get("airspace");
    1E-4 < b ? (b = a.get("altitudeUnit")(b), b = b[0] + b[1]) : b = "OFF";
    Qd(a.a.children[1], b);
  }

  function Mg(a) {
    var b = a.get("distance"),
        c = a.get("distanceUnit");
    q(b) && q(c) && (b = c(b)[0].split(".", 2), a = a.j.children[1].children, Qd(a[0], b[0]), Qd(a[1], "." + b[1]));
  }

  function Lg(a) {
    var b = a.get("constraint"),
        c = a.get("flownDistance"),
        d = a.get("speedUnit");
    if (q(b) && q(c) && q(d)) {
      var e = null === b.a ? c / b.b : b.a;
      Qd(a.b.children[1], Math.floor(e / 3600) + ":" + ua(Math.floor(e / 60 % 60), 2));
      b = d(null === b.b ? c / b.a : b.b)[0].split(".", 2);
      a = a.c.children[1].children;
      Qd(a[0], b[0]);
      Qd(a[1], "." + b[1]);
    }
  }

  function Sg(a) {
    var b = a.get("thermals"),
        c;
    0 > b ? (c = "OFF", b = null) : (c = Jg[b].innerHTML, b = new google.maps.ImageMapType({
      getTileUrl: v(function (a, b, c) {
        var h = new B("https://thermal.kk7.ch/php/tile.php"),
            k = h.b;
        D(k, "src", "meteo-parapente.com");
        D(k, "t", a.t);
        D(k, "typ", a.jb);
        a = 1 << c;
        D(k, "x", Qa(b.x, a));
        D(k, "y", Qa(a - b.y - 1, a));
        D(k, "z", c);
        return h.toString();
      }, Jg[b]),
      opacity: .5,
      tileSize: new google.maps.Size(256, 256)
    }));
    a.g.children[1].innerHTML = c;
    a.set("thermalLayer", b);
  }

  function Og(a, b, c) {
    var d = Math.floor(a / c);
    a = a / c % 1;
    return b ? 1E-4 > 1 - a ? c * (d + 2) : c * (d + 1) : 1E-4 > a ? c * (d - 1) : c * d;
  };

  function Tg(a, b) {
    for (var c = a.length, d = Array(c), e = 0; e < c; ++e) {
      d[e] = b.call(void 0, a[e], a[(e + 1) % c], e, a);
    }return d;
  };

  function Ug(a) {
    if (3 > a.length) return 0;
    a = Tg(a, function (a, c) {
      return new google.maps.Point(a.x - c.x, a.y - c.y);
    });
    a = Tg(a, function (a, c) {
      return a.x * c.y - a.y * c.x;
    });
    a = Aa(a, function (a, c) {
      return {
        min: Math.min(a.min, c),
        max: Math.max(a.max, c)
      };
    }, {
      min: a[0],
      max: a[0]
    });
    return 0 > a.max ? -1 : 0 < a.min ? 1 : 0;
  }

  function Vg(a) {
    var b = Ug(a);
    if (0 == b) return [];
    var c = new google.maps.Point(a[1].x - a[0].x, a[1].y - a[0].y),
        d = b * Math.atan2(c.y, c.x),
        e,
        f,
        h,
        c = Math.sqrt(c.x * c.x + c.y * c.y),
        k = Array(49);
    for (f = 28; 44 > f; ++f) {
      e = c * f / 28, h = c * (72 - f) / 28, e = (h * h + c * c - e * e) / (2 * c), h = Math.sqrt(h * h - e * e), k[f - 28] = new google.maps.Point(a[0].x + e * Math.cos(d) - h * Math.sin(d), a[0].y + b * (e * Math.sin(d) + h * Math.cos(d)));
    }for (f = 28; 44 > f; ++f) {
      e = c * (72 - f) / f, h = 28 * c / f, e = (h * h + c * c - e * e) / (2 * c), h = Math.sqrt(h * h - e * e), k[16 + f - 28] = new google.maps.Point(a[0].x + e * Math.cos(d) - h * Math.sin(d), a[0].y + b * (e * Math.sin(d) + h * Math.cos(d)));
    }for (f = 44; 28 <= f; --f) {
      e = 28 * c / f, h = c * (72 - f) / f, e = (h * h + c * c - e * e) / (2 * c), h = Math.sqrt(h * h - e * e), k[76 - f] = new google.maps.Point(a[0].x + e * Math.cos(d) - h * Math.sin(d), a[0].y + b * (e * Math.sin(d) + h * Math.cos(d)));
    }return k;
  };

  function Wg(a) {
    google.maps.MVCObject.call(this);
    this.b = 0;
    this.a = [null, null, null];
    this.g = Array(3);
    var b, c;
    for (b = 0; 3 > b; ++b) {
      c = new google.maps.Polygon({
        clickable: !1
      }), c.bindTo("fillColor", this, "fillColor" + (b + 1)), c.bindTo("fillOpacity", this), c.bindTo("map", this), c.bindTo("strokeColor", this, "strokeColor" + (b + 1)), c.bindTo("strokeOpacity", this), c.bindTo("strokeWeight", this), c.bindTo("zIndex", this), this.g[b] = c;
    }this.c = !1;
    this.setValues(a);
  }
  w(Wg, google.maps.MVCObject);
  Wg.prototype.h = function () {
    var a = this.get("map");
    null != a ? this.bindTo("projection", a) : this.unbind("projection");
  };
  Wg.prototype.map_changed = Wg.prototype.h;
  Wg.prototype.j = function () {
    Xg(this);
  };
  Wg.prototype.projection_changed = Wg.prototype.j;
  Wg.prototype.setAt = function (a, b) {
    null !== this.a[a] && this.a[a].equals(b) || (this.a[a] = b, Xg(this));
  };

  function Xg(a) {
    if (a.b) a.c = !0;else {
      a.c = !1;
      var b = a.get("map");
      if (null != b) {
        var c = b.getProjection();
        null != c && (b = z(a.a, function (a) {
          return c.fromLatLngToPoint(a);
        }), x([Vg([b[0], b[1], b[2]]), Vg([b[1], b[2], b[0]]), Vg([b[2], b[0], b[1]])], u(function (a, b) {
          this.g[b].setPath(z(a, function (a) {
            return c.fromPointToLatLng(a);
          }));
        }, a)));
      }
    }
  };

  function zc(a, b, c) {
    var d;
    d = google.maps.geometry.spherical.computeDistanceBetween(a, c, 6371E3);
    b = google.maps.geometry.spherical.computeHeading(a, b);
    a = google.maps.geometry.spherical.computeHeading(a, c);
    return 6371E3 * Math.asin(Math.sin(d / 6371E3) * Math.sin(Math.PI * (a - b) / 180));
  };

  function Y(a) {
    google.maps.MVCObject.call(this);
    this.a = new google.maps.Polygon({
      clickable: !1
    });
    this.a.bindTo("fillColor", this);
    this.a.bindTo("fillOpacity", this);
    this.a.bindTo("map", this);
    this.a.bindTo("strokeColor", this);
    this.a.bindTo("strokeOpacity", this);
    this.a.bindTo("strokeWeight", this);
    this.a.bindTo("zIndex", this);
    this.setValues(a);
  }
  w(Y, google.maps.MVCObject);
  Y.prototype.b = function () {
    Yg(this);
  };
  Y.prototype.center_changed = Y.prototype.b;
  Y.prototype.getCenter = function () {
    return this.get("center");
  };
  Y.prototype.c = function () {
    Yg(this);
  };
  Y.prototype.heading_changed = Y.prototype.c;
  Y.prototype.g = function () {
    Yg(this);
  };
  Y.prototype.radius_changed = Y.prototype.g;

  function Yg(a) {
    var b = a.get("heading") || 0,
        c = a.getCenter(),
        d = a.get("radius") || 0;
    if (null != c) {
      for (var e = Array(34), f = 0; 32 >= f; ++f) {
        e[f] = google.maps.geometry.spherical.computeOffset(c, d, b + 60 * (f / 32 - .5), 6371E3);
      }e[33] = c;
      a.a.setPath(e);
    }
  };

  function Zg() {
    return Tf('\x3cdiv\x3e\x3cdiv\x3eXC Planner 2.0-mp\x3c/div\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Original version') + ' \x26copy; Tom Payne \x26lt;\x3ca href\x3d"mailto:twpayne@gmail.com"\x3etwpayne@gmail.com\x3c/a\x3e\x26gt;, 2009-2015\x3c/div\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!') + '\x3c/div\x3e\x3c/div\x3e');
    /* return Tf('\x3cdiv\x3e\x3cdiv\x3eXC Planner version 2.0-mp\x3c/div\x3e\x3cdiv\x3eCopyright \x26copy; Tom Payne \x26lt;\x3ca href\x3d"mailto:twpayne@gmail.com"\x3etwpayne@gmail.com\x3c/a\x3e\x26gt;, 2009-2015\x3c/div\x3e\x3cdiv\x3eCopyright \x26copy; Meteo-Parapente, 2019\x3c/div\x3e\x3cdiv\x3eThank you Tom for letting us include XCPlanner in Meteo-Parapente!\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3eAirspace data\x3c/div\x3e\x3cdiv\x3eCourtesy of \x3ca href\x3d"http://www.openaip.net/"\x3eopenAIP.net\x3c/a\x3e\x3c/div\x3e\x3cdiv\x3eVisit \x3ca href\x3d"http://www.openaip.net/"\x3eopenAIP.net\x3c/a\x3e and contribute to better aviation data, free for everyone to use and share.\x3c/div\x3e\x3cdiv\x3eCourtesy of \x3ca href\x3d"http://soaringweb.org/Airspace/" target\x3d"_blank"\x3eWorldwide Soaring Turnpoint Exchange\x3c/a\x3e.\x3c/div\x3e\x3cdiv\x3eAll data and information contained in any of the data files are provided without guarantee as to their completeness or correctness.   Any conclusions drawn from these data and information are the sole responsibility of the user.\x3c/div\x3e\x3cdiv\x3eThis information may not be accurate or current and is not valid for navigation or flight planning.   No warranty of fitness for any purpose is made or implied.   Always consult the official publications for current and correct information.   This service is provided free of charge with no warrantees, expressed or implied.\x3c/div\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3eThermal data\x3c/div\x3e\x3cdiv\x3eCourtesy of \x3ca href\x3d"https://thermal.kk7.ch/" target\x3d"_blank"\x3eParaglidingNet\x3c/a\x3e.\x3c/a\x3e\x3cdiv\x3eAll ParaglidingNet Thermal Maps are licensed under a Creative Commons Attribution-NonCommercial-ShareAlike 3.0 Unported License by Michael von K\u00e4nel (info ...at... kk7. ch).\x3c/div\x3e\x3c/div\x3e') */
  }

  function mg(a) {
    return Tf("\x3cdiv style\x3d'width: 250px'\x3e\x3cb\x3eClass:\x3c/b\x3e " + T(a.row["class"].value) + "\x3cbr\x3e\x3cb\x3eName:\x3c/b\x3e " + T(a.row.name.value) + "\x3cbr\x3e\x3cb\x3eFloor:\x3c/b\x3e " + T(a.row.floor.value) + "\x3cbr\x3e\x3cb\x3eCeiling:\x3c/b\x3e " + T(a.row.ceiling.value) + "\x3cbr\x3e\x3cb\x3eCountry:\x3c/b\x3e " + T(a.row.country.value) + "\x3cbr\x3e\x3c/div\x3e");
  }

  function $g() {
    return Tf('\x3cdiv class\x3d"control"\x3e\x3cdiv class\x3d"control_distance"\x3e\x3cdiv\x3e\x3c/div\x3e\x3cdiv\x3e\x3cspan class\x3d"large"\x3e\x3c/span\x3e\x3cspan class\x3d"large secondary"\x3e\x3c/span\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_multiplier"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Multiplier') + '\x3c/div\x3e\x3cdiv class\x3d"large"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_points"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Points') + '\x3c/div\x3e\x3cdiv\x3e\x3cspan class\x3d"large"\x3e\x3c/span\x3e\x3cspan class\x3d"large secondary"\x3e\x3c/span\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_duration"\x3e\x3cdiv\x3e\x3cspan\x3e' + $pgettext('xc planner', 'Duration') + '\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg alt\x3d"Reduce duration" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg alt\x3d"Increase duration" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"large"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_speed"\x3e\x3cdiv\x3e\x3cspan\x3e' + $pgettext('xc planner', 'Speed') + '\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg alt\x3d"Reduce speed" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg alt\x3d"Increase speed" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cspan class\x3d"large"\x3e\x3c/span\x3e\x3cspan class\x3d"large secondary"\x3e\x3c/span\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_airspace hidden"\x3e\x3cdiv\x3e\x3cspan\x3eAirspace\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg alt\x3d"Reduce airspace ceiling" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg alt\x3d"Increase airspace ceiling" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"large"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_thermals hidden"\x3e\x3cdiv\x3e\x3cspan\x3eThermals\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"medium"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_close_flight"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Close flight') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_reset"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Reset') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_share"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Share') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_download"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Download') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_preferences"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Preferences') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_about"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'About') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_collapse"\x3e\x3cimg height\x3d"3" width\x3d"5" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADAQAAAABzTfhVAAAADklEQVQImWO4wdDBwAAABdYBYfESkFcAAAAASUVORK5CYII\x3d"\x3e\x3c/div\x3e\x3cdiv class\x3d"control_expand"\x3e\x3cimg height\x3d"3" width\x3d"5" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADAQAAAABzTfhVAAAADklEQVQImWNgYOhguAEAAnYBYaFuVa4AAAAASUVORK5CYII\x3d"\x3e\x3c/div\x3e\x3c/div\x3e');
  }

  function ah() {
    return Tf('\x3cinput class\x3d"go_to_input" type\x3d"search"\x3e');
  }

  function bh(a) {
    for (var b = '\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'League') + '\x3c/div\x3e\x3cselect name\x3d"league" class\x3d"league_select"\x3e', c = a.pb, d = c.length, e = 0; e < d; e++) {
      var f = c[e],
          b = b + ('\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e");
    }b += '\x3c/select\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Distance units') + '\x3c/div\x3e\x3cselect name\x3d"distanceUnit" class\x3d"distanceUnit_select"\x3e';
    c = a.mb;
    d = c.length;
    for (e = 0; e < d; e++) {
      f = c[e], b += '\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e";
    }b += '\x3c/select\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Altitude units') + '\x3c/div\x3e\x3cselect name\x3d"altitudeUnit" class\x3d"altitudeUnit_select"\x3e';
    c = a.kb;
    d = c.length;
    for (e = 0; e < d; e++) {
      f = c[e], b += '\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e";
    }b += '\x3c/select\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Coordinates format') + '\x3c/div\x3e\x3cselect name\x3d"coordinateUnit" class\x3d"coordinateUnit_select"\x3e';
    a = a.lb;
    c = a.length;
    for (d = 0; d < c; d++) {
      e = a[d], b += '\x3coption value\x3d"' + U(e.value) + '" ' + (e.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(e.label) + "\x3c/option\x3e";
    }return Tf(b + "\x3c/select\x3e\x3c/div\x3e");
  }

  function ch() {
    return Tf("\x3cdiv\x3e" + $pgettext('xc planner', 'Press Reset to reset your route permanently, press Cancel to keep you route.') + "\x3c/div\x3e");
  }

  function dh(a) {
    for (var b = "\x3cdiv\x3e\x3cdiv\x3e" + $pgettext('xc planner', 'Turnpoint details') + "\x3c/div\x3e\x3ctable\x3e", c = a.waypoints, d = c.length, e = 0; e < d; e++) {
      for (var f = c[e], b = b + ("\x3ctr\x3e\x3ctd\x3e" + T(f.id) + "\x3c/td\x3e"), h = f.coords, k = h.length, l = 0; l < k; l++) {
        for (var n = h[l], m = n.length, r = 0; r < m; r++) {
          var y = n[r],
              b = b + ('\x3ctd class\x3d"' + (0 == r ? "first_coordinate_element" : "coordinate_element") + '"\x3e' + T(y[0]) + T(y[1]) + "\x3c/td\x3e");
        }
      }b += '\x3ctd class\x3d"first_coordinate_element"\x3e' + T(f.elevation[0]) + T(f.elevation[1]) + "\x3c/td\x3e\x3c/tr\x3e";
    }
    b += '\x3c/table\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Download') + '\x3c/div\x3e\x3cform action\x3d"https://xcplanner.appspot.com/geojson2file" target="_blank" class\x3d"download_form" method\x3d"post"\x3e\x3ctable\x3e\x3ctr\x3e\x3ctd\x3e\x3clabel for\x3d"format"\x3e' + $pgettext('xc planner', 'Format') + '\x3c/label\x3e\x3c/td\x3e\x3ctd\x3e\x3cselect name\x3d"format" class\x3d"downloadFormat_select"\x3e';
    c = a.nb;
    d = c.length;
    for (e = 0; e < d; e++) {
      f = c[e], b += '\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e";
    }b += '\x3c/select\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd\x3e\x3clabel for\x3d"routename"\x3e' + $pgettext('xc planner', 'Route name') + '\x3c/label\x3e\x3c/td\x3e\x3ctd\x3e\x3cinput name\x3d"routename" type\x3d"text" value\x3d"' + U(a.qb) + '"\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd\x3e\x3clabel for\x3d"waypointprefix"\x3e' + $pgettext('xc planner', 'Waypoint prefix') + '\x3c/label\x3e\x3c/td\x3e\x3ctd\x3e\x3cinput name\x3d"waypointprefix" type\x3d"text" value\x3d"' + U(a.rb) + '"\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3cinput name\x3d"geojson" type\x3d"hidden" value\x3d"' + U(a.ob) + '"\x3e\x3c/form\x3e\x3c/div\x3e';
    return Tf(b);
  }

  function eh(a) {
    var b = Tf,
        c = '\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Lien') + '\x3c/div\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Paste link in email or IM') + '\x3cbr\x3e\x3cinput type\x3d"text" class\x3d"link_input" value\x3d"' + U(a.href) + '" style\x3d"width: 100%;"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Static image') + '\x3c/div\x3e\x3cdiv\x3e\x3cinput type\x3d"text" class\x3d"link_input" value\x3d"' + U(a.lc) + '" style\x3d"width: 100%;"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3ca href\x3d"' + U(gg(a.nc)) + '"\x3e' + $pgettext('xc planner', 'Open with XCTrack') + '\x3c/a\x3e\x3c/div\x3e\x3cdiv\x3e\x3ca href\x3d"' + U(gg(a.Ab)) + '"\x3e' + $pgettext('xc planner', 'Share with LocToMe: set as default route') + '\x3c/a\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3eQR Code\x3c/div\x3e\x3cdiv\x3e\x3cimg src\x3d"https://xcplanner.appspot.com/qrcode?level\x3dL\x26text\x3d',
        d;
    d = encodeURIComponent(String(String(a.href)));
    eg.lastIndex = 0;
    d = eg.test(d) ? d.replace(eg, fg) : d;
    return b(c + d + '" width\x3d"' + U(a.width) + '" height\x3d"' + U(a.height) + '"/\x3e\x3c/div\x3e\x3c/div\x3e');
  };
  var fh = "formatgeo compegps gpx kml lk8000 oziexplorer seeyou xcsoar".split(" "),
      gh = "FormatGEO (GpsDump);CompeGPS;GPX;KML (Google Earth);LK8000;OziExplorer;SeeYou;XCSoar".split(";"),
      hh = ["#ff6600", "#ff9933", "#ffcc00", "#ffff00"],
      ih = {
    key: "close",
    caption: $pgettext('general', 'Close')
  },
      jh = {
    key: "download",
    caption: $pgettext('general', 'Download')
  },
      kh = {
    key: "go_to",
    caption: $pgettext('general', 'Go to')
  },
      lh = {
    key: "reset",
    caption: $pgettext('general', 'Reset')
  };

  function mh(a, b) {
    google.maps.event.addListenerOnce(a, 'idle', function () {
      mapReady(a);
    });
    google.maps.MVCObject.call(this);
    this.setValues({
      airspace: b.sb || 0,
      altitudeUnit: b.xa || Db,
      coordinateUnit: b.Ya || Gb,
      distance: 0,
      distanceUnit: b.Za || Bb,
      constraint: b.Xa || new Ob(null, 2E4 / 3600),
      downloadFormat: b.tc || "formatgeo",
      geodesic: !0,
      flownDistance: 0,
      league: b.l || lc,
      multiplier: 1,
      points: 0,
      speedUnit: b.kc || Cb
    });
    this.set("map", a);
    var c = new V({
      buffer: 50,
      fillOpacity: .2,
      strokeOpacity: .5,
      tableId: "2923451"
    });
    c.bindTo("airspace", this);
    c.bindTo("map", this);
    var c = De($g),
        d = new X(c);
    d.bindTo("airspace", this);
    d.bindTo("altitudeUnit", this);
    d.bindTo("constraint", this);
    d.bindTo("distance", this);
    d.bindTo("distanceUnit", this);
    d.bindTo("flownDistance", this);
    d.bindTo("name", this);
    d.bindTo("thermalLayer", this);
    d.bindTo("multiplier", this);
    d.bindTo("points", this);
    d.bindTo("speedUnit", this);
    L(K("control_about", c), "click", this.Bb, !1, this);
    L(K("control_close_flight", c), "click", this.Fb, !1, this);
    L(K("control_preferences", c), "click", this.Xb, !1, this);
    L(K("control_reset", c), "click", this.Yb, !1, this);
    L(K("control_share", c), "click", this.ac, !1, this);
    L(K("control_download", c), "click", this.Ib, !1, this);
    a.controls[google.maps.ControlPosition.RIGHT_TOP].push(c);
    this.h = new Wg({ // triangles
      fillColor1: "#ff0000",
      fillColor2: "#00ff00",
      fillColor3: "#0000ff",
      fillOpacity: .25,
      strokeColor1: "#ffffff",
      strokeColor2: "#ffffff",
      strokeColor3: "#ffffff",
      strokeOpacity: .5,
      strokeWeight: 2,
      zIndex: 1
    });
    this.B = this.H = null;
    this.F = b.Sa || null;
    this.M = this.c = this.L = this.a = null;
    this.b = new Fg({
      clickable: !0,
      editable: !0,
      fillColor: "#000000",
      fillOpacity: 0,
      strokeColor: "#ff0000",
      strokeOpacity: 1,
      strokeWeight: 2,
      zIndex: 5
    });
    this.b.bindTo("geodesic", this);
    this.b.bindTo("map", this);
    google.maps.event.addListener(this.b.c, "dblclick", u(function () {
      this.get("map").fitBounds(Dg(this));
    }, this.b));
    this.j = new google.maps.Polyline({
      clickable: !0,
      path: new google.maps.MVCArray(),
      strokeColor: hh[0],
      strokeOpacity: 1,
      strokeWeight: 3,
      zIndex: 3
    });
    this.j.bindTo("geodesic", this);
    this.j.bindTo("map", this);
    google.maps.event.addListener(this.j, "dblclick", u(function () {
      var a = new google.maps.LatLngBounds();
      x(this.getPath().getArray(), a.extend, a);
      this.getMap().fitBounds(a);
    }, this.j));
    this.g = new Y({ // petit triangle
      fillColor: "#ffff00",
      fillOpacity: .1,
      strokeColor: "#ffffff",
      strokeOpacity: .5,
      strokeWeight: 2,
      zIndex: 2
    });
    this.X = 0;
    this.b instanceof Fg && google.maps.event.addListener(a, "rightclick", u(this.Zb, this));
    this.o = this.m = null;
    this.O = [];
    0 == b.path.length ? nh(this, a, b.center) : (this.b.setPath(new google.maps.MVCArray(b.path)), oh(this), this.v());
    this.K = [240, 1, .5];
    c = new ve(a.getDiv());
    L(c, "drop", this.Jb, !1, this);
  }
  w(mh, google.maps.MVCObject);

  function ph(a) {
    return a.get("map");
  }
  mh.prototype.Y = function () {
    this.v();
  };
  mh.prototype.league_changed = mh.prototype.Y;
  g = mh.prototype;
  g.Bb = function () {
    var a = new Q();
    Ae(a.U(), Zg);
    a.setTitle($pgettext('xc planner', 'About'));
    If(a, R(new S(), zf, !0, !0));
    a.I(!0);
  };
  g.Fb = function () {
    var a = this.b.getPath(),
        b = a.getLength(),
        c = this.b.getPosition(a, 0),
        a = this.b.getPosition(a, b - 1);
    2 < b && 1E3 > google.maps.geometry.spherical.computeDistanceBetween(c, a) ? this.b.setAt(b - 1, new google.maps.LatLng(c.lat(), c.lng())) : zg(this.b, new google.maps.LatLng(c.lat(), c.lng()));
  };
  g.Rb = function () {
    var a = ph(this).getCenter(),
        b,
        c = this.b.getPath().getLength();
    for (b = 0; b < c; ++b) {
      this.b.setAt(b, google.maps.geometry.spherical.computeOffset(a, 1E4, 270 + 360 * b / c, 6371E3));
    }
  };
  g.Sb = function (a) {
    var b = Qf(a.target.result);
    a = new google.maps.LatLngBounds();
    x(b, a.extend, a);
    ph(this).fitBounds(a);
    b = new google.maps.Polyline({
      path: b,
      strokeColor: Kc(this.K),
      strokeOpacity: 1,
      strokeWeight: 1,
      zIndex: 0
    });
    this.K[0] = (this.K[0] + 15) % 360;
    b.bindTo("geodesic", this);
    b.bindTo("map", this);
    google.maps.event.addListener(b, "dblclick", u(function () {
      this.unbind("map");
      this.setMap(null);
    }, b));
    google.maps.event.addListener(b, "rightclick", u(function (a) {
      this.getMap().fitBounds(a);
    }, b, a));
  };
  g.Jb = function (a) {
    a = a.c.dataTransfer.files;
    var b = u(this.Sb, this),
        c,
        d = a.length,
        e;
    for (c = 0; c < d; ++c) {
      /\.igc$/i.test(a[c].name) && (e = new FileReader(), e.onloadend = b, e.readAsText(a[c]));
    }
  };
  g.Xb = function () {
    var a = this.get("altitudeUnit"),
        b = z(Ib, function (b, c) {
      return {
        label: Jb[c],
        selected: b === a,
        value: c
      };
    }),
        c = this.get("coordinateUnit"),
        d = z(Kb, function (a, b) {
      return {
        label: Lb[b],
        selected: a === c,
        value: b
      };
    }),
        e = this.get("distanceUnit"),
        f = z(Mb, function (a, b) {
      return {
        label: Nb[b],
        selected: a === e,
        value: b
      };
    }),
        h = this.get("league"),
        k = z(Hc, function (a, b) {
      return {
        label: a.W(),
        selected: a === h,
        value: b
      };
    }, this),
        l = new Q(),
        n = l.U();
    Ae(n, bh, {
      kb: b,
      lb: d,
      mb: f,
      pb: k
    });
    L(K("altitudeUnit_select", n), "change", function (a) {
      var b = Ib[a.a.value];
      qb(sb, "altitudeUnit", a.a.value);
      b !== this.get("altitudeUnit") && this.set("altitudeUnit", b);
    }, !1, this);
    L(K("coordinateUnit_select", n), "change", function (a) {
      var b = Kb[a.a.value];
      qb(sb, "coordinateUnit", a.a.value);
      b !== this.get("coordinateUnit") && this.set("coordinateUnit", b);
    }, !1, this);
    L(K("distanceUnit_select", n), "change", function (a) {
      var b = Mb[a.a.value];
      qb(sb, "distanceUnit", a.a.value);
      b !== this.get("distanceUnit") && this.set("distanceUnit", b);
      a = b === Eb ? Fb : Cb;
      a != this.get("speedUnit") && this.set("speedUnit", a);
    }, !1, this);
    L(K("league_select", n), "change", function (a) {
      a = Hc[a.a.value];
      a !== this.get("league") && this.set("league", a);
    }, !1, this);
    l.setTitle($pgettext('xc planner', 'Preferences'));
    b = new S();
    R(b, ih, !0, !0);
    If(l, b);
    l.I(!0);
  };
  g.Yb = function () {
    var a = new Q();
    Ae(a.U(), ch);
    a.setTitle("Reset");
    var b = new S();
    R(b, lh, !0, !1);
    R(b, Af, !1, !0);
    If(a, b);
    L(a, Jf, function (a) {
      a.key == lh.key && (a = ph(this), nh(this, a, a.getCenter()));
    }, !1, this);
    a.I(!0);
  };

  function oh(a) {
    x(a.O, function (a) {
      google.maps.event.removeListener(a);
    });
    var b = a.b.getPath(),
        c = u(a.v, a);
    a.O = z(["insert_at", "remove_at", "set_at"], function (a) {
      return google.maps.event.addListener(b, a, c);
    });
  }
  g.Zb = function (a) {
    zg(this.b, a.latLng);
  };
  g.ac = function () {
    var a = google.maps.geometry.encoding.encodePath(this.b.getPath()),
        b,
        c = new B('https://xcplanner.appspot.com/');
    b = new bb();
    var d = this.get("league");
    D(b, "l", d.getId());
    D(b, "p", a);
    d = this.get("constraint");
    null === d.a || D(b, "d", Math.round(d.a / 60));
    null === d.b || D(b, "s", (3600 * d.b / 1E3).toFixed(1));
    D(b, "a", this.get("airspace"));
    $a(c, b);
    var d = new B("http://maps.googleapis.com/maps/api/staticmap"),
        e = new bb();
    D(e, "size", "640x480");
    D(e, "maptype", "terrain");
    D(e, "key", "AIzaSyAeL75QTVdyogmANb1M0UKxcrE7LiCPqm0");
    D(e, "path", "color:0xff0000ff|weight:3|enc:" + a);
    $a(d, e);
    a = new B("http://loctome.com/lab/xcplanner/");
    $a(a, b);
    b = $f("tobis-paragliding-map:xcplanner.appspot.com/" + b.toString());
    var e = new B("http://xctrack.org/xcplanner"),
        f = new bb(),
        h = [];
    this.b.getPath().forEach(function (a) {
      h.push(a.lat().toFixed(6) + "," + a.lng().toFixed(6));
    });
    D(f, "route", h.join(":"));
    $a(e, f);
    f = new Q();
    Ae(f.U(), eh, {
      height: 256,
      href: c.toString(),
      Ab: a.toString(),
      gc: b,
      lc: d.toString(),
      width: 256,
      nc: e.toString()
    });
    f.setTitle($pgettext('xc planner', 'Share'));
    c = new S();
    R(c, ih, !0, !0);
    If(f, c);
    L(f, "show", function (a) {
      a = K("link_input", a.a.U());
      a.focus();
      a.select();
    });
    f.I(!0);
  };
  g.Ib = function () {
    null === this.B && (this.B = new google.maps.ElevationService());
    this.B.getElevationForLocations({
      locations: this.c
    }, u(function (a, b) {
      var c = this.get("altitudeUnit"),
          d = this.get("coordinateUnit"),
          e = this.get("downloadFormat"),
          f = z(fh, function (a, b) {
        return {
          label: gh[b],
          selected: a == e,
          value: a
        };
      }),
          h = z(this.c, function (e, f) {
        return {
          id: ua(f + 1, 3),
          coords: [d(e.lat(), "NS"), d(e.lng(), "EW")],
          elevation: b == google.maps.ElevationStatus.OK ? c(a[f].elevation) : [0, 0]
        };
      }, this),
          k = {
        features: z(this.c, function (c, d) {
          var e = "T" + ua(d + 1, 2),
              f = [c.lng(), c.lat()];
          b == google.maps.ElevationStatus.OK ? (f.push(a[d].elevation), e += ua(a[d].elevation / 10, 3, 0)) : e += "000";
          return {
            geometry: {
              coordinates: f,
              type: "Point"
            },
            properties: {
              id: e
            },
            type: "Feature"
          };
        }, this),
        type: "FeatureCollection"
      },
          l = new Q();
      Ae(l.U(), dh, {
        nb: f,
        ob: we(k),
        qb: "XC Planner route",
        waypoints: h,
        rb: "XCP"
      });
      l.setTitle($pgettext('xc planner', 'Download'));
      f = new S();
      R(f, ih, !0, !0);
      R(f, jh, !1, !1);
      If(l, f);
      L(l, Jf, function (a) {
        var b = a.a;
        a.key == jh.key && (K("download_form", b.U()).submit(), b.I(!1));
      });
      l.I(!0);
    }, this));
  };
  g.Qb = function () {
    var a = new Q();
    Ae(a.U(), ah, {});
    a.setTitle("Go to");
    var b = K("go_to_input", a.U());
    new google.maps.places.Autocomplete(b, {
      bounds: ph(this).getBounds(),
      types: ["geocode"]
    });
    var c = new S();
    R(c, kh, !0, !1);
    R(c, Af, !1, !0);
    If(a, c);
    L(a, "show", function () {
      b.focus();
    });
    L(a, Jf, function (a) {
      a.key == kh.key && (null === this.F && (this.F = new google.maps.Geocoder()), this.F.geocode({
        address: Lc(b),
        bounds: ph(this).getBounds()
      }, u(function (a, b) {
        b == google.maps.GeocoderStatus.OK && ph(this).fitBounds(a[0].geometry.viewport);
      }, this)));
    }, !1, this);
    a.I(!0);
  };
  g.Ob = function () {
    google.maps.event.removeListener(this.m);
    this.m = null;
    google.maps.event.removeListener(this.o);
    this.o = null;
  };

  function nh(a, b, c) {
    var d = new google.maps.MVCArray(),
        e;
    for (e = 0; 2 > e; ++e) {
      d.push(google.maps.geometry.spherical.computeOffset(c, 1E4, 270 + 360 * e / 2, 6371E3));
    }Cg(a.b, !1);
    a.b.setPath(d);
    oh(a);
    a.v();
    null === a.m && (a.m = google.maps.event.addListener(a.b, "first_modified", u(a.Ob, a)));
    null === a.o && (a.o = google.maps.event.addListener(b, "idle", u(a.Rb, a)));
  }
  g.mc = function () {
    var a = ph(this),
        b = this.get("thermalLayer");
    null === b ? a.overlayMapTypes.removeAt(0) : a.overlayMapTypes.setAt(0, b);
  };
  mh.prototype.thermalLayer_changed = mh.prototype.mc;
  mh.prototype.v = function () {
    var a = this.get("league");
    if (q(a) && q(this.b)) {
      this.c = this.b.getPath().getArray();
      this.M = new Pb(this.c);
      var b = a.P(this.c, this.M);
      Ha(b, function (a, b) {
        return b.a - a.a;
      });
      this.a = b[0];
      this.L = a.oa(this.a.J.length);
      for (var a = 0, c = this.c.length, b = 1; b < c; ++b) {
        a += Qb(this.M, b - 1, b);
      }this.a.distance != this.get("distance") && this.set("distance", this.a.distance);
      a != this.get("flownDistance") && this.set("flownDistance", a);
      this.a.$ != this.get("multiplier") && this.set("multiplier", this.a.$);
      this.a.name != this.get("name") && this.set("name", this.a.name);
      this.a.a != this.get("points") && this.set("points", this.a.a);
      qh(this);
      rh(this);
      sh(this);
      th(this);
    }
  };

  function qh(a) {
    var b = a.j.getPath(),
        c = a.a.J.length,
        d = b.getLength(),
        e = Math.min(c, d),
        f,
        h;
    for (f = 0; f < e; ++f) {
      h = b.getAt(f), a.c[a.a.J[f]].equals(h) || b.setAt(f, a.c[a.a.J[f]]);
    }for (f = e; f < c; ++f) {
      b.push(a.c[a.a.J[f]]);
    }for (f = d - 1; f >= c; --f) {
      b.removeAt(f);
    }a.X != a.a.ja && (a.j.set("strokeColor", hh[a.a.ja]), a.X = a.a.ja);
  }

  function rh(a) {
    var b, c;
    if (a.a.ua) for (b = Array(3), c = 0; 3 > c; ++c) {
      b[c] = a.c[a.a.ua[c]];
    } else b = null;
    if (null === b) null !== a.H && (a.h.unbind("map"), a.h.set("map", null));else {
      ++a.h.b;
      for (c = 0; 3 > c; ++c) {
        a.h.setAt(c, b[c]);
      }c = a.h;
      0 === --c.b && c.c && Xg(c);
      null === a.H && a.h.bindTo("map", a);
    }
    a.H = b;
  }

  function sh(a) {
    var b = Ja(a.b.getPath().getLength());
    x(a.a.J, function (a, d) {
      b[a] = "" === b[a] ? this.L[d] : b[a] + (", " + this.L[d]);
    }, a);
    Eg(a.b, b);
  }

  function th(a) {
    if (null != a.a.ia) {
      var b = a.g.getCenter(),
          c = a.c[a.a.J[0]];
      q(b) && b.equals(c) || a.g.set("center", c);
      var d = a.c[a.a.J[a.a.J.length - 1]],
          b = a.g.get("heading") || 0,
          c = google.maps.geometry.spherical.computeHeading(c, d);
      q(b) && b == c || a.g.set("heading", c);
      (a.g.get("radius") || 0) != a.a.ia && a.g.set("radius", a.a.ia);
      null != a.g.get("map") || a.g.bindTo("map", a);
    } else null !== a.g.get("map") && (a.g.unbind("map"), a.g.set("map", null));
  };
  var Ma = {
    AR: {
      l: F
    },
    AT: {
      l: lc
    },
    AU: {
      l: bc
    },
    BR: {
      l: F
    },
    CA: {
      xa: Ab,
      l: cc
    },
    CH: {
      l: dc
    },
    CL: {
      l: ec
    },
    CU: {
      l: F
    },
    CZ: {
      l: fc
    },
    DE: {
      l: F
    },
    DK: {
      l: F
    },
    ES: {
      l: gc
    },
    FI: {
      l: hc
    },
    FR: {
      l: nc
    },
    GB: {
      xa: Ab,
      Ya: Hb,
      l: Gc
    },
    GR: {
      l: F
    },
    HU: {
      l: ic
    },
    IE: {
      l: F
    },
    IT: {
      l: lc
    },
    LT: {
      l: jc
    },
    LU: {
      l: F
    },
    LV: {
      l: lc
    },
    MX: {
      l: sc
    },
    NL: {
      l: lc
    },
    PL: {
      l: wc
    },
    PT: {
      l: F
    },
    RO: {
      l: lc
    },
    RU: {
      l: F
    },
    SK: {
      l: kc
    },
    TR: {
      l: F
    },
    US: {
      xa: Ab,
      Za: Eb,
      kc: Fb
    }
  },
      uh = {
    cfd: nc,
    olc: F,
    ukxcl: Gc,
    xc: lc
  },
      vh = /^\[((?:\[\-?\d+(?:\.\d*)?,\-?\d+(?:\.\d*)?\])(?:,\[\-?\d+(?:\.\d*)?,\-?\d+(?:\.\d*)?\])+)\]$/,
      wh = /^\[(\-?\d+(?:\.\d*)?),(\-?\d+(?:\.\d*)?)\]/,
      xh = /^(cfd|olc|ukxcl|xc)(\d+)(c?)$/;

  function yh(a) {
    var b,
        c,
        d = a.address_components.length;
    for (c = 0; c < d; ++c) {
      if (b = a.address_components[c], Ba(b.types, "country")) return b.short_name;
    }return null;
  }

  function zh(a, b) {
    var c = new google.maps.Map(a, {
      // draggable: false,
      // scrollwheel: false,
      // panControl: false,
      scaleControl: !1,
      streetViewControl: !1,
      mapTypeControl: !1,
      fullscreenControl: !1,
      zoomControl: !1,
      mapTypeControlOptions: {
        mapTypeIds: ["empty", "xcontest"]
      },
      mapTypeId: "empty",
      backgroundColor: 'none'
    });
    c.mapTypes.set("xcontest", new google.maps.ImageMapType(wb));
    c.mapTypes.set("empty", new EmptyMap());
    if (0 == b.path.length) b.bounds ? (c.fitBounds(b.bounds), b.center = b.bounds.getCenter()) : (b.center = b.center || new google.maps.LatLng(46, 11), c.setCenter(b.center), c.setZoom(b.zoom || 7));else {
      var d = new google.maps.LatLngBounds();
      x(b.path, function (a) {
        d.extend(a);
      });
      c.fitBounds(d);
      b.center = d.getCenter();
    }
    La(b.country) && Ka(Ma[b.country], function (a, c) {
      A(b, c, a);
    });
    if (q(rb("altitudeUnit"))) {
      var e = parseInt(rb("altitudeUnit"), 10);
      isNaN(e) || (b.xa = Ib[e]);
    }
    q(rb("distanceUnit")) && (e = parseInt(rb("distanceUnit"), 10), isNaN(e) || (b.Za = Mb[e]));
    q(rb("coordinateUnit")) && (e = parseInt(rb("coordinateUnit"), 10), isNaN(e) || (b.Ya = Kb[e]));
    new mh(c, b);
  }

  function Ah() {
    var a = Bh,
        b = Ch;
    b.Sa.geocode({
      address: b.address
    }, function (c, d) {
      d == google.maps.GeocoderStatus.OK && (b.bounds = c[0].geometry.bounds, b.center = c[0].geometry.location, b.country = yh(c[0]));
      zh(a, b);
    });
  }

  function Dh() {
    var a = Bh,
        b = Ch;
    navigator.geolocation ? navigator.geolocation.getCurrentPosition(function (c) {
      b.center = new google.maps.LatLng(c.coords.latitude, c.coords.longitude);
      b.zoom = b.zoom || 10;
      /* b.Sa.geocode(
      {
        location: b.center
      }, function(c, e)
      {
        e == google.maps.GeocoderStatus.OK && (b.country = yh(c[0]));
        zh(a, b)
      }) */
      zh(a, b);
    }, function () {
      zh(a, b);
    }) : zh(a, b);
  }

  var Bh;
  Bh = t("map") ? document.getElementById("xc-map") : "map";
  // top.location != self.location && (top.location = self.location.href);
  var Ch = {
    center: null
  };
  Ch.Sa = new google.maps.Geocoder();
  Ch.path = [];
  Ch.zoom = null;
  var Eh;
  Eh = new B('https://xcplanner.appspot.com/').b;
  var Fh = Ch,
      Gh,
      Z,
      Hh;
  C(Eh, "location") && (Fh.address = nb(Eh, "location"));
  C(Eh, "start") && (Z = wh.exec(nb(Eh, "start")), null === Z || Fh.path.push(new google.maps.LatLng(parseFloat(Z[1]), parseFloat(Z[2]))));
  if (C(Eh, "turnpoints") && (Z = vh.exec(nb(Eh, "turnpoints")), null !== Z)) for (Hh = Z[1], Z = wh.exec(Hh), Fh.path.push(new google.maps.LatLng(parseFloat(Z[1]), parseFloat(Z[2]))), Hh = Hh.slice(Z[0].length + 1); !/^[\s\xa0]*$/.test(Hh);) {
    Z = wh.exec(Hh), Fh.path.push(new google.maps.LatLng(parseFloat(Z[1]), parseFloat(Z[2]))), Hh = Hh.slice(Z[0].length + 1);
  }C(Eh, "flightType") && (Z = xh.exec(nb(Eh, "flightType")), null !== Z && (Fh.l = uh[Z[1]], (Gh = "c" == Z[3]) && 0 != Fh.path.length && Fh.path.push(Fh.path[0])));
  (function (a, b) {
    C(b, "a") && (a.sb = parseInt(nb(b, "a"), 10));
    C(b, "c") && (a.address = nb(b, "c"));
    C(b, "d") && (a.Xa = new Ob(60 * parseInt(nb(b, "d"), 10), null));
    if (C(b, "l")) {
      var c = nb(b, "l");
      x(Hc, function (b) {
        c == b.getId() && (a.l = b);
      });
    }
    C(b, "p") && (a.path = google.maps.geometry.encoding.decodePath(nb(b, "p")));
    C(b, "s") && (a.Xa = new Ob(null, 1E3 * parseInt(nb(b, "s"), 10) / 3600));
    C(b, "z") && (a.zoom = parseInt(nb(b, "z"), 10));
  })(Ch, Eh);
  0 == Ch.path.length ? Ch.address ? Ah() : Dh() : zh(Bh, Ch);
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment__ = __webpack_require__(164);
// import Vue from 'vue'
// import linkify from 'linkifyjs/string'

// import timeagoFilter from './timeago'
// import speedToColorsFilter from './speedToColors'


// const linkifyFilter = Vue.filter('linkify', src => linkify(src, { defaultProtocol: 'https', nl2br: true }))

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    // linkify: linkifyFilter,
    moment: __WEBPACK_IMPORTED_MODULE_0__moment__["a" /* default */]
    // speedToColors: speedToColorsFilter
  };
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022__);



var defaultZone = __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022___default.a.tz.guess();

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('moment', function (date, format) {
  __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022___default.a.locale(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.language);
  return __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022___default()(date).tz(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.timezone || defaultZone).format(format);
}));

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_math_cbrt__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gettext__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gettext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_gettext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_convert__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_translations__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_translations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__locale_translations__);







/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_gettext___default.a, {
    availableLanguages: {
      ca: 'Català',
      cs: 'Čeština',
      'zh-hk': '中文',
      de: 'Deutsch',
      el: 'ελληνικά',
      en: 'English',
      es: 'Español',
      eu: 'Euskara',
      fr: 'Français',
      it: 'Italiano',
      hu: 'Magyar',
      nl: 'Nederlands',
      pl: 'Polskie',
      pt: 'Português ',
      ro: 'Română',
      ru: 'Русский',
      sl: 'Slovenščina'
    },
    defaultLanguage: 'en',

    silent: true,

    translations: __WEBPACK_IMPORTED_MODULE_4__locale_translations___default.a
  });
});

var autoRound = function autoRound(v) {
  return v >= 10 ? Math.round(v) : Number(Math.round(v + 'e+1') + 'e-1');
};

var convert = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__plugins_convert__["a" /* default */], {
  availableUnits: {
    ms: 'm/s',
    kmh: 'km/h',
    mph: 'mph',
    knots: 'knots',
    bft: 'bft'
  },
  defaultUnit: 'kmh',

  conversions: {
    kmh: function kmh(v) {
      return autoRound(v * 3.6);
    },
    ms: function ms(v) {
      return autoRound(v);
    }, // eslint-disable-line no-mixed-operators
    knots: function knots(v) {
      return autoRound(v * 3.6 / 1.852);
    }, // eslint-disable-line no-mixed-operators
    mph: function mph(v) {
      return autoRound(v * 3.6 / 1.609);
    }, // eslint-disable-line no-mixed-operators
    bft: function bft(v) {
      return v * 3.6 >= 118 ? 12 : v * 3.6 < 1 ? 0 : Math.round(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_math_cbrt___default()(Math.pow(v * 3.6, 2) / 9));
    } // eslint-disable-line no-mixed-operators
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__);

var convertVm = void 0; // Singleton

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var defaultConfig = {
      availableUnits: { kmh: 'kmh' },
      defaultUnit: 'kmh',
      unitVmMixin: {},
      conversions: {
        kmh: function kmh(v) {
          return v;
        }
      }
    };

    options = __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default()(defaultConfig, options);

    convertVm = new Vue({
      created: function created() {
        this.available = options.availableUnits;
      },

      data: {
        current: options.defaultUnit
      },
      mixins: [options.unitVmMixin],
      computed: {
        currentLabel: function currentLabel() {
          return this.available[this.current];
        }
      }
    });

    Vue.config.availableUnits = options.availableUnits;

    Object.defineProperty(Vue.config, 'windUnit', {
      enumerable: true,
      configurable: true,
      get: function get() {
        return convertVm.current;
      },
      set: function set(val) {
        convertVm.current = val;
      }
    });

    // Override the main init sequence. This is called for every instance.
    var init = Vue.prototype._init;
    Vue.prototype._init = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var root = options._parent || options.parent || this;
      // Expose convertVm to every instance.
      this.$convert = root.$convert || convertVm;
      init.call(this, options);
    };

    // Override the main destroy sequence to destroy all convertVm watchers.
    var destroy = Vue.prototype._destroy;
    Vue.prototype._destroy = function () {
      this.$convert = null;
      destroy.apply(this, arguments);
    };

    Vue.$conversions = options.conversions;

    Vue.prototype.$getwind = function (value) {
      return Vue.$conversions[Vue.config.windUnit].apply(this, arguments);
    };
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(356);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */], {});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].url.options.root = 'https://data0.meteo-parapente.com';

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    root: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].url.options.root
  };
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes_app_template__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes_app_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__routes_app_template__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:region?/:name?/:lat,:lon,:zoom/:layer?',
  name: 'app',
  icon: 'home-outline',
  nav: true,

  component: __WEBPACK_IMPORTED_MODULE_0__routes_app_template___default.a
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_app__ = __webpack_require__(168);




// import map from '@/routes/map'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [__WEBPACK_IMPORTED_MODULE_2__routes_app__["a" /* default */]]
    // mode: 'history'
  });
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DEFAULT_STATE = {
  lastLogin: null,
  token: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    isContributor: function isContributor(state, getters) {
      var data = getters.data;
      if (!data) return false;
      return new Date(data.expires) > new Date();
    },
    data: function data(state, getters) {
      if (!state.token) return null;
      return JSON.parse(atob(state.token.split('.')[1]));
    },
    email: function email(state, getters) {
      var data = getters.data;
      if (!data) return null;
      return data.email;
    },
    expiration: function expiration(state, getters) {
      var data = getters.data;
      if (!data) return null;
      return new Date(data.expires);
    }
  },
  mutations: {
    logout: function logout(state) {
      state.token = null;
    },
    resetStore: function resetStore(state) {
      state = DEFAULT_STATE;
    },
    login: function login(state, token) {
      state.token = token;
      state.lastLogin = new Date();
    }
  },
  actions: {
    logout: function logout(context) {
      context.commit('logout');
    },
    resetStore: function resetStore(context) {
      context.commit('resetStore');
    },
    login: function login(context, token) {
      context.commit('login', token);
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);




var DEFAULT_STATE = {
  home: null,
  list: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    home: function home(state) {
      if (state.home === null) return {};
      var homeState = {};
      state.list.forEach(function (savedState) {
        if (savedState.uid === state.home) homeState = savedState.state;
      });
      return homeState;
    }
  },
  mutations: {
    add: function add(state, newState) {
      state.list.push({
        uid: new Date().valueOf(),
        name: newState.name,
        state: {
          center: newState.state.center
        }
      });
    },
    setHome: function setHome(state, id) {
      state.home = state.list[id].uid;
    },
    setName: function setName(state, _ref) {
      var id = _ref.id,
          name = _ref.name;

      state.list[id].name = name;
    },
    update: function update(state, _ref2) {
      var id = _ref2.id,
          newState = _ref2.newState;

      state.list[id].state = {
        center: newState.center
      };
    },
    delete: function _delete(state, id) {
      if (state.home === state.list[id].uid) {
        state.home = null;
      }
      state.list.splice(id, 1);
    },
    moveToUp: function moveToUp(state, id) {
      var newState = state.list[id];
      state.list.splice(id, 1);
      state.list.unshift(newState);
    },
    resetStore: function resetStore(state) {
      __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default()(state, DEFAULT_STATE);
    }
  },
  actions: {
    add: function add(context, newState) {
      context.commit('add', __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()({}, newState));
    },
    setHome: function setHome(context, id) {
      context.commit('setHome', id);
      context.commit('moveToUp', id);
    },
    setName: function setName(context, _ref3) {
      var id = _ref3.id,
          name = _ref3.name;

      context.commit('setName', { id: id, name: name });
    },
    update: function update(context, _ref4) {
      var id = _ref4.id,
          newState = _ref4.newState;

      context.commit('update', {
        id: id,
        newState: __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()({}, newState)
      });
    },
    delete: function _delete(context, id) {
      context.commit('delete', id);
    },
    moveToUp: function moveToUp(context, id) {
      context.commit('moveToUp', id);
    },
    resetStore: function resetStore(context) {
      context.commit('resetStore');
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_storage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_time__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_runtime__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_persistent__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_favorites__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_news__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_auth__ = __webpack_require__(170);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */], {});

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({
      key: 'state',
      paths: ['persistent', 'favorites', 'news', 'auth'],
      storage: __WEBPACK_IMPORTED_MODULE_3__assets_storage__["a" /* storage */]
    })],
    modules: {
      time: __WEBPACK_IMPORTED_MODULE_4__store_time__["a" /* default */],
      runtime: __WEBPACK_IMPORTED_MODULE_5__store_runtime__["a" /* default */],
      persistent: __WEBPACK_IMPORTED_MODULE_6__store_persistent__["a" /* default */],
      favorites: __WEBPACK_IMPORTED_MODULE_7__store_favorites__["a" /* default */],
      news: __WEBPACK_IMPORTED_MODULE_8__store_news__["a" /* default */],
      auth: __WEBPACK_IMPORTED_MODULE_9__store_auth__["a" /* default */]
    }
  });
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__);

// import Vue from 'vue'

var DEFAULT_STATE = {
  articles: [],
  read: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    articles: function articles(state) {
      var aWhileAgo = new Date(new Date().valueOf() - 15 * 24 * 3600 * 1000);
      return state.articles.map(function (article) {
        article.unread = article.date > aWhileAgo && state.read.indexOf(article.id) < 0;
        return article;
      });
    },
    unreadArticles: function unreadArticles(state, getters) {
      return getters.articles.filter(function (article) {
        return article.unread;
      });
    },
    unreadCount: function unreadCount(state, getters) {
      return getters.unreadArticles.length;
    }
  },
  mutations: {
    setArticles: function setArticles(state, articles) {
      state.articles = articles;
    },
    setRead: function setRead(state, id) {
      state.read.push(id);
    },
    resetStore: function resetStore(state) {
      __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default()(state, DEFAULT_STATE);
    }
  },
  actions: {
    fetch: function fetch(context) {
      /* Vue.http.get('news.php')
      .then(response => {
        let discourseNews = []
        let articles = []
        try {
          discourseNews = response.body.topic_list.topics
        } catch (e) {}
        discourseNews.forEach(article => {
          const id = article.id
          if (id === 17) return
          const titleData = article.title.split('#')
          const title = titleData.shift().trim()
          const articleLangs = titleData.map(lang => lang.trim())
          const isTranslated = articleLangs.length > 0
          const myLanguage = Vue.config.language === 'fr' ? 'FR' : 'EN'
          const isMyLanguage = articleLangs.indexOf(myLanguage) > -1
          const date = new Date(article.created_at)
          if (isTranslated && !isMyLanguage) return
          const url = `https://community.meteo-parapente.com/t/${article.slug}/${article.id}/1`
          articles.push({
            title,
            id,
            url,
            date
          })
          articles.sort((a, b) => {
            return a.date < b.date
          })
          articles = articles.slice(0, 5)
        })
        // articles.reverse()
        context.commit('setArticles', articles)
      }) */
    },
    setRead: function setRead(context, id) {
      context.commit('setRead', id);
    },
    resetStore: function resetStore(context) {
      context.commit('resetStore');
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_browser_locale__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_browser_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_browser_locale__);





var DEFAULT_STATE = {
  interpolate: true,
  colorblind: false,
  experimental: false,
  airspace: false,
  xcplanner: false,
  altitude: 1000,
  center: {
    lat: 45,
    lon: 5,
    zoom: 7,
    defaultValues: true
  },
  layer: 'pbltop',
  splitRatio: 0.5,
  lang: undefined,
  windUnit: 'kmh',
  appOpenCount: 0,
  dissmissedNews: new Date(0),
  acceptedRules: new Date(0),
  timezone: undefined,
  timezoneOveride: false,
  iapEmail: null,
  soundingTopAltitude: 4000,
  windgramTopAltitude: 4000
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    roundedAltitude: function roundedAltitude(state) {
      return Math.round(state.altitude / 250) * 250;
    }
  },
  mutations: {
    toggleInterpolation: function toggleInterpolation(state) {
      state.interpolate = !state.interpolate;
    },
    toggleAirspace: function toggleAirspace(state) {
      state.airspace = !state.airspace;
    },
    toggleXcplanner: function toggleXcplanner(state) {
      state.xcplanner = !state.xcplanner;
    },
    toggleColorblind: function toggleColorblind(state) {
      state.colorblind = !state.colorblind;
    },
    toggleExperimental: function toggleExperimental(state) {
      state.experimental = !state.experimental;
    },
    climbAltitude: function climbAltitude(state, height) {
      var altitude = state.altitude + height;
      if (altitude < 250) {
        altitude = 250;
      } else if (altitude > 5000) {
        altitude = 5000;
      }
      state.altitude = altitude;
    },
    setRouteParams: function setRouteParams(state, _ref) {
      var lat = _ref.lat,
          lon = _ref.lon,
          zoom = _ref.zoom,
          layer = _ref.layer,
          altitude = _ref.altitude;

      state.center = {
        lat: lat,
        lon: lon,
        zoom: zoom,
        defaultValues: false
        // if (layer !== undefined) state.layer = layer
        // if (altitude !== undefined) state.altitude = altitude
      };
    },
    setLayer: function setLayer(state, layer) {
      state.layer = layer;
    },
    setCenter: function setCenter(state, _ref2) {
      var lat = _ref2.lat,
          lon = _ref2.lon,
          zoom = _ref2.zoom;

      state.center = {
        lat: lat,
        lon: lon,
        zoom: zoom,
        defaultValues: false
      };
    },
    setSplitRatio: function setSplitRatio(state, ratio) {
      state.splitRatio = ratio;
    },
    load: function load(state, savedState) {
      var newState = __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default()({}, state, savedState);
      __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default()(state, newState);
    },
    resetStore: function resetStore(state) {
      __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_assign___default()(state, DEFAULT_STATE);
    },
    setLang: function setLang(state, lang) {
      state.lang = lang;
    },
    setWindUnit: function setWindUnit(state, unit) {
      state.windUnit = unit;
    },
    incrementAppOpenCount: function incrementAppOpenCount(state) {
      state.appOpenCount++;
    },
    dissmissNews: function dissmissNews(state, timestamp) {
      state.dissmissedNews = timestamp;
    },
    acceptRules: function acceptRules(state, timestamp) {
      state.acceptedRules = timestamp;
    },
    syncConfig: function syncConfig(state) {
      var setLang = function setLang(lang) {
        var systemLanguage = lang.split('-')[0];
        if (systemLanguage in __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$translations) {
          state.lang = systemLanguage;
        } else {
          state.lang = 'en';
        }
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.language = state.lang;
      };

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.windUnit = state.windUnit;
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.timezone = state.timezone;

      if (state.lang === undefined) {
        if ('cordova' in window) {
          navigator.globalization.getPreferredLanguage(function (language) {
            setLang(language.value);
          }, function () {
            setLang('en');
          });
        } else {
          setLang(__WEBPACK_IMPORTED_MODULE_3_browser_locale___default()());
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.language = state.lang;
      }
    },
    setTimezone: function setTimezone(state, timezone) {
      state.timezone = timezone;
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.timezone = state.timezone;
    },
    setTimezoneOveride: function setTimezoneOveride(state, overide) {
      state.timezoneOveride = overide;
    },
    setIapEmail: function setIapEmail(state, email) {
      state.iapEmail = email;
    },
    setSoundingTopAltitude: function setSoundingTopAltitude(state, altitude) {
      state.soundingTopAltitude = altitude;
    },
    setWindgramTopAltitude: function setWindgramTopAltitude(state, altitude) {
      state.windgramTopAltitude = altitude;
    }
  },
  actions: {
    toggleInterpolation: function toggleInterpolation(context) {
      context.commit('toggleInterpolation');
    },
    toggleAirspace: function toggleAirspace(context) {
      context.commit('toggleAirspace');
    },
    toggleXcplanner: function toggleXcplanner(context) {
      context.commit('toggleXcplanner');
    },
    toggleExperimental: function toggleExperimental(context) {
      context.commit('toggleExperimental');
    },
    toggleColorblind: function toggleColorblind(context) {
      context.commit('toggleColorblind');
    },
    climbAltitude: function climbAltitude(context, height) {
      context.commit('climbAltitude', height);
    },
    setRouteParams: function setRouteParams(context, params) {
      context.commit('setRouteParams', params);
    },
    setLayer: function setLayer(context, layer) {
      context.commit('setLayer', layer);
    },
    setSplitRatio: function setSplitRatio(context, ratio) {
      context.commit('setSplitRatio', ratio);
    },
    incrementAppOpenCount: function incrementAppOpenCount(context) {
      context.commit('incrementAppOpenCount');
    },
    setUserLocation: function setUserLocation(context) {
      /* if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(location => {
          context.commit('setCenter', {
            lat: location.coords.latitude,
            lon: location.coords.longitude,
            zoom: 7
          })
        },
        () => {
          context.dispatch('setIpLocation')
        })
      } else {
        context.dispatch('setIpLocation')
      } */
      context.dispatch('setIpLocation');
    },
    setIpLocation: function setIpLocation(context) {
      /* Vue.http.get('https://freegeoip.net/json/')
      .then(({ body: response }) => {
        context.commit('setCenter', {
          lat: response.latitude,
          lon: response.longitude
        })
      }) */
    },
    load: function load(context, savedState) {
      context.commit('load', savedState);
    },
    resetStore: function resetStore(context) {
      context.commit('resetStore');
      context.commit('syncConfig');
    },
    setLang: function setLang(context, lang) {
      context.commit('setLang', lang);
      context.commit('syncConfig');
    },
    setWindUnit: function setWindUnit(context, unit) {
      context.commit('setWindUnit', unit);
      context.commit('syncConfig');
    },
    syncConfig: function syncConfig(context) {
      context.commit('syncConfig');
    },
    dissmissNews: function dissmissNews(context, timestamp) {
      context.commit('dissmissNews', timestamp);
    },
    acceptRules: function acceptRules(context, timestamp) {
      context.commit('acceptRules', timestamp);
    },
    setTimezone: function setTimezone(context, timezone) {
      context.commit('setTimezone', timezone);
    },
    setTimezoneOveride: function setTimezoneOveride(context, overide) {
      context.commit('setTimezoneOveride', overide);
    },
    setIapEmail: function setIapEmail(context, email) {
      context.commit('setIapEmail', email);
    },
    setSoundingTopAltitude: function setSoundingTopAltitude(context, altitude) {
      context.commit('setSoundingTopAltitude', altitude);
    },
    setWindgramTopAltitude: function setWindgramTopAltitude(context, altitude) {
      context.commit('setWindgramTopAltitude', altitude);
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    dragSurface: false,
    contributionOverlay: null,
    cordova: false,
    modal: null,
    modalIsLoading: false,
    mapSync: null,
    touchscreen: false
  },
  mutations: {
    showDragSurface: function showDragSurface(state) {
      state.dragSurface = true;
    },
    hideDragSurface: function hideDragSurface(state) {
      state.dragSurface = false;
    },
    showContributionOverlay: function showContributionOverlay(state, url) {
      state.contributionOverlay = url;
    },
    hideContributionOverlay: function hideContributionOverlay(state) {
      state.contributionOverlay = null;
    },
    toggleCordova: function toggleCordova(state) {
      state.cordova = true;
    },
    showModal: function showModal(state, modal) {
      state.modal = modal;
    },
    setModalLoading: function setModalLoading(state, isLoading) {
      state.modalIsLoading = isLoading;
    },
    mapSync: function mapSync(state, center) {
      state.mapSync = center;
    },
    setTouchscreen: function setTouchscreen(state, isTouchscreen) {
      state.touchscreen = isTouchscreen;
    }
  },
  actions: {
    showDragSurface: function showDragSurface(context) {
      context.commit('showDragSurface');
    },
    hideDragSurface: function hideDragSurface(context) {
      context.commit('hideDragSurface');
    },
    showContributionOverlay: function showContributionOverlay(context, url) {
      context.commit('showContributionOverlay', url);
    },
    hideContributionOverlay: function hideContributionOverlay(context) {
      context.commit('hideContributionOverlay');
    },
    toggleCordova: function toggleCordova(context) {
      context.commit('toggleCordova');
    },
    showModal: function showModal(context, modal) {
      context.commit('showModal', modal);
    },
    closeModal: function closeModal(context) {
      context.commit('showModal', null);
    },
    setModalLoading: function setModalLoading(context, isLoading) {
      context.commit('showModal', isLoading);
    },
    mapSync: function mapSync(context, center) {
      context.commit('mapSync', center);
    },
    setTouchscreen: function setTouchscreen(context, isTouchscreen) {
      context.commit('setTouchscreen', isTouchscreen);
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_compare_versions__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_compare_versions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_compare_versions__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    segments: [],
    cursor: undefined,
    currentSegment: undefined,
    updateTime: undefined,
    appIsUpdating: false,
    needAppMarketUpdate: false,
    networkError: false,
    tosDate: new Date(0)
  },
  getters: {
    run: function run(state) {
      if (state.currentSegment === undefined) return undefined;
      return state.segments[state.currentSegment].run;
    },
    roundedTime: function roundedTime(state) {
      if (state.cursor === undefined) return undefined;
      var roundedDate = Math.round(state.cursor.valueOf() / 1800 / 1000) * 1800 * 1000;
      return new Date(roundedDate);
    },
    date: function date(state, getters) {
      if (getters.roundedTime === undefined) return undefined;
      var date = getters.roundedTime.toISOString().split('.');
      return date[0].replace(/[^\d]/g, '');
    },
    private: function _private(state) {
      if (state.currentSegment === undefined) return undefined;
      return state.segments[state.currentSegment].private;
    },
    segment: function segment(state) {
      if (state.currentSegment === undefined) return undefined;
      return state.segments[state.currentSegment];
    }
  },
  mutations: {
    initCursor: function initCursor(state) {
      if (state.appIsUpdating !== false || state.needAppMarketUpdate !== false) return;
      var now = new Date();
      var offset = now.getHours() < 13 ? 0 : 24 * 3600 * 1000;
      var cursor = new Date(now.valueOf() + offset);

      cursor.setHours(13);
      cursor.setMinutes(0);
      cursor.setSeconds(0);
      cursor.setMilliseconds(0);
      var currentSegment = null;

      __WEBPACK_IMPORTED_MODULE_1__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys___default()(state.segments).forEach(function (key) {
        if (state.segments[key].startTime <= cursor && state.segments[key].stopTime >= cursor) {
          currentSegment = key;
        }
      });

      if (currentSegment === null) throw Error('Current time segment not found');

      if (state.segments[currentSegment].private /* && window.UserId === 0 */) {
          if (offset) {
            cursor = new Date(cursor.valueOf() - offset);
            currentSegment++;
          } else {
            cursor = new Date(cursor.valueOf() + 24 * 3600 * 1000);
            currentSegment--;
          }
        }

      state.cursor = cursor;
      state.currentSegment = currentSegment;
    },
    refreshCursor: function refreshCursor(state) {
      if (state.appIsUpdating !== false || state.needAppMarketUpdate !== false) return;
      var cursor = state.cursor;
      var currentSegment = null;

      __WEBPACK_IMPORTED_MODULE_1__opt_buildhome_repo_node_modules_babel_runtime_core_js_object_keys___default()(state.segments).forEach(function (key) {
        if (state.segments[key].startTime <= cursor && state.segments[key].stopTime >= cursor) {
          currentSegment = key;
        }
      });

      if (currentSegment === null) throw Error('Current time segment not found');

      state.currentSegment = currentSegment;
    },
    updateSegments: function updateSegments(state, _ref) {
      var segments = _ref.segments;

      if (state.appIsUpdating !== false || state.needAppMarketUpdate !== false) return;
      var newSegments = [];
      state.updateTime = new Date();
      var knownDays = [];
      segments.forEach(function (segment) {
        if (segment.status !== 'complete') return;
        if (segment.day in knownDays) return;
        knownDays[segment.day] = 1;

        var Y = segment.day.substr(0, 4);
        var M = segment.day.substr(4, 2);
        var D = segment.day.substr(6, 2);

        var startTime = new Date(Y + '-' + M + '-' + D + 'T04:00Z');
        var stopTime = new Date(Y + '-' + M + '-' + D + 'T21:00Z');

        var isPrivate = segment.private;
        // const isPrivate = (stopTime.valueOf() > new Date().valueOf()) && segment.private

        newSegments.push({
          run: segment.run,
          private: isPrivate,
          startTime: startTime,
          stopTime: stopTime
        });
      });
      state.segments = newSegments;
    },
    seek: function seek(state, time) {
      var cursor = new Date(state.cursor.valueOf() + time);
      var currentSegment = Number(state.currentSegment);

      if (cursor < state.segments[currentSegment].startTime) {
        if (currentSegment + 1 in state.segments) {
          currentSegment++;
          if (time !== -24 * 3600 * 1000) {
            cursor = state.segments[currentSegment].stopTime;
          }
        } else {
          return;
          // cursor = state.segments[currentSegment].startTime
        }
      } else if (cursor > state.segments[currentSegment].stopTime) {
        if (currentSegment - 1 in state.segments) {
          currentSegment--;
          if (time !== 24 * 3600 * 1000) {
            cursor = state.segments[currentSegment].startTime;
          }
        } else {
          return;
          // cursor = state.segments[currentSegment].stopTime
        }
      }
      state.cursor = cursor;
      state.currentSegment = currentSegment;
    },
    checkAppVersions: function checkAppVersions(state, versions) {
      if (!('appInfo' in navigator)) return;
      var installed = navigator.appInfo.version;
      var minimal = versions.minimal;
      if (installed === undefined) return;
      if (minimal === undefined) return;
      if (__WEBPACK_IMPORTED_MODULE_3_compare_versions___default()(installed, minimal) < 0) {
        state.needAppMarketUpdate = { installed: installed, minimal: minimal };
      }
    },
    checkJsVersions: function checkJsVersions(state, versions) {
      if (state.needAppMarketUpdate !== false) return;
      if (window.location.port === '3000') return;
      var scripts = document.getElementsByTagName('script');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0__opt_buildhome_repo_node_modules_babel_runtime_core_js_get_iterator___default()(scripts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var script = _step.value;

          var matches = script.outerHTML.match(/\.\/(\w+)\.(\w+)\.js/);
          if (!matches) continue;
          var name = matches[1];
          var currentVersion = matches[2];
          if (name in versions && versions[name] !== currentVersion) {
            // alert(`version mismatch: ${name} -> ${currentVersion} != ${versions[name]}`) // eslint-disable-line
            console.log('version mismatch: ' + name + ' -> ' + currentVersion + ' != ' + versions[name]);
            console.log('reloading...');
            if ('cordova' in window) {
              var filename = 'app-update.' + versions.manifest + '.' + versions.vendor + '.' + versions.client + '.zip';
              state.contentSync = window.ContentSync.sync({
                src: __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.server + '/' + filename,
                id: 'app',
                copyCordovaAssets: true
              });
              state.appIsUpdating = '0%';
              state.contentSync.on('progress', function (data) {
                state.appIsUpdating = data.progress + '%';
              });
              state.contentSync.on('complete', function (data) {
                var cacheUrl = void 0;
                if (window.device.platform === 'iOS') {
                  cacheUrl = 'http://localhost:49086/';
                } else {
                  cacheUrl = 'file://' + data.localPath + '/www/index.html';
                }
                state.appIsUpdating = 'ok';
                window.NativeStorage.setItem('cacheUrl', cacheUrl, function () {
                  window.location.reload(true);
                }, function (e) {
                  throw e;
                });
              });
              state.contentSync.on('error', function (error) {
                console.error(error);
                state.appIsUpdating = 'error';
                setTimeout(function () {
                  document.location.reload(true);
                }, 60000);
              });
            } else {
              document.location.reload(true);
            }
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    setNetworkError: function setNetworkError(state, val) {
      state.networkError = val;
    },
    setTosDate: function setTosDate(state, date) {
      state.tosDate = new Date(date);
    }
  },
  actions: {
    fetchSegments: function fetchSegments(context, isRefresh) {
      var statusEndpoint = '_mtopara_dev_' in window ? 'status-dev.php' : 'status.php';
      statusEndpoint += '?refresh=' + new Date().valueOf();
      if ('appInfo' in navigator) statusEndpoint += '&app=' + navigator.appInfo.version;
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(statusEndpoint).then(function (_ref2) {
        var response = _ref2.body;

        // if (!isRefresh) {
        context.commit('checkAppVersions', response.app);
        context.commit('checkJsVersions', response.js);
        // }
        if (response.redirect !== undefined) {
          document.location = response.redirect;
          return;
        }
        if (response.france === undefined) throw new Error('domain not found');
        context.commit('updateSegments', { segments: response.france });
        context.commit('setTosDate', response.tos);
        if (isRefresh) {
          context.commit('refreshCursor');
        } else {
          context.commit('initCursor');
        }
      }).catch(function () {
        context.commit('setNetworkError', true);
        setTimeout(function () {
          return document.location.reload(true);
        }, 60 * 1000);
      });
    },
    seek: function seek(context, time) {
      context.commit('seek', time);
    }
  }
});

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-box',
  mounted: function mounted() {
    var this$1 = this;

    window.setTimeout(function () {
      this$1.agree()
    }, 60000)
  },
  computed: {
    tosLink: function tosLink() {
      return window.portalLink('legal/')
    },
    privacyLink: function privacyLink() {
      return window.portalLink('privacy/')
    }
  },
  methods: {
    close: function close() {
      this.agree()
    },
    agree: function agree() {
      this.$store.dispatch('persistent/acceptRules', new Date())
    }
  }
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_palette__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fleche__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);






























// import testWindData from '@/test/wind-data'
// import { SwipeDetector } from 'swipedetector'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alti-winds-view',

  data: function data() {
    return {
      canvas: undefined,
      ctx: undefined,
      scaleCanvas: undefined,
      scaleCtx: undefined,
      pxRatio: window.devicePixelRatio || 1,
      waitForRedraw: false,
      cache: {}
    }
  },
  props: [
    'redraw'
  ],
  computed: {
    date: function date() {
      return String(this.$store.getters['time/date']).substring(0, 8)
    },
    run: function run() {
      return this.$store.getters['time/run']
    },
    private: function private$1() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    },
    lat: function lat() {
      return this.$store.state.persistent.center.lat
    },
    lon: function lon() {
      return this.$store.state.persistent.center.lon
    },
    dataUrl: function dataUrl() {
      if (this.run === undefined) { return undefined }
      if (this.private) { return undefined }
      return ("https://data0.meteo-parapente.com/data2017.php?run=" + (this.run) + "&location=" + (this.lat) + "," + (this.lon) + "&date=" + (this.date) + "&plot=windgram")
    },
    data: function data() {
      return this.dataUrl in this.cache ? this.cache[this.dataUrl] : undefined
    },
    loading: function loading() {
      return this.data === undefined && !this.private
    },
    colorblind: function colorblind() {
      return this.$store.state.persistent.colorblind
    },
    timezone: function timezone() {
      return this.$store.state.persistent.timezone
    },
    topAltitude: {
      get: function get() {
        return this.$store.state.persistent.windgramTopAltitude
      },
      set: function set(val) {
        this.$store.dispatch('persistent/setWindgramTopAltitude', val)
      }
    },
    windUnit: function windUnit() {
      return this.$store.state.persistent.windUnit
    }
  },
  watch: {
    redraw: function redraw() {
      this.delayedDraw()
    },
    colorblind: function colorblind() {
      this.delayedDraw()
    },
    timezone: function timezone() {
      this.delayedDraw()
    },
    dataUrl: function dataUrl() {
      this.loadData()
    },
    lat: function lat() {
      this.cache = {}
    },
    lon: function lon() {
      this.cache = {}
    },
    topAltitude: function topAltitude() {
      this.delayedDraw()
    },
    windUnit: function windUnit() {
      this.delayedDraw()
    }
  },

  mounted: function mounted() {
    var this$1 = this;

    this.canvas = this.$refs.canvas
    this.ctx = this.canvas.getContext('2d')
    this.scaleCanvas = this.$refs.scale
    this.scaleCtx = this.scaleCanvas.getContext('2d')
    window.addEventListener('resize', this.draw)
    this.$refs.scrollable.addEventListener('wheel', function (e) {
      if (e.deltY !== 0) {
        this$1.$refs.scrollable.scrollLeft += (e.deltaY * 30)
        e.preventDefault()
      }
    })
    /* const swipe = new SwipeDetector(this.$el).emitter
    swipe.on('left', () => {
      const scroll = this.$el.clientWidth + this.$el.scrollLeft - this.$el.scrollWidth
      if (scroll > 80) {
        this.$emit('swipe-tab', 1)
      }
    })
    swipe.on('right', () => {
      this.draw()
      if (this.$el.scrollLeft < -80) {
        this.$emit('swipe-tab', -1)
      }
    }) */
    this.loadData()
  },
  activated: function activated() {
    this.delayedDraw()
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.delayedDraw)
  },
  methods: {
    delayedDraw: function delayedDraw() {
      var this$1 = this;

      if (this.waitForRedraw) { return }
      this.waitForRedraw = true
      requestAnimationFrame(function () {
        this$1.draw()
        this$1.waitForRedraw = false
      })
    },
    loadData: function loadData() {
      var this$1 = this;

      var url = this.dataUrl
      if (this.data === undefined) {
        if (this.ctx !== undefined) { this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height) }
        this.$http.get(url).then(function (response) {
          if (response.body.status === 'ok') {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this$1.cache, url, response.body.data)
            this$1.delayedDraw()
          } else if (response.body.error === 'out_of_bounds') {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this$1.cache, url, 'no-data')
          }
        })
      } else {
        this.delayedDraw()
      }
    },
    draw: function draw() {
      var this$1 = this;

      /* eslint no-multi-assign: 0 */
      /* eslint no-mixed-operators: 0 */
      if (this.data === undefined || this.data === 'no-data') { return }
      var box = {
        top: 0,
        left: 0,
        h: 0,
        w: 0,
        bottom: 0
      }

      var c = this.ctx
      var w = this.canvas.width = this.canvas.clientWidth * this.pxRatio
      var h = this.canvas.height = this.canvas.clientHeight * this.pxRatio

      var sc = this.scaleCtx
      this.scaleCanvas.width = this.scaleCanvas.clientWidth * this.pxRatio
      this.scaleCanvas.height = this.scaleCanvas.clientHeight * this.pxRatio

      var colorblind = this.colorblind
      // const wind = 'kmh' // a renommer

      var scaleStep = 500

      var heureStop = 21
      var heureStart = 4
      var tz = 0
      var date = new Date(this.date.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3T00:00:00Z"))

      var data = this.data // todo

      var nZ = data[String(("0" + (heureStart - tz) + ":00")).slice(-5)].z.length

      // clear
      c.clearRect(0, 0, w, h)
      sc.clearRect(0, 0, w, h)

      // taille
      var nh = (heureStop - heureStart) + 1
      box.top = 25 * this.pxRatio
      box.left = 0 // 40 * this.pxRatio
      box.bottom = 33 * this.pxRatio
      box.h = h - box.top - box.bottom
      var colw = (w - box.left) / nh
      box.w = colw * nh
      var kmOffset = box.h / this.topAltitude

      // Terrain
      var ter = kmOffset * data[String(("0" + (heureStart - tz) + ":00")).slice(-5)].ter

      c.beginPath()
      c.rect(box.left, box.top + box.h, box.w, -ter)
      c.fillStyle = '#ccc'
      c.fill()

      for (var icol = 0; icol < nh; icol++) {
        var heure = heureStart + icol - tz
        var left = box.left + (colw * icol)

        // couche convective
        var pblh = data[String(("0" + heure + ":00")).slice(-5)].pblh * kmOffset
        c.beginPath()
        c.rect(left, box.top + box.h - ter, colw, -pblh)
        c.fillStyle = '#ffff77'
        c.fill()

        // nuages new
        for (var iz = 0; iz < nZ; iz++) {
          var altiA = data[String(("0" + (heureStart - tz) + ":00")).slice(-5)].z[iz]
          var altiB = data[String(("0" + (heureStart - tz) + ":00")).slice(-5)].z[iz + 1]
          var hauteur = (altiA - altiB) * kmOffset
          if (altiA > this$1.topAltitude) { break }
          var altiBottom = box.top + box.h - (kmOffset * altiA)
          c.beginPath()
          c.rect(left, altiBottom, colw - 12 * this$1.pxRatio, hauteur)
          c.fillStyle = 'rgba(155, 155, 155, ' + data[String(("0" + heure + ":00")).slice(-5)].cldfra[iz] + ')'
          c.fill()
        }

        // nuages
        if (isNaN(data[String(("0" + heure + ":00")).slice(-5)].cfracl)) {
          c.beginPath()
          c.fillStyle = 'rgba(155, 0, 0, 0.5)'
          c.rect(left, box.top - 25 * this$1.pxRatio, colw, 15 * this$1.pxRatio)
          c.fill()
        } else {
          var rgbL = Math.round(255 - data[String(("0" + heure + ":00")).slice(-5)].cfracl)
          var rgbM = Math.round(255 - data[String(("0" + heure + ":00")).slice(-5)].cfracm)
          var rgbH = Math.round(255 - data[String(("0" + heure + ":00")).slice(-5)].cfrach)
          c.beginPath()
          c.fillStyle = 'rgb(' + rgbH + ', ' + rgbH + ', ' + rgbH + ')'
          c.rect(left, box.top - 25 * this$1.pxRatio, colw, 5 * this$1.pxRatio)
          c.fill()
          c.beginPath()
          c.fillStyle = 'rgb(' + rgbM + ', ' + rgbM + ', ' + rgbM + ')'
          c.rect(left, box.top - 20 * this$1.pxRatio, colw, 5 * this$1.pxRatio)
          c.fill()
          c.beginPath()
          c.fillStyle = 'rgb(' + rgbL + ', ' + rgbL + ', ' + rgbL + ')'
          c.rect(left, box.top - 15 * this$1.pxRatio, colw, 5 * this$1.pxRatio)
          c.fill()
        }
      }
      // lignes nuages
      c.strokeStyle = '#aaa'
      for (var i = 2; i < 6; i++) {
        var level = box.top - (i * 5 * this$1.pxRatio) + 0.5 * this$1.pxRatio
        c.beginPath()
        c.moveTo(box.left, level)
        c.lineTo(box.left + box.w, level)
        c.lineWidth = 0.5 * this$1.pxRatio
        c.stroke()
      }

      // colonnes
      c.strokeStyle = '#ddd'
      var max = nh + 1
      for (var icol$1 = 0; icol$1 < max; icol$1++) {
        var left$1 = box.left + (colw * icol$1)
        // const milieu = left + (colw / 2)
        c.beginPath()
        c.moveTo(left$1, box.top)
        c.lineTo(left$1, box.h + box.top + box.bottom)
        c.lineWidth = 2 * this$1.pxRatio
        c.stroke()
      }

      // legende alti
      // const altiLeft = box.left - 5 * this.pxRatio
      var altiLeft = 35 * this.pxRatio

      sc.font = (14 * this.pxRatio) + "px Arial"
      sc.fillStyle = 'black'
      sc.textAlign = 'right'

      for (var i$1 = 0; i$1 < this.topAltitude / scaleStep; i$1++) {
        var alti = scaleStep * i$1
        var altiTop = box.top + box.h - (kmOffset * alti)
        sc.fillText(alti, altiLeft, altiTop)
      }
      // sc.fillText('(m)', altiLeft, box.top + 10 * this.pxRatio)
      // c.fillText('(m)', altiLeft, box.top + 25)

      // vent
      c.fillStyle = 'black'
      var isPluie = false
      var palette = 'PAL_WIND'
      if (colorblind) { palette += '_CB' }
      for (var icol$2 = 0; icol$2 < nh; icol$2++) {
        var last = h
        var heure$1 = heureStart + icol$2
        var heurez = heure$1 - tz
        var left$2 = box.left + (colw * icol$2)
        var milieu = left$2 + (colw / 2)
        c.font = (10 * this$1.pxRatio) + "px Arial"
        c.textAlign = 'left'
        for (var iz$1 = 0; iz$1 < nZ; iz$1++) {
          var alti$1 = data[String(("0" + (heureStart - tz) + ":00")).slice(-5)].z[iz$1]
          if (alti$1 > this$1.topAltitude) { break }
          var altiTop$1 = box.top + box.h - (kmOffset * alti$1)
          if (last - altiTop$1 < 10 * this$1.pxRatio) { continue }
          last = altiTop$1

          var u = data[String(("0" + heurez + ":00")).slice(-5)].umet[iz$1]
          var v = data[String(("0" + heurez + ":00")).slice(-5)].vmet[iz$1]
          var ms = Math.sqrt((u * u) + (v * v))
          var kmh = Math.round(ms * 3.6)
          /*
          switch (wind) {
            case 'ms':
              c.fillText(Math.round(ms), milieu + 4 * this.pxRatio, altiTop)
              break
            case 'nds':
              c.fillText(Math.round(ms * 1.94), milieu + 4 * this.pxRatio, altiTop)
              break
            default:
            case 'kmh':
              c.fillText(kmh, milieu + 4 * this.pxRatio, altiTop)
              break
          } */

          c.fillText(Math.round(this$1.$getwind(ms)), milieu + 4 * this$1.pxRatio, altiTop$1)

          var w$1 = (4 / 30 * kmh) * this$1.pxRatio
          // if (w>7) w=7
          var rgb = __WEBPACK_IMPORTED_MODULE_0__assets_palette__["a" /* getColor */](ms, palette) // todo
          if (w$1 > 0) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_fleche__["a" /* default */])({
              x: milieu - this$1.pxRatio,
              y: altiTop$1,
              a: Math.atan2(u, v) + Math.PI,
              s: 10 * this$1.pxRatio,
              w: w$1,
              color: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',1)'
            }, c, this$1.pxRatio)
          } else {
            c.beginPath()
            c.arc(milieu - 3 * this$1.pxRatio, altiTop$1 - 4 * this$1.pxRatio, this$1.pxRatio, 0, 2 * Math.PI, true)
            c.fill()
          }
        }

        c.textAlign = 'center'

        if (data[String(("0" + heurez + ":00")).slice(-5)].raintot >= 0.009 || isNaN(data[String(("0" + heurez + ":00")).slice(-5)].raintot)) {
          c.font = (12 * this$1.pxRatio) + "px Arial"
          var pluieTxt = ''
          if (isNaN(data[String(("0" + heurez + ":00")).slice(-5)].raintot)) {
            pluieTxt = '?'
            c.fillStyle = 'black'
          } else {
            pluieTxt = Math.round(data[String(("0" + heurez + ":00")).slice(-5)].raintot * 10) / 10
            c.fillStyle = 'navy'
          }
          c.fillText(pluieTxt, milieu, h - 21 * this$1.pxRatio)
          isPluie = true
        }

        c.font = (14 * this$1.pxRatio) + "px Arial"
        c.fillStyle = 'black'

        var heureDate = new Date(date.valueOf() + heure$1 * 3600 * 1000)
        var heuretxt = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].options.filters.moment(heureDate, 'H') + 'h'
        c.fillText(heuretxt, milieu, h - 5 * this$1.pxRatio)
      }

      // legende pluie
      if (isPluie) {
        c.font = (12 * this.pxRatio) + "px Arial"
        c.fillStyle = 'navy'
        c.textAlign = 'right'
        c.fillText('pluie', box.left - 5 * this.pxRatio, h - 21 * this.pxRatio)
      }
    }
  }
});


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'altitude-control',
  data: function data() {
    return {
      context: undefined,
      wheelHeight: undefined,
      wheelWidth: undefined,
      pxRatio: window.devicePixelRatio || 1,
      lastMove: {},
      waitForRedraw: false,
      bigLabel: false,
      bigLabelDebounce: 0,
      stepInc: undefined,
      nstep: undefined
    }
  },
  mounted: function mounted() {
    var this$1 = this;

    this.$refs.bar.addEventListener('wheel', __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(this.scrollMouseWheel, 100))
    this.context = this.$refs.wheel.getContext('2d')
    this.draw()
    window.addEventListener('resize', function () {
      this$1.draw()
    })
    window.addEventListener('keydown', this.keyScroll)
  },
  updated: function updated() {
  },
  computed: {
    angle: function angle() {
      return this.altitude * Math.PI * 2 / 1333
    },
    altitude: function altitude() {
      return this.$store.state.persistent.altitude
    },
    roundedAltitude: function roundedAltitude() {
      return this.$store.getters['persistent/roundedAltitude']
    },
    isVisible: function isVisible() {
      return this.$store.state.persistent.layer.substr(-4, 4) === 'alti'
    }
  },
  watch: {
    angle: function angle() {
      if (this.context !== undefined) {
        this.draw()
      }
    },
    isVisible: function isVisible() {
      if (this.isVisible) {
        this.showBigLabel()
        this.draw(true)
      }
    }
  },
  methods: {
    climb: function climb(height) {
      this.$store.dispatch('persistent/climbAltitude', height)
      this.showBigLabel()
    },
    beginMouseMove: function beginMouseMove(e) {
      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('mouseup', this.endMouseMove)
      window.addEventListener('mouseleave', this.endMouseMove)
      this.beginMove({ x: e.clientX, y: e.clientY })
    },
    beginTouchMove: function beginTouchMove(e) {
      window.addEventListener('touchmove', this.touchMove)
      window.addEventListener('touchend', this.endTouchMove)
      window.addEventListener('touchleave', this.endTouchMove)
      this.beginMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
      this.bigLabel = true
      this.labelTimeoutArmed = false
    },
    endTouchMove: function endTouchMove() {
      var this$1 = this;

      window.removeEventListener('touchmove', this.touchMove)
      window.removeEventListener('touchend', this.endTouchMove)
      window.removeEventListener('touchleave', this.endTouchMove)
      this.labelTimeoutArmed = true
      setTimeout(function () {
        if (!this$1.labelTimeoutArmed) { return }
        this$1.bigLabel = false
        this$1.labelTimeoutArmed = false
      }, 500)
      this.endMove()
    },
    endMouseMove: function endMouseMove() {
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('mouseup', this.endMouseMove)
      window.removeEventListener('mouseleave', this.endMouseMove)
      this.endMove()
    },
    beginMove: function beginMove(origin) {
      this.lastMove = origin
      this.$store.dispatch('runtime/showDragSurface')
    },
    doMove: function doMove(e) {
      var y = e.y - this.lastMove.y
      this.lastMove = e
      var metres = -y * 10
      this.climb(metres)
    },
    touchMove: function touchMove(e) {
      this.doMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
    },
    mouseMove: function mouseMove(e) {
      this.doMove({ x: e.clientX, y: e.clientY })
    },
    endMove: function endMove() {
      this.$store.dispatch('runtime/hideDragSurface')
    },
    scrollMouseWheel: function scrollMouseWheel(e) {
      if (e.deltaY < 0) {
        this.climb(250)
      } else if (e.deltaY > 0) {
        this.climb(-250)
      }
    },
    showBigLabel: function showBigLabel() {
      var this$1 = this;

      this.bigLabel = true
      this.bigLabelDebounce = new Date().valueOf()
      setTimeout(function () {
        if ((new Date()).valueOf() < this$1.bigLabelDebounce + 800) { return }
        this$1.bigLabel = false
        this$1.bigLabelDebounce = 0
      }, 800)
    },
    draw: function draw(force) {
      var this$1 = this;

      if (!force && this.waitForRedraw) { return }
      this.waitForRedraw = true
      requestAnimationFrame(function () {
        this$1.wheelHeight = this$1.$refs.wheel.clientHeight * this$1.pxRatio
        this$1.wheelWidth = this$1.$refs.wheel.clientWidth * this$1.pxRatio
        this$1.$refs.wheel.height = this$1.wheelHeight
        this$1.$refs.wheel.width = this$1.wheelWidth
        this$1.nstep = this$1.wheelHeight / this$1.pxRatio / 2.5
        this$1.stepInc = (2 * Math.PI) / this$1.nstep
        // TODO redraw on resize

        var h = this$1.wheelHeight
        var w = this$1.wheelWidth

        this$1.context.clearRect(0, 0, w, h)
        var a = 0
        while (a < (2 * Math.PI)) {
          var centerSin = Math.sin(this$1.angle + a)
          var centerCos = Math.cos(this$1.angle + a)
          if (centerSin < 0) {
            a += this$1.stepInc
            continue
          }
          // if (centerSin < 0) continue;
          var hh = (centerSin * h) / this$1.nstep * 2
          if (a === 0) {
            this$1.context.fillStyle = "rgba(0, 85, 255, " + centerSin + ")"
          } else {
            this$1.context.fillStyle = "rgba(170, 170, 170, " + centerSin + ")"
          }
          // ctx.fillStyle = 'rgb(119, 119, 119)'
          // this.context.shadowColor = 'rgba(0, 0, 0, ' + centerCos + ')'
          this$1.context.fillRect(0, ((h / 2) + ((centerCos * h) / 2)) - (hh / 2), w, hh)
          a += this$1.stepInc
          this$1.waitForRedraw = false
        }
      })
    },
    keyScroll: function keyScroll(e) {
      if (!this.isVisible) { return }
      switch (e.key) {
        case 'ArrowUp':
          this.climb(250)
          break
        case 'ArrowDown':
          this.climb(-250)
          break
        default:
      }
    }
  }
});


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'connexion-check',
  data: function data() {
    return {
      online: true
    }
  },
  created: function created() {
    var this$1 = this;

    if (window.navigator === undefined || window.navigator.onLine === undefined) { return }
    document.addEventListener('online', function () {
      this$1.online = true
    }, false)
    document.addEventListener('offline', function () {
      this$1.online = false
    }, false)
    this.online = window.navigator.onLine
  }
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_right_tabs__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_right_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_right_tabs__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'details-view',
  components: {
    RightTabs: __WEBPACK_IMPORTED_MODULE_0__components_right_tabs___default.a
  },
  mounted: function mounted() {
  },
  props: [
    'redraw'
  ]
});


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'drag-surface',
  computed: {
    visible: function visible() {
      return this.$store.state.runtime.dragSurface
    }
  }
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swipedetector__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swipedetector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swipedetector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timezones_json__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timezones_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_timezones_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone_builds_moment_timezone_with_data_2012_2022__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone_builds_moment_timezone_with_data_2012_2022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone_builds_moment_timezone_with_data_2012_2022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fscreen__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fscreen__);























































































































































































































































































































































































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'left-menu',
  data: function data() {
    return {
      isOpen: false,
      subMenu: null,
      timezones: __WEBPACK_IMPORTED_MODULE_1_timezones_json___default.a,
      isFullscreen: false
    }
  },
  computed: {
    interpolate: function interpolate() {
      return this.$store.state.persistent.interpolate
    },
    airspace: function airspace() {
      return this.$store.state.persistent.airspace
    },
    xcplanner: function xcplanner() {
      return this.$store.state.persistent.xcplanner
    },
    colorblind: function colorblind() {
      return this.$store.state.persistent.colorblind
    },
    experimental: function experimental() {
      return this.$store.state.persistent.experimental
    },
    contributor: function contributor() {
      return this.$store.getters['auth/isContributor']
    },
    email: function email() {
      return this.$store.getters['auth/email']
    },
    expiration: function expiration() {
      return this.$store.getters['auth/expiration']
    },
    news: function news() {
      return this.$store.getters['news/articles']
    },
    unreadNewsCount: function unreadNewsCount() {
      return this.$store.getters['news/unreadCount']
    },
    cordova: function cordova() {
      return this.$store.state.runtime.cordova
    },
    mobileBrowser: function mobileBrowser() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera

        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      }

      if (/android/i.test(userAgent)) {
        return 'Android'
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }

      return false
    },
    currentTimezone: function currentTimezone() {
      return this.$store.state.persistent.timezone
    },
    timezoneOveride: function timezoneOveride() {
      return this.$store.state.persistent.timezoneOveride
    },
    fullscreen: function fullscreen() {
      if (!__WEBPACK_IMPORTED_MODULE_3_fscreen___default.a.fullscreenEnabled || this.cordova) { return null }
      return this.isFullscreen
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_3_fscreen___default.a.fullscreenEnabled && !('cordova' in window)) {
      window.addEventListener('keydown', this.escape)
      __WEBPACK_IMPORTED_MODULE_3_fscreen___default.a.addEventListener('fullscreenchange', this.fullscreenChange, false)
    }
  },
  mounted: function mounted() {
    var swipe = new __WEBPACK_IMPORTED_MODULE_0_swipedetector__["SwipeDetector"](this.$el).emitter
    swipe.on('right', this.close)
    swipe.on('left', this.close)
  },
  methods: {
    doAction: function doAction() {},
    escape: function escape(event) {
      if (this.$data.isOpen && event.keyCode === 27) {
        this.close()
      }
    },
    close: function close() {
      this.isOpen = false
      this.openMenu('favorites')
      // this.subMenu = null
    },
    toggleSubMenu: function toggleSubMenu(event, menu) {
      var this$1 = this;

      var menuSplit = menu.split('/') || []
      if (menu === this.subMenu) {
        menuSplit.pop()
        this.subMenu = menuSplit.join('/')
      } else {
        this.subMenu = menu
        // if (true || menuSplit[0] === 'settings') {
        this.$nextTick(function () { return this$1.scrollMenu(event.target); })
        // }
      }
    },
    setLayer: function setLayer(layer) {
      this.$store.dispatch('persistent/setLayer', layer)
      this.close()
    },
    toggleInterpolation: function toggleInterpolation() {
      this.$store.dispatch('persistent/toggleInterpolation')
      this.close()
    },
    toggleAirspace: function toggleAirspace() {
      this.$store.dispatch('persistent/toggleAirspace')
      this.close()
    },
    toggleXcplanner: function toggleXcplanner() {
      this.$store.dispatch('persistent/toggleXcplanner')
      this.close()
    },
    toggleColorblind: function toggleColorblind() {
      this.$store.dispatch('persistent/toggleColorblind')
      this.close()
    },
    toggleExperimental: function toggleExperimental(event) {
      var this$1 = this;

      this.$store.dispatch('persistent/toggleExperimental')
      if (this.experimental) {
        this.$nextTick(function () {
          this$1.scrollMenu(document.getElementById('menu-experimental'))
        })
      }
    },
    toggleFullscreen: function toggleFullscreen() {
      if (this.isFullscreen) {
        __WEBPACK_IMPORTED_MODULE_3_fscreen___default.a.exitFullscreen()
      } else {
        __WEBPACK_IMPORTED_MODULE_3_fscreen___default.a.requestFullscreen(document.documentElement)
      }
      this.close()
    },
    fullscreenChange: function fullscreenChange() {
      if (__WEBPACK_IMPORTED_MODULE_3_fscreen___default.a.fullscreenElement === null) {
        this.isFullscreen = false
      } else {
        this.isFullscreen = true
      }
    },
    openContribution: function openContribution() {
      var this$1 = this;

      window.openLink(window.portalLink('users/contribute/'))
      setTimeout(function () { return this$1.$store.dispatch('runtime/showModal', 'login'); }, 3000)
      this.close()
    },
    openTour: function openTour() {
      window.openLink("https://portal.meteo-parapente.com/tour/")
      this.close()
    },
    logout: function logout() {
      this.$store.dispatch('auth/logout')
      this.openMenu('')
      this.close()
    },
    changePassword: function changePassword() {
      this.$store.dispatch('runtime/showModal', 'password')
      this.close()
    },
    openLogin: function openLogin() {
      this.$store.dispatch('runtime/showModal', 'login')
      this.close()
    },
    addFavorite: function addFavorite() {
      var this$1 = this;

      /* eslint no-alert: 0 */
      window.promptAsync(this.$pgettext('new favorite prompt', 'Enter a name'), function (name) {
        if (name === null || name === '') { return }
        this$1.$store.dispatch('favorites/add', { name: name, state: this$1.$store.state.persistent })
      })
      // this.close()
    },
    loadFavorite: function loadFavorite(id) {
      this.$store.dispatch('persistent/load', this.$store.state.favorites.list[id].state)
      this.close()
    },
    setHomeFavorite: function setHomeFavorite(id) {
      this.$store.dispatch('favorites/setHome', id)
      this.openMenu('favorites')
    },
    renameFavorite: function renameFavorite(id) {
      var this$1 = this;

      /* eslint no-alert: 0 */
      window.promptAsync(this.$pgettext('new favorite prompt', 'Enter the new name'), function (name) {
        if (name === null || name === '') { return }
        this$1.$store.dispatch('favorites/setName', { id: id, name: name })
        this$1.openMenu('favorites')
      })
    },
    updateFavorite: function updateFavorite(id, name) {
      var this$1 = this;

      var text = this.$pgettext('updateFavorite', 'Overwrite favorite "%{ name }"?')
      text = this.$gettextInterpolate(text, { name: name })
      window.confirmAsync(text, function () {
        this$1.$store.dispatch('favorites/update', { id: id, newState: this$1.$store.state.persistent })
        this$1.openMenu('favorites')
      })
    },
    deleteFavorite: function deleteFavorite(id, name) {
      var this$1 = this;

      var text = this.$pgettext('deleteFavorite', 'Delete favorite "%{ name }"?')
      text = this.$gettextInterpolate(text, { name: name })
      window.confirmAsync(text, function () {
        this$1.$store.dispatch('favorites/delete', id)
        this$1.openMenu('favorites')
      })
    },
    moveToUpFavorite: function moveToUpFavorite(id) {
      this.$store.dispatch('favorites/moveToUp', id)
      this.openMenu('favorites')
    },
    resetStore: function resetStore() {
      var this$1 = this;

      var text = this.$pgettext('resetStore', 'Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!')
      window.confirmAsync(text, function () {
        this$1.$store.dispatch('persistent/resetStore')
        this$1.$store.dispatch('favorites/resetStore')
        this$1.$store.dispatch('news/resetStore')
        this$1.$store.dispatch('auth/resetStore')
        this$1.close()
      })
    },
    openNews: function openNews(ref) {
      var url = ref.url;
      var id = ref.id;

      window.openLink(url)
      this.$store.dispatch('news/setRead', id)
    },
    openCommunity: function openCommunity() {
      window.openLink('https://community.meteo-parapente.com')
      this.close()
    },
    changeLanguage: function changeLanguage(lang) {
      this.$store.dispatch('persistent/setLang', lang)
      this.openMenu('settings')
    },
    openTranslatePage: function openTranslatePage() {
      window.openLink('https://poeditor.com/join/project/kmNoPTFkQP')
    },
    openHelp: function openHelp() {
      window.openLink(window.portalLink(''))
      this.close()
    },
    openAndroidApp: function openAndroidApp() {
      window.openLink('market://details?id=com.meteo_parapente')
    },
    openIOSApp: function openIOSApp() {
      window.openLink('itms-apps://itunes.apple.com/app/id1255974302')
    },
    isMenuOpen: function isMenuOpen(path) {
      return this.subMenu && this.subMenu.search(path) >= 0
    },
    openMenu: function openMenu(event, menu) {
      this.subMenu = menu
      // this.$nextTick(() => this.scrollMenu(event.target))
    },
    toggleTimezoneOveride: function toggleTimezoneOveride() {
      this.$store.dispatch('persistent/setTimezoneOveride', !this.timezoneOveride)
      if (!this.timezoneOveride) {
        var timezone = __WEBPACK_IMPORTED_MODULE_2_moment_timezone_builds_moment_timezone_with_data_2012_2022___default.a.tz.guess()
        this.$store.dispatch('persistent/setTimezone', timezone)
        // this.openMenu('settings')
      }
    },
    setTimezone: function setTimezone(timezone) {
      this.$store.dispatch('persistent/setTimezone', timezone)
      this.$store.dispatch('persistent/setTimezoneOveride', true)
      // this.openMenu('settings')
    },
    scrollMenu: function scrollMenu(target) {
      try {
        target.scrollIntoView()
        var parent = target.parentNode
        var offset = 40 * 2
        if (parent.scrollTopMax > parent.scrollTop + offset) {
          parent.scrollTop -= offset
        }
      } catch (e) {}
    },
    setWindUnit: function setWindUnit(unit) {
      this.$store.dispatch('persistent/setWindUnit', unit)
      this.close()
    }
  }
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sideview_button__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sideview_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sideview_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_map_view__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_map_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_map_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vertical_splitter__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vertical_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_vertical_splitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_details_view__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_details_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_details_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_time_control__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_time_control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_time_control__);






















var SMALLSCREEN = 568
var MAPMIN = 320
var DETAILSMIN = 248

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-view',
  components: {
    SideviewButton: __WEBPACK_IMPORTED_MODULE_0__components_sideview_button___default.a,
    MapView: __WEBPACK_IMPORTED_MODULE_1__components_map_view___default.a,
    VerticalSplitter: __WEBPACK_IMPORTED_MODULE_2__components_vertical_splitter___default.a,
    DetailsView: __WEBPACK_IMPORTED_MODULE_3__components_details_view___default.a,
    TimeControl: __WEBPACK_IMPORTED_MODULE_4__components_time_control___default.a
  },
  data: function data() {
    return {
      viewportWidth: undefined,
      detailsVisible: true
    }
  },
  computed: {
    smallView: function smallView() {
      return this.viewportWidth < SMALLSCREEN
    },
    splitterVisible: function splitterVisible() {
      return !this.smallView && this.detailsVisible
    },
    appWidth: function appWidth() {
      return this.splitterVisible ? this.viewportWidth : 2 * this.viewportWidth
    },
    appLeft: function appLeft() {
      // return (!this.splitterVisible && !this.detailsVisible) ? -this.viewportWidth : 0
      return (this.splitterVisible || this.detailsVisible) ? 0 : -this.viewportWidth
    },
    splitRatio: function splitRatio() {
      return this.$store.state.persistent.splitRatio
    },
    freeWidth: function freeWidth() {
      return this.viewportWidth - MAPMIN - DETAILSMIN
    },
    splitterLeft: function splitterLeft() {
      return Math.round(DETAILSMIN + (this.splitRatio * this.freeWidth) - 10)
    },
    mapWidth: function mapWidth() {
      return this.splitterVisible ? this.viewportWidth - this.splitterLeft - 11 : this.viewportWidth
    },
    detailsWidth: function detailsWidth() {
      return this.splitterVisible ? this.splitterLeft + 10 : this.viewportWidth
    }
    // ,
    // center() {
    //  return this.$store.state.persistent.center
    // }
  },
  watch: {
    smallView: function smallView() {
      this.detailsVisible = !this.smallView
    }
    // center() {
    //  setTimeout(() => {
    //    this.detailsVisible = true
    //  }, 300)
    // }
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize)
  },
  mounted: function mounted() {
    // this.detailsVisible = !this.smallView
    setTimeout(this.handleResize, 500)
    this.handleResize()
  },
  methods: {
    handleResize: function handleResize() {
      this.viewportWidth = window.innerWidth
    },
    toggleView: function toggleView() {
      this.detailsVisible = !this.detailsVisible
    },
    beginTouchMove: function beginTouchMove() {
      window.addEventListener('touchmove', this.touchMove)
      window.addEventListener('touchend', this.endTouchMove)
      window.addEventListener('touchleave', this.endTouchMove)
      this.beginMove()
    },
    beginMouseMove: function beginMouseMove(e) {
      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('mouseup', this.endMouseMove)
      window.addEventListener('mouseleave', this.endMouseMove)
      this.beginMove()
    },
    endTouchMove: function endTouchMove() {
      window.removeEventListener('touchmove', this.touchMove)
      window.removeEventListener('touchend', this.endTouchMove)
      window.removeEventListener('touchleave', this.endTouchMove)
      this.endMove()
    },
    endMouseMove: function endMouseMove() {
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('mouseup', this.endMouseMove)
      window.removeEventListener('mouseleave', this.endMouseMove)
      this.endMove()
    },
    beginMove: function beginMove() {
      // this.disableTransitions()
      this.$store.dispatch('runtime/showDragSurface')
    },
    endMove: function endMove() {
      // this.enableTransitions()
      this.$store.dispatch('runtime/hideDragSurface')
    },
    doMove: function doMove(e) {
      var ratio = (e.x - DETAILSMIN) / this.freeWidth
      if (ratio < 0) {
        ratio = 0
      } else if (ratio > 1) {
        ratio = 1
      }
      this.$store.dispatch('persistent/setSplitRatio', ratio)
    },
    touchMove: function touchMove(e) {
      this.doMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
    },
    mouseMove: function mouseMove(e) {
      this.doMove({ x: e.clientX, y: e.clientY })
    }
  }
});



/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_palette__ = __webpack_require__(15);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-legend',

  data: function data() {
    return {
      context: undefined,
      pxRatio: window.devicePixelRatio || 1,
      highlighted: false,
      layerLegends: {}
    }
  },

  computed: {
    layer: function layer() {
      return this.$store.state.persistent.layer
    },
    colorblind: function colorblind() {
      return this.$store.state.persistent.colorblind
    },
    roundedAltitude: function roundedAltitude() {
      return this.$store.getters['persistent/roundedAltitude']
    },
    palette: function palette() {
      var palette = this.layerLegends[this.layer].palette
      return this.colorblind ? palette + '_CB' : palette
    },
    legendTxtA: function legendTxtA() {
      return this.layerLegends[this.layer].legendA
    },
    legendTxtB: function legendTxtB() {
      var txt = this.layerLegends[this.layer].legendB
      return txt === '_ALTI_' ? ((this.roundedAltitude) + "m") : txt
    },
    unitTxt: function unitTxt() {
      var unit = this.layerLegends[this.layer].unit
      return unit === '_WIND_UNIT_' ? this.$convert.currentLabel : unit
    },
    windUnit: function windUnit() {
      return this.$store.state.persistent.windUnit
    },
    lang: function lang() {
      return this.$store.state.persistent.lang
    }
  },

  watch: {
    layer: function layer() {
      this.draw()
    },
    colorblind: function colorblind() {
      this.draw()
    },
    roundedAltitude: function roundedAltitude() {
      this.draw()
    },
    lang: function lang() {
      this.layerLegends = this.updateLayerLegends()
      this.draw()
    },
    windUnit: function windUnit() {
      this.layerLegends = this.updateLayerLegends()
      this.draw()
    }
  },

  mounted: function mounted() {
    this.layerLegends = this.updateLayerLegends()
    this.context = this.$refs.legend.getContext('2d')
    window.addEventListener('resize', this.draw)
    this.draw()
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.draw)
  },

  methods: {
    toggleHighlight: function toggleHighlight() {
      this.highlighted = !this.highlighted
      this.draw()
    },
    hideHighlight: function hideHighlight() {
      this.highlighted = false
      this.draw()
    },
    draw: function draw() {
      window.requestAnimationFrame(this._draw)
    },
    _draw: function _draw() {
      var this$1 = this;

      var height = this.$refs.legend.clientHeight * this.pxRatio
      var width = this.$refs.legend.clientWidth * this.pxRatio

      this.$refs.legend.width = width
      this.$refs.legend.height = height

      var ctx = this.context
      ctx.clearRect(0, 0, width, height)

      var w = width
      var h = height

      ctx.clearRect(0, 0, w, h)

      var paddingTop = 55 * this.pxRatio
      var paddingBottom = 55 * this.pxRatio

      var freeHeight = h - paddingTop - paddingBottom

      var palette = __WEBPACK_IMPORTED_MODULE_0__assets_palette__["b" /* getPalette */](this.palette)

      var colorCount = palette.length
      // const colorWidth = 8
      var colorWidth = this.highlighted ? 24 : 8
      colorWidth *= this.pxRatio
      var colorHeight = Math.round(freeHeight / colorCount)
      var colorLeft = 0
      // const colorLeft = this.highlighted ? 1 : w - colorWidth
      var textLeft = colorWidth + (4 * this.pxRatio)

      ctx.font = "bold " + (12 * this.pxRatio) + "px sans-serif"
      ctx.textBaseline = 'alphabetic'
      ctx.textAlign = 'start'
      var textColor = 'white'
      var textShadowBlur = 6
      var colorShadowBlur = 1

      ctx.shadowColor = 'black'
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 0

      var i = 0
      ctx.shadowBlur = colorShadowBlur
      var bottom = h - paddingBottom

      if (!this.highlighted) {
        ctx.fillStyle = "rgba(" + (palette[i][1]) + ", " + (palette[i][2]) + ", " + (palette[i][3]) + ", " + (palette[i][4]) + ")"
        ctx.fillRect(colorLeft, h, colorWidth, -paddingBottom)
      }

      for (i = 0; i < colorCount; i++) {
        ctx.fillStyle = "rgba(" + (palette[i][1]) + "," + (palette[i][2]) + ", " + (palette[i][3]) + ", " + (palette[i][4]) + ")"
        ctx.fillRect(colorLeft, bottom, colorWidth, -colorHeight)
        bottom -= colorHeight
      }

      i = colorCount - 1
      if (!this.highlighted) {
        ctx.fillStyle = "rgba(" + (palette[i][1]) + ", " + (palette[i][2]) + ", " + (palette[i][3]) + ", " + (palette[i][4]) + ")"
        ctx.fillRect(colorLeft, 0, colorWidth, bottom)
      }

      ctx.shadowBlur = textShadowBlur
      ctx.fillStyle = textColor

      bottom = h - paddingBottom
      // ctx.fillText(this.layer, textLeft, bottom - 2 - 16)

      for (i = 0; i < colorCount; i++) {
        if (((i % 2) === 0)) {
          var text = (this$1.palette === 'PAL_WIND' || this$1.palette === 'PAL_WIND_CB') ? Math.round(this$1.$getwind(palette[i][0])) : palette[i][0]
          ctx.fillText(text, textLeft, bottom - (2 * this$1.pxRatio))
        }
        bottom -= colorHeight
      }

      ctx.font = "italic bold " + (12 * this.pxRatio) + "px sans-serif"
      ctx.fillText(this.unitTxt, textLeft, bottom - (2 * this.pxRatio))

      ctx.font = "bold " + (12 * this.pxRatio) + "px sans-serif"

      bottom -= 15 * this.pxRatio
      ctx.fillText(this.legendTxtB, textLeft, bottom)

      bottom -= 15 * this.pxRatio
      ctx.fillText(this.legendTxtA, textLeft, bottom)
    },
    updateLayerLegends: function updateLayerLegends() {
      return {
        pbltop: {
          palette: 'PAL_ALTI',
          unit: this.$pgettext('layer unit', 'm MSL'),
          legendA: this.$pgettext('layer legend A', 'Boundary Layer'),
          legendB: this.$pgettext('layer legend B', 'Ceiling')
        },
        pblh: {
          palette: 'PAL_ALTI',
          unit: this.$pgettext('layer unit', 'm AGL'),
          legendA: this.$pgettext('layer legend A', 'Boundary Layer'),
          legendB: this.$pgettext('layer legend B', 'Thickness')
        },
        ter: {
          palette: 'PAL_ALTI',
          unit: this.$pgettext('layer unit', 'm MSL'),
          legendA: this.$pgettext('layer legend A', 'Topography'),
          legendB: this.$pgettext('layer legend B', 'Model')
        },
        wstar: {
          palette: 'PAL_THERMIQUES',
          unit: this.$pgettext('layer unit', 'm/s'),
          legendA: this.$pgettext('layer legend A', 'Thermals'),
          legendB: this.$pgettext('layer legend B', 'Velocity')
        },
        bsratio: {
          palette: 'PAL_BSRATIO',
          unit: this.$pgettext('layer unit', 'dimensionless'),
          legendA: this.$pgettext('layer legend A', 'Thermals'),
          legendB: this.$pgettext('layer legend B', 'Shearing')
        },
        windsfc: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: this.$pgettext('layer legend B', 'Surface')
        },
        windblavg: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: this.$pgettext('layer legend B', 'Boundary Layer')
        },
        windbltop: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: this.$pgettext('layer legend B', 'Ceiling of BL')
        },
        windalti: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: '_ALTI_'
        },
        blwindshear: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind Shear'),
          legendB: this.$pgettext('layer legend B', 'Boundary Layer')
        },
        cfracl: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'Low altitude')
        },
        cfrach: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'High altitude')
        },
        cfracm: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'Medium altitude')
        },
        cfract: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'All altitudes')
        },
        cfracalti: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: '_ALTI_'
        },
        tc2: {
          palette: 'PAL_TEMP',
          unit: this.$pgettext('layer unit', '°C'),
          legendA: this.$pgettext('layer legend A', 'Temperature'),
          legendB: this.$pgettext('layer legend B', '2m AGL')
        },
        tempalti: {
          palette: 'PAL_TEMP',
          unit: this.$pgettext('layer unit', '°C'),
          legendA: this.$pgettext('layer legend A', 'Temperature'),
          legendB: '_ALTI_'
        },
        wblmaxmin: {
          palette: 'PAL_CONVERGENCE',
          unit: this.$pgettext('layer unit', 'm/s'),
          legendA: this.$pgettext('layer legend A', 'Vertical Motion'),
          legendB: this.$pgettext('layer legend B', 'Boundary Layer')
        },
        raintot: {
          palette: 'PAL_RAIN',
          unit: this.$pgettext('layer unit', 'mm/h'),
          legendA: this.$pgettext('layer legend A', 'Precipitations'),
          legendB: this.$pgettext('layer legend B', '1 hour')
        },
        slp: {
          palette: 'PAL_PRESS',
          unit: this.$pgettext('layer unit', 'hPa'),
          legendA: this.$pgettext('layer legend A', 'Pressure'),
          legendB: this.$pgettext('layer legend B', 'Mean Sea Level')
        }
      }
    }
  }
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_left_menu__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_left_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_left_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_search_box__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_search_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_search_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notification__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accept_terms__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accept_terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_accept_terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_altitude_control__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_altitude_control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_altitude_control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_map_legend__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_map_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_map_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_super_map__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_super_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_super_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xc_planner__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xc_planner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xc_planner__);

































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'map-view',
  components: {
    LeftMenu: __WEBPACK_IMPORTED_MODULE_0__components_left_menu___default.a,
    SearchBox: __WEBPACK_IMPORTED_MODULE_1__components_search_box___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2__components_notification___default.a,
    AltitudeControl: __WEBPACK_IMPORTED_MODULE_4__components_altitude_control___default.a,
    MapLegend: __WEBPACK_IMPORTED_MODULE_5__components_map_legend___default.a,
    XcPlanner: __WEBPACK_IMPORTED_MODULE_7__components_xc_planner___default.a,
    SuperMap: __WEBPACK_IMPORTED_MODULE_6__components_super_map___default.a,
    AcceptTerms: __WEBPACK_IMPORTED_MODULE_3__components_accept_terms___default.a
  },
  props: [
    'width',
    'mapVisible'
  ],
  computed: {
    xcplanner: function xcplanner() {
      return this.$store.state.persistent.xcplanner
    },
    needAgreement: function needAgreement() {
      return new Date(this.$store.state.persistent.acceptedRules) < new Date(this.$store.state.time.tosDate)
    }
  },
  methods: {
    zoom: function zoom(diff) {
      var mapSync = Object.assign({}, this.$store.state.runtime.mapSync)
      mapSync.zoom += diff
      this.$store.dispatch('runtime/mapSync', mapSync)
    }
  }
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_login__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_contribute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_password__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modals_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_private__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_private___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modals_private__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_app_market_update__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_app_market_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_app_market_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_news__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_news___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_news__);



























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-dialog',
  components: {
    LoginModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_login___default.a,
    ContributeModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute___default.a,
    PasswordModal: __WEBPACK_IMPORTED_MODULE_2__components_modals_password___default.a,
    PrivateModal: __WEBPACK_IMPORTED_MODULE_3__components_modals_private___default.a,
    AppMarketUpdateModal: __WEBPACK_IMPORTED_MODULE_4__components_modals_app_market_update___default.a,
    NewsModal: __WEBPACK_IMPORTED_MODULE_5__components_modals_news___default.a
  },
  data: function data() {
    return {
    }
  },
  computed: {
    modal: function modal() {
      return this.$store.state.runtime.modal
    },
    loading: function loading() {
      return this.$store.state.runtime.modalIsLoading
    },
    private: function private$1() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    }
  },
  watch: {
    private: function private$2(isPrivate, wasPrivate) {
      if (isPrivate && !wasPrivate) {
        this.$store.dispatch('runtime/showModal', 'private')
      } else if (this.modal === 'private') {
        this.$store.dispatch('runtime/closeModal')
      }
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
    if (new Date(this.$store.state.persistent.dissmissedNews) < new Date('2022-05-20T19:00:00Z')) {
      this.$store.dispatch('runtime/showModal', 'news')
    }
  },
  methods: {
  }
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);













 // eslint-disable-line no-unused-vars

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-market-update-modal',
  components: {
  },
  data: function data() {
    return {
    }
  },
  mounted: function mounted() {
  },
  methods: {
    openStore: function openStore() {
      var url
      if (window.device.platform === 'Android') {
        url = "market://details?id=com.meteo_parapente"
      } else if (window.device.platform === 'iOS') {
        url = "itms-apps://itunes.apple.com/app/id1255974302"
      } else {
        throw Error(("Unknown platform: " + (window.device.platform)))
      }
      window.open(url, '_system')
    }
  },
  computed: {
    versions: function versions() {
      return this.$store.state.time.needAppMarketUpdate
    }
  }
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail__);



























































































































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contribute-modal',
  components: {
  },
  data: function data() {
    return {
      email1: this.$store.getters['auth/email'],
      email2: this.$store.getters['auth/email'],
      product: '1-year-standard',
      pricing: {
        standard: 3,
        reduced: 2,
        supporter: 5,
        currency: 'EUR'
      },
      forceErrorMessage: false,
      loading: false,
      success: false,
      initialized: false
    }
  },
  mounted: function mounted() {
    var this$1 = this;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.server + '/api/pricing')
    .then(function (response) {
      var pricing = response.body
      pricing.standard = Math.round(pricing.standard / 12 * 100) / 100
      pricing.reduced = Math.round(pricing.reduced / 12 * 100) / 100
      pricing.supporter = Math.round(pricing.supporter / 12 * 100) / 100
      if (pricing.currency) {
        this$1.pricing = pricing
      }
    })
  },
  computed: {
    emailOk: function emailOk() {
      if (!this.email1 || !this.email2) { return null }
      if (this.email1 !== this.email2) { return false }
      if (!__WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail___default()(this.email1)) { return false }
      if (!__WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail___default()(this.email2)) { return false }
      return true
    },
    currencySymbol: function currencySymbol() {
      return String(this.pricing.currency).replace('EUR', '€').replace('USD', '$').replace('GBP', '£')
    }
  },
  methods: {
    close: function close() {
      this.$store.dispatch('runtime/closeModal')
      if (document.location.hash === '#/contribute') { document.location.hash = '#/' }
    },
    contribute: function contribute() {
      if (!this.emailOk) {
        this.forceErrorMessage = true
        setTimeout(this.clearErrorMessage, 2000)
        return
      }
      this.contributeWebsite()
    },
    clearErrorMessage: function clearErrorMessage() {
      this.forceErrorMessage = false
    },
    contributeWebsite: function contributeWebsite() {
      var this$1 = this;

      var locale = this.$store.state.persistent.lang
      this.loading = true
      var productId
      if (this.product === '1-year-standard') {
        productId = '540669'
      } else if (this.product === '1-year-reduced') {
        productId = '540704'
      } else if (this.product === '1-year-supporter') {
        productId = '556897'
      } else {
        throw Error('invalid product id')
      }
      setTimeout(function () { return this$1.$store.dispatch('runtime/showModal', 'login'); }, 10000)
      window.open(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.server + "/api/contribute?product=" + productId + "&locale=" + locale + "&email=" + (this.email1), '_top')
    }
  },
  watch: {
    email1: function email1() {
      this.clearErrorMessage()
    },
    email2: function email2() {
      this.clearErrorMessage()
    }
  }
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);












































































 // eslint-disable-line no-unused-vars

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login-modal',
  components: {
  },
  data: function data() {
    return {
      email: undefined,
      password: undefined,
      stayConnected: true,
      expired: false,
      badLogin: false,
      error: false,
      loading: false,
      success: false,
      showPassword: false
    }
  },
  mounted: function mounted() {
  },
  methods: {
    close: function close() {
      this.$store.dispatch('runtime/closeModal')
    },
    go: function go(destination) {
      this.$store.dispatch('runtime/showModal', destination)
    },
    contribute: function contribute() {
      window.openLink(window.portalLink('users/contribute/'))
    },
    login: function login() {
      var this$1 = this;

      this.loading = true
      this.badLogin = false
      this.error = false
      this.expired = false
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.server + '/api/user/login', { email: this.email, password: this.password })
      .then(function (response) {
        if (response.body.redirect !== undefined) {
          document.location = response.body.redirect
          return
        }
        this$1.$store.dispatch('auth/login', response.body.token)
        this$1.success = true
        setTimeout(this$1.close, 1000)
      })
      .catch(function (response) {
        switch (response.status) {
          case 401:
            this$1.badLogin = true
            break
          case 403:
            this$1.expired = response.body.expiration
            break
          default:
            this$1.error = true
        }
      })
      .finally(function () {
        this$1.loading = false
      })
    },
    togglePassword: function togglePassword() {
      this.showPassword = !this.showPassword
    }
  },
  computed: {
    expirationDate: function expirationDate() {
      if (!this.expired) { return null }
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].options.filters.moment(this.expired, 'll')
    }
  }
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_contribute__);























 // eslint-disable-line no-unused-vars


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'private-modal',
  components: {
    ContributeModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute___default.a
  },
  data: function data() {
    return {
    }
  },
  mounted: function mounted() {
  },
  methods: {
    close: function close() {
      this.$store.dispatch('runtime/closeModal')
      this.$store.dispatch('persistent/dissmissNews', new Date())
    },
    open: function open() {
      window.openLink("https://portal.meteo-parapente.com/tour/")
      this.$store.dispatch('persistent/dissmissNews', new Date())
    }
  }
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
















































































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'password-modal',
  components: {
  },
  data: function data() {
    return {
      email: undefined,
      password1: undefined,
      password2: undefined,
      showPassword: false,
      error: false,
      loading: false,
      success: false
    }
  },
  mounted: function mounted() {
  },
  methods: {
    close: function close() {
      if (document.location.hash === '#/password') { document.location.hash = '#/' }
      this.$store.dispatch('runtime/closeModal')
    },
    changePassword: function changePassword() {
      var this$1 = this;

      if (!this.passwordOk) { return }
      this.loading = true
      this.error = false
      var email = this.contributor ? this.contributorEmail : this.email
      var lang = this.$store.state.persistent.lang
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.server + '/api/user/password', { email: email, password: this.password1, lang: lang })
      .then(function (response) {
        this$1.success = true
      })
      .catch(function (response) {
        this$1.error = true
      })
      .finally(function () {
        this$1.loading = false
      })
    },
    togglePassword: function togglePassword() {
      this.showPassword = !this.showPassword
    }
  },
  computed: {
    contributor: function contributor() {
      return this.$store.getters['auth/isContributor']
    },
    contributorEmail: function contributorEmail() {
      return this.$store.getters['auth/email']
    },
    passwordOk: function passwordOk() {
      if (!this.password1 || !this.password2) { return null }
      return (this.password1 === this.password2)
    }
  }
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_contribute__);

















































 // eslint-disable-line no-unused-vars


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'private-modal',
  components: {
    ContributeModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_contribute___default.a
  },
  data: function data() {
    return {
    }
  },
  mounted: function mounted() {
  },
  computed: {
    date: function date() {
      var roundedTime = this.$store.getters['time/roundedTime']
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].options.filters.moment(roundedTime, 'dddd Do')
    },
    aboutLink: function aboutLink() {
      return window.portalLink('about-us/')
    }
  },
  methods: {
    login: function login() {
      this.$store.dispatch('runtime/showModal', 'login')
    },
    contribute: function contribute() {
      var this$1 = this;

      window.openLink(window.portalLink('users/contribute/'))
      setTimeout(function () { return this$1.$store.dispatch('runtime/showModal', 'login'); }, 3000)
    }
  }
});


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-box',
  data: function data() {
    return {
      timedOut: false
    }
  },
  mounted: function mounted() {
    var this$1 = this;

    window.setTimeout(function () {
      this$1.timedOut = true
      if (this$1.lastArticle !== false) {
        this$1.$store.dispatch('news/setRead', this$1.lastArticle.id)
      }
    }, 10000)
  },
  methods: {
    openNews: function openNews(ref) {
      var url = ref.url;
      var id = ref.id;

      window.openLink(url)
      this.$store.dispatch('news/setRead', id)
    }
  },
  computed: {
    somethingNew: function somethingNew() {
      return this.unreadNewsCount > 0
    },
    visible: function visible() {
      return this.somethingNew && !this.timedOut
    },
    unreadNewsCount: function unreadNewsCount() {
      return this.$store.getters['news/unreadCount']
    },
    lastArticle: function lastArticle() {
      var articles = this.$store.getters['news/unreadArticles']
      return articles.length > 0 ? articles[Math.floor(Math.random() * articles.length)] : false
    }
  }
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_alti_winds_view__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_alti_winds_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_alti_winds_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sounding_view__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sounding_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sounding_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);










































// import TourOfEurope from '@/components/tour-of-europe'
// import { SwipeDetector } from 'swipedetector'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'right-tabs',
  components: { AltiWindsView: __WEBPACK_IMPORTED_MODULE_0__components_alti_winds_view___default.a, SoundingView: __WEBPACK_IMPORTED_MODULE_1__components_sounding_view___default.a },
  data: function data() {
    return {
      tab: 0,
      tabCount: 2
    }
  },
  props: [
    'redraw'
  ],
  computed: {
    windUnit: {
      set: function set(val) {
        this.$store.dispatch('persistent/setWindUnit', val)
      },
      get: function get() {
        return this.$store.state.persistent.windUnit
      }
    }
  },
  mounted: function mounted() {
    this.$refs.header.addEventListener('wheel', __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(this.scrollTab, 300))
    // const swipe = new SwipeDetector(this.$el).emitter
    // swipe.on('up', () => {
    //   this.close()
    // })
    // swipe.on('down', () => {
    //  this.swipeTab(1)
    // })
  },
  methods: {
    close: function close() {
      this.$emit('close-details')
    },
    swipeTab: function swipeTab(distance) {
      var tab = this.tab + distance
      tab %= this.tabCount
      if (tab < 0) { tab += this.tabCount }
      this.tab = tab
    },
    scrollTab: function scrollTab(e) {
      if (e.deltaY < 0) {
        this.swipeTab(-1)
      } else if (e.deltaY > 0) {
        this.swipeTab(1)
      }
    }
  }
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rules-acceptation',
  data: function data() {
    return {
    }
  },
  computed: {
    isNews: function isNews() {
      return new Date(this.$store.state.persistent.acceptedRules) < new Date('2018-08-02')
    }
  },
  methods: {
    close: function close() {
      this.$store.dispatch('persistent/acceptRules', new Date('2018-08-02'))
    },
    openLinkFr: function openLinkFr() {
      window.openLink('https://community.meteo-parapente.com/t/the-rules-of-meteo-parapente-le-reglement-de-meteo-parapente/560/4')
    },
    openLinkEn: function openLinkEn() {
      window.openLink('https://community.meteo-parapente.com/t/the-rules-of-meteo-parapente-le-reglement-de-meteo-parapente/560')
    }
  }
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-box',
  data: function data() {
    return {
      searchInput: '',
      showResults: false,
      locationResult: [],
      lastSearch: undefined
    }
  },
  created: function created() {
    window.addEventListener('keydown', this.escape)
  },
  methods: {
    escape: function escape(event) {
      if (this.$data.showResults && event.keyCode === 27) {
        this.showResults = false
        if (document.activeElement) {
          document.activeElement.blur()
        }
      }
    },
    open: function open(location) {
      // this.$store.dispatch('runtime/showDragSurface')
      // setTimeout(() => {
      //   this.$store.dispatch('runtime/hideDragSurface')
      // }, 500)
      this.showResults = false
      this.$router.push({
        name: 'app',
        params: {
          name: location.properties.name,
          region: location.properties.region,
          country: location.properties.country,
          lat: location.geometry.coordinates[1],
          lon: location.geometry.coordinates[0],
          zoom: 11
        }
      })
    },
    delayedBlur: function delayedBlur() {
      var this$1 = this;

      setTimeout(function () {
        this$1.showResults = false
      }, 1000)
    }
  },
  computed: {
    focusQuery: function focusQuery() {
      var center = this.$store.state.persistent.center
      return ("&focus.point.lat=" + (center.lat) + "&focus.point.lon=" + (center.lon))
    }
  },
  watch: {
    showResults: function showResults() {
      if (this.showResults === false) {
        this.searchInput = ''
      }
    },
    searchInput: function searchInput() {
      var this$1 = this;

      if (this.searchInput === '') {
        this.locationResult = []
      }

      if (this.searchInput === this.lastSearch) {
        return
      }

      this.lastSearch = this.searchInput

      if (this.searchInput.length < 3) { return }

      // console.log('Search ' + this.searchInput)

      var query = "https://api-search.meteo-parapente.com/v1/autocomplete?text=" + (this.searchInput) + (this.focusQuery)
      this.$http.get(query)
        .then(function (ref) {
          var response = ref.body;

          if (this$1.searchInput !== response.geocoding.query.text) { return }
          this$1.locationResult = response.features
        })
    }
  }
});


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sideview-button'
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_palette__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fleche__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
























// import testData from '@/test/sounding-data'


// import { SwipeDetector } from 'swipedetector'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sounding-view',

  props: {
    /* topAltitude: {
      type: Number,
      default: 4000
    }, */
    title: {
      type: String,
      default: 'No title'
    },
    showMixingRatios: {
      type: Boolean,
      default: false
    },
    showSaturationAdiabats: {
      type: Boolean,
      default: false
    },
    showDryAdiabats: {
      type: Boolean,
      default: false
    },
    redraw: { type: String }
  },

  data: function data() {
    return {
      canvas: undefined,
      context: undefined,
      height: 0,
      width: 0,
      pxRatio: window.devicePixelRatio || 1,
      waitForRedraw: false,
      cache: {}
    }
  },
  computed: {
    date: function date() {
      return this.$store.getters['time/date']
    },
    run: function run() {
      return this.$store.getters['time/run']
    },
    private: function private$1() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    },
    roundedTime: function roundedTime() {
      return this.$store.getters['time/roundedTime']
    },
    hours: function hours() {
      var hours = this.roundedTime.getUTCHours()
      return String(("0" + hours)).slice(-2)
    },
    minutes: function minutes() {
      var minutes = this.roundedTime.getUTCMinutes()
      return String(("0" + minutes)).slice(-2)
    },
    time: function time() {
      return ((this.hours) + ":" + (this.minutes))
    },
    lat: function lat() {
      return this.$store.state.persistent.center.lat
    },
    lon: function lon() {
      return this.$store.state.persistent.center.lon
    },
    dataUrl: function dataUrl() {
      if (this.private) { return undefined }
      if (this.run === undefined) { return undefined }
      return ("https://data0.meteo-parapente.com/data2017.php?run=" + (this.run) + "&location=" + (this.lat) + "," + (this.lon) + "&date=" + (this.date) + "&plot=sounding&time=" + (this.time))
    },
    data: function data() {
      return this.dataUrl in this.cache ? this.cache[this.dataUrl] : undefined
    },
    loading: function loading() {
      return this.data === undefined && !this.private
    },
    colorblind: function colorblind() {
      return this.$store.state.persistent.colorblind
    },
    topAltitude: {
      get: function get() {
        return this.$store.state.persistent.soundingTopAltitude
      },
      set: function set(val) {
        this.$store.dispatch('persistent/setSoundingTopAltitude', val)
      }
    },
    windUnit: function windUnit() {
      return this.$store.state.persistent.windUnit
    }
  },
  watch: {
    redraw: function redraw() {
      this.delayedDraw()
    },
    colorblind: function colorblind() {
      this.delayedDraw()
    },
    dataUrl: function dataUrl(value) {
      if (value === undefined) {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
      } else {
        this.loadData()
      }
    },
    lat: function lat() {
      this.cache = {}
      if (this.context !== undefined) { this.context.clearRect(0, 0, this.canvas.width, this.canvas.height) }
    },
    lon: function lon() {
      this.cache = {}
      if (this.context !== undefined) { this.context.clearRect(0, 0, this.canvas.width, this.canvas.height) }
    },
    date: function date() {
      // this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    topAltitude: function topAltitude() {
      this.delayedDraw()
    },
    windUnit: function windUnit() {
      this.delayedDraw()
    }
  },
  mounted: function mounted() {
    this.canvas = this.$refs.canvas
    this.context = this.$refs.canvas.getContext('2d')
    window.addEventListener('resize', this.delayedDraw)
    /* const swipe = new SwipeDetector(this.$el).emitter
    swipe.on('left', () => {
      this.$emit('swipe-tab', 1)
    })
    swipe.on('right', () => {
      this.$emit('swipe-tab', -1)
    }) */
    this.loadData()
  },
  activated: function activated() {
    this.delayedDraw()
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.delayedDraw)
  },

  methods: {
    delayedDraw: function delayedDraw() {
      var this$1 = this;

      if (this.waitForRedraw) { return }
      this.waitForRedraw = true
      requestAnimationFrame(function () {
        this$1.draw()
        this$1.waitForRedraw = false
      })
    },
    loadData: function loadData() {
      var this$1 = this;

      var url = this.dataUrl
      if (this.data === undefined) {
        this.$http.get(url).then(function (response) {
          if (response.body.status === 'ok') {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this$1.cache, url, response.body.data[Object.keys(response.body.data)[0]])
            this$1.delayedDraw()
          } else if (response.body.error === 'out_of_bounds') {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this$1.cache, url, 'no-data')
          }
        })
      } else {
        this.delayedDraw()
      }
    },
    draw: function draw() {
      var this$1 = this;

      /* eslint no-mixed-operators: 0 */
      /* eslint camelcase: 0 */
      /* eslint no-floating-decimal: 0 */
      /* eslint dot-notation: 0 */
      /* eslint new-cap: 0 */
      /* eslint no-unreachable: 0 */
      /* eslint no-multi-assign: 0 */
      if (this.data === undefined || this.data === 'no-data') { return }

      this.width = this.canvas.width = this.canvas.clientWidth * this.pxRatio // todo: DPI
      this.height = this.canvas.height = this.canvas.clientHeight * this.pxRatio
      this.context.clearRect(0, 0, this.width, this.height)

      var data = this.data // todo
      // const windUnit = 'kmh'

      var top = this.topAltitude
      var altiOffset = 250
      var m = {
        l: 30 * this.pxRatio,
        r: 30 * this.pxRatio,
        t: 10 * this.pxRatio,
        b: 18 * this.pxRatio
      }
      var boxH = this.height - m.t - m.b
      var boxW = this.width - m.l - m.r
      var alt2px = boxH / top

      this.context.font = (11 * this.pxRatio) + "px Arial"

      var altiY = function (alti) { return this$1.height - (alti * alt2px) - m.b; }

      var tempXY = function (temp, alti) {
        var minT = -15
        var maxT = 50

        var y = altiY(alti)
        // let x = m.l + boxW/3 + alti/top*boxW
        var x = m.l + (temp - minT + 0.009767 * alti) / (maxT - minT) * boxW

        return {
          x: x,
          y: y
        }
      }

      var gamma_s = function (T, p) {
        // T en celsius
        // p en hPa

        // from https://code.google.com/p/pywrfplot/

        var cp = 1005.
        var R = 287.04 // gas constant air
        var Rv = 461.5 // gas constant vapor
        var eps = R / Rv
        var L = 2.501e6 // latent heat of vaporization
        var T_zero = 273.15

        // constants used to calculate moist adiabatic lapse rate
        // See formula 3.16 in Rogers&Yau
        var a = 2. / 7.
        var b = eps * L * L / (R * cp)
        var c = a * L / R

        p *= 100 // hPa to Pa

        var esat = 611.2 * Math.exp(17.67 * T / (T + 243.5)) // Rogers&Yau Formula 2.17
        var wsat = eps * esat / (p - esat) // Rogers&Yau 2.18

        var numer = a * (T + T_zero) + c * wsat
        var denom = p * (1 + b * wsat / (Math.pow( (T + T_zero), 2 )))

        return numer / denom * 100 // en hPa
      }

      var T_rwsA = function (r_ws, p) {
        // T en celsius
        // p en hPa

        // http://www.lthe.fr/PagePerso/molinie/pdf_files/slide_meteo.pdf
        // p *= 100 // hPa -> Pa
        r_ws /= 1000 // en kg/kg

        // pression partielle eau saturée, en Pa
        var e_ws = r_ws * p / (0.622 + r_ws)
        var lg = Math.log(e_ws / 6.107) / Math.LN10
        var T = 237.3 * lg / (7.5 - lg)

        return T // en g/Kg
      }

      var T_rwsB = function (w, p) {
        p *= 100
        w /= 1000 // en kg/kg

        var R = 287.04 // gas constant air
        var Rv = 461.5 // gas constant vapor
        var eps = R / Rv

        var es = w * p / (w + eps)

        var ln = Math.log(es / 611.2)
        var T = ln * 243.5 / (17.67 - ln)

        return T
      }

      var nPoints = data['z'].length

      // ter
      var txtLeft = m.l - 3 * this.pxRatio

      var terB = altiY(0)
      var terT = altiY(data['ter'])

      this.context.beginPath()
      this.context.rect(m.l, terT, boxW, terB - terT)
      this.context.fillStyle = '#ccc'
      this.context.fill()
      this.context.textAlign = 'end'
      this.context.fillStyle = '#777'
      this.context.fillText(Math.round(data['ter']), txtLeft, terT)

      // couche conv
      var blB = altiY(data['ter'])
      var blT = altiY(data['ter'] + data['pblh'])
      this.context.beginPath()
      this.context.rect(m.l, blT, boxW, blB - blT)
      this.context.fillStyle = '#ffff77'
      this.context.fill()
      this.context.fillStyle = 'black'

      // altis --------------------
      var nAltis = Math.ceil(top / altiOffset) + 1
      var right = this.width - m.r

      // let txtLeft = m.l - 3
      this.context.textAlign = 'end'
      this.context.strokeStyle = '#BDBDBD'
      for (var i = 0; i < nAltis; i++) {
        var alti = i * altiOffset
        var y = altiY(alti) + 0.5 * this$1.pxRatio
        if (i % 4 === 0) {
          this$1.context.fillText(alti, txtLeft, y)
          this$1.context.lineWidth = 1.5 * this$1.pxRatio
        } else {
          this$1.context.lineWidth = 0.5 * this$1.pxRatio
        }
        this$1.context.beginPath()
        this$1.context.moveTo(m.l, y)
        this$1.context.lineTo(right, y)
        this$1.context.stroke()
      }

      if (this.showMixingRatios) {
        // rapports de mélange
        this.context.textAlign = 'center'
        var rm = [.4, 1, 2, 3, 5, 8, 12, 20]
        this.context.lineWidth = this.pxRatio
        this.context.strokeStyle = '#5F4C0B'
        this.context.fillStyle = '#5F4C0B'
        this.context['setLineDash']([2 * this.pxRatio])

        for (var i$1 = 0; i$1 < rm.length; i$1++) {
          var temp = T_rwsA(rm[i$1], data['p'][0])
          var A$1 = tempXY(temp, data['z'][0])
          this$1.context.rect(A$1.x, 0, 10 * this$1.pxRatio, 10 * this$1.pxRatio)
          this$1.context.fill()
          this$1.context.fillText(rm[i$1], A$1.x, A$1.y + 10 * this$1.pxRatio)
          this$1.context.beginPath()
          this$1.context.moveTo(A$1.x, A$1.y)
          for (var j = 1; j < nPoints; j++) {
            if (data['p'][j] < 400) { break }
            temp = T_rwsB(rm[i$1], data['p'][j])
            A$1 = tempXY(temp, data['z'][j])
            this$1.context.lineTo(A$1.x, A$1.y)
          }
          this$1.context.stroke()
        }
        this.context['setLineDash']([])
      }

      if (this.showSaturationAdiabats) {
        // adiabatique saturée
        this.context.lineWidth = this.pxRatio
        this.context.strokeStyle = 'green'
        this.context['setLineDash']([6 * this.pxRatio, 2 * this.pxRatio])
        for (var t = 0; t < 20; t++) {
          var temp$1 = 30 - 5 * t - 0.009767 * data['z'][0]
          var A$2 = tempXY(temp$1, data['z'][0])
          this$1.context.beginPath()
          this$1.context.moveTo(A$2.x, A$2.y)
          for (var i$2 = 1; i$2 < nPoints; i$2++) {
            var dp = data['p'][i$2 - 1] - data['p'][i$2]
            temp$1 -= dp * gamma_s(temp$1, data['p'][i$2])
            var B = tempXY(temp$1, data['z'][i$2])
            this$1.context.lineTo(B.x, B.y)
          }
          this$1.context.stroke()
        }
        this.context['setLineDash']([])
      }

      if (this.showDryAdiabats) {
        // adiabatique seche -9,767 K/km
        this.context.lineWidth = 0.5 * this.pxRatio
        this.context.strokeStyle = 'green'
        for (var i$3 = 0; i$3 < 10; i$3++) {
          var temp$2 = 30 - 10 * i$3
          var A$3 = tempXY(temp$2, 0)
          var B$1 = tempXY(temp$2 - top * (9.767) / 1000, top)
          this$1.context.beginPath()
          this$1.context.moveTo(A$3.x, A$3.y)
          this$1.context.lineTo(B$1.x, B$1.y)
          this$1.context.stroke()
        }
      }

      // axe temps
      this.context.lineWidth = 1
      this.context.strokeStyle = '#BDBDBD'
      this.context.textAlign = 'start'
      this.context.fillStyle = 'black'
      var bottom = this.height - m.b + 13 * this.pxRatio
      for (var i$4 = 0; i$4 < 10; i$4++) {
        var temp$3 = 30 - 10 * i$4
        if (temp$3 === 0) {
          this$1.context.lineWidth = 1.5 * this$1.pxRatio
        } else {
          this$1.context.lineWidth = this$1.pxRatio
        }
        var A$4 = tempXY(temp$3, 0)
        var B$2 = tempXY(temp$3, top)
        this$1.context.beginPath()
        this$1.context.moveTo(A$4.x, A$4.y)
        this$1.context.lineTo(B$2.x, B$2.y)
        this$1.context.stroke()
        this$1.context.fillText(temp$3, A$4.x, bottom)
      }
      this.context.textAlign = 'end'
      this.context.fillText('T (°C)', m.l + boxW - 2 * this.pxRatio, bottom)

      // température vs alti

      this.context.lineWidth = 2 * this.pxRatio

      for (var i$5 = 1; i$5 < nPoints; i$5++) {
        var dZ = data['z'][i$5] - data['z'][i$5 - 1]
        var dT = (data['tc'][i$5] - data['tc'][i$5 - 1]) / dZ
        var dp$1 = data['p'][i$5] - data['p'][i$5 - 1]
        var dTs = (dp$1 * gamma_s(data['tc'][i$5], data['p'][i$5])) / dZ
        if (dT <= -0.009767) {
          this$1.context.strokeStyle = '#C02A00'
        } else if (dT < dTs) {
          this$1.context.strokeStyle = '#0AC000'
        } else {
          this$1.context.strokeStyle = 'black'
        }

        var A$5 = tempXY(data['tc'][i$5 - 1], data['z'][i$5 - 1])
        var B$3 = tempXY(data['tc'][i$5], data['z'][i$5])
        this$1.context.beginPath()
        this$1.context.moveTo(A$5.x, A$5.y)
        this$1.context.lineTo(B$3.x, B$3.y)
        this$1.context.stroke()
        // this.context.lineTo(B.x-2, B.y)
        // this.context.lineTo(B.x+2, B.y)
        // this.context.lineTo(B.x, B.y)
      }

      // temp td vs alti
      this.context.beginPath()
      var A = tempXY(data['td'][0], data['z'][0])
      this.context.moveTo(A.x, A.y)
      for (var i$6 = 1; i$6 < nPoints; i$6++) {
        var B$4 = tempXY(data['td'][i$6], data['z'][i$6])
        this$1.context.lineTo(B$4.x, B$4.y)
      }
      this.context.strokeStyle = 'blue'
      this.context.stroke()

      // haut
      this.context.fillStyle = 'white'
      this.context.fillRect(m.l, 0, boxW, m.t)

      // titre
      // this.context.font = '14px Arial'
      // this.context.fillStyle = 'black'
      // this.context.textAlign = 'left'

      // this.context.fillText(this.title, m.l, 14)

      // droite
      var left = m.l + boxW

      this.context.fillStyle = 'white'
      this.context.fillRect(left, 0, m.r, this.height)

      // vent
      this.context.fillStyle = 'black'
      this.context.font = (10 * this.pxRatio) + "px Arial"
      this.context.textAlign = 'left'
      var last = altiY(0)
      for (var iz = 0; iz < nPoints; iz++) {
        var alti$1 = data['z'][iz]
        if (alti$1 > top) { break }
        var alti_top = altiY(alti$1)
        if (last - alti_top < 10 * this$1.pxRatio) { continue }
        last = alti_top
        var milieu = left + m.r / 2
        var u = data['umet'][iz]
        var v = data['vmet'][iz]
        var ms = Math.sqrt(u * u + v * v)
        var kmh = Math.round(ms * 3.6)
        this$1.context.fillText(Math.round(this$1.$getwind(ms)), milieu + 4 * this$1.pxRatio, alti_top)
        /* switch (windUnit) {
          case 'ms':
            this.context.fillText(Math.round(ms), milieu + 4 * this.pxRatio, alti_top)
            break
          default:
          case 'kmh':
            this.context.fillText(kmh, milieu + 4 * this.pxRatio, alti_top)
            break
          case 'nds':
            this.context.fillText(Math.round(ms * 1.94 * this.pxRatio), milieu + 4, alti_top)
            break
        } */
        var w = (4 / 30 * kmh) * this$1.pxRatio
        var rgb = __WEBPACK_IMPORTED_MODULE_0__assets_palette__["a" /* getColor */](ms, this$1.colorblind ? 'PAL_WIND_CB' : 'PAL_WIND')
        if (w > 0.1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_fleche__["a" /* default */])({
            x: milieu - this$1.pxRatio,
            y: alti_top,
            a: Math.atan2(u, v) + Math.PI,
            s: 10 * this$1.pxRatio,
            w: w,
            color: ("rgba(" + (rgb.r) + "," + (rgb.g) + "," + (rgb.b) + ",1)")
          }, this$1.context, this$1.pxRatio)
        } else {
          this$1.context.beginPath()
          this$1.context.arc(milieu - 3 * this$1.pxRatio, alti_top - 4 * this$1.pxRatio, this$1.pxRatio, 0, 2 * Math.PI, true)
          this$1.context.fill()
        }
      }
    }
  }
});


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nprogress__);









__WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.configure({
  // showSpinner: false,
  parent: '#map'
})

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'super-map',
  data: function data() {
    return {
      map: {},
      loadingLayer: null,
      loadedLayer: null,
      airspaceLayer: null,
      layerOptions: {
        // noWrap: true
      },
      showLoader: false,
      layerHash: undefined,
      debounceUrl: undefined,
      marker: undefined
    }
  },
  props: [
    'width',
    'visible'
  ],
  computed: {
    layer: function layer() {
      return this.$store.state.persistent.layer
    },
    airspace: function airspace() {
      return this.$store.state.persistent.airspace
    },
    colorblind: function colorblind() {
      return this.$store.state.persistent.colorblind
    },
    date: function date() {
      return this.$store.getters['time/date']
    },
    run: function run() {
      return this.$store.getters['time/run']
    },
    private: function private$1() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    },
    altitude: function altitude() {
      return this.$store.getters['persistent/roundedAltitude']
    },
    tileUrl: function tileUrl() {
      if (this.private) { return '' }
      var date = this.date
      var run = this.run
      var layer = this.layer
      if (this.layer === 'windalti') {
        layer = "wind" + (this.altitude)
      } else if (this.layer === 'cfracalti') {
        layer = "cfrac" + (this.altitude)
      } else if (this.layer === 'tempalti') {
        layer = "temp" + (this.altitude)
      } else if (this.layer === 'walti') {
        layer = "w" + (this.altitude)
      }
      var style = 'tile'
      if (!this.colorblind && !this.interpolate) {
        style = 'noip'
      } else if (this.colorblind && this.interpolate) {
        style = 'cbip'
      } else if (this.colorblind && !this.interpolate) {
        style = 'cbnn'
      }
      return ("https://{s}-rasp.meteo-parapente.com/tiles/rasp.php/" + run + "/" + date + "/france/" + layer + "/{z}/{x}/{y}/" + style + ".png")
    },
    interpolate: function interpolate() {
      return this.$store.state.persistent.interpolate
    },
    center: function center() {
      return this.$store.state.persistent.center || { lat: 0, lon: 0, zoom: 1 }
    },
    centerLeaflet: function centerLeaflet() {
      return __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.latLng([this.center.lat, this.center.lon])
    },
    syncData: function syncData() {
      return this.$store.state.runtime.mapSync
    }
  },
  watch: {
    tileUrl: function tileUrl() {
      this.updateLayer()
    },
    width: function width() {
      var this$1 = this;

      window.Raven.context({
        extra: {
          watcher: 'width',
          center: JSON.stringify(this.center),
          centerLeaflet: JSON.stringify(this.centerLeaflet)
        }
      }, function () {
        // console.log('invalidateSize width')
        this$1.map.invalidateSize(false)
        // if (!this.map.getBounds().contains(this.centerLeaflet)) {
        // this.map.flyTo(this.centerLeaflet)
        this$1.map.panTo(this$1.centerLeaflet)
        // }
      })
    },
    visible: function visible() {
      var this$1 = this;

      window.Raven.context({
        extra: {
          watcher: 'visible',
          center: JSON.stringify(this.center),
          centerLeaflet: JSON.stringify(this.centerLeaflet)
        }
      }, function () {
        // console.log('toggle visible')
        this$1.map.invalidateSize(false)
        this$1.updateLayer()
      })
    },
    centerLeaflet: function centerLeaflet() {
      var this$1 = this;

      window.Raven.context({
        extra: {
          watcher: 'centerLeaflet',
          center: JSON.stringify(this.center),
          centerLeaflet: JSON.stringify(this.centerLeaflet)
        }
      }, function () {
        this$1.marker.setLatLng(this$1.centerLeaflet)
        this$1.map.setZoom(this$1.center.zoom)
        if (!this$1.map.getBounds().contains(this$1.centerLeaflet)) {
          // this.map.flyTo(this.centerLeaflet)
          this$1.map.panTo(this$1.centerLeaflet)
        }
      })
    },
    airspace: function airspace() {
      if (this.airspace && !this.map.hasLayer(this.airspaceLayer)) {
        this.map.addLayer(this.airspaceLayer)
      } else if (!this.airspace && this.map.hasLayer(this.airspaceLayer)) {
        this.map.removeLayer(this.airspaceLayer)
      }
    },
    syncData: function syncData() {
      // if (this.syncData === null) return
      var currentCenter = this.map.getCenter()
      var currentLat = currentCenter.lat
      var currentLon = currentCenter.lng
      var currentZoom = this.map.getZoom()
      var latDiff = Math.abs(this.syncData.lat - currentLat)
      var lonDiff = Math.abs(this.syncData.lon - currentLon)
      if (latDiff > 0.000001 || lonDiff > 0.000001) {
        this.map.panTo(__WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.latLng([this.syncData.lat, this.syncData.lon]))
      }
      if (currentZoom !== this.syncData.zoom) {
        this.map.setZoom(this.syncData.zoom)
      }
    }
  },
  mounted: function mounted() {
    var this$1 = this;

    var mapOptions = {
      center: this.centerLeaflet,
      zoom: this.center.zoom,
      attributionControl: false,
      zoomControl: false,
      fadeAnimation: false,
      zoomAnimation: false,
      markerZoomAnimation: false // bug marker qui n'apparait pas ?
    }

    var map = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.map('map', mapOptions)

    var getOptions = function (options) {
      return Object.assign(Object.assign({}, this$1.layerOptions), options)
    }

    var geoShadedLayer = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer('https://geo-{s}.meteo-parapente.com/shaded/{z}/{x}/{y}.png', getOptions({
      zIndex: 2,
      maxNativeZoom: 11
    }))
    geoShadedLayer.addTo(map)

    var geoOsmLayer = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer('https://geo-{s}.meteo-parapente.com/osm/{z}/{x}/{y}.png', getOptions({
      zIndex: 3,
      minZoom: 11
    }))
    geoOsmLayer.addTo(map)

    this.airspaceLayer = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer('https://maps.openaip.net/geowebcache/service/tms/1.0.0/openaip_basemap@EPSG%3A900913@png/{z}/{x}/{y}.png', {
      zIndex: 4,
      tms: true
    })
    if (this.airspace) { this.airspaceLayer.addTo(map) }

    var iconOptions = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Icon.Default.prototype.options
    iconOptions.iconUrl = 'img/marker-icon.png'
    iconOptions.iconRetinaUrl = 'img/marker-icon-2x.png'
    iconOptions.shadowUrl = 'img/marker-shadow.png'
    iconOptions.shadowRetinaUrl = 'img/marker-shadow.png'

    __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.control.scale({ imperial: false }).addTo(map)

    var markerOptions = {
      draggable: true,
      icon: __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.icon(iconOptions)
    }
    this.marker = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.marker(this.centerLeaflet, markerOptions).addTo(map)
    this.marker.on('dragend', function (event) {
      var latlng = event.target.getLatLng()
      this$1.$router.push({
        name: 'app',
        params: {
          lat: Math.round(latlng.lat * 10000) / 10000,
          lon: Math.round(latlng.lng * 10000) / 10000,
          zoom: this$1.map.getZoom()
        }
      })
    })
    map.on('click', function (event) {
      this$1.marker.setLatLng([event.latlng.lat, event.latlng.lng])
      this$1.$router.push({
        name: 'app',
        params: {
          lat: Math.round(event.latlng.lat * 10000) / 10000,
          lon: Math.round(event.latlng.lng * 10000) / 10000,
          zoom: event.target.getZoom()
        }
      })
    })
    map.on('zoomend', this.sync)
    map.on('moveend', this.sync)
    map.keyboard.disable()
    this.map = map
    this.updateLayer()
    this.sync()
  },
  methods: {
    sync: function sync() {
      var center = this.map.getCenter()
      var zoom = this.map.getZoom()
      this.$store.dispatch('runtime/mapSync', {
        lat: center.lat,
        lon: center.lng,
        zoom: zoom
      })
    },
    updateLayer: function updateLayer() {
      var this$1 = this;

      // console.log('updateLayer')
      if (!this.visible) {
        // console.log('no update hidden')
        return
      }
      if (this.debounceUrl === this.tileUrl) {
        // console.log('debounce url')
        return
      }
      // console.log('switch')
      this.debounceUrl = this.tileUrl
      // console.log('create', this.date)
      var newLayer = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer(this.tileUrl, this.layerOptions)
      newLayer.setZIndex(1)

      newLayer.on('loading', function () {
        this$1.showLoader = true
        setTimeout(function () {
          if (this$1.showLoader) { __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.start() }
        }, 300)
      })
      newLayer.on('load', function () {
        this$1.showLoader = false
        __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.done()
      })
      newLayer.once('load', function () {
        // console.log('loaded', this.date)
        this$1.loadingLayer = null
        if (this$1.loadedLayer !== null) {
          this$1.map.removeLayer(this$1.loadedLayer)
        }
        newLayer.setZIndex(0)
        this$1.loadedLayer = newLayer

        // this.map.eachLayer(layer => {
          // console.log(layer._url)
        // })
      })

      if (this.loadingLayer !== null) {
        // console.log('abort', this.loadingLayer._url)
        this.map.removeLayer(this.loadingLayer)
      }
      this.loadingLayer = newLayer

      newLayer.addTo(this.map)
    },
    vrac: function vrac() {
      // flyTo [coords], zoom
      // mouseEventToLatLng
      // map.on('click', function(e) {
      // alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng)
      // });
    }
  }
});


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022__);













































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'time-control',
  data: function data() {
    return {
      context: undefined,
      wheelHeight: undefined,
      wheelWidth: undefined,
      pxRatio: window.devicePixelRatio || 1,
      lastMove: {},
      waitForRedraw: false,
      bigLabel: false,
      bigLabelDebounce: 0,
      stepInc: undefined,
      nstep: undefined,
      right: undefined,
      lastClick: new Date(0),
      daysMenu: false,
      pressed: false
    }
  },
  props: [
    'view-width',
    'shadow'
  ],
  mounted: function mounted() {
    this.updateRight()
    this.$refs.handle.addEventListener('wheel', __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(this.scrollMouseWheel, 100))
    this.wheelHeight = this.$refs.wheel.clientHeight * this.pxRatio
    this.wheelWidth = this.$refs.wheel.clientWidth * this.pxRatio
    this.$refs.wheel.height = this.wheelHeight
    this.$refs.wheel.width = this.wheelWidth
    this.nstep = this.wheelWidth / this.pxRatio / 2.5
    this.stepInc = (2 * Math.PI) / this.nstep
    this.context = this.$refs.wheel.getContext('2d')
    this.draw()
    window.addEventListener('keydown', this.keyScroll)
  },
  computed: {
    currentTime: function currentTime() {
      return this.$store.state.time.cursor
    },
    currentRun: function currentRun() {
      var run = this.$store.getters['time/run']
      return run.substring(6, 8) + '>' + run.substring(8) + 'Z' // run.replace(/(\d{4})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4Z')
    },
    currentZoneOffset: function currentZoneOffset() {
      var name = this.$store.state.persistent.timezone
      var zone = __WEBPACK_IMPORTED_MODULE_1_moment_timezone_builds_moment_timezone_with_data_2012_2022___default.a.tz(name).format('Z')
      return 'UTC' + zone
    },
    roundedTime: function roundedTime() {
      return this.$store.getters['time/roundedTime']
    },
    angle: function angle() {
      var hours = this.currentTime / (3600 * 1000)
      return hours * Math.PI * 2 / 12
    },
    run: function run() {
      return this.$store.getters['time/run'].substring(8)
    },
    days: function days() {
      var days = this.$store.state.time.segments.slice()
      days.reverse()
      return days
    },
    hours: function hours() {
      var hours = []
      for (var time = this.segment.startTime.valueOf(); time <= this.segment.stopTime.valueOf(); time += 30 * 60 * 1000) {
        hours.push(time)
      }
      return hours
    },
    segment: function segment() {
      return this.$store.getters['time/segment']
    },
    contributor: function contributor() {
      return this.$store.getters['auth/isContributor']
    }
  },
  watch: {
    angle: function angle() {
      if (this.context !== undefined) {
        this.draw()
      }
    },
    viewWidth: function viewWidth() {
      this.updateRight()
    },
    shadow: function shadow() {}
  },
  methods: {
    seek: function seek(time) {
      this.daysMenu = false
      this.$store.dispatch('time/seek', time)
      this.showBigLabel()
    },
    beginMouseMove: function beginMouseMove(e) {
      this.handleMenuClick()
      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('mouseup', this.endMouseMove)
      window.addEventListener('mouseleave', this.endMouseMove)
      this.beginMove({ x: e.clientX, y: e.clientY })
    },
    beginTouchMove: function beginTouchMove(e) {
      e.preventDefault()
      this.handleMenuClick()
      window.addEventListener('touchmove', this.touchMove)
      window.addEventListener('touchend', this.endTouchMove)
      window.addEventListener('touchleave', this.endTouchMove)
      this.beginMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
      this.bigLabel = true
      this.labelTimeoutArmed = false
    },
    endTouchMove: function endTouchMove() {
      var this$1 = this;

      window.removeEventListener('touchmove', this.touchMove)
      window.removeEventListener('touchend', this.endTouchMove)
      window.removeEventListener('touchleave', this.endTouchMove)
      this.labelTimeoutArmed = true
      setTimeout(function () {
        if (!this$1.labelTimeoutArmed) { return }
        this$1.bigLabel = false
        this$1.labelTimeoutArmed = false
      }, 500)
      this.endMove()
    },
    endMouseMove: function endMouseMove() {
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('mouseup', this.endMouseMove)
      window.removeEventListener('mouseleave', this.endMouseMove)
      this.endMove()
    },
    beginMove: function beginMove(origin) {
      this.pressed = true
      this.lastMove = origin
      this.$store.dispatch('runtime/showDragSurface')
    },
    doMove: function doMove(e) {
      var x = e.x - this.lastMove.x
      this.lastMove = e
      // const y = Math.abs(this.moveOrigin.y - e.y)
      //  this.wheelTime += x / 120
      var secondes = x * 180
      // console.log(x, secondes)
      this.seek(secondes * 1000)
    },
    touchMove: function touchMove(e) {
      this.doMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
    },
    mouseMove: function mouseMove(e) {
      this.doMove({ x: e.clientX, y: e.clientY })
    },
    endMove: function endMove() {
      this.pressed = false
      this.$store.dispatch('runtime/hideDragSurface')
    },
    scrollMouseWheel: function scrollMouseWheel(e) {
      if (e.deltaX > 0 || e.deltaY > 0) {
        this.seek(1 * 1800 * 1000)
      } else if (e.deltaX < 0 || e.deltaY < 0) {
        this.seek(-1 * 1800 * 1000)
      }
    },
    showBigLabel: function showBigLabel() {
      var this$1 = this;

      this.bigLabel = true
      this.bigLabelDebounce = new Date().valueOf()
      setTimeout(function () {
        if ((new Date()).valueOf() < this$1.bigLabelDebounce + 800) { return }
        this$1.bigLabel = false
        this$1.bigLabelDebounce = 0
      }, 800)
    },
    draw: function draw() {
      var this$1 = this;

      if (this.waitForRedraw) { return }
      this.waitForRedraw = true
      requestAnimationFrame(function () {
        var h = this$1.wheelHeight
        var w = this$1.wheelWidth

        this$1.context.clearRect(0, 0, w, h)
        var a = 0
        while (a < (2 * Math.PI)) {
          var centerSin = Math.sin(this$1.angle + a)
          var centerCos = Math.cos(this$1.angle + a)
          if (centerCos < 0) {
            a += this$1.stepInc
            continue
          }
          // if (centerSin < 0) continue;
          var ww = (centerCos * w) / this$1.nstep * 2
          if (a === 0) {
            this$1.context.fillStyle = "rgba(0, 85, 255, " + centerCos + ")"
          } else {
            this$1.context.fillStyle = "rgba(170, 170, 170, " + centerCos + ")"
          }
          // ctx.fillStyle = 'rgb(119, 119, 119)'
          // this.context.shadowColor = 'rgba(0, 0, 0, ' + centerCos + ')'
          this$1.context.fillRect(((w / 2) + ((centerSin * w) / 2)) - (ww / 2), 0, ww, h)
          a += this$1.stepInc
          this$1.waitForRedraw = false
        }
      })
    },
    updateRight: function updateRight() {
      if (this.$refs.control === undefined) { this.right = undefined }
      var right = (parseInt(this.viewWidth, 10) - this.$refs.control.clientWidth) / 2
      this.right = right + 'px'
    },
    handleMenuClick: function handleMenuClick() {
      var this$1 = this;

      if (this.daysMenu) {
        this.daysMenu = false
      } else {
        setTimeout(function () {
          if (!this$1.pressed) {
            this$1.daysMenu = true
            this$1.$nextTick(function () {
              var hourLine =
              document.getElementsByClassName('active-hour')[0]
              try {
                hourLine.scrollIntoView()
                var parent = hourLine.parentNode
                var offset = 40 * 2
                if (parent.scrollTopMax > parent.scrollTop + offset) {
                  parent.scrollTop -= offset
                }
              } catch (e) {}
            })
          }
        }, 200)
      }
    },
    setDay: function setDay(newDay) {
      var this$1 = this;

      var nDays = (newDay.startTime - this.segment.startTime) / 24 / 3600 / 1000

      // ugly hack
      // TODO : revoir système de segments
      var max = Math.abs(nDays)
      var delta = (nDays < 0 ? -24 : 24) * 3600 * 1000
      for (var i = 0; i < max; i++) {
        this$1.seek(delta)
      }
    },
    setHour: function setHour(newHour) {
      var delta = newHour - this.currentTime
      this.seek(delta)
    },
    keyScroll: function keyScroll(e) {
      if (this.$store.state.runtime.modal) { return }
      switch (e.key) {
        case 'ArrowLeft':
          this.seek(-30 * 60 * 1000)
          break
        case 'ArrowRight':
          this.seek(30 * 60 * 1000)
          break
        default:
      }
    }
  }
});


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);








 // eslint-disable-line no-unused-vars

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-update-modal',
  components: {
  },
  data: function data() {
    return {
    }
  },
  mounted: function mounted() {
  },
  methods: {
  },
  computed: {
    appIsUpdating: function appIsUpdating() {
      return this.$store.state.time.appIsUpdating
    }
  }
});


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vertical-splitter'
});


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_xcplanner_js__ = __webpack_require__(162);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xc-planner',
  data: function data() {
    return {
      map: null,
      movingMarker: false
    }
  },
  computed: {
    sync: function sync() {
      return this.$store.state.runtime.mapSync
    }
  },
  watch: {
    sync: function sync() {
      this.doSync()
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
    if (this.$store.state.runtime.touchscreen) {
      alert(this.$pgettext('xc planner', 'XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com'))  // eslint-disable-line no-alert
      this.$store.dispatch('persistent/toggleXcplanner')
      return
    }
    if (window.google === undefined || window.google.maps === undefined) {
      var script = document.createElement('script')
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAeL75QTVdyogmANb1M0UKxcrE7LiCPqm0&libraries=geometry,places'
      script.onload = this.init
      var firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      this.init()
    }
  },
  methods: {
    init: function init() {
      var this$1 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_xcplanner_js__["a" /* default */])(this.$pgettext, function (map) {
        this$1.map = map
        var backDiv = document.getElementById('map')
        var xcDiv = document.getElementById('xc-map')

        var events = [
          ['wheel', WheelEvent],
          ['click', MouseEvent],
          ['dblclick', MouseEvent],
          ['mousedown', MouseEvent],
          ['mouseup', MouseEvent] ]
        // TODO : fix touch events

        events.forEach(function (event) {
          var name = event[0]
          var EventType = event[1]
          xcDiv.addEventListener(name, function (e) {
            // console.log(e.target.parentNode.className)
            if (name === 'mouseup') { this$1.movingMarker = false }
            if (e.target.tagName === 'AREA' && name !== 'wheel') {
              if (name === 'mousedown') { this$1.movingMarker = true }
              return
            }
            if (/control/.test(e.target.parentNode.className)) { return }
            if (/control/.test(e.target.parentNode.parentNode.className)) { return }
            var newEvent = new EventType(name, e)
            backDiv.dispatchEvent(newEvent)
          })
        })
        map.addListener('center_changed', function () {
          if (!this$1.movingMarker) { return }
          var center = map.getCenter()
          var zoom = map.getZoom()
          var lat = center.lat()
          var lon = center.lng()
          this$1.$store.dispatch('runtime/mapSync', {
            lat: lat,
            lon: lon,
            zoom: zoom
          })
        })
        this$1.doSync()
      })
    },
    doSync: function doSync() {
      if (this.map === null) { return }
      if (this.movingMarker) { return }
      this.map.setCenter({
        lat: this.sync.lat,
        lng: this.sync.lon
      })
      this.map.setZoom(this.sync.zoom)
      this.map.panTo(this.map.getCenter())
    }
  }
});


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_view_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_drag_surface_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_drag_surface_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_drag_surface_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connexion_check_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connexion_check_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_connexion_check_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_rules_acceptation_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_rules_acceptation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_rules_acceptation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_dialog__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modal_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_update_progress__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_update_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_update_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone_builds_moment_timezone_with_data_2012_2022__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone_builds_moment_timezone_with_data_2012_2022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone_builds_moment_timezone_with_data_2012_2022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);




































// import NewsModal from '@/components/news-modal.vue'




// import { init as analytics } from '@/plugins/analytics'




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { MainView: __WEBPACK_IMPORTED_MODULE_0__components_main_view_vue___default.a, DragSurface: __WEBPACK_IMPORTED_MODULE_1__components_drag_surface_vue___default.a, ConnexionCheck: __WEBPACK_IMPORTED_MODULE_2__components_connexion_check_vue___default.a, RulesAcceptation: __WEBPACK_IMPORTED_MODULE_3__components_rules_acceptation_vue___default.a, ModalDialog: __WEBPACK_IMPORTED_MODULE_4__components_modal_dialog___default.a, UpdateProgress: __WEBPACK_IMPORTED_MODULE_5__components_update_progress___default.a },
  computed: {
    routeParams: function routeParams() {
      var layer
      var altitude
      if (this.$route.params.layer !== undefined) {
        var split = this.$route.params.layer.split('@')
        layer = split[0]
        altitude = parseInt(split[1], 10)
      }
      return {
        lat: this.$route.params.lat,
        lon: this.$route.params.lon,
        zoom: this.$route.params.zoom,
        layer: layer,
        altitude: altitude
      }
    },
    lang: function lang() {
      return this.$store.state.persistent.lang
    },
    ready: function ready() {
      return (this.$store.state.time.cursor !== undefined) && (this.modal !== 'app-market-update')
    },
    appVersion: function appVersion() {
      return this.$store.state.time.appVersion
    },
    cordova: function cordova() {
      return this.$store.state.runtime.cordova
    },
    appIsUpdating: function appIsUpdating() {
      return this.$store.state.time.appIsUpdating
    },
    needAppMarketUpdate: function needAppMarketUpdate() {
      return this.$store.state.time.needAppMarketUpdate
    },
    modal: function modal() {
      return this.$store.state.runtime.modal
    },
    networkError: function networkError() {
      return this.$store.state.time.networkError
    }
  },
  watch: {
    needAppMarketUpdate: function needAppMarketUpdate() {
      if (this.needAppMarketUpdate !== false) {
        this.$store.dispatch('runtime/showModal', 'app-market-update')
      }
    },
    $route: function $route() {
      this.updateLocation()
    },
    lang: function lang() {
      this.updateTitle()
      this.$store.dispatch('news/fetch')
    },
    ready: function ready(isReady, wasReady) {
      if (!isReady || wasReady) { return }
      if ('cordova' in window) {
        this.$store.dispatch('persistent/incrementAppOpenCount')

        window.AppRate.preferences.storeAppURL = {
          ios: '1255974302',
          android: 'market://details?id=com.meteo_parapente'
        }
        window.AppRate.preferences.usesUntilPrompt = 10
        window.AppRate.preferences.useLanguage = this.$store.state.persistent.lang
        window.AppRate.promptForRating(false)
      }
    }
  },
  methods: {
    updateLocation: function updateLocation() {
      var degreesCheck = /^-?\d+(\.\d+)?$/
      var zoomCheck = /^(\d*)$/
      var layerCheck = /^([a-z0-9]*)$/
      var altitudeCheck = /^(\d*)$/
      // console.log(this.routeParams)
      if (!degreesCheck.test(this.routeParams.lat)) { return false }
      if (!degreesCheck.test(this.routeParams.lon)) { return false }
      if (!zoomCheck.test(this.routeParams.zoom)) { return false }
      if (!layerCheck.test(this.routeParams.layer)) { this.routeParams.layer = null }
      if (!altitudeCheck.test(this.routeParams.altitude)) { this.routeParams.altitude = null }
      this.$store.dispatch('persistent/setRouteParams', this.routeParams)
      return true
    },
    updateTitle: function updateTitle() {
      document.title = this.$pgettext('application title', 'Soaring weather forecasts | Meteo-Parapente.com')
    },
    resume: function resume() {
      if (new Date() - this.$store.state.time.updateTime > 2 * 3600 * 1000) {
        window.location.reload(false)
      }
    },
    initCordova: function initCordova() {
      this.$store.dispatch('runtime/toggleCordova')

      document.addEventListener('resume', this.resume, false)
      // document.addEventListener('pause', onResume, false)

      window.openLink = function (url) {
        window.open(url, '_system')
      }

      window.alert = function (content) {
        navigator.notification.alert(content, null, ' ')
      }

      window.promptAsync = function (content, callback) {
        var awaiter = function (result) {
          if (result.buttonIndex === 1) {
            return callback(result.input1)
          }
        }
        navigator.notification.prompt(content, awaiter, ' ')
      }

      window.confirmAsync = function (content, callback, error) {
        var awaiter = function (buttonIndex) {
          if (buttonIndex === 1) {
            callback()
          } else if (error !== undefined) {
            error()
          }
        }
        navigator.notification.confirm(content, awaiter, ' ')
      }
    },
    detectTouchscreen: function detectTouchscreen() {
      var this$1 = this;

      var listener = function () {
        this$1.$store.dispatch('runtime/setTouchscreen', true)
        window.removeEventListener('touchstart', listener)
        console.log('touchscreen detected')
      }
      window.addEventListener('touchstart', listener)
    }
  },
  created: function created() {
    var this$1 = this;

    __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].config.server = '_mtopara_dev_' in window ? 'https://dev.meteo-parapente.com' : 'https://meteo-parapente.com'
    // Vue.config.server = 'https://meteo-parapente.com'

    if ('cordova' in window) {
      this.initCordova()
    }
    this.$store.dispatch('persistent/syncConfig')
    this.updateTitle()

    this.$store.dispatch('persistent/load', this.$store.getters['favorites/home'])
    this.$store.dispatch('time/fetchSegments', false)
    setInterval(function () { return this$1.$store.dispatch('time/fetchSegments', true); }, 5 * 60 * 1000)

    var needLocate = !this.updateLocation() && this.$store.state.persistent.center.defaultValues
    if (needLocate) {
      this.$store.dispatch('persistent/setUserLocation')
    }
    this.$store.dispatch('news/fetch')

    if (!this.$store.state.persistent.timezoneOveride) {
      var timezone = __WEBPACK_IMPORTED_MODULE_6_moment_timezone_builds_moment_timezone_with_data_2012_2022___default.a.tz.guess()
      this.$store.dispatch('persistent/setTimezone', timezone)
    }

    this.detectTouchscreen()

    if (document.location.hash === '#/contribute') {
      document.location = window.portalLink('users/contribute/')
    } else if (document.location.hash === '#/password') {
      this.$store.dispatch('runtime/showModal', 'password')
    }
  },
  mounted: function mounted() {
    /* window.ga = analytics()

    let page
    if ('cordova' in window) {
      page = `/app-${window.device.platform}/${this.lang}`
    } else {
      page = `/web/${this.lang}`
    }
    window.ga('set', {
      page,
      title: this.$route.name
    })
    window.ga('send', 'pageview')
    /* this.$router.afterEach((to, from) => {
      window.ga('set', {
        page: to.path,
        title: to.name
      })
      window.ga('send', 'pageview')
    }) */
  }
});


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 42,
	"./af.js": 42,
	"./ar": 49,
	"./ar-dz": 43,
	"./ar-dz.js": 43,
	"./ar-kw": 44,
	"./ar-kw.js": 44,
	"./ar-ly": 45,
	"./ar-ly.js": 45,
	"./ar-ma": 46,
	"./ar-ma.js": 46,
	"./ar-sa": 47,
	"./ar-sa.js": 47,
	"./ar-tn": 48,
	"./ar-tn.js": 48,
	"./ar.js": 49,
	"./az": 50,
	"./az.js": 50,
	"./be": 51,
	"./be.js": 51,
	"./bg": 52,
	"./bg.js": 52,
	"./bn": 53,
	"./bn.js": 53,
	"./bo": 54,
	"./bo.js": 54,
	"./br": 55,
	"./br.js": 55,
	"./bs": 56,
	"./bs.js": 56,
	"./ca": 57,
	"./ca.js": 57,
	"./cs": 58,
	"./cs.js": 58,
	"./cv": 59,
	"./cv.js": 59,
	"./cy": 60,
	"./cy.js": 60,
	"./da": 61,
	"./da.js": 61,
	"./de": 64,
	"./de-at": 62,
	"./de-at.js": 62,
	"./de-ch": 63,
	"./de-ch.js": 63,
	"./de.js": 64,
	"./dv": 65,
	"./dv.js": 65,
	"./el": 66,
	"./el.js": 66,
	"./en-au": 67,
	"./en-au.js": 67,
	"./en-ca": 68,
	"./en-ca.js": 68,
	"./en-gb": 69,
	"./en-gb.js": 69,
	"./en-ie": 70,
	"./en-ie.js": 70,
	"./en-nz": 71,
	"./en-nz.js": 71,
	"./eo": 72,
	"./eo.js": 72,
	"./es": 74,
	"./es-do": 73,
	"./es-do.js": 73,
	"./es.js": 74,
	"./et": 75,
	"./et.js": 75,
	"./eu": 76,
	"./eu.js": 76,
	"./fa": 77,
	"./fa.js": 77,
	"./fi": 78,
	"./fi.js": 78,
	"./fo": 79,
	"./fo.js": 79,
	"./fr": 82,
	"./fr-ca": 80,
	"./fr-ca.js": 80,
	"./fr-ch": 81,
	"./fr-ch.js": 81,
	"./fr.js": 82,
	"./fy": 83,
	"./fy.js": 83,
	"./gd": 84,
	"./gd.js": 84,
	"./gl": 85,
	"./gl.js": 85,
	"./gom-latn": 86,
	"./gom-latn.js": 86,
	"./he": 87,
	"./he.js": 87,
	"./hi": 88,
	"./hi.js": 88,
	"./hr": 89,
	"./hr.js": 89,
	"./hu": 90,
	"./hu.js": 90,
	"./hy-am": 91,
	"./hy-am.js": 91,
	"./id": 92,
	"./id.js": 92,
	"./is": 93,
	"./is.js": 93,
	"./it": 94,
	"./it.js": 94,
	"./ja": 95,
	"./ja.js": 95,
	"./jv": 96,
	"./jv.js": 96,
	"./ka": 97,
	"./ka.js": 97,
	"./kk": 98,
	"./kk.js": 98,
	"./km": 99,
	"./km.js": 99,
	"./kn": 100,
	"./kn.js": 100,
	"./ko": 101,
	"./ko.js": 101,
	"./ky": 102,
	"./ky.js": 102,
	"./lb": 103,
	"./lb.js": 103,
	"./lo": 104,
	"./lo.js": 104,
	"./lt": 105,
	"./lt.js": 105,
	"./lv": 106,
	"./lv.js": 106,
	"./me": 107,
	"./me.js": 107,
	"./mi": 108,
	"./mi.js": 108,
	"./mk": 109,
	"./mk.js": 109,
	"./ml": 110,
	"./ml.js": 110,
	"./mr": 111,
	"./mr.js": 111,
	"./ms": 113,
	"./ms-my": 112,
	"./ms-my.js": 112,
	"./ms.js": 113,
	"./my": 114,
	"./my.js": 114,
	"./nb": 115,
	"./nb.js": 115,
	"./ne": 116,
	"./ne.js": 116,
	"./nl": 118,
	"./nl-be": 117,
	"./nl-be.js": 117,
	"./nl.js": 118,
	"./nn": 119,
	"./nn.js": 119,
	"./pa-in": 120,
	"./pa-in.js": 120,
	"./pl": 121,
	"./pl.js": 121,
	"./pt": 123,
	"./pt-br": 122,
	"./pt-br.js": 122,
	"./pt.js": 123,
	"./ro": 124,
	"./ro.js": 124,
	"./ru": 125,
	"./ru.js": 125,
	"./sd": 126,
	"./sd.js": 126,
	"./se": 127,
	"./se.js": 127,
	"./si": 128,
	"./si.js": 128,
	"./sk": 129,
	"./sk.js": 129,
	"./sl": 130,
	"./sl.js": 130,
	"./sq": 131,
	"./sq.js": 131,
	"./sr": 133,
	"./sr-cyrl": 132,
	"./sr-cyrl.js": 132,
	"./sr.js": 133,
	"./ss": 134,
	"./ss.js": 134,
	"./sv": 135,
	"./sv.js": 135,
	"./sw": 136,
	"./sw.js": 136,
	"./ta": 137,
	"./ta.js": 137,
	"./te": 138,
	"./te.js": 138,
	"./tet": 139,
	"./tet.js": 139,
	"./th": 140,
	"./th.js": 140,
	"./tl-ph": 141,
	"./tl-ph.js": 141,
	"./tlh": 142,
	"./tlh.js": 142,
	"./tr": 143,
	"./tr.js": 143,
	"./tzl": 144,
	"./tzl.js": 144,
	"./tzm": 146,
	"./tzm-latn": 145,
	"./tzm-latn.js": 145,
	"./tzm.js": 146,
	"./uk": 147,
	"./uk.js": 147,
	"./ur": 148,
	"./ur.js": 148,
	"./uz": 150,
	"./uz-latn": 149,
	"./uz-latn.js": 149,
	"./uz.js": 150,
	"./vi": 151,
	"./vi.js": 151,
	"./x-pseudo": 152,
	"./x-pseudo.js": 152,
	"./yo": 153,
	"./yo.js": 153,
	"./zh-cn": 154,
	"./zh-cn.js": 154,
	"./zh-hk": 155,
	"./zh-hk.js": 155,
	"./zh-tw": 156,
	"./zh-tw.js": 156
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 286;

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports) {

module.exports = [
	{
		"value": "Dateline Standard Time",
		"abbr": "DST",
		"offset": -12,
		"isdst": false,
		"text": "(UTC-12:00) International Date Line West",
		"utc": [
			"Etc/GMT+12"
		]
	},
	{
		"value": "UTC-11",
		"abbr": "U",
		"offset": -11,
		"isdst": false,
		"text": "(UTC-11:00) Coordinated Universal Time-11",
		"utc": [
			"Etc/GMT+11",
			"Pacific/Midway",
			"Pacific/Niue",
			"Pacific/Pago_Pago"
		]
	},
	{
		"value": "Hawaiian Standard Time",
		"abbr": "HST",
		"offset": -10,
		"isdst": false,
		"text": "(UTC-10:00) Hawaii",
		"utc": [
			"Etc/GMT+10",
			"Pacific/Honolulu",
			"Pacific/Johnston",
			"Pacific/Rarotonga",
			"Pacific/Tahiti"
		]
	},
	{
		"value": "Alaskan Standard Time",
		"abbr": "AKDT",
		"offset": -8,
		"isdst": true,
		"text": "(UTC-09:00) Alaska",
		"utc": [
			"America/Anchorage",
			"America/Juneau",
			"America/Nome",
			"America/Sitka",
			"America/Yakutat"
		]
	},
	{
		"value": "Pacific Standard Time (Mexico)",
		"abbr": "PDT",
		"offset": -7,
		"isdst": true,
		"text": "(UTC-08:00) Baja California",
		"utc": [
			"America/Santa_Isabel"
		]
	},
	{
		"value": "Pacific Daylight Time",
		"abbr": "PDT",
		"offset": -7,
		"isdst": true,
		"text": "(UTC-07:00) Pacific Time (US & Canada)",
		"utc": [
			"America/Dawson",
			"America/Los_Angeles",
			"America/Tijuana",
			"America/Vancouver",
			"America/Whitehorse"
		]
	},
	{
		"value": "Pacific Standard Time",
		"abbr": "PST",
		"offset": -8,
		"isdst": false,
		"text": "(UTC-08:00) Pacific Time (US & Canada)",
		"utc": [
			"America/Dawson",
			"America/Los_Angeles",
			"America/Tijuana",
			"America/Vancouver",
			"America/Whitehorse",
			"PST8PDT"
		]
	},
	{
		"value": "US Mountain Standard Time",
		"abbr": "UMST",
		"offset": -7,
		"isdst": false,
		"text": "(UTC-07:00) Arizona",
		"utc": [
			"America/Creston",
			"America/Dawson_Creek",
			"America/Hermosillo",
			"America/Phoenix",
			"Etc/GMT+7"
		]
	},
	{
		"value": "Mountain Standard Time (Mexico)",
		"abbr": "MDT",
		"offset": -6,
		"isdst": true,
		"text": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
		"utc": [
			"America/Chihuahua",
			"America/Mazatlan"
		]
	},
	{
		"value": "Mountain Standard Time",
		"abbr": "MDT",
		"offset": -6,
		"isdst": true,
		"text": "(UTC-07:00) Mountain Time (US & Canada)",
		"utc": [
			"America/Boise",
			"America/Cambridge_Bay",
			"America/Denver",
			"America/Edmonton",
			"America/Inuvik",
			"America/Ojinaga",
			"America/Yellowknife",
			"MST7MDT"
		]
	},
	{
		"value": "Central America Standard Time",
		"abbr": "CAST",
		"offset": -6,
		"isdst": false,
		"text": "(UTC-06:00) Central America",
		"utc": [
			"America/Belize",
			"America/Costa_Rica",
			"America/El_Salvador",
			"America/Guatemala",
			"America/Managua",
			"America/Tegucigalpa",
			"Etc/GMT+6",
			"Pacific/Galapagos"
		]
	},
	{
		"value": "Central Standard Time",
		"abbr": "CDT",
		"offset": -5,
		"isdst": true,
		"text": "(UTC-06:00) Central Time (US & Canada)",
		"utc": [
			"America/Chicago",
			"America/Indiana/Knox",
			"America/Indiana/Tell_City",
			"America/Matamoros",
			"America/Menominee",
			"America/North_Dakota/Beulah",
			"America/North_Dakota/Center",
			"America/North_Dakota/New_Salem",
			"America/Rainy_River",
			"America/Rankin_Inlet",
			"America/Resolute",
			"America/Winnipeg",
			"CST6CDT"
		]
	},
	{
		"value": "Central Standard Time (Mexico)",
		"abbr": "CDT",
		"offset": -5,
		"isdst": true,
		"text": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
		"utc": [
			"America/Bahia_Banderas",
			"America/Cancun",
			"America/Merida",
			"America/Mexico_City",
			"America/Monterrey"
		]
	},
	{
		"value": "Canada Central Standard Time",
		"abbr": "CCST",
		"offset": -6,
		"isdst": false,
		"text": "(UTC-06:00) Saskatchewan",
		"utc": [
			"America/Regina",
			"America/Swift_Current"
		]
	},
	{
		"value": "SA Pacific Standard Time",
		"abbr": "SPST",
		"offset": -5,
		"isdst": false,
		"text": "(UTC-05:00) Bogota, Lima, Quito",
		"utc": [
			"America/Bogota",
			"America/Cayman",
			"America/Coral_Harbour",
			"America/Eirunepe",
			"America/Guayaquil",
			"America/Jamaica",
			"America/Lima",
			"America/Panama",
			"America/Rio_Branco",
			"Etc/GMT+5"
		]
	},
	{
		"value": "Eastern Standard Time",
		"abbr": "EDT",
		"offset": -4,
		"isdst": true,
		"text": "(UTC-05:00) Eastern Time (US & Canada)",
		"utc": [
			"America/Detroit",
			"America/Havana",
			"America/Indiana/Petersburg",
			"America/Indiana/Vincennes",
			"America/Indiana/Winamac",
			"America/Iqaluit",
			"America/Kentucky/Monticello",
			"America/Louisville",
			"America/Montreal",
			"America/Nassau",
			"America/New_York",
			"America/Nipigon",
			"America/Pangnirtung",
			"America/Port-au-Prince",
			"America/Thunder_Bay",
			"America/Toronto",
			"EST5EDT"
		]
	},
	{
		"value": "US Eastern Standard Time",
		"abbr": "UEDT",
		"offset": -4,
		"isdst": true,
		"text": "(UTC-05:00) Indiana (East)",
		"utc": [
			"America/Indiana/Marengo",
			"America/Indiana/Vevay",
			"America/Indianapolis"
		]
	},
	{
		"value": "Venezuela Standard Time",
		"abbr": "VST",
		"offset": -4.5,
		"isdst": false,
		"text": "(UTC-04:30) Caracas",
		"utc": [
			"America/Caracas"
		]
	},
	{
		"value": "Paraguay Standard Time",
		"abbr": "PYT",
		"offset": -4,
		"isdst": false,
		"text": "(UTC-04:00) Asuncion",
		"utc": [
			"America/Asuncion"
		]
	},
	{
		"value": "Atlantic Standard Time",
		"abbr": "ADT",
		"offset": -3,
		"isdst": true,
		"text": "(UTC-04:00) Atlantic Time (Canada)",
		"utc": [
			"America/Glace_Bay",
			"America/Goose_Bay",
			"America/Halifax",
			"America/Moncton",
			"America/Thule",
			"Atlantic/Bermuda"
		]
	},
	{
		"value": "Central Brazilian Standard Time",
		"abbr": "CBST",
		"offset": -4,
		"isdst": false,
		"text": "(UTC-04:00) Cuiaba",
		"utc": [
			"America/Campo_Grande",
			"America/Cuiaba"
		]
	},
	{
		"value": "SA Western Standard Time",
		"abbr": "SWST",
		"offset": -4,
		"isdst": false,
		"text": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
		"utc": [
			"America/Anguilla",
			"America/Antigua",
			"America/Aruba",
			"America/Barbados",
			"America/Blanc-Sablon",
			"America/Boa_Vista",
			"America/Curacao",
			"America/Dominica",
			"America/Grand_Turk",
			"America/Grenada",
			"America/Guadeloupe",
			"America/Guyana",
			"America/Kralendijk",
			"America/La_Paz",
			"America/Lower_Princes",
			"America/Manaus",
			"America/Marigot",
			"America/Martinique",
			"America/Montserrat",
			"America/Port_of_Spain",
			"America/Porto_Velho",
			"America/Puerto_Rico",
			"America/Santo_Domingo",
			"America/St_Barthelemy",
			"America/St_Kitts",
			"America/St_Lucia",
			"America/St_Thomas",
			"America/St_Vincent",
			"America/Tortola",
			"Etc/GMT+4"
		]
	},
	{
		"value": "Pacific SA Standard Time",
		"abbr": "PSST",
		"offset": -4,
		"isdst": false,
		"text": "(UTC-04:00) Santiago",
		"utc": [
			"America/Santiago",
			"Antarctica/Palmer"
		]
	},
	{
		"value": "Newfoundland Standard Time",
		"abbr": "NDT",
		"offset": -2.5,
		"isdst": true,
		"text": "(UTC-03:30) Newfoundland",
		"utc": [
			"America/St_Johns"
		]
	},
	{
		"value": "E. South America Standard Time",
		"abbr": "ESAST",
		"offset": -3,
		"isdst": false,
		"text": "(UTC-03:00) Brasilia",
		"utc": [
			"America/Sao_Paulo"
		]
	},
	{
		"value": "Argentina Standard Time",
		"abbr": "AST",
		"offset": -3,
		"isdst": false,
		"text": "(UTC-03:00) Buenos Aires",
		"utc": [
			"America/Argentina/La_Rioja",
			"America/Argentina/Rio_Gallegos",
			"America/Argentina/Salta",
			"America/Argentina/San_Juan",
			"America/Argentina/San_Luis",
			"America/Argentina/Tucuman",
			"America/Argentina/Ushuaia",
			"America/Buenos_Aires",
			"America/Catamarca",
			"America/Cordoba",
			"America/Jujuy",
			"America/Mendoza"
		]
	},
	{
		"value": "SA Eastern Standard Time",
		"abbr": "SEST",
		"offset": -3,
		"isdst": false,
		"text": "(UTC-03:00) Cayenne, Fortaleza",
		"utc": [
			"America/Araguaina",
			"America/Belem",
			"America/Cayenne",
			"America/Fortaleza",
			"America/Maceio",
			"America/Paramaribo",
			"America/Recife",
			"America/Santarem",
			"Antarctica/Rothera",
			"Atlantic/Stanley",
			"Etc/GMT+3"
		]
	},
	{
		"value": "Greenland Standard Time",
		"abbr": "GDT",
		"offset": -3,
		"isdst": true,
		"text": "(UTC-03:00) Greenland",
		"utc": [
			"America/Godthab"
		]
	},
	{
		"value": "Montevideo Standard Time",
		"abbr": "MST",
		"offset": -3,
		"isdst": false,
		"text": "(UTC-03:00) Montevideo",
		"utc": [
			"America/Montevideo"
		]
	},
	{
		"value": "Bahia Standard Time",
		"abbr": "BST",
		"offset": -3,
		"isdst": false,
		"text": "(UTC-03:00) Salvador",
		"utc": [
			"America/Bahia"
		]
	},
	{
		"value": "UTC-02",
		"abbr": "U",
		"offset": -2,
		"isdst": false,
		"text": "(UTC-02:00) Coordinated Universal Time-02",
		"utc": [
			"America/Noronha",
			"Atlantic/South_Georgia",
			"Etc/GMT+2"
		]
	},
	{
		"value": "Mid-Atlantic Standard Time",
		"abbr": "MDT",
		"offset": -1,
		"isdst": true,
		"text": "(UTC-02:00) Mid-Atlantic - Old",
		"utc": []
	},
	{
		"value": "Azores Standard Time",
		"abbr": "ADT",
		"offset": 0,
		"isdst": true,
		"text": "(UTC-01:00) Azores",
		"utc": [
			"America/Scoresbysund",
			"Atlantic/Azores"
		]
	},
	{
		"value": "Cape Verde Standard Time",
		"abbr": "CVST",
		"offset": -1,
		"isdst": false,
		"text": "(UTC-01:00) Cape Verde Is.",
		"utc": [
			"Atlantic/Cape_Verde",
			"Etc/GMT+1"
		]
	},
	{
		"value": "Morocco Standard Time",
		"abbr": "MDT",
		"offset": 1,
		"isdst": true,
		"text": "(UTC) Casablanca",
		"utc": [
			"Africa/Casablanca",
			"Africa/El_Aaiun"
		]
	},
	{
		"value": "UTC",
		"abbr": "UTC",
		"offset": 0,
		"isdst": false,
		"text": "(UTC) Coordinated Universal Time",
		"utc": [
			"America/Danmarkshavn",
			"Etc/GMT"
		]
	},
	{
		"value": "Greenwich Mean Time",
		"abbr": "GMT",
		"offset": 0,
		"isdst": false,
		"text": "(UTC) Edinburgh, London",
		"utc": [
			"Europe/Isle_of_Man",
			"Europe/Guernsey",
			"Europe/Jersey",
			"Europe/London"
		]
	},
	{
		"value": "British Summer Time",
		"abbr": "BST",
		"offset": 1,
		"isdst": true,
		"text": "(UTC+01:00) Edinburgh, London",
		"utc": [
			"Europe/Isle_of_Man",
			"Europe/Guernsey",
			"Europe/Jersey",
			"Europe/London"
		]
	},
	{
		"value": "GMT Standard Time",
		"abbr": "GDT",
		"offset": 1,
		"isdst": true,
		"text": "(UTC) Dublin, Lisbon",
		"utc": [
			"Atlantic/Canary",
			"Atlantic/Faeroe",
			"Atlantic/Madeira",
			"Europe/Dublin",
			"Europe/Lisbon"
		]
	},
	{
		"value": "Greenwich Standard Time",
		"abbr": "GST",
		"offset": 0,
		"isdst": false,
		"text": "(UTC) Monrovia, Reykjavik",
		"utc": [
			"Africa/Abidjan",
			"Africa/Accra",
			"Africa/Bamako",
			"Africa/Banjul",
			"Africa/Bissau",
			"Africa/Conakry",
			"Africa/Dakar",
			"Africa/Freetown",
			"Africa/Lome",
			"Africa/Monrovia",
			"Africa/Nouakchott",
			"Africa/Ouagadougou",
			"Africa/Sao_Tome",
			"Atlantic/Reykjavik",
			"Atlantic/St_Helena"
		]
	},
	{
		"value": "W. Europe Standard Time",
		"abbr": "WEDT",
		"offset": 2,
		"isdst": true,
		"text": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
		"utc": [
			"Arctic/Longyearbyen",
			"Europe/Amsterdam",
			"Europe/Andorra",
			"Europe/Berlin",
			"Europe/Busingen",
			"Europe/Gibraltar",
			"Europe/Luxembourg",
			"Europe/Malta",
			"Europe/Monaco",
			"Europe/Oslo",
			"Europe/Rome",
			"Europe/San_Marino",
			"Europe/Stockholm",
			"Europe/Vaduz",
			"Europe/Vatican",
			"Europe/Vienna",
			"Europe/Zurich"
		]
	},
	{
		"value": "Central Europe Standard Time",
		"abbr": "CEDT",
		"offset": 2,
		"isdst": true,
		"text": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
		"utc": [
			"Europe/Belgrade",
			"Europe/Bratislava",
			"Europe/Budapest",
			"Europe/Ljubljana",
			"Europe/Podgorica",
			"Europe/Prague",
			"Europe/Tirane"
		]
	},
	{
		"value": "Romance Standard Time",
		"abbr": "RDT",
		"offset": 2,
		"isdst": true,
		"text": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
		"utc": [
			"Africa/Ceuta",
			"Europe/Brussels",
			"Europe/Copenhagen",
			"Europe/Madrid",
			"Europe/Paris"
		]
	},
	{
		"value": "Central European Standard Time",
		"abbr": "CEDT",
		"offset": 2,
		"isdst": true,
		"text": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
		"utc": [
			"Europe/Sarajevo",
			"Europe/Skopje",
			"Europe/Warsaw",
			"Europe/Zagreb"
		]
	},
	{
		"value": "W. Central Africa Standard Time",
		"abbr": "WCAST",
		"offset": 1,
		"isdst": false,
		"text": "(UTC+01:00) West Central Africa",
		"utc": [
			"Africa/Algiers",
			"Africa/Bangui",
			"Africa/Brazzaville",
			"Africa/Douala",
			"Africa/Kinshasa",
			"Africa/Lagos",
			"Africa/Libreville",
			"Africa/Luanda",
			"Africa/Malabo",
			"Africa/Ndjamena",
			"Africa/Niamey",
			"Africa/Porto-Novo",
			"Africa/Tunis",
			"Etc/GMT-1"
		]
	},
	{
		"value": "Namibia Standard Time",
		"abbr": "NST",
		"offset": 1,
		"isdst": false,
		"text": "(UTC+01:00) Windhoek",
		"utc": [
			"Africa/Windhoek"
		]
	},
	{
		"value": "GTB Standard Time",
		"abbr": "GDT",
		"offset": 3,
		"isdst": true,
		"text": "(UTC+02:00) Athens, Bucharest",
		"utc": [
			"Asia/Nicosia",
			"Europe/Athens",
			"Europe/Bucharest",
			"Europe/Chisinau"
		]
	},
	{
		"value": "Middle East Standard Time",
		"abbr": "MEDT",
		"offset": 3,
		"isdst": true,
		"text": "(UTC+02:00) Beirut",
		"utc": [
			"Asia/Beirut"
		]
	},
	{
		"value": "Egypt Standard Time",
		"abbr": "EST",
		"offset": 2,
		"isdst": false,
		"text": "(UTC+02:00) Cairo",
		"utc": [
			"Africa/Cairo"
		]
	},
	{
		"value": "Syria Standard Time",
		"abbr": "SDT",
		"offset": 3,
		"isdst": true,
		"text": "(UTC+02:00) Damascus",
		"utc": [
			"Asia/Damascus"
		]
	},
	{
		"value": "E. Europe Standard Time",
		"abbr": "EEDT",
		"offset": 3,
		"isdst": true,
		"text": "(UTC+02:00) E. Europe",
		"utc": [
			"Asia/Nicosia",
			"Europe/Athens",
			"Europe/Bucharest",
			"Europe/Chisinau",
			"Europe/Helsinki",
			"Europe/Kiev",
			"Europe/Mariehamn",
			"Europe/Nicosia",
			"Europe/Riga",
			"Europe/Sofia",
			"Europe/Tallinn",
			"Europe/Uzhgorod",
			"Europe/Vilnius",
			"Europe/Zaporozhye"
		]
	},
	{
		"value": "South Africa Standard Time",
		"abbr": "SAST",
		"offset": 2,
		"isdst": false,
		"text": "(UTC+02:00) Harare, Pretoria",
		"utc": [
			"Africa/Blantyre",
			"Africa/Bujumbura",
			"Africa/Gaborone",
			"Africa/Harare",
			"Africa/Johannesburg",
			"Africa/Kigali",
			"Africa/Lubumbashi",
			"Africa/Lusaka",
			"Africa/Maputo",
			"Africa/Maseru",
			"Africa/Mbabane",
			"Etc/GMT-2"
		]
	},
	{
		"value": "FLE Standard Time",
		"abbr": "FDT",
		"offset": 3,
		"isdst": true,
		"text": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
		"utc": [
			"Europe/Helsinki",
			"Europe/Kiev",
			"Europe/Mariehamn",
			"Europe/Riga",
			"Europe/Sofia",
			"Europe/Tallinn",
			"Europe/Uzhgorod",
			"Europe/Vilnius",
			"Europe/Zaporozhye"
		]
	},
	{
		"value": "Turkey Standard Time",
		"abbr": "TDT",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Istanbul",
		"utc": [
			"Europe/Istanbul"
		]
	},
	{
		"value": "Israel Standard Time",
		"abbr": "JDT",
		"offset": 3,
		"isdst": true,
		"text": "(UTC+02:00) Jerusalem",
		"utc": [
			"Asia/Jerusalem"
		]
	},
	{
		"value": "Libya Standard Time",
		"abbr": "LST",
		"offset": 2,
		"isdst": false,
		"text": "(UTC+02:00) Tripoli",
		"utc": [
			"Africa/Tripoli"
		]
	},
	{
		"value": "Jordan Standard Time",
		"abbr": "JST",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Amman",
		"utc": [
			"Asia/Amman"
		]
	},
	{
		"value": "Arabic Standard Time",
		"abbr": "AST",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Baghdad",
		"utc": [
			"Asia/Baghdad"
		]
	},
	{
		"value": "Kaliningrad Standard Time",
		"abbr": "KST",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Kaliningrad, Minsk",
		"utc": [
			"Europe/Kaliningrad",
			"Europe/Minsk"
		]
	},
	{
		"value": "Arab Standard Time",
		"abbr": "AST",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Kuwait, Riyadh",
		"utc": [
			"Asia/Aden",
			"Asia/Bahrain",
			"Asia/Kuwait",
			"Asia/Qatar",
			"Asia/Riyadh"
		]
	},
	{
		"value": "E. Africa Standard Time",
		"abbr": "EAST",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Nairobi",
		"utc": [
			"Africa/Addis_Ababa",
			"Africa/Asmera",
			"Africa/Dar_es_Salaam",
			"Africa/Djibouti",
			"Africa/Juba",
			"Africa/Kampala",
			"Africa/Khartoum",
			"Africa/Mogadishu",
			"Africa/Nairobi",
			"Antarctica/Syowa",
			"Etc/GMT-3",
			"Indian/Antananarivo",
			"Indian/Comoro",
			"Indian/Mayotte"
		]
	},
	{
		"value": "Moscow Standard Time",
		"abbr": "MSK",
		"offset": 3,
		"isdst": false,
		"text": "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
		"utc": [
			"Europe/Kirov",
			"Europe/Moscow",
			"Europe/Simferopol",
			"Europe/Volgograd"
		]
	},
	{
		"value": "Samara Time",
		"abbr": "SAMT",
		"offset": 4,
		"isdst": false,
		"text": "(UTC+04:00) Samara, Ulyanovsk, Saratov",
		"utc": [
			"Europe/Astrakhan",
			"Europe/Samara",
			"Europe/Ulyanovsk"
		]
	},
	{
		"value": "Iran Standard Time",
		"abbr": "IDT",
		"offset": 4.5,
		"isdst": true,
		"text": "(UTC+03:30) Tehran",
		"utc": [
			"Asia/Tehran"
		]
	},
	{
		"value": "Arabian Standard Time",
		"abbr": "AST",
		"offset": 4,
		"isdst": false,
		"text": "(UTC+04:00) Abu Dhabi, Muscat",
		"utc": [
			"Asia/Dubai",
			"Asia/Muscat",
			"Etc/GMT-4"
		]
	},
	{
		"value": "Azerbaijan Standard Time",
		"abbr": "ADT",
		"offset": 5,
		"isdst": true,
		"text": "(UTC+04:00) Baku",
		"utc": [
			"Asia/Baku"
		]
	},
	{
		"value": "Mauritius Standard Time",
		"abbr": "MST",
		"offset": 4,
		"isdst": false,
		"text": "(UTC+04:00) Port Louis",
		"utc": [
			"Indian/Mahe",
			"Indian/Mauritius",
			"Indian/Reunion"
		]
	},
	{
		"value": "Georgian Standard Time",
		"abbr": "GET",
		"offset": 4,
		"isdst": false,
		"text": "(UTC+04:00) Tbilisi",
		"utc": [
			"Asia/Tbilisi"
		]
	},
	{
		"value": "Caucasus Standard Time",
		"abbr": "CST",
		"offset": 4,
		"isdst": false,
		"text": "(UTC+04:00) Yerevan",
		"utc": [
			"Asia/Yerevan"
		]
	},
	{
		"value": "Afghanistan Standard Time",
		"abbr": "AST",
		"offset": 4.5,
		"isdst": false,
		"text": "(UTC+04:30) Kabul",
		"utc": [
			"Asia/Kabul"
		]
	},
	{
		"value": "West Asia Standard Time",
		"abbr": "WAST",
		"offset": 5,
		"isdst": false,
		"text": "(UTC+05:00) Ashgabat, Tashkent",
		"utc": [
			"Antarctica/Mawson",
			"Asia/Aqtau",
			"Asia/Aqtobe",
			"Asia/Ashgabat",
			"Asia/Dushanbe",
			"Asia/Oral",
			"Asia/Samarkand",
			"Asia/Tashkent",
			"Etc/GMT-5",
			"Indian/Kerguelen",
			"Indian/Maldives"
		]
	},
	{
		"value": "Yekaterinburg Time",
		"abbr": "YEKT",
		"offset": 5,
		"isdst": false,
		"text": "(UTC+05:00) Yekaterinburg",
		"utc": [
			"Asia/Yekaterinburg"
		]
	},
	{
		"value": "Pakistan Standard Time",
		"abbr": "PKT",
		"offset": 5,
		"isdst": false,
		"text": "(UTC+05:00) Islamabad, Karachi",
		"utc": [
			"Asia/Karachi"
		]
	},
	{
		"value": "India Standard Time",
		"abbr": "IST",
		"offset": 5.5,
		"isdst": false,
		"text": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
		"utc": [
			"Asia/Kolkata"
		]
	},
	{
		"value": "Sri Lanka Standard Time",
		"abbr": "SLST",
		"offset": 5.5,
		"isdst": false,
		"text": "(UTC+05:30) Sri Jayawardenepura",
		"utc": [
			"Asia/Colombo"
		]
	},
	{
		"value": "Nepal Standard Time",
		"abbr": "NST",
		"offset": 5.75,
		"isdst": false,
		"text": "(UTC+05:45) Kathmandu",
		"utc": [
			"Asia/Kathmandu"
		]
	},
	{
		"value": "Central Asia Standard Time",
		"abbr": "CAST",
		"offset": 6,
		"isdst": false,
		"text": "(UTC+06:00) Astana",
		"utc": [
			"Antarctica/Vostok",
			"Asia/Almaty",
			"Asia/Bishkek",
			"Asia/Qyzylorda",
			"Asia/Urumqi",
			"Etc/GMT-6",
			"Indian/Chagos"
		]
	},
	{
		"value": "Bangladesh Standard Time",
		"abbr": "BST",
		"offset": 6,
		"isdst": false,
		"text": "(UTC+06:00) Dhaka",
		"utc": [
			"Asia/Dhaka",
			"Asia/Thimphu"
		]
	},
	{
		"value": "Myanmar Standard Time",
		"abbr": "MST",
		"offset": 6.5,
		"isdst": false,
		"text": "(UTC+06:30) Yangon (Rangoon)",
		"utc": [
			"Asia/Rangoon",
			"Indian/Cocos"
		]
	},
	{
		"value": "SE Asia Standard Time",
		"abbr": "SAST",
		"offset": 7,
		"isdst": false,
		"text": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
		"utc": [
			"Antarctica/Davis",
			"Asia/Bangkok",
			"Asia/Hovd",
			"Asia/Jakarta",
			"Asia/Phnom_Penh",
			"Asia/Pontianak",
			"Asia/Saigon",
			"Asia/Vientiane",
			"Etc/GMT-7",
			"Indian/Christmas"
		]
	},
	{
		"value": "N. Central Asia Standard Time",
		"abbr": "NCAST",
		"offset": 7,
		"isdst": false,
		"text": "(UTC+07:00) Novosibirsk",
		"utc": [
			"Asia/Novokuznetsk",
			"Asia/Novosibirsk",
			"Asia/Omsk"
		]
	},
	{
		"value": "China Standard Time",
		"abbr": "CST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
		"utc": [
			"Asia/Hong_Kong",
			"Asia/Macau",
			"Asia/Shanghai"
		]
	},
	{
		"value": "North Asia Standard Time",
		"abbr": "NAST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Krasnoyarsk",
		"utc": [
			"Asia/Krasnoyarsk"
		]
	},
	{
		"value": "Singapore Standard Time",
		"abbr": "MPST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Kuala Lumpur, Singapore",
		"utc": [
			"Asia/Brunei",
			"Asia/Kuala_Lumpur",
			"Asia/Kuching",
			"Asia/Makassar",
			"Asia/Manila",
			"Asia/Singapore",
			"Etc/GMT-8"
		]
	},
	{
		"value": "W. Australia Standard Time",
		"abbr": "WAST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Perth",
		"utc": [
			"Antarctica/Casey",
			"Australia/Perth"
		]
	},
	{
		"value": "Taipei Standard Time",
		"abbr": "TST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Taipei",
		"utc": [
			"Asia/Taipei"
		]
	},
	{
		"value": "Ulaanbaatar Standard Time",
		"abbr": "UST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Ulaanbaatar",
		"utc": [
			"Asia/Choibalsan",
			"Asia/Ulaanbaatar"
		]
	},
	{
		"value": "North Asia East Standard Time",
		"abbr": "NAEST",
		"offset": 8,
		"isdst": false,
		"text": "(UTC+08:00) Irkutsk",
		"utc": [
			"Asia/Irkutsk"
		]
	},
	{
		"value": "Japan Standard Time",
		"abbr": "JST",
		"offset": 9,
		"isdst": false,
		"text": "(UTC+09:00) Osaka, Sapporo, Tokyo",
		"utc": [
			"Asia/Dili",
			"Asia/Jayapura",
			"Asia/Tokyo",
			"Etc/GMT-9",
			"Pacific/Palau"
		]
	},
	{
		"value": "Korea Standard Time",
		"abbr": "KST",
		"offset": 9,
		"isdst": false,
		"text": "(UTC+09:00) Seoul",
		"utc": [
			"Asia/Pyongyang",
			"Asia/Seoul"
		]
	},
	{
		"value": "Cen. Australia Standard Time",
		"abbr": "CAST",
		"offset": 9.5,
		"isdst": false,
		"text": "(UTC+09:30) Adelaide",
		"utc": [
			"Australia/Adelaide",
			"Australia/Broken_Hill"
		]
	},
	{
		"value": "AUS Central Standard Time",
		"abbr": "ACST",
		"offset": 9.5,
		"isdst": false,
		"text": "(UTC+09:30) Darwin",
		"utc": [
			"Australia/Darwin"
		]
	},
	{
		"value": "E. Australia Standard Time",
		"abbr": "EAST",
		"offset": 10,
		"isdst": false,
		"text": "(UTC+10:00) Brisbane",
		"utc": [
			"Australia/Brisbane",
			"Australia/Lindeman"
		]
	},
	{
		"value": "AUS Eastern Standard Time",
		"abbr": "AEST",
		"offset": 10,
		"isdst": false,
		"text": "(UTC+10:00) Canberra, Melbourne, Sydney",
		"utc": [
			"Australia/Melbourne",
			"Australia/Sydney"
		]
	},
	{
		"value": "West Pacific Standard Time",
		"abbr": "WPST",
		"offset": 10,
		"isdst": false,
		"text": "(UTC+10:00) Guam, Port Moresby",
		"utc": [
			"Antarctica/DumontDUrville",
			"Etc/GMT-10",
			"Pacific/Guam",
			"Pacific/Port_Moresby",
			"Pacific/Saipan",
			"Pacific/Truk"
		]
	},
	{
		"value": "Tasmania Standard Time",
		"abbr": "TST",
		"offset": 10,
		"isdst": false,
		"text": "(UTC+10:00) Hobart",
		"utc": [
			"Australia/Currie",
			"Australia/Hobart"
		]
	},
	{
		"value": "Yakutsk Standard Time",
		"abbr": "YST",
		"offset": 9,
		"isdst": false,
		"text": "(UTC+09:00) Yakutsk",
		"utc": [
			"Asia/Chita",
			"Asia/Khandyga",
			"Asia/Yakutsk"
		]
	},
	{
		"value": "Central Pacific Standard Time",
		"abbr": "CPST",
		"offset": 11,
		"isdst": false,
		"text": "(UTC+11:00) Solomon Is., New Caledonia",
		"utc": [
			"Antarctica/Macquarie",
			"Etc/GMT-11",
			"Pacific/Efate",
			"Pacific/Guadalcanal",
			"Pacific/Kosrae",
			"Pacific/Noumea",
			"Pacific/Ponape"
		]
	},
	{
		"value": "Vladivostok Standard Time",
		"abbr": "VST",
		"offset": 11,
		"isdst": false,
		"text": "(UTC+11:00) Vladivostok",
		"utc": [
			"Asia/Sakhalin",
			"Asia/Ust-Nera",
			"Asia/Vladivostok"
		]
	},
	{
		"value": "New Zealand Standard Time",
		"abbr": "NZST",
		"offset": 12,
		"isdst": false,
		"text": "(UTC+12:00) Auckland, Wellington",
		"utc": [
			"Antarctica/McMurdo",
			"Pacific/Auckland"
		]
	},
	{
		"value": "UTC+12",
		"abbr": "U",
		"offset": 12,
		"isdst": false,
		"text": "(UTC+12:00) Coordinated Universal Time+12",
		"utc": [
			"Etc/GMT-12",
			"Pacific/Funafuti",
			"Pacific/Kwajalein",
			"Pacific/Majuro",
			"Pacific/Nauru",
			"Pacific/Tarawa",
			"Pacific/Wake",
			"Pacific/Wallis"
		]
	},
	{
		"value": "Fiji Standard Time",
		"abbr": "FST",
		"offset": 12,
		"isdst": false,
		"text": "(UTC+12:00) Fiji",
		"utc": [
			"Pacific/Fiji"
		]
	},
	{
		"value": "Magadan Standard Time",
		"abbr": "MST",
		"offset": 12,
		"isdst": false,
		"text": "(UTC+12:00) Magadan",
		"utc": [
			"Asia/Anadyr",
			"Asia/Kamchatka",
			"Asia/Magadan",
			"Asia/Srednekolymsk"
		]
	},
	{
		"value": "Kamchatka Standard Time",
		"abbr": "KDT",
		"offset": 13,
		"isdst": true,
		"text": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
		"utc": [
			"Asia/Kamchatka"
		]
	},
	{
		"value": "Tonga Standard Time",
		"abbr": "TST",
		"offset": 13,
		"isdst": false,
		"text": "(UTC+13:00) Nuku'alofa",
		"utc": [
			"Etc/GMT-13",
			"Pacific/Enderbury",
			"Pacific/Fakaofo",
			"Pacific/Tongatapu"
		]
	},
	{
		"value": "Samoa Standard Time",
		"abbr": "SST",
		"offset": 13,
		"isdst": false,
		"text": "(UTC+13:00) Samoa",
		"utc": [
			"Pacific/Apia"
		]
	}
];

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(328),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(348),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(245)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(327),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(331),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(336),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(332),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(330),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-view"
  }, [_c('div', {
    staticClass: "zoom-buttons"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.zoom(+1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.zoom(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])]), _vm._v(" "), _c('super-map', {
    attrs: {
      "width": _vm.width,
      "visible": _vm.mapVisible
    }
  }), _vm._v(" "), (_vm.xcplanner) ? _c('xc-planner', {
    attrs: {
      "width": _vm.width,
      "visible": _vm.mapVisible
    }
  }) : _vm._e(), _vm._v(" "), _c('left-menu'), _vm._v(" "), _c('search-box'), _vm._v(" "), (_vm.needAgreement) ? _c('accept-terms', {
    attrs: {
      "date": ""
    }
  }) : _c('notification'), _vm._v(" "), _c('altitude-control'), _vm._v(" "), _c('map-legend')], 1)
},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accept-terms",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-fw"
  }), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("By using this application, you agree to the")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.tosLink,
      "target": "_blank"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "startup"
    }
  }, [_vm._v("terms of use")])], 1), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("and to the")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyLink,
      "target": "_blank"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("privacy policy")])], 1)], 1), _vm._v(" "), _c('p', [_c('strong', [_c('i', {
    staticClass: "fa fa-thumbs-up fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "startup terms"
    }
  }, [_vm._v("\n        Meteo-Parapente doesn't use tracking cookies\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-tabs"
  }, [_c('div', {
    ref: "header",
    staticClass: "header"
  }, [_c('ul', [_c('li', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "windgram tab"
    }
  }, [_vm._v("Windgram")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "windgram tab"
    }
  }, [_vm._v("Sounding")])], 1), _vm._v(" "), _c('li', {
    staticClass: "unit"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.windUnit),
      expression: "windUnit"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.windUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "kmh"
    }
  }, [_c('translate', [_vm._v("km/h")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "knots"
    }
  }, [_c('translate', [_vm._v("knots")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ms"
    }
  }, [_c('translate', [_vm._v("m/s")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mph"
    }
  }, [_c('translate', [_vm._v("mph")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('keep-alive', [(_vm.tab == 0) ? _c('alti-winds-view', {
    attrs: {
      "redraw": _vm.redraw
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('keep-alive', [(_vm.tab == 1) ? _c('sounding-view', {
    attrs: {
      "redraw": _vm.redraw
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-splitter"
  }, [_c('div', {
    staticClass: "splitter-handle"
  })])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modal) ? _c('div', {
    staticClass: "modal-dialog",
    style: ({
      'z-index': (_vm.modal == 'private') ? 19 : 20
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "dialog"
  }, [(_vm.modal == 'app-market-update') ? _c('app-market-update-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'login') ? _c('login-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'contribute') ? _c('contribute-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'password') ? _c('password-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'private') ? _c('private-modal') : _vm._e(), _vm._v(" "), (_vm.modal == 'news') ? _c('news-modal') : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]) : _vm._e()], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideview-button"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  })])
}]}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "drag-surface"
  })
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-market-update-modal"
  }, [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "version check"
    }
  }, [_vm._v("Meteo-Parapente requires an update.")])], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.versions.installed) + " "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  }), _vm._v(" " + _vm._s(_vm.versions.minimal))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openStore
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "version check"
    }
  }, [_vm._v("Install now")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contribute-modal"
  }, [(_vm.success) ? _c('div', [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("Thank you!")])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("Here is your access code. Please keep it safely.")])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n        Username:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(this.success.email))])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n        Password:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(this.success.password))])], 1), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])]) : _c('div', [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("Join Meteo-Parapente contributors club")])], 1), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!\n        ")])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Support the development of a quality tool accessible to every pilots.\n        ")])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Get free entry to local weather trainings and users meetups.\n        ")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Meet me once a month to discuss new features and improvements.\n        ")]), _vm._v(" "), (_vm.$language.current === 'fr') ? _c('a', {
    attrs: {
      "href": "https://community.meteo-parapente.com/t/soirees-retours-et-ameliorations-fr/1055",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })]) : _c('a', {
    attrs: {
      "href": "https://community.meteo-parapente.com/t/feedbacks-and-improvements-online-meetups-en/1056",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "private popup"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.contribute($event)
      }
    }
  }, [_c('p', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product),
      expression: "product"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1-year-standard"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup",
      "translate-params": {
        currency: _vm.currencySymbol,
        pricing: _vm.pricing.standard
      }
    }
  }, [_vm._v("\n                12 months Standard － %{currency} %{pricing} / month\n              ")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1-year-supporter"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup",
      "translate-params": {
        currency: _vm.currencySymbol,
        pricing: _vm.pricing.supporter
      }
    }
  }, [_vm._v("\n                12 months Supporter － %{currency} %{pricing} / month\n              ")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1-year-reduced"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup",
      "translate-params": {
        currency: _vm.currencySymbol,
        pricing: _vm.pricing.reduced
      }
    }
  }, [_vm._v("\n                 12 months Student － %{currency} %{pricing} / month\n              ")])], 1)])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email1),
      expression: "email1"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.$pgettext('contribute popup', 'Email')
    },
    domProps: {
      "value": (_vm.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email1 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.forceErrorMessage) ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Emails are not the same or invalid\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "keyboard-submit-bug-fix"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "high"
  }, [_c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]) : _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.contribute()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://community.meteo-parapente.com/t/tour-of-europe-part-1/968",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])
}]}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    style: ({
      'z-index': _vm.showResults ? 35 : 10,
      'width': _vm.showResults ? 'calc(100% - 20px)' : ''
    }),
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "focus": function($event) {
        _vm.showResults = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showResults) ? _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.showResults = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]) : _vm._e(), _vm._v(" "), (_vm.showResults) ? _c('div', {
    staticClass: "search-overlay",
    on: {
      "click": function($event) {
        _vm.showResults = false
      }
    }
  }, [_c('div', {
    staticClass: "search-results"
  }, [_c('ul', _vm._l((_vm.locationResult), function(location) {
    return (location !== undefined) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.open(location)
        }
      }
    }, [_vm._v("\n          " + _vm._s(location.properties.name)), _c('small', [_vm._v(", " + _vm._s(location.properties.region))]), _vm._v(" "), (location.properties.source === 'paraglidingearth-beta') ? _c('small', [_c('translate', {
      attrs: {
        "translate-context": "search result"
      }
    }, [_vm._v("(Paragliding)")])], 1) : _vm._e(), _vm._v(" "), (location.properties.source === 'ffvl-beta') ? _c('small', [_c('translate', {
      attrs: {
        "translate-context": "search result"
      }
    }, [_vm._v("(Kitesurf)")])], 1) : _vm._e()]) : _vm._e()
  }))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_c('div', {
    staticClass: "fa fa-sliders"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-menu",
    class: {
      visible: _vm.isOpen
    },
    attrs: {
      "id": "menu"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.close($event)
      }
    }
  }, [_c('ul', {
    staticClass: "menu-main"
  }, [_c('li', {
    staticClass: "title",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "menu title"
    }
  }, [_vm._v("Meteo Parapente")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'favorites')
      }
    }
  }, [(_vm.isMenuOpen('favorites')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-star fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "menu title"
    }
  }, [_vm._v("Favorites")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('favorites')) ? _c('div', [_vm._l((_vm.$store.state.favorites.list), function(favorite, index) {
    return _c('div', [(!_vm.isMenuOpen('favorites/' + index)) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.loadFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: favorite.uid === _vm.$store.state.favorites.home ? 'fa-home' : ''
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "padding": "0 5px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openMenu($event, 'favorites/' + index)
        }
      }
    }, [_vm._m(1, true)]), _vm._v("\n            " + _vm._s(favorite.name) + "\n          ")]) : _c('li', {
      on: {
        "click": function($event) {
          _vm.openMenu($event, 'favorites')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('strong', [_vm._v(_vm._s(favorite.name))])]), _vm._v(" "), (_vm.isMenuOpen('favorites/' + index)) ? _c('div', [_c('li', {
      on: {
        "click": function($event) {
          _vm.loadFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-external-link"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Open")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.renameFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-pencil"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Rename")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.moveToUpFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-level-up"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Move to top")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.setHomeFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-home"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Set as homepage")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.deleteFavorite(index, favorite.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-trash"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Delete")])], 1)]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.addFavorite
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "favorites menu"
    }
  }, [_vm._v("Add new…")])], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.contributor) ? _c('li', {
    staticClass: "contribute spacer",
    on: {
      "click": _vm.openContribution
    }
  }, [_c('i', {
    staticClass: "fa fa-heart fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "contribute menu"
    }
  }, [_vm._v("Become a member")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'windy')
      }
    }
  }, [(_vm.isMenuOpen('windy')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('windy')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windalti')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw star"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windsfc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Ground")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windblavg')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Boundary layer")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windbltop')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Ceiling of b. layer")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('blwindshear')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind Shear")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("B. Layer")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('slp')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Pressure")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Sea level")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'rising')
      }
    }
  }, [(_vm.isMenuOpen('rising')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Updrafts")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('rising')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('wstar')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Thermals")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Velocity")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('bsratio')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Thermals")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Shearing")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('pblh')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Boundary Layer")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Thickness")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('pbltop')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Boundary Layer")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Ceiling")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('wblmaxmin')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Vertical motion")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("B. layer")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'foggy')
      }
    }
  }, [(_vm.isMenuOpen('foggy')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Humidity")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('foggy')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('raintot')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Rain")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("1h")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfracalti')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfract')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("All")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfrach')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("High")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfracm')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Medium")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfracl')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Low")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'shiny')
      }
    }
  }, [(_vm.isMenuOpen('shiny')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Temperature")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('shiny')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('tempalti')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('tc2')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Ground")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "tour spacer",
    on: {
      "click": _vm.openTour
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "contribute menu"
    }
  }, [_vm._v("Meetings")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleInterpolation
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.interpolate, 'fa-toggle-off': !_vm.interpolate
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Interpolation")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleXcplanner
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.xcplanner, 'fa-toggle-off': !_vm.xcplanner
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("XC Planner")]), _vm._v(" "), _c('small', [_c('sup', [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("experimental")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleAirspace
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.airspace, 'fa-toggle-off': !_vm.airspace
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Airspace")])], 1), _vm._v(" "), (_vm.fullscreen !== null) ? _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-compress': _vm.fullscreen, 'fa-expand': !_vm.fullscreen
    }
  }), _vm._v(" "), (!_vm.fullscreen) ? _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Fullscreen")]) : _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Exit Fullscreen")])], 1) : _vm._e(), _vm._v(" "), (!_vm.contributor) ? _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.openLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "login menu"
    }
  }, [_vm._v("Login")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMenuOpen('news')) ? _c('div', _vm._l((_vm.news), function(article, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.openNews(article)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: article.unread ? 'fa-angle-right' : '',
      staticStyle: {
        "color": "red",
        "font-weight": "bold"
      }
    }), _vm._v("\n          " + _vm._s(article.title) + "\n         ")])
  })) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.openHelp
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "menu"
    }
  }, [_vm._v("Help / Contact / About")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings')
      }
    }
  }, [(_vm.isMenuOpen('settings')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-wrench fa-fw"
  }), _vm._v(" "), _c('translate', {
    style: ({
      'font-weight': (_vm.isMenuOpen('settings') ? 'bold' : 'normal')
    }),
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Settings")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings')) ? _c('div', [_c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings/language')
      }
    }
  }, [(_vm.isMenuOpen('settings/language')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-fw fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "flag-icon flag-icon-right",
    class: ("flag-icon-" + (_vm.$language.current))
  }), _vm._v(" "), _c('translate', {
    style: ({
      'font-weight': (_vm.isMenuOpen('settings/language') ? 'bold' : 'normal')
    }),
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Language")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings/language')) ? _c('div', [_c('li', {
    on: {
      "click": _vm.openTranslatePage
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Help us translate!")])], 1), _vm._v(" "), _vm._l((_vm.$language.available), function(language, key) {
    return _c('li', {
      class: {
        active: _vm.$language.current === key
      },
      on: {
        "click": function($event) {
          _vm.changeLanguage(key)
        }
      }
    }, [_c('span', {
      staticClass: "flag-icon",
      class: ("flag-icon-" + key)
    }), _vm._v("\n            " + _vm._s(language) + "\n          ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings/timezone')
      }
    }
  }, [(_vm.isMenuOpen('settings/timezone')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" "), _c('translate', {
    style: ({
      'font-weight': (_vm.isMenuOpen('settings/timezone') ? 'bold' : 'normal')
    }),
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Timezone")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings/timezone')) ? _c('div', [_c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleTimezoneOveride
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': !_vm.timezoneOveride, 'fa-toggle-off': _vm.timezoneOveride
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "timezone menu"
    }
  }, [_vm._v("Same as device")])], 1), _vm._v(" "), _vm._l((_vm.timezones), function(zone) {
    return _c('li', {
      class: {
        active: zone.utc.includes(_vm.currentTimezone)
      },
      on: {
        "click": function($event) {
          _vm.setTimezone(zone.utc[0], true)
        }
      }
    }, [(zone.utc.includes(_vm.currentTimezone)) ? _c('i', {
      staticClass: "fa fa-check-square-o"
    }) : _vm._e(), _vm._v(" "), _c('small', [_c('strong', [_vm._v(_vm._s(zone.text.replace(/\((.+)\)\s.+/, '($1)')))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(zone.text.replace(/\((.+)\)\s/, '')))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings/wind-unit')
      }
    }
  }, [(_vm.isMenuOpen('settings/wind-unit')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-tachometer fa-fw"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.$convert.currentLabel))]), _vm._v(" "), _c('translate', [_vm._v("Wind unit")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings/wind-unit')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('kmh')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("km/h")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('knots')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("knots")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('ms')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("m/s")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('mph')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("mph")])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleExperimental
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.experimental, 'fa-toggle-off': !_vm.experimental
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Experimental features")])], 1), _vm._v(" "), (_vm.experimental) ? _c('div', {
    attrs: {
      "id": "menu-experimental"
    }
  }, [_c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleColorblind
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.colorblind, 'fa-toggle-off': !_vm.colorblind
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Color blind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("experimental")])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.resetStore
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Reset all settings")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("debug")])], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contributor) ? _c('li', {
    staticClass: "spacer email",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'contributor')
      }
    }
  }, [(_vm.isMenuOpen('contributor')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.email))])]) : _vm._e(), _vm._v(" "), (_vm.isMenuOpen('contributor')) ? _c('div', [_c('li', {
    staticClass: "spacer email"
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw"
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("moment")(_vm.expiration, 'll')))])]), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.changePassword
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Change password")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Logout")])], 1)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-close fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-fw fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "padding": "0 5px"
    }
  }, [_c('small', [_c('i', {
    staticClass: "fa fa-fw fa-caret-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrows-v fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrows-v fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrows-v fa-fw"
  })])
}]}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "altitude-control",
    class: {
      visible: _vm.isVisible
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "big-label",
    class: {
      visible: _vm.bigLabel
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.roundedAltitude) + "m")])]), _vm._v(" "), _c('div', {
    ref: "bar",
    staticClass: "altitude-control-bar",
    on: {
      "mouseover": function($event) {
        _vm.showBigLabel(true)
      },
      "touchstart": function($event) {
        _vm.showBigLabel(true)
      }
    }
  }, [_c('div', {
    staticClass: "up button",
    on: {
      "click": function($event) {
        _vm.climb(250)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  })]), _vm._v(" "), _c('canvas', {
    ref: "wheel"
  }), _vm._v(" "), _c('div', {
    staticClass: "handle",
    on: {
      "mousedown": _vm.beginMouseMove,
      "touchstart": _vm.beginTouchMove
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "down button",
    on: {
      "click": function($event) {
        _vm.climb(-250)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-modal"
  }, [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Please log-in")])], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "mtopara-email",
      "placeholder": _vm.$pgettext('login popup', 'Email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "password"
  }, [_c('a', {
    staticClass: "show",
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.togglePassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v(" "), (_vm.showPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "name": "password",
      "autocomplete": "off",
      "placeholder": _vm.$pgettext('login popup', 'Password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$pgettext('login popup', 'Password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.success) ? _c('p', {
    staticClass: "high success"
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("\n        Welcome!\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.badLogin) ? _c('p', {
    staticClass: "error high"
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("\n        Error! Bad login or password\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error high"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("\n        An error has occured. Please try again.\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.expired) ? _c('p', {
    staticClass: "error high"
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup",
      "translate-params": {
        expirationDate: _vm.expirationDate
      }
    }
  }, [_vm._v("\n        Error! Your access has expired on %{ expirationDate }.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.contribute()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Click here to renew.")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "keyboard-submit-bug-fix"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "high"
  }, [_c('img', {
    attrs: {
      "src": "/img/load.gif"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.success) ? _c('p', {
    staticClass: "high"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "high"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.go('password')
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Already a member? Click to reset your password")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "high"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.contribute()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Not a member yet? Click to get an access code")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sounding-view"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topAltitude),
      expression: "topAltitude"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.topAltitude = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("10000")]), _vm._v(" "), _c('option', [_vm._v("8000")]), _vm._v(" "), _c('option', [_vm._v("6000")]), _vm._v(" "), _c('option', [_vm._v("4000")]), _vm._v(" "), _c('option', [_vm._v("2000")])]), _vm._v(" "), _c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader middle"
  }, [_c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data === 'no-data'),
      expression: "data === 'no-data'"
    }],
    staticClass: "no-data"
  }, [_c('div', {
    staticClass: "middle"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "windgram view"
    }
  }, [_vm._v("No data for this place")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('i', {
    staticClass: "fa fa-frown-o"
  })])])
}]}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "super-map"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])
}]}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isNews) ? _c('div', {
    staticClass: "rules-acceptation"
  }, [_c('div', {
    staticClass: "middle"
  }, [(_vm.$language.current === 'fr') ? _c('div', [_c('p', [_vm._v("Avant d'utiliser Météo-Parapente, vous devez accepter les règles d'utilisation")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Voir le réglement"
    },
    on: {
      "click": _vm.openLinkFr
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "prefered",
    attrs: {
      "type": "button",
      "value": "J'ai lu et j'accepte"
    },
    on: {
      "click": _vm.close
    }
  })]) : _c('div', [_c('p', [_vm._v("You must accept the rules before using Meteo-Parapente")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Read the rules"
    },
    on: {
      "click": _vm.openLinkEn
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "prefered",
    attrs: {
      "value": "I have read and I accept",
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  })])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alti-winds-view"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topAltitude),
      expression: "topAltitude"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.topAltitude = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("10000")]), _vm._v(" "), _c('option', [_vm._v("8000")]), _vm._v(" "), _c('option', [_vm._v("6000")]), _vm._v(" "), _c('option', [_vm._v("4000")]), _vm._v(" "), _c('option', [_vm._v("2000")])]), _vm._v(" "), _c('canvas', {
    ref: "scale",
    attrs: {
      "id": "scale"
    }
  }), _vm._v(" "), _c('div', {
    ref: "scrollable",
    staticClass: "scrollable"
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "id": "canvas"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader middle"
  }, [_c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data === 'no-data'),
      expression: "data === 'no-data'"
    }],
    staticClass: "no-data"
  }, [_c('div', {
    staticClass: "middle"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "windgram view"
    }
  }, [_vm._v("No data for this place")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('i', {
    staticClass: "fa fa-frown-o"
  })])])
}]}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.ready && !_vm.modal) ? _c('div', {
    staticClass: "app-loading"
  }, [(_vm.networkError) ? _c('div', [_c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "startup"
    }
  }, [_vm._v("\n            Unable to reach Meteo-Parapente servers. Please check your connection.\n          ")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "startup"
    }
  }, [_vm._v("\n          If the problem persists, contact support@meteo-parapente.com\n        ")])], 1)]) : _c('img', {
    attrs: {
      "src": "img/load.gif",
      "alt": "loading..."
    }
  }), _vm._v(" "), _c('update-progress')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', [_c('connexion-check'), _vm._v(" "), _c('drag-surface'), _vm._v(" "), (_vm.ready) ? _c('main-view') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('modal-dialog')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    staticClass: "btn-error",
    attrs: {
      "type": "button",
      "value": "Retry",
      "onclick": "document.location.reload(true)"
    }
  })])
}]}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "big-label",
    class: {
      visible: _vm.bigLabel
    },
    style: ({
      width: _vm.viewWidth + 'px'
    })
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.roundedTime, 'LT')))]), _c('br'), _vm._v("\n    " + _vm._s(_vm._f("moment")(_vm.roundedTime, 'ddd Do')) + "\n  ")]), _vm._v(" "), _c('div', {
    ref: "control",
    staticClass: "time-control",
    class: {
      shadow: _vm.shadow
    },
    style: ({
      right: _vm.right
    }),
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "": function($event) {}
    }
  }, [_c('div', {
    staticClass: "previous-day button",
    on: {
      "click": function($event) {
        _vm.seek(-24 * 3600 * 1000)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fast-backward"
  })]), _vm._v(" "), _c('div', {
    staticClass: "previous-hour button",
    on: {
      "click": function($event) {
        _vm.seek(-1 * 3600 * 1000)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward"
  })]), _vm._v(" "), _c('div', {
    ref: "handle",
    staticClass: "wheel",
    on: {
      "mousedown": _vm.beginMouseMove,
      "touchstart": _vm.beginTouchMove
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.roundedTime, 'ddd Do - LT')))])]), _vm._v(" "), _c('canvas', {
    ref: "wheel"
  }), _vm._v(" "), _c('div', {
    staticClass: "utc"
  }, [_vm._v(_vm._s(_vm.currentZoneOffset) + " − "), _c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.currentRun))])]), _vm._v(" "), _c('div', {
    staticClass: "next-hour button",
    on: {
      "click": function($event) {
        _vm.seek(1 * 3600 * 1000)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward"
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-day button",
    on: {
      "click": function($event) {
        _vm.seek(24 * 3600 * 1000)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fast-forward"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.daysMenu),
      expression: "daysMenu"
    }],
    staticClass: "days-menu",
    style: ({
      right: _vm.right
    })
  }, [_c('ul', {
    staticClass: "hours"
  }, _vm._l((_vm.hours), function(hour) {
    return _c('li', {
      class: hour.valueOf() === _vm.roundedTime.valueOf() ? 'active-hour' : '',
      on: {
        "click": function($event) {
          _vm.setHour(hour)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm._f("moment")(hour, 'LT')) + "\n      ")])
  })), _vm._v(" "), _c('ul', {
    staticClass: "days"
  }, _vm._l((_vm.days), function(day, key) {
    return _c('li', {
      class: {
        'active': (day.startTime <= _vm.currentTime && day.stopTime > _vm.currentTime)
      },
      on: {
        "click": function($event) {
          _vm.setDay(day)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm._f("moment")(day.startTime, 'ddd Do MMM')) + "\n        "), _c('div', {
      staticClass: "run-info"
    }, [(day.private && !_vm.contributor) ? _c('i', {
      staticClass: "fa fa-lock"
    }) : _c('small', [_vm._v(_vm._s(day.run.substring(8)) + "Z")])])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-modal"
  }, [(!_vm.success) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("Reset your password")])], 1), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contributor ? _vm.contributorEmail : _vm.email),
      expression: "contributor ? contributorEmail : email"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.$pgettext('password popup', 'Email'),
      "disabled": _vm.contributor
    },
    domProps: {
      "value": (_vm.contributor ? _vm.contributorEmail : _vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contributor ? _vm.contributorEmail : _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "password"
  }, [_c('a', {
    staticClass: "show",
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.togglePassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v(" "), (_vm.showPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.$pgettext('password popup', 'New password')
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$pgettext('password popup', 'New password')
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [(_vm.showPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.$pgettext('password popup', 'Confirm new password')
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$pgettext('password popup', 'Confirm new password')
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.passwordOk === false) ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n        Passwords must be the same\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("\n        An error has occured. Please try again.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "keyboard-submit-bug-fix"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "high"
  }, [_c('img', {
    attrs: {
      "src": "/img/load.gif"
    }
  })]) : _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.changePassword()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])]) : _c('div', [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("One last step...")])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n        If you are a contributor, you will receive an email.\n      ")])], 1), _vm._v(" "), _c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n          Click on the link inside the email to change your password.\n        ")])], 1)]), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "password popup"
    }
  }, [_vm._v("\n        Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo‑parapente.com\n      ")])], 1), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xc-planner"
  }, [_c('div', {
    attrs: {
      "id": "xc-map"
    }
  })])
}]}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-legend"
  }, [_c('canvas', {
    ref: "legend",
    class: {
      active: _vm.highlighted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "handle",
    on: {
      "click": _vm.toggleHighlight
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-view",
    style: ({
      width: _vm.appWidth + 'px',
      left: _vm.appLeft + 'px'
    })
  }, [_c('sideview-button', {
    class: {
      active: _vm.detailsVisible, hidden: _vm.smallView && _vm.detailsVisible
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleView($event)
      }
    }
  }), _vm._v(" "), _c('map-view', {
    style: ({
      width: _vm.mapWidth + 'px'
    }),
    attrs: {
      "width": _vm.mapWidth,
      "mapVisible": !(_vm.smallView && _vm.detailsVisible)
    }
  }), _vm._v(" "), _c('vertical-splitter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.splitterVisible),
      expression: "splitterVisible"
    }],
    style: ({
      left: _vm.splitterLeft + 'px'
    }),
    nativeOn: {
      "mousedown": function($event) {
        _vm.beginMouseMove($event)
      },
      "touchstart": function($event) {
        _vm.beginTouchMove($event)
      }
    }
  }), _vm._v(" "), _c('details-view', {
    ref: "details",
    class: {
      'small-view': _vm.smallView
    },
    style: ({
      width: _vm.detailsWidth + 'px'
    }),
    attrs: {
      "redraw": (_vm.detailsWidth + "_" + _vm.smallView)
    },
    on: {
      "close-details": function($event) {
        _vm.detailsVisible = false
      }
    }
  }), _vm._v(" "), _c('time-control', {
    attrs: {
      "view-width": _vm.mapWidth,
      "shadow": !(_vm.smallView && _vm.detailsVisible)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "notification",
    on: {
      "click": function($event) {
        _vm.openNews(_vm.lastArticle)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rss"
  }), _vm._v(" " + _vm._s(_vm.lastArticle.title) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-modal"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("We are coming to your club for a free weather training!")]), _vm._v(" "), _c('p', [_vm._v("First meetings: Southern French Alps, Spain, Portugal")]), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.open()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("See the dates / Learn more")])], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('p')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Meteo-Parapente Tour 2022")])])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "private-modal"
  }, [_c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "private popup",
      "translate-params": {
        date: _vm.date
      }
    }
  }, [_vm._v("\n        To see %{ date }, please login or become a member.\n      ")])], 1)]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.contribute
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Become a member")])], 1), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("I am already a member")])], 1), _vm._v(" "), _c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "private popup"
    }
  }, [_vm._v("\n        2 days a week are reserved to members\n      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "private popup"
    }
  }, [_vm._v(" Meteo-Parapente can exist thanks to you!\n      ")])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n        My goal is to provide a quality tool accessible to every pilots.\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.aboutLink,
      "target": "_blank"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Read more…\n        ")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.appIsUpdating !== false) ? _c('div', {
    staticClass: "app-update-modal"
  }, [(_vm.appIsUpdating === 'error') ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "update modal"
    }
  }, [_vm._v("Error! Please try again later")])], 1) : _c('p', [_vm._v(_vm._s(_vm.appIsUpdating))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-view"
  }, [_c('right-tabs', {
    attrs: {
      "redraw": _vm.redraw
    },
    on: {
      "close-details": function($event) {
        _vm.$emit('close-details')
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.online) ? _c('div', {
    staticClass: "connexion-check"
  }, [_c('div', {
    staticClass: "middle"
  }, [_c('p', [_c('translate', [_vm._v("No internet connexion")])], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, exports) {

module.exports = {
	"ca": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Parapent)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Afegeix nou..."
		},
		"Airspace": {
			"toggle menu": "Espai aeri"
		},
		"All": {
			"map menu humidity": "Tot"
		},
		"B. layer": {
			"map menu updrafts": "Capa límit"
		},
		"B. Layer": {
			"map menu wind": "Capa Límit"
		},
		"Boundary layer": {
			"map menu wind": "Capa límit"
		},
		"Boundary Layer": {
			"map menu updrafts": "Capa Límit",
			"layer legend A": "Capa de límit",
			"layer legend B": "Capa de límit"
		},
		"Ceiling": {
			"map menu updrafts": "Sostre",
			"layer legend B": "Sostre"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Sostre de capa límit"
		},
		"Change password": {
			"settings menu": "Canvia la contrasenya"
		},
		"Clouds": {
			"map menu humidity": "Núvols"
		},
		"Color blind": {
			"settings menu": "Daltònic"
		},
		"debug": {
			"settings menu": "depura"
		},
		"Delete": {
			"favorites menu": "Esborra"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Característiques experimentals"
		},
		"Favorites": {
			"menu title": "Favorits"
		},
		"Ground": {
			"map menu wind": "Terra",
			"map menu temperature": "Terra"
		},
		"Help us translate!": {
			"settings menu": "Ajuda'ns a traduir!"
		},
		"High": {
			"map menu humidity": "Alt"
		},
		"Humidity": {
			"map menu humidity": "Humitat"
		},
		"Interpolation": {
			"toggle menu": "Interpolació"
		},
		"Language": {
			"settings menu": "Idioma"
		},
		"Login": {
			"login menu": "Iniciar sessió"
		},
		"Logout": {
			"settings menu": "Tancar sessió"
		},
		"Low": {
			"map menu humidity": "Baix"
		},
		"Medium": {
			"map menu humidity": "Mitjà"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapent"
		},
		"Move to top": {
			"favorites menu": "Mou a la part superior"
		},
		"News": {
			"news menu": "Notícies"
		},
		"News!": {
			"news menu": "Notícies!"
		},
		"No data for this place": {
			"windgram view": "No hi ha dades per a aquest lloc"
		},
		"Open": {
			"favorites menu": "Obre"
		},
		"Pressure": {
			"map menu wind": "Pressió",
			"layer legend A": "Pressió"
		},
		"Rain": {
			"map menu humidity": "Pluja"
		},
		"Rename": {
			"favorites menu": "Reanomena"
		},
		"Reset all settings": {
			"settings menu": "Reinicia totes les configuracions"
		},
		"Sea level": {
			"map menu wind": "Nivell del mar"
		},
		"Set as homepage": {
			"favorites menu": "Estableix com a pàgina d'inici"
		},
		"Settings": {
			"settings menu": "Configuració"
		},
		"Shearing": {
			"map menu updrafts": "Cisallament",
			"layer legend B": "Cisallament"
		},
		"Sounding": {
			"windgram tab": "Sondeig"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Tèrmiques",
			"layer legend A": "Tèrmiques"
		},
		"Thickness": {
			"map menu updrafts": "Gruix",
			"layer legend B": "Gruix"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendències"
		},
		"Velocity": {
			"map menu updrafts": "Velocitat",
			"layer legend B": "Velocitat"
		},
		"Vertical motion": {
			"map menu updrafts": "Moviment vertical",
			"": "Moviment vertical"
		},
		"Wind": {
			"map menu wind": "Vent",
			"layer legend A": "Vent"
		},
		"Wind Shear": {
			"map menu wind": "Vent de cisalla",
			"layer legend A": "Vent de cisalla"
		},
		"Windgram": {
			"windgram tab": "Diagrama de vent"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "Senyora"
		},
		"dimensionless": {
			"layer unit": "adimensional"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superfície"
		},
		"Ceiling of BL": {
			"layer legend B": "Sostre de la CL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Coberta de núvols"
		},
		"Low altitude": {
			"layer legend B": "Baixa altitud"
		},
		"High altitude": {
			"layer legend B": "Alta altitud"
		},
		"Medium altitude": {
			"layer legend B": "Altitud mitjana"
		},
		"All altitudes": {
			"layer legend B": "Totes les altituds"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Moviment vertical"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitacions"
		},
		"1 hour": {
			"layer legend B": "1 hora"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Nivell del mar mitjà"
		},
		"Enter a name": {
			"new favorite prompt": "Introdueix un nom"
		},
		"Enter the new name": {
			"new favorite prompt": "Introdueix el nom nou"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Sobreescriu el favorit \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Esborrar el favorit \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Esteu segur que voleu reiniciar-ho tot?\nTOTES LES VOSTRES CONFIGURACIONS I FAVORITS ES PERDRAN PER SEMPRE!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Previsions meteorològiques pel vol lliure | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ajuda / Contacte / Sobre"
		},
		"Install now": {
			"version check": "Instal·la ara"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Previsions meteorològiques pel vol lliure"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente necessita una actualització"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente és ara mòbil!"
		},
		"Mobile app": "App mòbil",
		"No internet connexion": "No hi ha connexió a internet",
		"Community": "Comunitat",
		"Day selection": "Selecció del dia",
		"knots": "nusos",
		"mph": "mph",
		"Radiation": "Radiació",
		"Sun": "Sol",
		"Update": "Actualització",
		"Wind unit": "Unitat de vent",
		"An error has occured. Please try again.": {
			"popup": "S'ha produït un error. Siusplau torna-ho a provar."
		},
		"Click here to renew.": {
			"login popup": "Feu clic aquí per renovar."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Feu clic a l'enllaç dins del correu electrònic per canviar la vostra contrasenya."
		},
		"Close": {
			"popup": "Tanca",
			"general": "Tanca"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Els correus electrònics no són iguals o no són vàlids"
		},
		"Error! Bad login or password": {
			"login popup": "Error! Inici de sessió o contrasenya incorrectes"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Error! El vostre accés ha caducat el %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Si ets col·laborador, rebràs un correu electrònic."
		},
		"OK": {
			"popup": "D'acord",
			"general": "D'acord"
		},
		"One last step...": {
			"password popup": "Un últim pas..."
		},
		"Passwords must be the same": {
			"password popup": "Les contrasenyes han de ser les mateixes"
		},
		"Please log-in": {
			"login popup": "Si us plau inicieu sessió"
		},
		"Private device − stay connected": {
			"login popup": "Dispositiu privat: mantingueu-vos connectat"
		},
		"Read more…": {
			"contribute popup": "Llegeix més…"
		},
		"Reset your password": {
			"password popup": "Restablir la contrasenya"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Alguns proveïdors com Orange, GMX i Hotmail de vegades bloquegen els nostres correus electrònics. Si no rebeu res, poseu-vos en contacte amb support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Benvingut!"
		},
		"Same as device": {
			"timezone menu": "Igual que el dispositiu"
		},
		"Timezone": {
			"settings menu": "Fus horari"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiplicador"
		},
		"Points": {
			"xc planner": "Punts"
		},
		"Duration": {
			"xc planner": "Durada"
		},
		"Speed": {
			"xc planner": "Velocitat"
		},
		"Close flight": {
			"xc planner": "Vol tancat"
		},
		"Share": {
			"xc planner": "Compartir"
		},
		"Download": {
			"xc planner": "descarregar",
			"general": "descarregar"
		},
		"Preferences": {
			"xc planner": "Preferències"
		},
		"Reset": {
			"xc planner": "Restableix",
			"general": "Restableix"
		},
		"About": {
			"xc planner": "Sobre"
		},
		"Exit Fullscreen": {
			"toggle menu": "Sortir de pantalla completa"
		},
		"Fullscreen": {
			"toggle menu": "Pantalla completa"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner és una característica experimental.\nNomés està disponible des d'un ordinador, a meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancel · lar"
		},
		"Yes": {
			"general": "Sí"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Desa"
		},
		"Continue": {
			"general": "Continua"
		},
		"Original version": {
			"xc planner": "Versió original"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Molt piratejat per treballar a Meteo-Parapente, amb autorització de Tom. Gràcies!"
		},
		"League": {
			"xc planner": "Lliga"
		},
		"Distance units": {
			"xc planner": "Unitats de distància"
		},
		"Altitude units": {
			"xc planner": "Unitats d'altitud"
		},
		"Coordinates format": {
			"xc planner": "Format de coordenades"
		},
		"Turnpoint details": {
			"xc planner": "Detalls del punt d'inflexió"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nom de la ruta"
		},
		"Waypoint prefix": {
			"xc planner": "Prefix de waypoint"
		},
		"Lien": {
			"xc planner": "Enllaç"
		},
		"Paste link in email or IM": {
			"xc planner": "Enganxeu l'enllaç al correu electrònic o missatgeria instantània"
		},
		"Static image": {
			"xc planner": "Imatge estàtica"
		},
		"Open with XCTrack": {
			"xc planner": "Obriu amb XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Comparteix amb LocToMe: defineix com a ruta predeterminada"
		},
		"Go to": {
			"general": "Anar a"
		},
		"Error! Please try again later": {
			"update modal": "Error! Siusplau, intenta-ho més tard"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Premeu Restableix per restablir la ruta permanentment, premeu Cancel·la per mantenir la ruta."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Aquí teniu el vostre codi d'accés. Si us plau, guardeu-lo amb seguretat."
		},
		"Password:": {
			"contribute popup": "Contrasenya:"
		},
		"Thank you!": {
			"contribute popup": "Gràcies!"
		},
		"Username:": {
			"contribute popup": "Nom d'usuari:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesos Estàndard － %{currency} %{pricing}/mes"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesos Estudiant － %{currency} %{pricing}/mes"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesos de suport － %{currency} %{pricing}/mes"
		},
		"Tour of Europe": {
			"tab": "Volta per Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Gaudeix de les millors previsions cada dia. Meteo-Parapente pot existir gràcies a tu!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Aconsegueix entrada gratuïta a entrenaments meteorològics locals i trobades d'usuaris."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Uneix-te al club de col·laboradors de Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Trobeu-me un cop al mes per parlar de noves funcions i millores."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente pot existir gràcies a tu!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "El meu objectiu és oferir una eina de qualitat accessible a tots els pilots."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Donar suport al desenvolupament d'una eina de qualitat accessible a tots els pilots."
		},
		"and to the": {
			"startup terms": "i al"
		},
		"By using this application, you agree to the": {
			"startup terms": "En utilitzar aquesta aplicació, accepteu el"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Si el problema persisteix, poseu-vos en contacte amb support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente no utilitza cookies de seguiment"
		},
		"privacy policy": {
			"startup terms": "política de privacitat"
		},
		"terms of use": {
			"startup": "condicions d'ús"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "No es pot arribar als servidors de Meteo-Parapente. Comproveu la vostra connexió."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dies a la setmana estan reservats als socis"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Ja ets membre? Feu clic per restablir la vostra contrasenya"
		},
		"Become a member": {
			"contribute menu": "Fes-te soci",
			"popup": "Fes-te soci"
		},
		"Click here to learn the details": {
			"contest": "Feu clic aquí per conèixer els detalls"
		},
		"I am already a member": {
			"popup": "Ja en sóc soci"
		},
		"Learn more": {
			"contest": "Aprèn més"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente celebra el seu 10è aniversari."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Encara no ets membre? Feu clic per obtenir un codi d'accés"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "En aquesta ocasió, organitzem un concurs excepcional"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Es sortejarà un guanyador d'entre tots aquells que hagin adquirit o renovat una subscripció entre el setembre passat i el proper 30 de març."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Per guanyar: L'ALA DE PARAPENT DE LA TEVA Elecció!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Per veure %{ date }, inicieu sessió o feu-vos-hi membre."
		},
		"Win a paraglider!": {
			"contribute menu": "Guanya un parapent!"
		}
	},
	"cs": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Paragliding)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Přidat nový ..."
		},
		"Airspace": {
			"toggle menu": "Letové prostory"
		},
		"All": {
			"map menu humidity": "Vše"
		},
		"B. layer": {
			"map menu updrafts": "Mezní vrstva"
		},
		"B. Layer": {
			"map menu wind": "Mezní vrstva"
		},
		"Boundary layer": {
			"map menu wind": "Mezní vrstva"
		},
		"Boundary Layer": {
			"map menu updrafts": "Mezní vrstva",
			"layer legend A": "Mezní vrstva",
			"layer legend B": "Mezní vrstva"
		},
		"Ceiling": {
			"map menu updrafts": "Strop",
			"layer legend B": "Strop"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Strop vrstvy b."
		},
		"Change password": {
			"settings menu": "Změna hesla"
		},
		"Clouds": {
			"map menu humidity": "Oblačnost"
		},
		"Color blind": {
			"settings menu": "Vysoký kontrast"
		},
		"debug": {
			"settings menu": "ladit"
		},
		"Delete": {
			"favorites menu": "Smazat"
		},
		"experimental": {
			"settings menu": "experimentální"
		},
		"Experimental features": {
			"settings menu": "Experimentální funkce"
		},
		"Favorites": {
			"menu title": "Oblíbené"
		},
		"Ground": {
			"map menu wind": "Přízemní",
			"map menu temperature": "Přízemní"
		},
		"Help us translate!": {
			"settings menu": "Pomožte nám s překladem"
		},
		"High": {
			"map menu humidity": "Vysoká"
		},
		"Humidity": {
			"map menu humidity": "Vlhkost"
		},
		"Interpolation": {
			"toggle menu": "Interpolace"
		},
		"Language": {
			"settings menu": "Jazyk"
		},
		"Login": {
			"login menu": "Přihlášení"
		},
		"Logout": {
			"settings menu": "Odhlášení"
		},
		"Low": {
			"map menu humidity": "Nízká"
		},
		"Medium": {
			"map menu humidity": "Střední"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Posunout nahoru"
		},
		"News": {
			"news menu": "Novinky"
		},
		"News!": {
			"news menu": "Novinky!"
		},
		"No data for this place": {
			"windgram view": "Nejsou data pro tuto lokalitu"
		},
		"Open": {
			"favorites menu": "Otevřít"
		},
		"Pressure": {
			"map menu wind": "Tlak",
			"layer legend A": "Tlak"
		},
		"Rain": {
			"map menu humidity": "Srážky"
		},
		"Rename": {
			"favorites menu": "Přejmenovat"
		},
		"Reset all settings": {
			"settings menu": "Výchozí nastavení"
		},
		"Sea level": {
			"map menu wind": "Úrověň moře"
		},
		"Set as homepage": {
			"favorites menu": "Nastavit jako domovskou stránku"
		},
		"Settings": {
			"settings menu": "Nastavení"
		},
		"Shearing": {
			"map menu updrafts": "Stříhání",
			"layer legend B": "Stříhání"
		},
		"Sounding": {
			"windgram tab": "Výstup"
		},
		"Temperature": {
			"map menu temperature": "Teplota",
			"layer legend A": "Teplota"
		},
		"Thermals": {
			"map menu updrafts": "Stoupání",
			"layer legend A": "Termika"
		},
		"Thickness": {
			"map menu updrafts": "Tloušťka",
			"layer legend B": "Tloušťka"
		},
		"Updrafts": {
			"map menu updrafts": "Termika"
		},
		"Velocity": {
			"map menu updrafts": "Rychlost",
			"layer legend B": "Rychlost"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertikální pohyb",
			"": "Vertikální pohyb"
		},
		"Wind": {
			"map menu wind": "Vítr",
			"layer legend A": "Vítr"
		},
		"Wind Shear": {
			"map menu wind": "Střih větru",
			"layer legend A": "Střih větru"
		},
		"Windgram": {
			"windgram tab": "Vítr"
		},
		"m MSL": {
			"layer unit": "m nad mořem"
		},
		"m AGL": {
			"layer unit": "m nad zemí"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "bezrozměrný"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Povrch"
		},
		"Ceiling of BL": {
			"layer legend B": "Strop BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Oblačnost"
		},
		"Low altitude": {
			"layer legend B": "Nizká"
		},
		"High altitude": {
			"layer legend B": "Vysoká"
		},
		"Medium altitude": {
			"layer legend B": "Střední"
		},
		"All altitudes": {
			"layer legend B": "Vše"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m nad zemí"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikální pohyb"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Srážky"
		},
		"1 hour": {
			"layer legend B": "1 hodina"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Střední hladina moře"
		},
		"Enter a name": {
			"new favorite prompt": "Název"
		},
		"Enter the new name": {
			"new favorite prompt": "Nový název"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Přepsat oblíbenou položku \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Smazat oblíbenou položku \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Jsi si jistý, že chceš vše resetovat?\nVŠECHNA TVÁ NASTAVENÍ A OBLÍBENÉ BUDOU NA VŽDY SMAZÁNY!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Předpověď počasí pro volné létání | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Nápověda / Kontakt / O Aplikaci"
		},
		"Install now": {
			"version check": "Instalovat"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Předpověď počasí pro volné létání"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente vyžaduje aktualizaci."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente je již mobilní!\nPředpověď počasí speciálně navržená pro létání a paragliding.\n"
		},
		"Mobile app": "Mobilní aplikace",
		"No internet connexion": "Není připojení k internetu",
		"Community": "Společenství",
		"Day selection": "Výběr dne",
		"knots": "uzly",
		"mph": "mph",
		"Radiation": "Radiace",
		"Sun": "Sun",
		"Update": "Aktualizace",
		"Wind unit": "Větrná jednotka",
		"An error has occured. Please try again.": {
			"popup": "Došlo k chybě. Zkuste to prosím znovu."
		},
		"Click here to renew.": {
			"login popup": "Pro obnovení klikněte zde."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kliknutím na odkaz v e-mailu si můžete změnit heslo."
		},
		"Close": {
			"popup": "Zavřít",
			"general": "Zavřít"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-maily nejsou stejné nebo neplatné"
		},
		"Error! Bad login or password": {
			"login popup": "Chyba! Špatné přihlašovací jméno nebo heslo"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Chyba! Váš přístup vypršel dne %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Pokud jste přispěvatelem, obdržíte e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Poslední krok..."
		},
		"Passwords must be the same": {
			"password popup": "Hesla musí být stejná"
		},
		"Please log-in": {
			"login popup": "Přihlaste se prosím"
		},
		"Private device − stay connected": {
			"login popup": "Soukromé zařízení - zůstaňte ve spojení"
		},
		"Read more…": {
			"contribute popup": "Více informací..."
		},
		"Reset your password": {
			"password popup": "Obnovení hesla"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Někteří poskytovatelé, například Orange, GMX a Hotmail, někdy naše e-maily blokují. Pokud vám nic nepřijde, kontaktujte prosím support@meteo&#x2011;parapente.com."
		},
		"Welcome!": {
			"login popup": "Vítejte!"
		},
		"Same as device": {
			"timezone menu": "Stejné jako zařízení"
		},
		"Timezone": {
			"settings menu": "Časové pásmo"
		},
		"XC Planner": {
			"toggle menu": "Plánovač XC"
		},
		"Multiplier": {
			"xc planner": "Multiplikátor"
		},
		"Points": {
			"xc planner": "Body"
		},
		"Duration": {
			"xc planner": "Doba trvání"
		},
		"Speed": {
			"xc planner": "Rychlost"
		},
		"Close flight": {
			"xc planner": "Blízký let"
		},
		"Share": {
			"xc planner": "Sdílet"
		},
		"Download": {
			"xc planner": "Stáhnout",
			"general": "Stáhnout"
		},
		"Preferences": {
			"xc planner": "Předvolby"
		},
		"Reset": {
			"xc planner": "Obnovení",
			"general": "Obnovení"
		},
		"About": {
			"xc planner": "O stránkách"
		},
		"Exit Fullscreen": {
			"toggle menu": "Ukončení zobrazení na celou obrazovku"
		},
		"Fullscreen": {
			"toggle menu": "Celá obrazovka"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Plánovač XC je experimentální funkce.\nJe dostupná pouze z počítače na webu meteo-parapente.com."
		},
		"Cancel": {
			"general": "Zrušit"
		},
		"Yes": {
			"general": "Ano"
		},
		"No": {
			"general": "Ne"
		},
		"Save": {
			"general": "Uložit"
		},
		"Continue": {
			"general": "Pokračovat"
		},
		"Original version": {
			"xc planner": "Původní verze"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "S autorizací od Toma silně hacknuto pro práci v Meteo-Parapente. Děkujeme!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Jednotky vzdálenosti"
		},
		"Altitude units": {
			"xc planner": "Jednotky nadmořské výšky"
		},
		"Coordinates format": {
			"xc planner": "Formát souřadnic"
		},
		"Turnpoint details": {
			"xc planner": "Podrobnosti o bodu obratu"
		},
		"Format": {
			"xc planner": "Formát"
		},
		"Route name": {
			"xc planner": "Název trasy"
		},
		"Waypoint prefix": {
			"xc planner": "Předpona bodu cesty"
		},
		"Lien": {
			"xc planner": "Odkaz"
		},
		"Paste link in email or IM": {
			"xc planner": "Vložte odkaz do e-mailu nebo IM"
		},
		"Static image": {
			"xc planner": "Statický obrázek"
		},
		"Open with XCTrack": {
			"xc planner": "Otevřít pomocí XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Sdílet s LocToMe: nastavit jako výchozí trasu"
		},
		"Go to": {
			"general": "Přejít na"
		},
		"Error! Please try again later": {
			"update modal": "Chyba! Zkuste to prosím později"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Stisknutím tlačítka Obnovit trasu trvale resetujete, stisknutím tlačítka Zrušit trasu zachováte."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Zde je váš přístupový kód. Uschovejte si ho prosím."
		},
		"Password:": {
			"contribute popup": "Heslo:"
		},
		"Thank you!": {
			"contribute popup": "Děkujeme!"
		},
		"Username:": {
			"contribute popup": "Uživatelské jméno:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 měsíců Standard - %{currency} %{pricing} / měsíc"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 měsíců Student - %{currency} %{pricing} / měsíc"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 měsíců Příznivec - %{currency} %{pricing} / měsíc"
		},
		"Tour of Europe": {
			"tab": "Cestování po Evropě"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Užijte si nejlepší předpovědi každý den. Meteo-Parapente může existovat díky vám!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Získejte volný vstup na místní školení o počasí a setkání uživatelů."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Připojte se ke klubu přispěvatelů Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Jednou měsíčně se se mnou sejdete a probereme nové funkce a vylepšení."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente může existovat díky vám!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mým cílem je poskytnout kvalitní nástroj dostupný všem pilotům."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Podporovat vývoj kvalitního nástroje, který bude dostupný všem pilotům."
		},
		"and to the": {
			"startup terms": "a na"
		},
		"By using this application, you agree to the": {
			"startup terms": "Používáním této aplikace souhlasíte s"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Pokud problém přetrvává, kontaktujte support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente nepoužívá sledovací soubory cookie"
		},
		"privacy policy": {
			"startup terms": "zásady ochrany osobních údajů"
		},
		"terms of use": {
			"startup": "podmínky používání"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nelze se spojit se servery Meteo-Parapente. Zkontrolujte prosím své připojení."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dny v týdnu jsou vyhrazeny pro členy"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Jste již členem? Klikněte pro obnovení hesla"
		},
		"Become a member": {
			"contribute menu": "Staňte se členem",
			"popup": "Staňte se členem"
		},
		"Click here to learn the details": {
			"contest": "Kliknutím sem se dozvíte podrobnosti"
		},
		"I am already a member": {
			"popup": "Jsem již členem"
		},
		"Learn more": {
			"contest": "Zjistěte více"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente slaví 10. výročí."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Ještě nejste členem? Kliknutím získáte přístupový kód"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Při této příležitosti pořádáme výjimečnou soutěž."
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Ze všech, kteří si v období od loňského září do 30. března příštího roku zakoupili nebo obnovili předplatné, bude vylosován jeden výherce."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "K výhře: PARAGLIDISTICKÉ KŘÍDLO DLE VLASTNÍHO VÝBĚRU!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Chcete-li zobrazit %{ date }, přihlaste se nebo se staňte členem."
		},
		"Win a paraglider!": {
			"contribute menu": "Vyhrajte paragliding!"
		}
	},
	"de": {
		"(Kitesurf)": {
			"search result": "(Kitesurfen)"
		},
		"(Paragliding)": {
			"search result": "(Gleitschirmfliegen)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Hinzufügen"
		},
		"Airspace": {
			"toggle menu": "Luftraum\n"
		},
		"All": {
			"map menu humidity": "Alle\n"
		},
		"B. layer": {
			"map menu updrafts": "G.-schicht"
		},
		"B. Layer": {
			"map menu wind": "G.-schicht"
		},
		"Boundary layer": {
			"map menu wind": "Grenzschicht"
		},
		"Boundary Layer": {
			"map menu updrafts": "Grenzschicht",
			"layer legend A": "Grenzschicht",
			"layer legend B": "Grenzschicht"
		},
		"Ceiling": {
			"map menu updrafts": "Basishöhe",
			"layer legend B": "Decke"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Höhe der G.-schicht"
		},
		"Change password": {
			"settings menu": "Passwort ändern"
		},
		"Clouds": {
			"map menu humidity": "Wolken"
		},
		"Color blind": {
			"settings menu": "Kontrastmodus"
		},
		"debug": {
			"settings menu": "Debug"
		},
		"Delete": {
			"favorites menu": "Löschen\n"
		},
		"experimental": {
			"settings menu": "Experimentell"
		},
		"Experimental features": {
			"settings menu": "Betafunktionen"
		},
		"Favorites": {
			"menu title": "Favoriten"
		},
		"Ground": {
			"map menu wind": "Boden",
			"map menu temperature": "Boden\n"
		},
		"Help us translate!": {
			"settings menu": "Übersetze für uns!"
		},
		"High": {
			"map menu humidity": "Hoch"
		},
		"Humidity": {
			"map menu humidity": "Luftfeuchtigkeit"
		},
		"Interpolation": {
			"toggle menu": "Glätten"
		},
		"Language": {
			"settings menu": "Sprache"
		},
		"Login": {
			"login menu": "Anmelden"
		},
		"Logout": {
			"settings menu": "Abmelden"
		},
		"Low": {
			"map menu humidity": "Niedrig"
		},
		"Medium": {
			"map menu humidity": "Mittel"
		},
		"Meteo Parapente": {
			"menu title": "Gleitschirmwetter"
		},
		"Move to top": {
			"favorites menu": "Nach oben schieben"
		},
		"News": {
			"news menu": "Neuigkeiten"
		},
		"News!": {
			"news menu": "Neuigkeiten!"
		},
		"No data for this place": {
			"windgram view": "Keine Daten für diesen Ort"
		},
		"Open": {
			"favorites menu": "Öffnen"
		},
		"Pressure": {
			"map menu wind": "Luftdruck",
			"layer legend A": "Luftdruck"
		},
		"Rain": {
			"map menu humidity": "Regen"
		},
		"Rename": {
			"favorites menu": "Umbenennen"
		},
		"Reset all settings": {
			"settings menu": "Alle Einstellungen zurücksetzen"
		},
		"Sea level": {
			"map menu wind": "Meereshöhe"
		},
		"Set as homepage": {
			"favorites menu": "Homepage eintragen"
		},
		"Settings": {
			"settings menu": "Einstellungen"
		},
		"Shearing": {
			"map menu updrafts": "Scherung",
			"layer legend B": "Scherung"
		},
		"Sounding": {
			"windgram tab": "Temps"
		},
		"Temperature": {
			"map menu temperature": "Temperatur",
			"layer legend A": "Temperatur"
		},
		"Thermals": {
			"map menu updrafts": "Thermik",
			"layer legend A": "Thermik"
		},
		"Thickness": {
			"map menu updrafts": "Dicke",
			"layer legend B": "Dicke"
		},
		"Updrafts": {
			"map menu updrafts": "Aufwinde"
		},
		"Velocity": {
			"map menu updrafts": "Steigwerte",
			"layer legend B": "Geschwindigkeit"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertikalbewegung",
			"": "Vertikalbewegung"
		},
		"Wind": {
			"map menu wind": "Wind",
			"layer legend A": "Wind"
		},
		"Wind Shear": {
			"map menu wind": "Windscherung",
			"layer legend A": "Windscherung"
		},
		"Windgram": {
			"windgram tab": "Winddiagramm"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Modell"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Keine Dimension"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Oberfläche"
		},
		"Ceiling of BL": {
			"layer legend B": "Obere Grenzschicht"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Wolkendecke"
		},
		"Low altitude": {
			"layer legend B": "Untere Schicht"
		},
		"High altitude": {
			"layer legend B": "Hohe Schicht"
		},
		"Medium altitude": {
			"layer legend B": "Mittlere Schicht"
		},
		"All altitudes": {
			"layer legend B": "Alle Höhen"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikale Bewegung"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Niederschläge"
		},
		"1 hour": {
			"layer legend B": "1 Stunde"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Normalnull"
		},
		"Enter a name": {
			"new favorite prompt": "Gib einen Namen ein"
		},
		"Enter the new name": {
			"new favorite prompt": "Gib einen neuen Namen ein"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Überschreibe Favorit \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Lösche Favorit \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Bist du sicher, dass du alles zurücksetzen willst?\nALL DEINE EINSTELLUNGEN UND FAVORITEN WERDEN UNWIDERRUFLICH GELÖSCHT!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Gleitsegelwettervorhersage | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Hilfe / Kontakt / Über"
		},
		"Install now": {
			"version check": "Jetzt installieren"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Gleitschirmwetter Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Gleitschirm Wetter Vorhersagen"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Gleitschirmwetter benötigt ein Update"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Gleitschirmwetter ist jetzt mobil verfügbar!\nWetter Vorhersagen speziell für Gleitschirmpiloten"
		},
		"Mobile app": "mobile App",
		"No internet connexion": "Keine Internetverbindung",
		"Community": "Gemeinschaft",
		"Day selection": "Tag",
		"knots": "knoten",
		"mph": "mph",
		"Radiation": "Strahlung",
		"Sun": "Sonnenschein",
		"Update": "Update",
		"Wind unit": "Geschwindigkeitsmaß",
		"An error has occured. Please try again.": {
			"popup": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
		},
		"Click here to renew.": {
			"login popup": "Klicken Sie hier, um zu verlängern."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Klicken Sie auf den Link in der E-Mail, um Ihr Passwort zu ändern."
		},
		"Close": {
			"popup": "Schließen",
			"general": "Schließen"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-Mails sind nicht gleich oder ungültig"
		},
		"Error! Bad login or password": {
			"login popup": "Fehler! Falsches Login oder Passwort"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Fehler! Ihr Zugang ist am %{ expirationDate } abgelaufen."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Wenn Sie ein Beitragszahler sind, erhalten Sie eine E-Mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Ein letzter Schritt..."
		},
		"Passwords must be the same": {
			"password popup": "Die Passwörter müssen identisch sein"
		},
		"Please log-in": {
			"login popup": "Bitte loggen Sie sich ein"
		},
		"Private device − stay connected": {
			"login popup": "Privates Gerät - in Verbindung bleiben"
		},
		"Read more…": {
			"contribute popup": "Lesen Sie mehr..."
		},
		"Reset your password": {
			"password popup": "Setzen Sie Ihr Passwort zurück"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Einige Anbieter wie Orange, GMX und Hotmail blockieren manchmal unsere E-Mails. Wenn Sie nichts erhalten, kontaktieren Sie bitte support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Willkommen!"
		},
		"Same as device": {
			"timezone menu": "Gleiches wie Gerät"
		},
		"Timezone": {
			"settings menu": "Zeitzone"
		},
		"XC Planner": {
			"toggle menu": "XC-Planer"
		},
		"Multiplier": {
			"xc planner": "Multiplikator"
		},
		"Points": {
			"xc planner": "Punkte"
		},
		"Duration": {
			"xc planner": "Dauer"
		},
		"Speed": {
			"xc planner": "Geschwindigkeit"
		},
		"Close flight": {
			"xc planner": "Flug beenden"
		},
		"Share": {
			"xc planner": "Teilen"
		},
		"Download": {
			"xc planner": "Herunterladen",
			"general": "herunterladen"
		},
		"Preferences": {
			"xc planner": "Voreinstellungen"
		},
		"Reset": {
			"xc planner": "Zurücksetzen",
			"general": "Zurücksetzen"
		},
		"About": {
			"xc planner": "Über"
		},
		"Exit Fullscreen": {
			"toggle menu": "Vollbild beenden"
		},
		"Fullscreen": {
			"toggle menu": "Vollbild"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner ist eine experimentelle Funktion. Sie ist nur von einem Computer aus verfügbar, auf meteo-parapente.com"
		},
		"Cancel": {
			"general": "Abbrechen"
		},
		"Yes": {
			"general": "Ja"
		},
		"No": {
			"general": "Nein"
		},
		"Save": {
			"general": "Speichern"
		},
		"Continue": {
			"general": "Weiter"
		},
		"Original version": {
			"xc planner": "Ursprüngliche Version"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Stark gehackt, um in Meteo-Parapente zu funktionieren, mit Genehmigung von Tom. Vielen Dank dafür!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Einheiten der Entfernung"
		},
		"Altitude units": {
			"xc planner": "Höheneinheiten"
		},
		"Coordinates format": {
			"xc planner": "Koordinaten-Format"
		},
		"Turnpoint details": {
			"xc planner": "Details zum Wendepunkt"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Name der Route"
		},
		"Waypoint prefix": {
			"xc planner": "Wegpunkt-Präfix"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Link in E-Mail oder IM einfügen"
		},
		"Static image": {
			"xc planner": "Statisches Bild"
		},
		"Open with XCTrack": {
			"xc planner": "Mit XCTrack öffnen"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Freigeben mit LocToMe: als Standardroute festlegen"
		},
		"Go to": {
			"general": "Weiter zu"
		},
		"Error! Please try again later": {
			"update modal": "Fehler! Bitte versuchen Sie es später noch einmal"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Drücken Sie Reset, um Ihre Route dauerhaft zurückzusetzen, drücken Sie Cancel, um Ihre Route zu behalten."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Hier ist Ihr Zugangscode. Bitte bewahren Sie ihn sicher auf."
		},
		"Password:": {
			"contribute popup": "Das Passwort:"
		},
		"Thank you!": {
			"contribute popup": "Dankeschön"
		},
		"Username:": {
			"contribute popup": "Benutzername:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 Monate Standard - %{currency} %{pricing} / Monat"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 Monate Student - %{currency} %{pricing} / Monat"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 Monate Supporter - %{currency} %{pricing} / Monat"
		},
		"Tour of Europe": {
			"tab": "Tour durch Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Genießen Sie jeden Tag die besten Vorhersagen. Meteo-Parapente kann nur dank Ihnen existieren!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Erhalten Sie freien Eintritt zu lokalen Wettertrainings und Nutzertreffen."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Werden Sie Mitglied im Club der Meteo-Parapente-Mitarbeiter"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Treffen Sie mich einmal im Monat, um neue Funktionen und Verbesserungen zu besprechen."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente kann nur dank Ihnen existieren!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mein Ziel ist es, ein qualitativ hochwertiges Programm für alle Piloten bereitzustellen."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Unterstützen Sie die Entwicklung eines Qualitätswerkzeugs, das für jeden Piloten zugänglich ist."
		},
		"and to the": {
			"startup terms": "und zum"
		},
		"By using this application, you agree to the": {
			"startup terms": "Durch die Nutzung dieser Anwendung erklären Sie sich mit den"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Wenn das Problem weiterhin besteht, wenden Sie sich an support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente verwendet keine Spionage-Cookies"
		},
		"privacy policy": {
			"startup terms": "Datenschutzbestimmungen"
		},
		"terms of use": {
			"startup": "Allgemeine Nutzungsbedingungen"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Die Server von Meteo-Parapente können nicht erreicht werden. Bitte überprüfen Sie Ihre Verbindung."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 Tage pro Woche sind für Mitglieder reserviert"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Sie sind bereits Mitglied? Klicken Sie, um Ihr Passwort zurückzusetzen"
		},
		"Become a member": {
			"contribute menu": "Mitglied werden",
			"popup": "Mitglied werden"
		},
		"Click here to learn the details": {
			"contest": "Klicken Sie hier, um die Details zu erfahren"
		},
		"I am already a member": {
			"popup": "Ich bin bereits Mitglied"
		},
		"Learn more": {
			"contest": "Mehr erfahren"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente feiert sein 10-jähriges Bestehen."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Noch kein Mitglied? Klicken Sie hier, um einen Zugangscode zu erhalten"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Aus diesem Anlass veranstalten wir einen außergewöhnlichen Wettbewerb"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Unter allen, die zwischen September letzten Jahres und dem 30. März nächsten Jahres ein Abonnement erworben oder verlängert haben, wird ein Gewinner ausgelost."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Zu gewinnen gibt es: DEN GLEITSCHIRMSCHIRM IHRER WAHL!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Um %{ date } zu sehen, melden Sie sich bitte an oder werden Sie Mitglied."
		},
		"Win a paraglider!": {
			"contribute menu": "Gewinnen Sie einen Gleitschirm!"
		}
	},
	"el": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "Αλεξίπτωτο πλαγιάς "
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Προσθήκη νέου"
		},
		"Airspace": {
			"toggle menu": "Ελεγχόμενος εναέριος χώρος "
		},
		"All": {
			"map menu humidity": "Όλα"
		},
		"B. layer": {
			"map menu updrafts": "Ο. στρώμα "
		},
		"B. Layer": {
			"map menu wind": "Ο. στρώμα␣ "
		},
		"Boundary layer": {
			"map menu wind": "Οριακό στρώμα "
		},
		"Boundary Layer": {
			"map menu updrafts": "Οριακό στρώμα ",
			"layer legend A": "Οριακό Στρώμα \n",
			"layer legend B": "Οριακό Στρώμα "
		},
		"Ceiling": {
			"map menu updrafts": "Οροφή ",
			"layer legend B": "Οροφή "
		},
		"Ceiling of b. layer": {
			"map menu wind": "Οροφή οριακού στρώματος "
		},
		"Change password": {
			"settings menu": "Αλλαγή password "
		},
		"Clouds": {
			"map menu humidity": "Σύννεφα "
		},
		"Color blind": {
			"settings menu": "Αχρωματοψία "
		},
		"debug": {
			"settings menu": "Αποσφαλμάτωση "
		},
		"Delete": {
			"favorites menu": "Διαγραφή "
		},
		"experimental": {
			"settings menu": "Πειραματικό "
		},
		"Experimental features": {
			"settings menu": "Πειραματικά χαρακτηριστικά "
		},
		"Ground": {
			"map menu wind": "Έδαφος ",
			"map menu temperature": "Έδαφος"
		},
		"Help us translate!": {
			"settings menu": " Βοηθήστε μας στη μετάφραση "
		},
		"High": {
			"map menu humidity": "Υψηλά"
		},
		"Humidity": {
			"map menu humidity": "Υγρασία "
		},
		"Interpolation": {
			"toggle menu": "Παρεμβολή "
		},
		"Language": {
			"settings menu": "Γλώσσα "
		},
		"Login": {
			"login menu": "Είσοδος "
		},
		"Logout": {
			"settings menu": "Έξοδος "
		},
		"Low": {
			"map menu humidity": "Χαμηλά"
		},
		"Medium": {
			"map menu humidity": "Μεσαία "
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Μετακίνηση στην κορυφή "
		},
		"News": {
			"news menu": "Νέα "
		},
		"News!": {
			"news menu": "Νέα!"
		},
		"No data for this place": {
			"windgram view": " Δεν υπάρχουν δεδομένα για αυτό το μέρος "
		},
		"Open": {
			"favorites menu": "Ανοικτό "
		},
		"Pressure": {
			"map menu wind": "Πίεση ",
			"layer legend A": "Πίεση "
		},
		"Rain": {
			"map menu humidity": "Βροχή "
		},
		"Rename": {
			"favorites menu": "Μετονομασία"
		},
		"Reset all settings": {
			"settings menu": "Επαναφορά όλων των ρυθμίσεων "
		},
		"Sea level": {
			"map menu wind": "Επίπεδο θάλασσας "
		},
		"Set as homepage": {
			"favorites menu": "Ορίστε ως αρχική σελίδα "
		},
		"Settings": {
			"settings menu": "Ρυθμίσεις "
		},
		"Shearing": {
			"map menu updrafts": "Διάτμηση ",
			"layer legend B": "Διάτμηση "
		},
		"Sounding": {
			"windgram tab": "Ραδιοβόληση"
		},
		"Temperature": {
			"map menu temperature": "Θερμοκρασία ",
			"layer legend A": "Θερμοκρασία "
		},
		"Thermals": {
			"map menu updrafts": "Θερμικά ",
			"layer legend A": "Θερμικά "
		},
		"Thickness": {
			"map menu updrafts": "Πάχος ",
			"layer legend B": "Πάχος "
		},
		"Updrafts": {
			"map menu updrafts": "Ανοδικά "
		},
		"Velocity": {
			"map menu updrafts": "Ταχύτητα  ",
			"layer legend B": "Ταχύτητα "
		},
		"Vertical motion": {
			"map menu updrafts": "Κάθετη κίνηση ",
			"": "Κάθετη κίνηση "
		},
		"Wind": {
			"map menu wind": "Άνεμος ",
			"layer legend A": "Άνεμος "
		},
		"Wind Shear": {
			"map menu wind": "Διάτμηση ανέμου ",
			"layer legend A": "Διάτμηση Ανέμου "
		},
		"Windgram": {
			"windgram tab": "Γράφημα ανέμου \n"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Τοπογραφία "
		},
		"Model": {
			"layer legend B": "Μοντέλο "
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Χωρίς διαστάσεις "
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Επιφάνεια "
		},
		"Ceiling of BL": {
			"layer legend B": "Οροφή Ο.Σ."
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Νεφοκάλυψη "
		},
		"Low altitude": {
			"layer legend B": "Χαμηλό ύψος "
		},
		"High altitude": {
			"layer legend B": "Υψηλό ύψος "
		},
		"Medium altitude": {
			"layer legend B": "Μεσαίο ύψος "
		},
		"All altitudes": {
			"layer legend B": "Όλα τα ύψη "
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Κάθετη Κίνηση "
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Βροχοπτώσεις "
		},
		"1 hour": {
			"layer legend B": "1 ώρα "
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Απόλυτο επίπεδο θαλάσσης "
		},
		"Enter a name": {
			"new favorite prompt": "Προσθέστε ένα όνομα "
		},
		"Enter the new name": {
			"new favorite prompt": "Προσθέστε ένα νέο όνομα "
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Επικάλυψη  αγαπημένου  \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Διαγραφή αγαπημένου  \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Εισαι βέβαιος ότι θες να επαναφέρεις όλες τις ρυθμίσεις?\nΟΛΕΣ ΣΟΥ ΟΙ ΡΥΘΜΊΣΕΙΣ ΚΑΙ ΤΑ ΑΓΑΠΗΜΈΝΑ ΘΑ ΔΙΑΓΡΑΦΟΥΝ ΓΙΑ ΠΆΝΤΑ! "
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Πρόγνωση καιρού ανεμοπορίας"
		},
		"Help / Contact / About": {
			"menu": "Βοήθεια/  Επικοινωνία/ Περί "
		},
		"Install now": {
			"version check": "Εγκατάσταση τώρα"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Πρόγνωση καιρού ανεμοπορίας "
		},
		"Meteo-Parapente requires an update.": {
			"version check": " χρειάζεται μία αναβάθμιση. "
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Το Meteo-Parapente είναι τώρα εύχρηστο !\nΠρόγνωση καιρού ανεμοπορίας ειδικά σχεδιασμένη για πτήση και Παρα5 "
		},
		"Mobile app": "Εφαρμογή κινητού ",
		"No internet connexion": "Δεν υπάρχει σύνδεση internet",
		"Community": "Κοινότητα ",
		"Day selection": "Επιλογή ημέρας ",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Ακτινοβολία ",
		"Sun": "Ήλιος ",
		"Update": "Αναβάθμιση ",
		"Wind unit": "Μονάδες ανέμου ",
		"An error has occured. Please try again.": {
			"popup": "Παρουσιάστηκε ένα σφάλμα. Παρακαλώ δοκιμάστε πάλι.\n"
		},
		"Click here to renew.": {
			"login popup": "Κλίκαρε εδώ για ανανέωση "
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Κλικάρετε στο link μέσα στο email για να αλλάξεις το password."
		},
		"Close": {
			"popup": "Κλείσιμο ",
			"general": "Κλείσιμο "
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Τα email δεν είναι ίδια ή δεν ισχύουν "
		},
		"Error! Bad login or password": {
			"login popup": "Σφάλμα! Λαθος κατά την είσοδο ή στο password"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Σφάλμα! Η πρόσβαση σας έχει λήξει την  %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Εάν είσαι χορηγός, θα λάβεις ένα email."
		},
		"OK": {
			"popup": "Οκ",
			"general": "Οκ"
		},
		"One last step...": {
			"password popup": "Ένα τελευταίο βήμα..."
		},
		"Passwords must be the same": {
			"password popup": "Τα password πρέπει να είναι τα ίδια "
		},
		"Please log-in": {
			"login popup": "Παρακαλώ συνδεθείτε "
		},
		"Private device − stay connected": {
			"login popup": "Ιδιωτική  συσκευή- παραμείνετε συνδεδεμένος "
		},
		"Read more…": {
			"contribute popup": "Διαβάστε περισσότερα..."
		},
		"Reset your password": {
			"password popup": "Επαναφέρετε  το password σας"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Μερικοί πάροχοι όπως Orange, GMX και Hotmail μερικές φορές μπλοκάρουν  τα e-mail  μας.\nΕάν δεν λάβετε κάτι επικοινωνήστε \nsupport@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Καλώς ήλθατε! "
		},
		"Same as device": {
			"timezone menu": "Ίδιο με την συσκευή "
		},
		"Timezone": {
			"settings menu": "Ζώνη ώρας "
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Πολλαπλασιαστής "
		},
		"Points": {
			"xc planner": "Πόντοι "
		},
		"Duration": {
			"xc planner": "Διάρκεια "
		},
		"Speed": {
			"xc planner": "Ταχύτητα "
		},
		"Close flight": {
			"xc planner": "Κλείσε την πτήση "
		},
		"Share": {
			"xc planner": "Μοιράσου "
		},
		"Download": {
			"xc planner": "Κατέβασε ",
			"general": "Κατέβασε "
		},
		"Preferences": {
			"xc planner": "Προτιμήσεις "
		},
		"Reset": {
			"xc planner": "Επαναφορά ",
			"general": "Επαναφορά "
		},
		"About": {
			"xc planner": "Περί "
		},
		"Exit Fullscreen": {
			"toggle menu": "Έξοδος από πλήρη οθόνη "
		},
		"Fullscreen": {
			"toggle menu": "Πλήρης οθόνη "
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Το XC Planner είναι μία πειραματική λειτουργία. Είναι διαθέσιμη από pc μέσω meteo-parapente.com"
		},
		"Cancel": {
			"general": "Ακυρωση6"
		},
		"Yes": {
			"general": "Ναί"
		},
		"No": {
			"general": "Οχι"
		},
		"Save": {
			"general": "Αποθήκευση "
		},
		"Continue": {
			"general": "Συνέχεια "
		},
		"Original version": {
			"xc planner": "Επίσημη έκδοση "
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Ζόρικα  χακευμένο για να δουλεύει στο\n  Meteo-Parapente,με την άδεια του Tom.Ευχαριστ"
		},
		"League": {
			"xc planner": "Πρωτάθλημα "
		},
		"Distance units": {
			"xc planner": "Μονάδες απόστασης "
		},
		"Altitude units": {
			"xc planner": "Μονάδες υψομέτρου "
		},
		"Coordinates format": {
			"xc planner": "Μορφή συντεταγμένων "
		},
		"Turnpoint details": {
			"xc planner": "Λεπτομέρειες πυλώνων "
		},
		"Format": {
			"xc planner": "Μορφή "
		},
		"Route name": {
			"xc planner": "Όνομα διαδρομής "
		},
		"Waypoint prefix": {
			"xc planner": "Πρόθεμα πυλώνων "
		},
		"Lien": {
			"xc planner": "Σύνδεσμος "
		},
		"Paste link in email or IM": {
			"xc planner": "Αντιγράψτε το link σε e mail ή messenger "
		},
		"Static image": {
			"xc planner": "Στατική εικόνα "
		},
		"Open with XCTrack": {
			"xc planner": "Άνοιγμα με XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Μοιράσου με LocToMe:όρισε ως προκαθορισμένη διαδρομή"
		},
		"Go to": {
			"general": "Πήγαινε σε"
		},
		"Error! Please try again later": {
			"update modal": "Σφάλμα!  Παρακαλώ δοκιμάστε πάλι αργότερα "
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Πατήστε Επαναφορά για να επαναφέρετε την διαδρομή σας μόνιμα, πατήστε Ακύρωση για να κρατήσετε την διαδρομή .\n"
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Εδώ είναι ο κωδικός σας.Παρακαλώ κρατήστε τον ασφαλή. "
		},
		"Password:": {
			"contribute popup": "Password:"
		},
		"Thank you!": {
			"contribute popup": "Ευχαριστούμε! "
		},
		"Username:": {
			"contribute popup": "Username:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12μηνες βασικό － %{currency} %{pricing} / μήνα "
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 μήνες  Σπουδαστής － %{currency} %{pricing} /  μήνα "
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 μηνός υποστηρικτής-  Supporter － %{currency} %{pricing} /μήνα "
		},
		"Tour of Europe": {
			"tab": "Γύρος της Ευρώπης "
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Απολαύστε τις καλύτερες προβλέψεις κάθε μέρα. Το Meteo-Parapente μπορεί να υπάρχει χάρη σε εσάς!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Αποκτήστε δωρεάν είσοδο σε τοπικές προπονήσεις καιρού και συναντήσεις χρηστών."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Εγγραφείτε στο κλαμπ των συνεργατών του Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Συναντήστε με μία φορά το μήνα για να συζητήσουμε νέα χαρακτηριστικά και βελτιώσεις."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Η Meteo-Parapente μπορεί να υπάρξει χάρη σε εσάς!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Στόχος μου είναι να παρέχω ένα ποιοτικό εργαλείο προσβάσιμο σε κάθε πιλότο."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Υποστήριξη της ανάπτυξης ενός ποιοτικού εργαλείου προσβάσιμου σε κάθε πιλότο."
		},
		"and to the": {
			"startup terms": "και στο"
		},
		"By using this application, you agree to the": {
			"startup terms": "Με τη χρήση αυτής της εφαρμογής, συμφωνείτε με"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Εάν το πρόβλημα εξακολουθεί να υφίσταται, επικοινωνήστε με το support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Η Meteo-Parapente δεν χρησιμοποιεί cookies παρακολούθησης"
		},
		"privacy policy": {
			"startup terms": "πολιτική απορρήτου"
		},
		"terms of use": {
			"startup": "όροι χρήσης"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Αδυναμία πρόσβασης στους διακομιστές Meteo-Parapente. Ελέγξτε τη σύνδεσή σας."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 ημέρες την εβδομάδα προορίζονται για τα μέλη"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Είστε ήδη μέλος; Κάντε κλικ για να επαναφέρετε τον κωδικό πρόσβασής σας"
		},
		"Become a member": {
			"contribute menu": "Γίνετε μέλος",
			"popup": "Γίνετε μέλος"
		},
		"Click here to learn the details": {
			"contest": "Κάντε κλικ εδώ για να μάθετε τις λεπτομέρειες"
		},
		"I am already a member": {
			"popup": "Είμαι ήδη μέλος"
		},
		"Learn more": {
			"contest": "Μάθετε περισσότερα"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Η Meteo-Parapente γιορτάζει τη 10η επέτειό της."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Δεν είστε ακόμα μέλος; Κάντε κλικ για να λάβετε έναν κωδικό πρόσβασης"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Με την ευκαιρία αυτή, διοργανώνουμε έναν εξαιρετικό διαγωνισμό"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Ένας νικητής θα κληρωθεί μεταξύ όλων όσοι αγόρασαν ή ανανέωσαν τη συνδρομή τους από τον περασμένο Σεπτέμβριο έως τις 30 Μαρτίου του επόμενου έτους."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Για να κερδηθεί: ΤΗΝ ΠΤΈΡΥΓΑ ΑΛΕΞΊΠΤΩΤΟΥ ΠΛΑΓΙΆΣ ΤΗΣ ΕΠΙΛΟΓΉΣ ΣΑΣ!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Για να δείτε %{ date }, συνδεθείτε ή γίνετε μέλος."
		},
		"Win a paraglider!": {
			"contribute menu": "Κερδίστε ένα αλεξίπτωτο πλαγιάς!"
		}
	},
	"en": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Paragliding)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Add new…"
		},
		"Airspace": {
			"toggle menu": "Airspace"
		},
		"All": {
			"map menu humidity": "All"
		},
		"B. layer": {
			"map menu updrafts": "B. layer"
		},
		"B. Layer": {
			"map menu wind": "B. Layer"
		},
		"Boundary layer": {
			"map menu wind": "Boundary layer"
		},
		"Boundary Layer": {
			"map menu updrafts": "Boundary Layer",
			"layer legend A": "Boundary Layer",
			"layer legend B": "Boundary Layer"
		},
		"Ceiling": {
			"map menu updrafts": "Ceiling",
			"layer legend B": "Ceiling"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Ceiling of b. layer"
		},
		"Change password": {
			"settings menu": "Change password"
		},
		"Clouds": {
			"map menu humidity": "Clouds"
		},
		"Color blind": {
			"settings menu": "Color blind"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Delete"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Experimental features"
		},
		"Favorites": {
			"menu title": "Favorites"
		},
		"Ground": {
			"map menu wind": "Ground",
			"map menu temperature": "Ground"
		},
		"Help us translate!": {
			"settings menu": "Help us translate!"
		},
		"High": {
			"map menu humidity": "High"
		},
		"Humidity": {
			"map menu humidity": "Humidity"
		},
		"Interpolation": {
			"toggle menu": "Interpolation"
		},
		"Language": {
			"settings menu": "Language"
		},
		"Login": {
			"login menu": "Login"
		},
		"Logout": {
			"settings menu": "Logout"
		},
		"Low": {
			"map menu humidity": "Low"
		},
		"Medium": {
			"map menu humidity": "Medium"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Move to top"
		},
		"News": {
			"news menu": "News"
		},
		"News!": {
			"news menu": "News!"
		},
		"No data for this place": {
			"windgram view": "No data for this place"
		},
		"Open": {
			"favorites menu": "Open"
		},
		"Pressure": {
			"map menu wind": "Pressure",
			"layer legend A": "Pressure"
		},
		"Rain": {
			"map menu humidity": "Rain"
		},
		"Rename": {
			"favorites menu": "Rename"
		},
		"Reset all settings": {
			"settings menu": "Reset all settings"
		},
		"Sea level": {
			"map menu wind": "Sea level"
		},
		"Set as homepage": {
			"favorites menu": "Set as homepage"
		},
		"Settings": {
			"settings menu": "Settings"
		},
		"Shearing": {
			"map menu updrafts": "Shearing",
			"layer legend B": "Shearing"
		},
		"Sounding": {
			"windgram tab": "Sounding"
		},
		"Temperature": {
			"map menu temperature": "Temperature",
			"layer legend A": "Temperature"
		},
		"Thermals": {
			"map menu updrafts": "Thermals",
			"layer legend A": "Thermals"
		},
		"Thickness": {
			"map menu updrafts": "Thickness",
			"layer legend B": "Thickness"
		},
		"Updrafts": {
			"map menu updrafts": "Updrafts"
		},
		"Velocity": {
			"map menu updrafts": "Velocity",
			"layer legend B": "Velocity"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertical motion",
			"": "Vertical motion"
		},
		"Wind": {
			"map menu wind": "Wind",
			"layer legend A": "Wind"
		},
		"Wind Shear": {
			"map menu wind": "Wind Shear",
			"layer legend A": "Wind Shear"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topography"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimensionless"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Surface"
		},
		"Ceiling of BL": {
			"layer legend B": "Ceiling of BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Cloud cover"
		},
		"Low altitude": {
			"layer legend B": "Low altitude"
		},
		"High altitude": {
			"layer legend B": "High altitude"
		},
		"Medium altitude": {
			"layer legend B": "Medium altitude"
		},
		"All altitudes": {
			"layer legend B": "All altitudes"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Vertical Motion"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitations"
		},
		"1 hour": {
			"layer legend B": "1 hour"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Mean Sea Level"
		},
		"Enter a name": {
			"new favorite prompt": "Enter a name"
		},
		"Enter the new name": {
			"new favorite prompt": "Enter the new name"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Overwrite favorite \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Delete favorite \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Soaring weather forecasts | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Help / Contact / About"
		},
		"Install now": {
			"version check": "Install now"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Soaring Weather Forecasts"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente requires an update."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding."
		},
		"Mobile app": "Mobile app",
		"No internet connexion": "No internet connexion",
		"Community": "Community",
		"Day selection": "Day selection",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Radiation",
		"Sun": "Sun",
		"Update": "Update",
		"Wind unit": "Wind unit",
		"An error has occured. Please try again.": {
			"popup": "An error has occured. Please try again."
		},
		"Click here to renew.": {
			"login popup": "Click here to renew."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Click on the link inside the email to change your password."
		},
		"Close": {
			"popup": "Close",
			"general": "Close"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Emails are not the same or invalid"
		},
		"Error! Bad login or password": {
			"login popup": "Error! Bad login or password"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Error! Your access has expired on %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "If you are a contributor, you will receive an email."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "One last step..."
		},
		"Passwords must be the same": {
			"password popup": "Passwords must be the same"
		},
		"Please log-in": {
			"login popup": "Please log-in"
		},
		"Private device − stay connected": {
			"login popup": "Private device − stay connected"
		},
		"Read more…": {
			"contribute popup": "Read more…"
		},
		"Reset your password": {
			"password popup": "Reset your password"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Welcome!"
		},
		"Same as device": {
			"timezone menu": "Same as device"
		},
		"Timezone": {
			"settings menu": "Timezone"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiplier"
		},
		"Points": {
			"xc planner": "Points"
		},
		"Duration": {
			"xc planner": "Duration"
		},
		"Speed": {
			"xc planner": "Speed"
		},
		"Close flight": {
			"xc planner": "Close flight"
		},
		"Share": {
			"xc planner": "Share"
		},
		"Download": {
			"xc planner": "Download",
			"general": "Download"
		},
		"Preferences": {
			"xc planner": "Preferences"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "About"
		},
		"Exit Fullscreen": {
			"toggle menu": "Exit Fullscreen"
		},
		"Fullscreen": {
			"toggle menu": "Fullscreen"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancel"
		},
		"Yes": {
			"general": "Yes"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Save"
		},
		"Continue": {
			"general": "Continue"
		},
		"Original version": {
			"xc planner": "Original version"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!"
		},
		"League": {
			"xc planner": "League"
		},
		"Distance units": {
			"xc planner": "Distance units"
		},
		"Altitude units": {
			"xc planner": "Altitude units"
		},
		"Coordinates format": {
			"xc planner": "Coordinates format"
		},
		"Turnpoint details": {
			"xc planner": "Turnpoint details"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Route name"
		},
		"Waypoint prefix": {
			"xc planner": "Waypoint prefix"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Paste link in email or IM"
		},
		"Static image": {
			"xc planner": "Static image"
		},
		"Open with XCTrack": {
			"xc planner": "Open with XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Share with LocToMe: set as default route"
		},
		"Go to": {
			"general": "Go to"
		},
		"Error! Please try again later": {
			"update modal": "Error! Please try again later"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Press Reset to reset your route permanently, press Cancel to keep you route."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Here is your access code. Please keep it safely."
		},
		"Password:": {
			"contribute popup": "Password:"
		},
		"Thank you!": {
			"contribute popup": "Thank you!"
		},
		"Username:": {
			"contribute popup": "Username:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 months Standard － %{currency} %{pricing} / month"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 months Student － %{currency} %{pricing} / month"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 months Supporter － %{currency} %{pricing} / month"
		},
		"Tour of Europe": {
			"tab": "Tour of Europe"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Get free entry to local weather trainings and users meetups."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Join Meteo-Parapente contributors club"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Meet me once a month to discuss new features and improvements."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente can exist thanks to you!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "My goal is to provide a quality tool accessible to every pilots."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Support the development of a quality tool accessible to every pilots."
		},
		"and to the": {
			"startup terms": "and to the"
		},
		"By using this application, you agree to the": {
			"startup terms": "By using this application, you agree to the"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "If the problem persists, contact support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente doesn't use tracking cookies"
		},
		"privacy policy": {
			"startup terms": "privacy policy"
		},
		"terms of use": {
			"startup": "terms of use"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Unable to reach Meteo-Parapente servers. Please check your connection."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 days a week are reserved to members"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Already a member? Click to reset your password"
		},
		"Become a member": {
			"contribute menu": "Become a member",
			"popup": "Become a member"
		},
		"Click here to learn the details": {
			"contest": "Click here to learn the details"
		},
		"I am already a member": {
			"popup": "I am already a member"
		},
		"Learn more": {
			"contest": "Learn more"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente celebrates its 10th anniversary."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Not a member yet? Click to get an access code"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "On this occasion, we are organizing an exceptional contest"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "To see %{ date }, please login or become a member."
		},
		"Win a paraglider!": {
			"contribute menu": "Win a paraglider!"
		}
	},
	"es": {
		"(Kitesurf)": {
			"search result": "Kite Surf"
		},
		"(Paragliding)": {
			"search result": "Parapente"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Añadir nuevo..."
		},
		"Airspace": {
			"toggle menu": "Espacio aéreo"
		},
		"All": {
			"map menu humidity": "todo"
		},
		"B. layer": {
			"map menu updrafts": "Capa lím."
		},
		"B. Layer": {
			"map menu wind": "Capa lím."
		},
		"Boundary layer": {
			"map menu wind": "Capa límite"
		},
		"Boundary Layer": {
			"map menu updrafts": "Capa límite",
			"layer legend A": "Capa límite",
			"layer legend B": "Capa límite"
		},
		"Ceiling": {
			"map menu updrafts": "Techo",
			"layer legend B": "Techo"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Techo de la capa lím."
		},
		"Change password": {
			"settings menu": "Cambiar contraseña"
		},
		"Clouds": {
			"map menu humidity": "Nubes"
		},
		"Color blind": {
			"settings menu": "Daltónico"
		},
		"debug": {
			"settings menu": "depurar"
		},
		"Delete": {
			"favorites menu": "Suprimir"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Funciones experimentales"
		},
		"Favorites": {
			"menu title": "Favoritos"
		},
		"Ground": {
			"map menu wind": "Suelo",
			"map menu temperature": "Suelo"
		},
		"Help us translate!": {
			"settings menu": "Ayúdanos a traducir!"
		},
		"High": {
			"map menu humidity": "Alto"
		},
		"Humidity": {
			"map menu humidity": "Humedad"
		},
		"Interpolation": {
			"toggle menu": "Interpolación"
		},
		"Language": {
			"settings menu": "Idioma"
		},
		"Login": {
			"login menu": "Iniciar sesión"
		},
		"Logout": {
			"settings menu": "Cerrar sesión"
		},
		"Low": {
			"map menu humidity": "Bajo"
		},
		"Medium": {
			"map menu humidity": "Medio"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "mover arriba"
		},
		"News": {
			"news menu": "Noticias"
		},
		"News!": {
			"news menu": "¡Noticias!"
		},
		"No data for this place": {
			"windgram view": "No hay datos para este lugar"
		},
		"Open": {
			"favorites menu": "Abrir"
		},
		"Pressure": {
			"map menu wind": "Presión",
			"layer legend A": "Presión"
		},
		"Rain": {
			"map menu humidity": "Lluvia"
		},
		"Rename": {
			"favorites menu": "Renombrar"
		},
		"Reset all settings": {
			"settings menu": "Restablecer ajustes"
		},
		"Sea level": {
			"map menu wind": "Nivel del mar"
		},
		"Set as homepage": {
			"favorites menu": "Establecer como página de inicio"
		},
		"Settings": {
			"settings menu": "Ajustes"
		},
		"Shearing": {
			"map menu updrafts": "Cizallamiento",
			"layer legend B": "Cizallamiento"
		},
		"Sounding": {
			"windgram tab": "Sondeo"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termicas",
			"layer legend A": "Termicas"
		},
		"Thickness": {
			"map menu updrafts": "Espesor",
			"layer legend B": "Espesor"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendencias"
		},
		"Velocity": {
			"map menu updrafts": "Velocidad",
			"layer legend B": "Velocidad"
		},
		"Vertical motion": {
			"map menu updrafts": "Movimiento vertical",
			"": "Movimiento vertical"
		},
		"Wind": {
			"map menu wind": "Viento",
			"layer legend A": "Viento"
		},
		"Wind Shear": {
			"map menu wind": "Cizalladura",
			"layer legend A": "Cizalladura"
		},
		"Windgram": {
			"windgram tab": "Diagrama de viento"
		},
		"m MSL": {
			"layer unit": "m MLS"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografía"
		},
		"Model": {
			"layer legend B": "Modelo"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Sin dimensiones"
		},
		"km/h": {
			"layer unit": "Km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superficie"
		},
		"Ceiling of BL": {
			"layer legend B": "Techo de C.L."
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Nubosidad"
		},
		"Low altitude": {
			"layer legend B": "baja"
		},
		"High altitude": {
			"layer legend B": "alta"
		},
		"Medium altitude": {
			"layer legend B": "media"
		},
		"All altitudes": {
			"layer legend B": "Total"
		},
		"°C": {
			"layer unit": "ºC"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Movimiento Vertical"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitaciones"
		},
		"1 hour": {
			"layer legend B": "1 hora"
		},
		"hPa": {
			"layer unit": "hpa"
		},
		"Mean Sea Level": {
			"layer legend B": "Nivel medio del mar"
		},
		"Enter a name": {
			"new favorite prompt": "Introduce nombre"
		},
		"Enter the new name": {
			"new favorite prompt": "Introduce nuevo nombre"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Sobrescribir favorito \"% {name}\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Eliminar favorito \"% {name}\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "¿Seguro que quieres restablecer todo?\n¡TODOS TUS AJUSTES Y FAVORITOS SE PERDERAN PARA SIEMPRE!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Pronóstico meteorológico para el vuelo | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ayuda / Contacto / A cerca de"
		},
		"Install now": {
			"version check": "Instala ahora"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "RASP Meteo-Parapente Europa"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Prediccion Meteorológica para Vuelo"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente necesita actualizarse."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "¡Meteo-Parapente ahora es móvil!\nPredicción Meteorológica especialmente diseñada para vuelo y parapente."
		},
		"Mobile app": "Aplicación móvil.",
		"No internet connexion": "Sin conexión a internet",
		"Community": "Comunidad",
		"Day selection": "Selección de días",
		"knots": "nudos",
		"mph": "mph",
		"Radiation": "Radiación",
		"Sun": "Sol",
		"Update": "Actualización",
		"Wind unit": "Unidad de viento",
		"An error has occured. Please try again.": {
			"popup": "Se ha producido un error. Por favor, inténtelo de nuevo."
		},
		"Click here to renew.": {
			"login popup": "Haga clic aquí para renovar."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Haga clic en el enlace del correo electrónico para cambiar su contraseña."
		},
		"Close": {
			"popup": "Cerrar",
			"general": "Cerrar"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Los correos electrónicos no son iguales o no son válidos"
		},
		"Error! Bad login or password": {
			"login popup": "¡Error! Nombre de usuario o contraseña incorrecta"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Error. Su acceso ha expirado en %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Si eres un colaborador, recibirás un correo electrónico."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Un último paso..."
		},
		"Passwords must be the same": {
			"password popup": "Las contraseñas deben ser las mismas"
		},
		"Please log-in": {
			"login popup": "Por favor, conéctese"
		},
		"Private device − stay connected": {
			"login popup": "Dispositivo privado: mantente conectado"
		},
		"Read more…": {
			"contribute popup": "Leer más..."
		},
		"Reset your password": {
			"password popup": "Restablecer la contraseña"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Algunos proveedores como Orange, GMX y Hotmail a veces bloquean nuestros correos electrónicos. Si no recibe nada, póngase en contacto con support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bienvenido."
		},
		"Same as device": {
			"timezone menu": "Igual que el dispositivo"
		},
		"Timezone": {
			"settings menu": "Zona horaria"
		},
		"XC Planner": {
			"toggle menu": "Planificador XC"
		},
		"Multiplier": {
			"xc planner": "Multiplicador"
		},
		"Points": {
			"xc planner": "Puntos"
		},
		"Duration": {
			"xc planner": "Duración"
		},
		"Speed": {
			"xc planner": "Velocidad"
		},
		"Close flight": {
			"xc planner": "Vuelo cercano"
		},
		"Share": {
			"xc planner": "Compartir"
		},
		"Download": {
			"xc planner": "Descargar",
			"general": "Descargar"
		},
		"Preferences": {
			"xc planner": "Preferencias"
		},
		"Reset": {
			"xc planner": "Reiniciar",
			"general": "Reiniciar"
		},
		"About": {
			"xc planner": "Acerca de"
		},
		"Exit Fullscreen": {
			"toggle menu": "Salir de la pantalla completa"
		},
		"Fullscreen": {
			"toggle menu": "Pantalla completa"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner es una función experimental.\nSólo está disponible desde un ordenador, en meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancelar"
		},
		"Yes": {
			"general": "Sí"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Guardar"
		},
		"Continue": {
			"general": "Continuar"
		},
		"Original version": {
			"xc planner": "Versión original"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Muy hackeado para trabajar en Meteo-Parapente, con autorización de Tom. Gracias."
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Unidades de distancia"
		},
		"Altitude units": {
			"xc planner": "Unidades de altitud"
		},
		"Coordinates format": {
			"xc planner": "Formato de las coordenadas"
		},
		"Turnpoint details": {
			"xc planner": "Detalles del punto de giro"
		},
		"Format": {
			"xc planner": "Formato"
		},
		"Route name": {
			"xc planner": "Nombre de la ruta"
		},
		"Waypoint prefix": {
			"xc planner": "Prefijo de la baliza"
		},
		"Lien": {
			"xc planner": "Enlace"
		},
		"Paste link in email or IM": {
			"xc planner": "Pegar el enlace en el correo electrónico o en la mensajería instantánea"
		},
		"Static image": {
			"xc planner": "Imagen estática"
		},
		"Open with XCTrack": {
			"xc planner": "Abrir con XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Compartir con LocToMe: establecer como ruta por defecto"
		},
		"Go to": {
			"general": "Ir a"
		},
		"Error! Please try again later": {
			"update modal": "¡Error! Por favor, inténtelo de nuevo más tarde"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Pulse Reiniciar para restablecer su ruta de forma permanente, pulse Cancelar para mantener su ruta."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Aquí tiene su código de acceso. Por favor, guárdelo de forma segura."
		},
		"Password:": {
			"contribute popup": "Contraseña:"
		},
		"Thank you!": {
			"contribute popup": "Gracias."
		},
		"Username:": {
			"contribute popup": "Nombre de usuario:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Estándar - %{currency} %{pricing} / mes"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Estudiante - %{currency} %{pricing} / mes"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Supporter - %{currency} %{pricing} / mes"
		},
		"Tour of Europe": {
			"tab": "Vuelta a Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Disfruta de las mejores previsiones cada día. ¡Meteo-Parapente puede existir gracias a ti!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Consigue una entrada gratuita a las formaciones meteorológicas locales y a los encuentros de usuarios."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Únase al club de colaboradores de Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Reúnete conmigo una vez al mes para hablar de las nuevas características y mejoras."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "¡Meteo-Parapente puede existir gracias a ti!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mi objetivo es ofrecer una herramienta de calidad accesible a todos los pilotos."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Apoyar el desarrollo de una herramienta de calidad accesible a todos los pilotos."
		},
		"and to the": {
			"startup terms": "y la"
		},
		"By using this application, you agree to the": {
			"startup terms": "Al utilizar esta aplicación, usted acepta las"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Si el problema persiste, póngase en contacto con support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente no utiliza cookies espía"
		},
		"privacy policy": {
			"startup terms": "política de privacidad"
		},
		"terms of use": {
			"startup": "condiciones generales de uso"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "No se puede acceder a los servidores de Meteo-Parapente. Por favor, compruebe su conexión."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 días a la semana están reservados a los socios"
		},
		"Already a member? Click to reset your password": {
			"login popup": "¿Ya es miembro? Haga clic para restablecer su contraseña"
		},
		"Become a member": {
			"contribute menu": "Hazte socio",
			"popup": "Hazte socio"
		},
		"Click here to learn the details": {
			"contest": "Haga clic aquí para conocer los detalles"
		},
		"I am already a member": {
			"popup": "Ya soy miembro"
		},
		"Learn more": {
			"contest": "Más información"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente celebra su décimo aniversario."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "¿Aún no es miembro? Haga clic para obtener un código de acceso"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "En esta ocasión, organizamos un concurso excepcional"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Se sorteará un ganador entre todos los que hayan adquirido o renovado una suscripción entre el pasado mes de septiembre y el próximo 30 de marzo."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Para ganar: ¡¡EL ALA DE PARAPENTE DE SU ELECCIÓN!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Para ver %{ date }, inicie sesión o hágase miembro."
		},
		"Win a paraglider!": {
			"contribute menu": "¡Gana un parapente!"
		}
	},
	"eu": {
		"(Kitesurf)": {
			"search result": "(Kitesurfa)"
		},
		"(Paragliding)": {
			"search result": "(Parapentea)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Gehitu berria"
		},
		"Airspace": {
			"toggle menu": "Aire eremua"
		},
		"All": {
			"map menu humidity": "Denak"
		},
		"B. layer": {
			"map menu updrafts": "O. Geruza"
		},
		"B. Layer": {
			"map menu wind": "O. Geruza"
		},
		"Boundary layer": {
			"map menu wind": "Geruzaren muga"
		},
		"Boundary Layer": {
			"map menu updrafts": "Geruzaren Muga",
			"layer legend A": "Geruza muga",
			"layer legend B": "Geruza limitea"
		},
		"Ceiling": {
			"map menu updrafts": "Sabaia",
			"layer legend B": "Sabaia"
		},
		"Ceiling of b. layer": {
			"map menu wind": "O. Geruzaren sabaia"
		},
		"Change password": {
			"settings menu": "Aldatu pasahitza"
		},
		"Clouds": {
			"map menu humidity": "Hodeiak"
		},
		"Color blind": {
			"settings menu": "Kolore ikusgaitza"
		},
		"debug": {
			"settings menu": "arazketa"
		},
		"Delete": {
			"favorites menu": "Ezabatu"
		},
		"experimental": {
			"settings menu": "esperimentala"
		},
		"Experimental features": {
			"settings menu": "Ezaugarri esperimentalak"
		},
		"Favorites": {
			"menu title": "Gogokoak"
		},
		"Ground": {
			"map menu wind": "Lurra",
			"map menu temperature": "Lurra"
		},
		"Help us translate!": {
			"settings menu": "Lagundu iezaguzu itzultzen!"
		},
		"High": {
			"map menu humidity": "Altua"
		},
		"Humidity": {
			"map menu humidity": "Hezetasuna"
		},
		"Interpolation": {
			"toggle menu": "Interpolatzea"
		},
		"Language": {
			"settings menu": "Hizkuntza"
		},
		"Login": {
			"login menu": "Sartu"
		},
		"Logout": {
			"settings menu": "Irten"
		},
		"Low": {
			"map menu humidity": "Bajua"
		},
		"Medium": {
			"map menu humidity": "Erdia"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Mugitu gora"
		},
		"News": {
			"news menu": "Berriak"
		},
		"News!": {
			"news menu": "Berriak!"
		},
		"No data for this place": {
			"windgram view": "Ez dago daturik toki honentzat"
		},
		"Open": {
			"favorites menu": "Ireki"
		},
		"Pressure": {
			"map menu wind": "Presioa",
			"layer legend A": "Presioa"
		},
		"Rain": {
			"map menu humidity": "Euria"
		},
		"Rename": {
			"favorites menu": "Berrizendatu"
		},
		"Reset all settings": {
			"settings menu": "Berregin parametro guztiak"
		},
		"Sea level": {
			"map menu wind": "Itsas maila"
		},
		"Set as homepage": {
			"favorites menu": "Hasierako orri egin"
		},
		"Settings": {
			"settings menu": "Ezarpenak"
		},
		"Shearing": {
			"map menu updrafts": "Zizailadura",
			"layer legend B": "zizaila"
		},
		"Sounding": {
			"windgram tab": "Zundaketa"
		},
		"Temperature": {
			"map menu temperature": "Tenperatura",
			"layer legend A": "Tenperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termikak",
			"layer legend A": "Termikak"
		},
		"Thickness": {
			"map menu updrafts": "Lodiera",
			"layer legend B": "Lodiera"
		},
		"Updrafts": {
			"map menu updrafts": "Goranzkoak"
		},
		"Velocity": {
			"map menu updrafts": "Abiadura",
			"layer legend B": "Abiadura"
		},
		"Vertical motion": {
			"map menu updrafts": "Mugimendu bertikala",
			"": "Mugimendu bertikala"
		},
		"Wind": {
			"map menu wind": "Haizea",
			"layer legend A": "Haizea"
		},
		"Wind Shear": {
			"map menu wind": "Haizearen zizailadura",
			"layer legend A": "Haizearen zizailadura"
		},
		"Windgram": {
			"windgram tab": "Gradientea"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Modeloa"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimentsiogabe"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Gainazala"
		},
		"Ceiling of BL": {
			"layer legend B": "BL-ren zizailadura"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Hodei estalkia"
		},
		"Low altitude": {
			"layer legend B": "Altuera baxua"
		},
		"High altitude": {
			"layer legend B": "Altuera gorena"
		},
		"Medium altitude": {
			"layer legend B": "Erdi maila"
		},
		"All altitudes": {
			"layer legend B": "Altuera guztiak"
		},
		"°C": {
			"layer unit": "ºC"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Mugimendu bertikala"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Prezipitazioak"
		},
		"1 hour": {
			"layer legend B": "Ordu 1"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Itsas maila"
		},
		"Enter a name": {
			"new favorite prompt": "Sartu izena"
		},
		"Enter the new name": {
			"new favorite prompt": "Izen berria sartu"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Berridatzi gogokoena \"%{ izena }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Ezabatu gogokoena \"%{ izena }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Ziur zaude dena berrabiarazi nahi duzula?\nMODIFIKAZIO ETA GOGOKO GUZTIAK BETIKO EZABATUKO DIRA!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Soaring Weather Forecasts - Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Laguntza / Kontaktua / Gutaz"
		},
		"Install now": {
			"version check": "Instalatu orain"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente RASP Europa"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Soaring Weather Forecasts"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapentek eguneratzea eskatzen du"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente orain mugikor bertsioan!\nEspreski zuzendua aire kirol eta parapenterako."
		},
		"Mobile app": "Mugikorrentzat app-a",
		"No internet connexion": "Internet konexiorik ez",
		"Community": "Komunitatea",
		"Day selection": "Eguna aukeratu",
		"knots": "korapiloak",
		"mph": "mph",
		"Radiation": "Irradiazioa",
		"Sun": "Eguzkia",
		"Update": "Eguneratu",
		"Wind unit": "Haize unitatea",
		"An error has occured. Please try again.": {
			"popup": "Errorea gertatu da. Arren, saiatu berriro."
		},
		"Click here to renew.": {
			"login popup": "Hemen klikatu berritzeko."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Email barneko loturan egizu klik pasahitza aldatzeko."
		},
		"Close": {
			"popup": "Itxi",
			"general": "Itxi"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Email baliogabea edo ez dira berdinak"
		},
		"Error! Bad login or password": {
			"login popup": "Errorea! erabiltzaile edo pasahitz okerrak"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Errorea! Zure sarbidea %{ expirationDate }n iraungi da."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Kolaboratzailea bazara, email bat jasoko duzu."
		},
		"OK": {
			"popup": "Ok",
			"general": "Ok"
		},
		"One last step...": {
			"password popup": "Azken pausua..."
		},
		"Passwords must be the same": {
			"password popup": "Pasahitzak berdina izan behar du"
		},
		"Please log-in": {
			"login popup": "Mesedez, hasi saioa"
		},
		"Private device − stay connected": {
			"login popup": "Gailu pribatua - konektatuta mantendu"
		},
		"Read more…": {
			"contribute popup": "Gehiago irakurri..."
		},
		"Reset your password": {
			"password popup": "Berrezarri pasahitza"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Zenbait hornitzailek, hala nola Orangek, GMXek eta Hotmail-ek, blokeatu egiten dituzte batzuetan gure mezu elektronikoak. Ezer jasotzen ez baduzu, jarri harremanetan support@the&#x2011;parapente.com-ekin"
		},
		"Welcome!": {
			"login popup": "Ongi etorri!"
		},
		"Same as device": {
			"timezone menu": "Gailuko bera"
		},
		"Timezone": {
			"settings menu": "Ordu zona"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Biderkatzailea"
		},
		"Points": {
			"xc planner": "Puntuak"
		},
		"Duration": {
			"xc planner": "Iraupena"
		},
		"Speed": {
			"xc planner": "Abiadura"
		},
		"Close flight": {
			"xc planner": "Hegaldia itxi"
		},
		"Share": {
			"xc planner": "Partekatu"
		},
		"Download": {
			"xc planner": "Jaitsi",
			"general": "Jaitsi"
		},
		"Preferences": {
			"xc planner": "Hobespenak"
		},
		"Reset": {
			"xc planner": "Berrezarri",
			"general": "Berrezarri"
		},
		"About": {
			"xc planner": "Honi buruz"
		},
		"Exit Fullscreen": {
			"toggle menu": "Pantaila osotik atera"
		},
		"Fullscreen": {
			"toggle menu": "Pantaila osoa"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner ezaugarri esperimentala da.\nOrdenagailu batetik bakarrik erabil daiteke, meteo-parapente.com-en"
		},
		"Cancel": {
			"general": "Ezeztatu"
		},
		"Yes": {
			"general": "Bai"
		},
		"No": {
			"general": "Ez"
		},
		"Save": {
			"general": "Gorde"
		},
		"Continue": {
			"general": "Jarraitu"
		},
		"Original version": {
			"xc planner": "Bertsio originala"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Meteo-parapentean lan egiteko hackeatze gogorra, Tom-en baimenarekin. Eskerrik asko!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Distantzia unitateak"
		},
		"Altitude units": {
			"xc planner": "Altuera-unitateak"
		},
		"Coordinates format": {
			"xc planner": "Koordenatuen formatua"
		},
		"Turnpoint details": {
			"xc planner": "Turnpoint-en xehetasunak"
		},
		"Format": {
			"xc planner": "Formatua"
		},
		"Route name": {
			"xc planner": "Ibilbidearen izena"
		},
		"Waypoint prefix": {
			"xc planner": "Waypoint aurrezenbakia"
		},
		"Lien": {
			"xc planner": "Lotura"
		},
		"Paste link in email or IM": {
			"xc planner": "Lotura emailean edota IMen itsatsi"
		},
		"Static image": {
			"xc planner": "Irudi estatikoa"
		},
		"Open with XCTrack": {
			"xc planner": "XCTrack-ekin ireki"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "LocToMe-rekin partekatu: ibilbide lehenetsi modura ezarri"
		},
		"Go to": {
			"general": "Hona joan"
		},
		"Error! Please try again later": {
			"update modal": "Errorea! Mesedez, berriro saitu beranduago."
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Sakatu Berrezarri zure ibilbidea modu iraunkorrean berrezartzeko, eta sakatu Baztertu ibilbidea mantentzeko."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Hemen da zure sarbide kodea. Mesedez, ongi gorde."
		},
		"Password:": {
			"contribute popup": "Pasahitza:"
		},
		"Thank you!": {
			"contribute popup": "Eskerrik asko!"
		},
		"Username:": {
			"contribute popup": "Erabiltzailea:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 hilabete Arrunta－ %{currency} %{pricing} / hileko"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 hilabete Ikaslea－ %{currency} %{pricing} / hileko"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 hilabete Laguntzailea－ %{currency} %{pricing} / hileko"
		},
		"Tour of Europe": {
			"tab": "Europako bira"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Gozatu iragarpen onenez egunero. Meteo-Parapentea zuri esker izan daiteke!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Tokiko entrenamendu meteorologikoetarako eta erabiltzaileen bileretarako sarrera doan lortu."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Meteo-Parapente kolaboratzaile klubarekin bat egin"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Hilean behin elkartu ezaugarri eta hobekuntza berriak eztabaidatzeko."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente zuri esker existitu daiteke!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Nire helburua  pilotu guztien eskura dagoen kalitatezko tresna bat eskaintzea da."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Pilotu guztientzat irisgarria den kalitateko tresna bat garatzen lagundu."
		},
		"and to the": {
			"startup terms": "eta"
		},
		"By using this application, you agree to the": {
			"startup terms": "Aplikazio hau erabiltzean, onartu egiten duzu"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Arazoak jarraituko balu, jarri harremanetan support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapentek ez ditu erregistro-cookieak erabiltzen"
		},
		"privacy policy": {
			"startup terms": "pribatutasun-politika"
		},
		"terms of use": {
			"startup": "erabilera baldintzak"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Ezin da Meteo-parapente zerbitzarietara iritsi. Mesedez, egiaztatu zure konexioa."
		},
		"2 days a week are reserved to members": {
			"private popup": "Astean 2 egun bazkideentzat gordeta daude"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Dagoeneko kide zara? Egin klik pasahitza berrezartzeko"
		},
		"Become a member": {
			"contribute menu": "Egin zaitez kide",
			"popup": "Egin zaitez kide"
		},
		"Click here to learn the details": {
			"contest": "Egin klik hemen xehetasunak ezagutzeko"
		},
		"I am already a member": {
			"popup": "Dagoeneko kide naiz"
		},
		"Learn more": {
			"contest": "Gehiago ikasi"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapentek bere 10. urteurrena ospatzen du."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Oraindik ez zara kide? Egin klik sarbide-kode bat lortzeko"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Oraingo honetan, aparteko lehiaketa bat antolatzen ari gara"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Irabazle bat zozketatuko da joan den irailetik datorren martxoaren 30era bitartean harpidetza erosi edo berritu zuten guztien artean."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Irabazi beharrekoa: ZUEK AUKERATUTAKO PARAPENTEA!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "%{ date } ikusteko, mesedez hasi saioa edo egin zaitez kide."
		},
		"Win a paraglider!": {
			"contribute menu": "Irabazi parapente bat!"
		}
	},
	"fr": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Parapente)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Nouveau…"
		},
		"Airspace": {
			"toggle menu": "Espaces aériens"
		},
		"All": {
			"map menu humidity": "Toutes alti"
		},
		"B. layer": {
			"map menu updrafts": "Couche Lim."
		},
		"B. Layer": {
			"map menu wind": "Couche Lim."
		},
		"Boundary layer": {
			"map menu wind": "Couche Limite"
		},
		"Boundary Layer": {
			"map menu updrafts": "Couche Limite",
			"layer legend A": "Couche Limite",
			"layer legend B": "Couche Limite"
		},
		"Ceiling": {
			"map menu updrafts": "Plafond",
			"layer legend B": "Plafond"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Plaf Couche Lim."
		},
		"Change password": {
			"settings menu": "Mot de passe"
		},
		"Clouds": {
			"map menu humidity": "Nuages"
		},
		"Color blind": {
			"settings menu": "Daltonien"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Supprimer"
		},
		"experimental": {
			"settings menu": "expérimental"
		},
		"Experimental features": {
			"settings menu": "Fonctions expérimentales"
		},
		"Favorites": {
			"menu title": "Favoris"
		},
		"Ground": {
			"map menu wind": "Sol",
			"map menu temperature": "2m Sol"
		},
		"Help us translate!": {
			"settings menu": "Aidez-nous à traduire !"
		},
		"High": {
			"map menu humidity": "Haute alti"
		},
		"Humidity": {
			"map menu humidity": "Humidité"
		},
		"Interpolation": {
			"toggle menu": "Interpolation"
		},
		"Language": {
			"settings menu": "Langue"
		},
		"Login": {
			"login menu": "Connexion"
		},
		"Logout": {
			"settings menu": "Déconnexion"
		},
		"Low": {
			"map menu humidity": "Basse alti"
		},
		"Medium": {
			"map menu humidity": "Moyenne alti"
		},
		"Meteo Parapente": {
			"menu title": "Météo Parapente"
		},
		"Move to top": {
			"favorites menu": "Placer en haut"
		},
		"News": {
			"news menu": "Actualités"
		},
		"News!": {
			"news menu": "Actualités !"
		},
		"No data for this place": {
			"windgram view": "Pas de données pour ce lieu"
		},
		"Open": {
			"favorites menu": "Ouvrir"
		},
		"Pressure": {
			"map menu wind": "Pression",
			"layer legend A": "Pression"
		},
		"Rain": {
			"map menu humidity": "Pluie"
		},
		"Rename": {
			"favorites menu": "Renommer"
		},
		"Reset all settings": {
			"settings menu": "Tout réinitialiser"
		},
		"Sea level": {
			"map menu wind": "Niveau Mer"
		},
		"Set as homepage": {
			"favorites menu": "En page d'accueil"
		},
		"Settings": {
			"settings menu": "Réglages"
		},
		"Shearing": {
			"map menu updrafts": "Cisaillement",
			"layer legend B": "Cisaillement"
		},
		"Sounding": {
			"windgram tab": "Émagramme"
		},
		"Temperature": {
			"map menu temperature": "Température",
			"layer legend A": "Température"
		},
		"Thermals": {
			"map menu updrafts": "Thermiques",
			"layer legend A": "Thermiques"
		},
		"Thickness": {
			"map menu updrafts": "Épaisseur",
			"layer legend B": "Épaisseur"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendances"
		},
		"Velocity": {
			"map menu updrafts": "Vitesse",
			"layer legend B": "Vitesse"
		},
		"Vertical motion": {
			"map menu updrafts": "Mouv. Verticaux",
			"": "Mouvements Verticaux"
		},
		"Wind": {
			"map menu wind": "Vent",
			"layer legend A": "Vent"
		},
		"Wind Shear": {
			"map menu wind": "Cisaillement",
			"layer legend A": "Cisaillement"
		},
		"Windgram": {
			"windgram tab": "Vent / Alti"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topographie"
		},
		"Model": {
			"layer legend B": "Modèle"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "sans dimension"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Sol"
		},
		"Ceiling of BL": {
			"layer legend B": "Plaf. C. Lim."
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Nuages"
		},
		"Low altitude": {
			"layer legend B": "Basse alti"
		},
		"High altitude": {
			"layer legend B": "Haute alti"
		},
		"Medium altitude": {
			"layer legend B": "Moyenne alti"
		},
		"All altitudes": {
			"layer legend B": "Toutes altis"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Mouv. Verticaux"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Précipitations"
		},
		"1 hour": {
			"layer legend B": "1 heure"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Niveau de la mer"
		},
		"Enter a name": {
			"new favorite prompt": "Entrez un nom"
		},
		"Enter the new name": {
			"new favorite prompt": "Entrez le nouveau nom"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Écraser le favori \"%{ name }\" ?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Supprimer le favori \"%{ name }\" ?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Voulez-vous vraiment remettre à zéro ?\nVOS RÉGLAGES ET VOS FAVORIS SERONT SUPPRIMÉS POUR TOUJOURS !"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Météo pour le Vol Libre et le Vol à Voile | Météo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Aide / Contact / Infos"
		},
		"Install now": {
			"version check": "Installer"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Météo-Parapente RASP Europe"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Météo pour le Vol Libre et le Vol à Voile"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Météo-Parapente a besoin d'être mis à jour"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Météo-Parapente devient mobile !\nDes prévisions conçues spécialement pour les activités aériennes et le parapente"
		},
		"Mobile app": "Application mobile",
		"No internet connexion": "Internet déconnecté",
		"Community": "Communauté",
		"Day selection": "Choix du jour",
		"knots": "Nœuds",
		"mph": "mph",
		"Radiation": "Radiation",
		"Sun": "Ensoleillement",
		"Update": "Mise à jour",
		"Wind unit": "Unité du vent",
		"An error has occured. Please try again.": {
			"popup": "Une erreur s'est produite. Réessayez."
		},
		"Click here to renew.": {
			"login popup": "Renouveler."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Pour changer votre mot de passe, cliquez sur le lien contenu dans l'email."
		},
		"Close": {
			"popup": "Fermer",
			"general": "Fermer"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Les adresses sont différentes ou invalides."
		},
		"Error! Bad login or password": {
			"login popup": "Adresse inconnue ou mauvais mot de passe"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Erreur ! Votre accès a expiré le %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Si votre adresse est connue, vous recevrez un email."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Dernière étape…"
		},
		"Passwords must be the same": {
			"password popup": "Les mots de passe doivent être identiques."
		},
		"Please log-in": {
			"login popup": "Connexion"
		},
		"Private device − stay connected": {
			"login popup": "Appareil privé - rester connecté"
		},
		"Read more…": {
			"contribute popup": "Plus d'infos…"
		},
		"Reset your password": {
			"password popup": "Nouveau mot de passe"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Certains fournisseurs tels que Orange, GMX ou Hotmail bloquent parfois nos emails automatiques. Si vous ne recevez rien, contactez support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bienvenue !"
		},
		"Same as device": {
			"timezone menu": "Comme mon appareil"
		},
		"Timezone": {
			"settings menu": "Fuseau horaire"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiple"
		},
		"Points": {
			"xc planner": "Points"
		},
		"Duration": {
			"xc planner": "Durée"
		},
		"Speed": {
			"xc planner": "Vitesse"
		},
		"Close flight": {
			"xc planner": "Boucler"
		},
		"Share": {
			"xc planner": "Partager"
		},
		"Download": {
			"xc planner": "Télécharger",
			"general": "Télécharger"
		},
		"Preferences": {
			"xc planner": "Réglages"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "À propos"
		},
		"Exit Fullscreen": {
			"toggle menu": "Réduire"
		},
		"Fullscreen": {
			"toggle menu": "Plein écran"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "La fonction XC Planner est expérimentale. Elle fonctionne uniquement avec un ordinateur, sur le site meteo-parapente.com"
		},
		"Cancel": {
			"general": "Annuler"
		},
		"Yes": {
			"general": "Oui"
		},
		"No": {
			"general": "Non"
		},
		"Save": {
			"general": "Enregistrer"
		},
		"Continue": {
			"general": "Continuer"
		},
		"Original version": {
			"xc planner": "Version originale"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Ici bien trafiquée pour pouvoir marcher dans Météo-Parapente, avec l'autorisation de Tom. Merci !"
		},
		"League": {
			"xc planner": "Ligue"
		},
		"Distance units": {
			"xc planner": "Unité de distance"
		},
		"Altitude units": {
			"xc planner": "Unité d'altitude"
		},
		"Coordinates format": {
			"xc planner": "Format des coordonnées"
		},
		"Turnpoint details": {
			"xc planner": "Balises"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nom de la trace"
		},
		"Waypoint prefix": {
			"xc planner": "Préfixe balise"
		},
		"Lien": {
			"xc planner": "Lien"
		},
		"Paste link in email or IM": {
			"xc planner": "Lien partageable"
		},
		"Static image": {
			"xc planner": "Image statique"
		},
		"Open with XCTrack": {
			"xc planner": "Ouvrir dans XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Définir route dans LocToMe"
		},
		"Go to": {
			"general": "Aller à"
		},
		"Error! Please try again later": {
			"update modal": "Erreur ! Ressayez plus tard."
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Cliquez Reset pour effacer définitivement le parcours, ou Annuler pour la garder."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Voici votre code d'accès. Gardez-le précieusement !"
		},
		"Password:": {
			"contribute popup": "Mot de passe:"
		},
		"Thank you!": {
			"contribute popup": "Merci !"
		},
		"Username:": {
			"contribute popup": "Identifiant :"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mois Standard － %{pricing}%{currency} / mois"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mois Étudiant － %{pricing}%{currency} / mois"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mois Soutien － %{pricing}%{currency} / mois"
		},
		"Tour of Europe": {
			"tab": "Tour d'Europe"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Profitez des meilleures prévisions chaque jour. Météo-Parapente existe grâce à vous."
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Participez gratuitement aux formations météo organisées dans les clubs"
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Rejoignez le club des contributeurs Météo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Rencontrez moi une fois par mois pour échanger nos idées et améliorer le site"
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Météo-Parapente existe grâce à vous !"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Je veux fournir un outil de qualité accessible à tous les pilotes."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Soutenez le développement d'un outil de qualité, accessible à tous les pilotes."
		},
		"and to the": {
			"startup terms": "et la"
		},
		"By using this application, you agree to the": {
			"startup terms": "En utilisant cette application, vous acceptez les"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Si le problème persiste, contactez support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente n'utilise pas de cookies espions"
		},
		"privacy policy": {
			"startup terms": "politique de confidentialité"
		},
		"terms of use": {
			"startup": "conditions générales d'utilisation"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Impossible de joindre les serveurs de Meteo-Parapente. Vérifiez votre connexion."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 jours par semaine sont réservés aux membres"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Vous êtes déjà membre ? Cliquez pour réinitialiser votre mot de passe"
		},
		"Become a member": {
			"contribute menu": "Devenir membre",
			"popup": "Devenir membre"
		},
		"Click here to learn the details": {
			"contest": "Cliquez ici pour en savoir plus"
		},
		"I am already a member": {
			"popup": "Je suis déjà membre"
		},
		"Learn more": {
			"contest": "En savoir plus"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente fête son 10e anniversaire."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Vous n'êtes pas encore membre ? Cliquez pour obtenir un code d'accès"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "À cette occasion, nous organisons un concours exceptionnel"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Un gagnant sera tiré au sort parmi tous ceux qui ont acheté ou renouvelé un abonnement entre septembre dernier et le 30 mars prochain."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "A gagner : L'AILE DE PARAPENTE DE VOTRE CHOIX ! !!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Pour voir %{ date }, veuillez vous connecter ou devenir membre."
		},
		"Win a paraglider!": {
			"contribute menu": "Gagnez un parapente !"
		}
	},
	"hu": {
		"(Kitesurf)": {
			"search result": "Kiteszörf"
		},
		"(Paragliding)": {
			"search result": "Siklóernyő"
		},
		"1h": {
			"map menu humidity": "1ó"
		},
		"Add new…": {
			"favorites menu": "Új hozzáadása..."
		},
		"Airspace": {
			"toggle menu": "Légtér"
		},
		"All": {
			"map menu humidity": "Összes"
		},
		"B. layer": {
			"map menu updrafts": "H. réteg"
		},
		"B. Layer": {
			"map menu wind": "H. réteg"
		},
		"Boundary layer": {
			"map menu wind": "Határ réteg"
		},
		"Boundary Layer": {
			"map menu updrafts": "Határ réteg",
			"layer legend A": "Határréteg",
			"layer legend B": "Határréteg"
		},
		"Ceiling": {
			"map menu updrafts": "Plafon",
			"layer legend B": "Plafon"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Határréteg teteje"
		},
		"Change password": {
			"settings menu": "Jelszóváltoztatás"
		},
		"Clouds": {
			"map menu humidity": "Felhők"
		},
		"Color blind": {
			"settings menu": "Színvak"
		},
		"debug": {
			"settings menu": "Hibajavítás"
		},
		"Delete": {
			"favorites menu": "Töröl"
		},
		"experimental": {
			"settings menu": "kísérleti"
		},
		"Experimental features": {
			"settings menu": "Kisérleti lehetőségek"
		},
		"Favorites": {
			"menu title": "Kedvencek"
		},
		"Ground": {
			"map menu wind": "Talaj",
			"map menu temperature": "Talaj"
		},
		"Help us translate!": {
			"settings menu": "Segíts a fordításban!"
		},
		"High": {
			"map menu humidity": "Magassági"
		},
		"Humidity": {
			"map menu humidity": "Páratartalom"
		},
		"Interpolation": {
			"toggle menu": "Interpoláció"
		},
		"Language": {
			"settings menu": "Nyelv"
		},
		"Login": {
			"login menu": "Bejelentkezés"
		},
		"Logout": {
			"settings menu": "Kijelentkezés"
		},
		"Low": {
			"map menu humidity": "Alacsony"
		},
		"Medium": {
			"map menu humidity": "Középszintű"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Ugorj a tetejére"
		},
		"News": {
			"news menu": "Hírek"
		},
		"News!": {
			"news menu": "Hírek!"
		},
		"No data for this place": {
			"windgram view": "Nincs adat ehhez a helyhez"
		},
		"Open": {
			"favorites menu": "Megnyit"
		},
		"Pressure": {
			"map menu wind": "Nyomás",
			"layer legend A": "Nyomás"
		},
		"Rain": {
			"map menu humidity": "Eső"
		},
		"Rename": {
			"favorites menu": "Átnevez"
		},
		"Reset all settings": {
			"settings menu": "Beállítások törlése"
		},
		"Sea level": {
			"map menu wind": "Tengerszint"
		},
		"Set as homepage": {
			"favorites menu": "Beállítás kezdőlapnak"
		},
		"Settings": {
			"settings menu": "Beállítások"
		},
		"Shearing": {
			"map menu updrafts": "Nyírás",
			"layer legend B": "Nyírás"
		},
		"Sounding": {
			"windgram tab": "Ballonos mérések"
		},
		"Temperature": {
			"map menu temperature": "Hőmérséklet",
			"layer legend A": "Hőmérséklet"
		},
		"Thermals": {
			"map menu updrafts": "Termikek",
			"layer legend A": "Termikek"
		},
		"Thickness": {
			"map menu updrafts": "Vastagság",
			"layer legend B": "Vastagság"
		},
		"Updrafts": {
			"map menu updrafts": "Feláramlás"
		},
		"Velocity": {
			"map menu updrafts": "Erősség",
			"layer legend B": "Erőssége"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertikális mozgás",
			"": "Függőleges mozgás"
		},
		"Wind": {
			"map menu wind": "Szél",
			"layer legend A": "Szél"
		},
		"Wind Shear": {
			"map menu wind": "Szélnyírás",
			"layer legend A": "Szélnyírás"
		},
		"Windgram": {
			"windgram tab": "Szél diagram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topográfia"
		},
		"Model": {
			"layer legend B": "Modell"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimenziómentes"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Felszín"
		},
		"Ceiling of BL": {
			"layer legend B": "Határréteg teteje"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Felhőtakaró"
		},
		"Low altitude": {
			"layer legend B": "Alacsony szintű"
		},
		"High altitude": {
			"layer legend B": "Magas szintű"
		},
		"Medium altitude": {
			"layer legend B": "Középmagas szintű"
		},
		"All altitudes": {
			"layer legend B": "Összes magasság"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikális Mozgás"
		},
		"mm/h": {
			"layer unit": "mm/ó"
		},
		"Precipitations": {
			"layer legend A": "Csapadék"
		},
		"1 hour": {
			"layer legend B": "1 óra"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Közepes tengerszint"
		},
		"Enter a name": {
			"new favorite prompt": "Írjon be nevet"
		},
		"Enter the new name": {
			"new favorite prompt": "Írjon be egy új nevet"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Kedvenc felülírásra:"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Kedvenc törlése:"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Biztosan törölni szeretne mindent?\nMINDEN BEÁLLÍTÁSOD ÉS KEDVENCED ÖRÖKRE ELVESZIK!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Siklóernyős időjárás előrejelzés | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Segítség / Kontakt / Rólunk"
		},
		"Install now": {
			"version check": "Azonnali telepítés"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Európa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Siklóernyős Időjárás Előrejelzés"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapentének frissítésre van szüksége."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente már mobilon is!\nRepülésmeteorológiai időjárás előrejelzés speciálisan repüléshez és siklóernyőzéshez."
		},
		"Mobile app": "Mobil applikáció",
		"No internet connexion": "Nincs internet kapcsolat",
		"Community": "Közösség",
		"Day selection": "Nap kiválasztása",
		"knots": "csomók",
		"mph": "mph",
		"Radiation": "Sugárzás",
		"Sun": "Sun",
		"Update": "Frissítés",
		"Wind unit": "Szél egység",
		"An error has occured. Please try again.": {
			"popup": "Hiba történt. Kérjük, próbálja meg újra."
		},
		"Click here to renew.": {
			"login popup": "Kattintson ide a megújításhoz."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kattintson az e-mailben található linkre a jelszó megváltoztatásához."
		},
		"Close": {
			"popup": "Zárja be a",
			"general": "Zárja be a"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Az e-mailek nem azonosak vagy érvénytelenek"
		},
		"Error! Bad login or password": {
			"login popup": "Hiba! Rossz bejelentkezés vagy jelszó"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Hiba! Az Ön hozzáférése %{ expirationDate } lejárt."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Ha Ön hozzájárul, kapni fog egy e-mailt."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Egy utolsó lépés..."
		},
		"Passwords must be the same": {
			"password popup": "A jelszavaknak azonosnak kell lenniük"
		},
		"Please log-in": {
			"login popup": "Kérjük, jelentkezzen be"
		},
		"Private device − stay connected": {
			"login popup": "Privát eszköz - maradjon kapcsolatban"
		},
		"Read more…": {
			"contribute popup": "Bővebben..."
		},
		"Reset your password": {
			"password popup": "Jelszó visszaállítása"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Egyes szolgáltatók, például az Orange, a GMX és a Hotmail néha blokkolják az e-mailjeinket. Ha nem kap semmit, kérjük, lépjen kapcsolatba a support@meteo&#x2011;parapente.com címen."
		},
		"Welcome!": {
			"login popup": "Üdvözöljük!"
		},
		"Same as device": {
			"timezone menu": "Ugyanaz, mint a készülék"
		},
		"Timezone": {
			"settings menu": "Időzóna"
		},
		"XC Planner": {
			"toggle menu": "XC tervező"
		},
		"Multiplier": {
			"xc planner": "Multiplikátor"
		},
		"Points": {
			"xc planner": "Pontok"
		},
		"Duration": {
			"xc planner": "Időtartam"
		},
		"Speed": {
			"xc planner": "Sebesség"
		},
		"Close flight": {
			"xc planner": "Közeli repülés"
		},
		"Share": {
			"xc planner": "Megosztás"
		},
		"Download": {
			"xc planner": "Letöltés",
			"general": "Letöltés"
		},
		"Preferences": {
			"xc planner": "Preferenciák"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "A  oldalról"
		},
		"Exit Fullscreen": {
			"toggle menu": "Teljes képernyőből kilépés"
		},
		"Fullscreen": {
			"toggle menu": "Teljes képernyő"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Az XC Planner egy kísérleti funkció.\nCsak számítógépről érhető el a meteo-parapente.com oldalon."
		},
		"Cancel": {
			"general": "Törölje"
		},
		"Yes": {
			"general": "Igen"
		},
		"No": {
			"general": "Nem"
		},
		"Save": {
			"general": "Mentés"
		},
		"Continue": {
			"general": "Folytatás"
		},
		"Original version": {
			"xc planner": "Eredeti változat"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Erősen feltört, hogy a Meteo-Parapente-ben működjön, Tom engedélyével. Köszönöm!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Távolsági egységek"
		},
		"Altitude units": {
			"xc planner": "Magassági egységek"
		},
		"Coordinates format": {
			"xc planner": "Koordináták formátuma"
		},
		"Turnpoint details": {
			"xc planner": "Fordulópont részletek"
		},
		"Format": {
			"xc planner": "Formátum"
		},
		"Route name": {
			"xc planner": "Útvonal neve"
		},
		"Waypoint prefix": {
			"xc planner": "Útpont előtag"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Link beillesztése e-mailben vagy IM-ben"
		},
		"Static image": {
			"xc planner": "Statikus kép"
		},
		"Open with XCTrack": {
			"xc planner": "Megnyitás XCTrack segítségével"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Megosztás a LocToMe-vel: alapértelmezett útvonalként beállítva"
		},
		"Go to": {
			"general": "Menjen a"
		},
		"Error! Please try again later": {
			"update modal": "Hiba! Kérjük, próbálja meg később újra"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Nyomja meg a Reset gombot az útvonal végleges visszaállításához, nyomja meg a Cancel gombot az útvonal megtartásához."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Itt van a belépési kódja. Kérjük, tartsa biztonságban."
		},
		"Password:": {
			"contribute popup": "Jelszó:"
		},
		"Thank you!": {
			"contribute popup": "Köszönöm!"
		},
		"Username:": {
			"contribute popup": "Felhasználónév:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 hónap Standard - %{currency} %{pricing} / hónap"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 hónap Diák - %{currency} %{pricing} / hónap"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 hónap Támogató - %{currency} %{pricing} / hónap"
		},
		"Tour of Europe": {
			"tab": "Európai körút"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Élvezze a legjobb előrejelzéseket minden nap. A Meteo-Parapente Önnek köszönhetően létezhet!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Ingyenes belépés a helyi időjárási képzésekre és felhasználói találkozókra."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Csatlakozzon a Meteo-Parapente közreműködők klubjához"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Havonta egyszer találkozzunk, hogy megbeszéljük az új funkciókat és fejlesztéseket."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "A Meteo-Parapente önöknek köszönhetően létezhet!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Célom, hogy minden pilóta számára elérhető, minőségi eszközt biztosítsak."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Támogassa egy minden pilóta számára elérhető minőségi eszköz kifejlesztését."
		},
		"and to the": {
			"startup terms": "és a"
		},
		"By using this application, you agree to the": {
			"startup terms": "Az alkalmazás használatával Ön elfogadja a"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Ha a probléma továbbra is fennáll, forduljon a support@meteo-parapente.com címre."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "A Meteo-Parapente nem használ nyomkövető cookie-kat."
		},
		"privacy policy": {
			"startup terms": "adatvédelmi politika"
		},
		"terms of use": {
			"startup": "használati feltételek"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nem lehet elérni a Meteo-Parapente szervereit. Kérjük, ellenőrizze a kapcsolatát."
		},
		"2 days a week are reserved to members": {
			"private popup": "Heti 2 nap a tagok számára van fenntartva"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Már tag vagy? Kattintson a jelszó visszaállításához"
		},
		"Become a member": {
			"contribute menu": "Legyen tag",
			"popup": "Legyen tag"
		},
		"Click here to learn the details": {
			"contest": "Kattintson ide a részletekért"
		},
		"I am already a member": {
			"popup": "Már tag vagyok"
		},
		"Learn more": {
			"contest": "Tudjon meg többet"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "A Meteo-Parapente ünnepli fennállásának 10. évfordulóját."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Még nem vagy tag? Kattintson a belépési kódért"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Ebből az alkalomból rendkívüli versenyt szervezünk."
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Egy nyertest sorsolunk ki azok közül, akik tavaly szeptember és jövő március 30. között előfizetést vásároltak vagy újítottak meg."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Nyerni kell: A VÁLASZTOTT SIKLÓERNYŐS SZÁRNY!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "A %{ date } megtekintéséhez kérjük, jelentkezzen be vagy legyen tag."
		},
		"Win a paraglider!": {
			"contribute menu": "Nyerj egy siklóernyőt!"
		}
	},
	"it": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Parapendio"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Aggiungi nuovo..."
		},
		"Airspace": {
			"toggle menu": "Spazio aereo"
		},
		"All": {
			"map menu humidity": "Tutte"
		},
		"B. layer": {
			"map menu updrafts": "Strato Convettivo"
		},
		"B. Layer": {
			"map menu wind": "Strato convettivo"
		},
		"Boundary layer": {
			"map menu wind": "Strato convettivo"
		},
		"Boundary Layer": {
			"map menu updrafts": "Strato convettivo",
			"layer legend A": "Strato convettivo",
			"layer legend B": "Strato convettivo"
		},
		"Ceiling": {
			"map menu updrafts": "Quota max",
			"layer legend B": "Quota max"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Quota max strato convettivo"
		},
		"Change password": {
			"settings menu": "Cambio password"
		},
		"Clouds": {
			"map menu humidity": "Nubi"
		},
		"Color blind": {
			"settings menu": "Daltonici"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Cancella"
		},
		"experimental": {
			"settings menu": "Sperimentale"
		},
		"Experimental features": {
			"settings menu": "Funzioni in fase sperimentale"
		},
		"Favorites": {
			"menu title": "Preferiti"
		},
		"Ground": {
			"map menu wind": "in superficie",
			"map menu temperature": "in superficie"
		},
		"Help us translate!": {
			"settings menu": "Aiutaci a tradurre!"
		},
		"High": {
			"map menu humidity": "Alte"
		},
		"Humidity": {
			"map menu humidity": "Umidità"
		},
		"Interpolation": {
			"toggle menu": "Interpolazione"
		},
		"Language": {
			"settings menu": "Lingua"
		},
		"Login": {
			"login menu": "Entra"
		},
		"Logout": {
			"settings menu": "Esci"
		},
		"Low": {
			"map menu humidity": "Basse"
		},
		"Medium": {
			"map menu humidity": "Medie"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapendio"
		},
		"Move to top": {
			"favorites menu": "Vai in cima"
		},
		"News": {
			"news menu": "Avvisi"
		},
		"News!": {
			"news menu": "Avvisi!"
		},
		"No data for this place": {
			"windgram view": "Nessun dato per questa località"
		},
		"Open": {
			"favorites menu": "Apri"
		},
		"Pressure": {
			"map menu wind": "Pressione",
			"layer legend A": "Pressione"
		},
		"Rain": {
			"map menu humidity": "Pioggia"
		},
		"Rename": {
			"favorites menu": "Rinomina"
		},
		"Reset all settings": {
			"settings menu": "Ripristina tutto"
		},
		"Sea level": {
			"map menu wind": "Livello del mare"
		},
		"Set as homepage": {
			"favorites menu": "Configura come pagina iniziale"
		},
		"Settings": {
			"settings menu": "Preferenze"
		},
		"Shearing": {
			"map menu updrafts": "uniformi/rotte",
			"layer legend B": "uniformi/rotte"
		},
		"Sounding": {
			"windgram tab": "Curva di stato"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termiche",
			"layer legend A": "Termiche"
		},
		"Thickness": {
			"map menu updrafts": "Spessore",
			"layer legend B": "Spessore"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendenze"
		},
		"Velocity": {
			"map menu updrafts": "Velocità",
			"layer legend B": "Velocità"
		},
		"Vertical motion": {
			"map menu updrafts": "Moto verticale",
			"": "Movimento verticale"
		},
		"Wind": {
			"map menu wind": "Vento",
			"layer legend A": "Vento"
		},
		"Wind Shear": {
			"map menu wind": "Gradiente di vento",
			"layer legend A": "Gradiente di vento"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Modello"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "(senza unità di misura)"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superficie"
		},
		"Ceiling of BL": {
			"layer legend B": "Quota max strato convettivo"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Copertura nuvolosa"
		},
		"Low altitude": {
			"layer legend B": "Bassa quota"
		},
		"High altitude": {
			"layer legend B": "Alta quota"
		},
		"Medium altitude": {
			"layer legend B": "Quota media"
		},
		"All altitudes": {
			"layer legend B": "Tutte le quote"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Moto verticale"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitazioni"
		},
		"1 hour": {
			"layer legend B": "1 ora"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Livello del mare (medio)"
		},
		"Enter a name": {
			"new favorite prompt": "Inserisci un nome"
		},
		"Enter the new name": {
			"new favorite prompt": "Inserisci un nuovo nome"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Sovrascrivi preferiti \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Cancella preferiti \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Sei sicuro di voler ripristinare tutto?\nTUTTE LE TUE PREFERENZE E PERSONALIZZAZIONI NON SARANNO PIÙ RECUPERABILI!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Previsioni meteo per il volo | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Aiuto/Contatti/Riferimenti"
		},
		"Install now": {
			"version check": "Installa adesso"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Previsioni meteo di volo libero"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente deve essere aggiornato"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente è adesso disponibile per dispositivi mobili!\nPrevisioni meteo specifiche per il volo libero in parapendio"
		},
		"Mobile app": "App per dispositivi mobili",
		"No internet connexion": "Manca la connessione a internet",
		"Community": "Comunità",
		"Day selection": "Selezione del giorno",
		"knots": "nodi",
		"mph": "mph",
		"Radiation": "Radiazione",
		"Sun": "Sole",
		"Update": "Aggiornamento",
		"Wind unit": "Unità di vento",
		"An error has occured. Please try again.": {
			"popup": "Si è verificato un errore. Si prega di riprovare."
		},
		"Click here to renew.": {
			"login popup": "Clicca qui per rinnovare."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Clicca sul link all'interno dell'e-mail per cambiare la tua password."
		},
		"Close": {
			"popup": "Chiudi",
			"general": "Chiudere"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Le e-mail non sono uguali o non sono valide"
		},
		"Error! Bad login or password": {
			"login popup": "Errore! Accesso o password errati"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Errore! Il tuo accesso è scaduto il %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Se sei un collaboratore, riceverai un'e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Un ultimo passo..."
		},
		"Passwords must be the same": {
			"password popup": "Le password devono essere uguali"
		},
		"Please log-in": {
			"login popup": "Per favore, accedi"
		},
		"Private device − stay connected": {
			"login popup": "Dispositivo privato - resta connesso"
		},
		"Read more…": {
			"contribute popup": "Leggi di più..."
		},
		"Reset your password": {
			"password popup": "Ripristina la tua password"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Alcuni provider come Orange, GMX e Hotmail a volte bloccano le nostre e-mail. Se non ricevi nulla, contatta il supporto@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Benvenuti!"
		},
		"Same as device": {
			"timezone menu": "Uguale al dispositivo"
		},
		"Timezone": {
			"settings menu": "Fuso orario"
		},
		"XC Planner": {
			"toggle menu": "Pianificatore XC"
		},
		"Multiplier": {
			"xc planner": "Moltiplicatore"
		},
		"Points": {
			"xc planner": "Punti"
		},
		"Duration": {
			"xc planner": "Durata"
		},
		"Speed": {
			"xc planner": "Velocità"
		},
		"Close flight": {
			"xc planner": "Chiudere il volo"
		},
		"Share": {
			"xc planner": "Condividi"
		},
		"Download": {
			"xc planner": "Scaricare",
			"general": "Scaricare"
		},
		"Preferences": {
			"xc planner": "Preferenze"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "Informazioni su"
		},
		"Exit Fullscreen": {
			"toggle menu": "Esci dallo schermo intero"
		},
		"Fullscreen": {
			"toggle menu": "Schermo intero"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner è una funzione sperimentale.\nÈ disponibile solo da un computer, su meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancella"
		},
		"Yes": {
			"general": "Sì"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Salva"
		},
		"Continue": {
			"general": "Continua"
		},
		"Original version": {
			"xc planner": "Versione originale"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Pesantemente modificato per funzionare in Meteo-Parapente, con l'autorizzazione di Tom. Grazie!"
		},
		"League": {
			"xc planner": "Lega"
		},
		"Distance units": {
			"xc planner": "Unità di distanza"
		},
		"Altitude units": {
			"xc planner": "Unità di altitudine"
		},
		"Coordinates format": {
			"xc planner": "Formato delle coordinate"
		},
		"Turnpoint details": {
			"xc planner": "Dettagli del punto di svolta"
		},
		"Format": {
			"xc planner": "Formato"
		},
		"Route name": {
			"xc planner": "Nome del percorso"
		},
		"Waypoint prefix": {
			"xc planner": "Prefisso del waypoint"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Incolla il link nell'e-mail o nel messaggio istantaneo"
		},
		"Static image": {
			"xc planner": "Immagine statica"
		},
		"Open with XCTrack": {
			"xc planner": "Apri su XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Condividere con LocToMe: impostare come percorso predefinito"
		},
		"Go to": {
			"general": "Vai a"
		},
		"Error! Please try again later": {
			"update modal": "Errore! Si prega di riprovare più tardi"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Premi Reset per reimpostare il tuo percorso in modo permanente, premi Annulla per mantenere il tuo percorso."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Ecco il suo codice di accesso. Per favore, lo tenga al sicuro."
		},
		"Password:": {
			"contribute popup": "Password:"
		},
		"Thank you!": {
			"contribute popup": "Grazie!"
		},
		"Username:": {
			"contribute popup": "Nome utente:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesi Standard - %{currency} %{pricing} / mese"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesi Studente - %{currency} %{pricing} / mese"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesi Fornitore - %{currency} %{pricing} / mese"
		},
		"Tour of Europe": {
			"tab": "Giro d'Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Goditi le migliori previsioni ogni giorno. Meteo-Parapente può esistere grazie a te!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Ottieni l'ingresso gratuito ai corsi di formazione meteo locali e ai meetup degli utenti."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Iscriviti al club dei collaboratori di Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Incontriamoci una volta al mese per discutere di nuove caratteristiche e miglioramenti."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente può esistere grazie a voi!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Il mio obiettivo è quello di fornire uno strumento di qualità accessibile a tutti i piloti."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Sostenere lo sviluppo di uno strumento di qualità accessibile a tutti i piloti."
		},
		"and to the": {
			"startup terms": "e à la"
		},
		"By using this application, you agree to the": {
			"startup terms": "Utilizzando questa applicazione, accettate le"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Se il problema persiste, contattare support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente non utilizza cookie di tracciamento"
		},
		"privacy policy": {
			"startup terms": "politica sulla riservatezza"
		},
		"terms of use": {
			"startup": "condizioni generali d'uso"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Impossibile raggiungere i server di Meteo-Parapente. Per favore controlla la tua connessione."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 giorni alla settimana sono riservati ai membri"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Sei già membro? Clicca per reimpostare la tua password"
		},
		"Become a member": {
			"contribute menu": "Diventa un membro",
			"popup": "Diventa un membro"
		},
		"Click here to learn the details": {
			"contest": "Clicca qui per conoscere i dettagli"
		},
		"I am already a member": {
			"popup": "Sono già membro"
		},
		"Learn more": {
			"contest": "Per saperne di più"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente festeggia il suo 10° anniversario."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Non sei ancora membro? Clicca per ottenere un codice di accesso"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "In questa occasione, stiamo organizzando un concorso eccezionale"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Un vincitore sarà estratto tra tutti coloro che hanno acquistato o rinnovato un abbonamento tra lo scorso settembre e il prossimo 30 marzo."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Da vincere: L'ALA DA PARAPENDIO DI TUA SCELTA!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Per vedere %{ date }, effettua il login o diventa membro."
		},
		"Win a paraglider!": {
			"contribute menu": "Vinci un parapendio!"
		}
	},
	"nl": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Parapente)"
		},
		"1h": {
			"map menu humidity": "1u"
		},
		"Add new…": {
			"favorites menu": "Nieuw"
		},
		"Airspace": {
			"toggle menu": "Luchtruim"
		},
		"All": {
			"map menu humidity": "Alles"
		},
		"B. layer": {
			"map menu updrafts": "Grenslaag"
		},
		"B. Layer": {
			"map menu wind": "Grenslaag"
		},
		"Boundary layer": {
			"map menu wind": "Grenslaag"
		},
		"Boundary Layer": {
			"map menu updrafts": "Grenslaag",
			"layer legend A": "Grenslaag",
			"layer legend B": "Grenslaag"
		},
		"Ceiling": {
			"map menu updrafts": "hoogte",
			"layer legend B": "Plafond"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Hoogte van grenslaag"
		},
		"Change password": {
			"settings menu": "Paswoord wijzigen"
		},
		"Clouds": {
			"map menu humidity": "Wolken"
		},
		"Color blind": {
			"settings menu": "Kleurenblind"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Verwijderen"
		},
		"experimental": {
			"settings menu": "experimenteel"
		},
		"Experimental features": {
			"settings menu": "Experimentele functies"
		},
		"Favorites": {
			"menu title": "Favorieten"
		},
		"Ground": {
			"map menu wind": "Grond",
			"map menu temperature": "Grond"
		},
		"Help us translate!": {
			"settings menu": "Help ons vertalen"
		},
		"High": {
			"map menu humidity": "Hoog"
		},
		"Humidity": {
			"map menu humidity": "Vochtigheid"
		},
		"Interpolation": {
			"toggle menu": "Interpolatie"
		},
		"Language": {
			"settings menu": "Taal"
		},
		"Login": {
			"login menu": "Inloggen"
		},
		"Logout": {
			"settings menu": "Uitloggen"
		},
		"Low": {
			"map menu humidity": "Laag"
		},
		"Medium": {
			"map menu humidity": "Gemiddeld"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Naar boven"
		},
		"News": {
			"news menu": "Nieuws"
		},
		"News!": {
			"news menu": "Nieuws!"
		},
		"No data for this place": {
			"windgram view": "Geen data voor deze locatie"
		},
		"Open": {
			"favorites menu": "Open"
		},
		"Pressure": {
			"map menu wind": "Druk",
			"layer legend A": "(Lucht)Druk"
		},
		"Rain": {
			"map menu humidity": "Regen"
		},
		"Rename": {
			"favorites menu": "Hernoem"
		},
		"Reset all settings": {
			"settings menu": "Wis alle instellingen"
		},
		"Sea level": {
			"map menu wind": "Zeeniveau"
		},
		"Set as homepage": {
			"favorites menu": "Als startpagina instellen"
		},
		"Settings": {
			"settings menu": "Instellingen"
		},
		"Shearing": {
			"map menu updrafts": "Schering",
			"layer legend B": "Schering"
		},
		"Sounding": {
			"windgram tab": "Emagram"
		},
		"Temperature": {
			"map menu temperature": "Temperatuur",
			"layer legend A": "Temperatuur"
		},
		"Thermals": {
			"map menu updrafts": "Thermiek",
			"layer legend A": "Thermieken"
		},
		"Thickness": {
			"map menu updrafts": "Dikte",
			"layer legend B": "Dikte"
		},
		"Updrafts": {
			"map menu updrafts": "Stijgwinden"
		},
		"Velocity": {
			"map menu updrafts": "Snelheid",
			"layer legend B": "Snelheid"
		},
		"Vertical motion": {
			"map menu updrafts": "Verticale beweging",
			"": "Verticale beweging"
		},
		"Wind": {
			"map menu wind": "Wind",
			"layer legend A": "wind"
		},
		"Wind Shear": {
			"map menu wind": "Windschering",
			"layer legend A": "Windschering"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimensieloos"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "oppervlakte"
		},
		"Ceiling of BL": {
			"layer legend B": "Hoogte van GL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Wolkendek"
		},
		"Low altitude": {
			"layer legend B": "Lage hoogte"
		},
		"High altitude": {
			"layer legend B": "Grote hoogte"
		},
		"Medium altitude": {
			"layer legend B": "Gemiddelde hoogte"
		},
		"All altitudes": {
			"layer legend B": "Alle hoogtes"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Verticale beweging"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Neerslag"
		},
		"1 hour": {
			"layer legend B": "1 uur"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Zeeniveau"
		},
		"Enter a name": {
			"new favorite prompt": "Voer een naam in"
		},
		"Enter the new name": {
			"new favorite prompt": "Voer de nieuwe naam in"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Overschrijf favoriete \"%name\""
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Verwijder favoriete \"%name\""
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Bent u zeker dat u alles wil wissen?\nALLE INSTELLINGEN EN FAVORIETEN WORDEN DEFINITIEF GEWIST!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Zweefvlieg weersvoorspellingen | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Help / Contact / Over"
		},
		"Install now": {
			"version check": "Nu installeren"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Stijgende weersvoorspellingen"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente heeft een update nodig."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente is nu mobiel!\nWeervoorspellingen speciaal ontworpen voor vliegen en paragliding."
		},
		"Mobile app": "Mobiele app",
		"No internet connexion": "Geen internetverbinding",
		"Community": "Gemeenschap",
		"Day selection": "Dag selectie",
		"knots": "knopen",
		"mph": "mph",
		"Radiation": "Straling",
		"Sun": "Zon",
		"Update": "Update",
		"Wind unit": "Windvoorziening",
		"An error has occured. Please try again.": {
			"popup": "Er is een fout opgetreden. Gelieve opnieuw te proberen."
		},
		"Click here to renew.": {
			"login popup": "Klik hier om te vernieuwen."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Klik op de link in de e-mail om uw wachtwoord te wijzigen."
		},
		"Close": {
			"popup": "Sluiten",
			"general": "Sluiten"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-mails zijn niet hetzelfde of ongeldig"
		},
		"Error! Bad login or password": {
			"login popup": "Fout! Slechte login of wachtwoord"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Fout. Uw toegang is verlopen op %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Als u een contribuant bent, ontvangt u een e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Een laatste stap..."
		},
		"Passwords must be the same": {
			"password popup": "Wachtwoorden moeten hetzelfde zijn"
		},
		"Please log-in": {
			"login popup": "Log in"
		},
		"Private device − stay connected": {
			"login popup": "Privé apparaat - blijf verbonden"
		},
		"Read more…": {
			"contribute popup": "Lees meer..."
		},
		"Reset your password": {
			"password popup": "Reset uw wachtwoord"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Sommige providers zoals Orange, GMX en Hotmail blokkeren soms onze emails. Mocht u toch niets ontvangen, neem dan contact op met support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Welkom."
		},
		"Same as device": {
			"timezone menu": "Zelfde als apparaat"
		},
		"Timezone": {
			"settings menu": "Tijdzone"
		},
		"XC Planner": {
			"toggle menu": "XC-planner"
		},
		"Multiplier": {
			"xc planner": "Vermenigvuldiger"
		},
		"Points": {
			"xc planner": "Punten"
		},
		"Duration": {
			"xc planner": "Duur"
		},
		"Speed": {
			"xc planner": "Snelheid"
		},
		"Close flight": {
			"xc planner": "Vlucht sluiten"
		},
		"Share": {
			"xc planner": "Deel"
		},
		"Download": {
			"xc planner": "Download",
			"general": "Download"
		},
		"Preferences": {
			"xc planner": "Voorkeuren"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "Over"
		},
		"Exit Fullscreen": {
			"toggle menu": "Volledig scherm afsluiten"
		},
		"Fullscreen": {
			"toggle menu": "Volledig scherm"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner is een experimentele functie.\nHet is alleen beschikbaar vanaf een computer, op meteo-parapente.com"
		},
		"Cancel": {
			"general": "Annuleren"
		},
		"Yes": {
			"general": "Ja"
		},
		"No": {
			"general": "Geen"
		},
		"Save": {
			"general": "Save"
		},
		"Continue": {
			"general": "Ga door"
		},
		"Original version": {
			"xc planner": "Originele versie"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Zwaar gehackt om in Meteo-Parapente te werken, met toestemming van Tom. Dank je wel!"
		},
		"League": {
			"xc planner": "Competitie"
		},
		"Distance units": {
			"xc planner": "Afstandseenheden"
		},
		"Altitude units": {
			"xc planner": "Hoogte-eenheden"
		},
		"Coordinates format": {
			"xc planner": "Coordinaten formaat"
		},
		"Turnpoint details": {
			"xc planner": "Details keerpunt"
		},
		"Format": {
			"xc planner": "Formaat"
		},
		"Route name": {
			"xc planner": "Naam van de route"
		},
		"Waypoint prefix": {
			"xc planner": "Waypoint voorvoegsel"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Plak link in e-mail of IM"
		},
		"Static image": {
			"xc planner": "Statisch beeld"
		},
		"Open with XCTrack": {
			"xc planner": "Open met XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Delen met LocToMe: instellen als standaardroute"
		},
		"Go to": {
			"general": "Ga naar"
		},
		"Error! Please try again later": {
			"update modal": "Fout! Probeer later opnieuw"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Druk op Reset om uw route permanent te resetten, druk op Annuleren om uw route te behouden."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Hier is uw toegangscode. Bewaar hem goed."
		},
		"Password:": {
			"contribute popup": "Wachtwoord:"
		},
		"Thank you!": {
			"contribute popup": "Dank je."
		},
		"Username:": {
			"contribute popup": "Gebruikersnaam:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 maanden Standaard - %{currency} %{pricing} / maand"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 maanden Student - %{currency} %{pricing} / maand"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 maanden Supporter - %{currency} %{pricing} / maand"
		},
		"Tour of Europe": {
			"tab": "Rondreis door Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Geniet elke dag van de beste voorspellingen. Meteo-Parapente kan bestaan dankzij jou!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Krijg gratis toegang tot lokale weertrainingen en gebruikersmeetups."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Word lid van de Meteo-Parapente contribuanten club"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Ontmoet me eens per maand om nieuwe functies en verbeteringen te bespreken."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente kan bestaan dankzij jou!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mijn doel is een kwaliteitsinstrument aan te bieden dat toegankelijk is voor elke piloot."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Steun voor de ontwikkeling van een kwaliteitsinstrument dat voor alle loodsen toegankelijk is."
		},
		"and to the": {
			"startup terms": "en met het"
		},
		"By using this application, you agree to the": {
			"startup terms": "Door deze toepassing te gebruiken, gaat u akkoord met de"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Als het probleem aanhoudt, neem dan contact op met support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente gebruikt geen tracking cookies"
		},
		"privacy policy": {
			"startup terms": "privacybeleid"
		},
		"terms of use": {
			"startup": "algemene gebruiksvoorwaarden"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Kan de Meteo-Parapente servers niet bereiken. Controleer uw verbinding."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dagen per week zijn gereserveerd voor leden"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Bent u al lid? Klik om uw wachtwoord te resetten"
		},
		"Become a member": {
			"contribute menu": "Lid worden",
			"popup": "Lid worden"
		},
		"Click here to learn the details": {
			"contest": "Klik hier voor de details"
		},
		"I am already a member": {
			"popup": "Ik ben al lid"
		},
		"Learn more": {
			"contest": "Leer meer"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente viert zijn 10-jarig bestaan."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Nog geen lid? Klik hier om een toegangscode te krijgen"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Bij deze gelegenheid organiseren wij een uitzonderlijke wedstrijd"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Er zal één winnaar worden getrokken uit al degenen die tussen september vorig jaar en 30 maart volgend jaar een abonnement hebben gekocht of verlengd."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Te winnen: DE PARAGLIDER VLEUGEL VAN UW KEUZE!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Om %{ date } te zien, logt u in of wordt u lid."
		},
		"Win a paraglider!": {
			"contribute menu": "Win een paraglider!"
		}
	},
	"pl": {
		"(Kitesurf)": {
			"search result": "(Kitesurfing)"
		},
		"(Paragliding)": {
			"search result": "(Paragliding)"
		},
		"1h": {
			"map menu humidity": "1 godz"
		},
		"Add new…": {
			"favorites menu": "Dodaj nowe…"
		},
		"Airspace": {
			"toggle menu": "Przestrzeń powietrzna"
		},
		"All": {
			"map menu humidity": "Wszystko"
		},
		"B. layer": {
			"map menu updrafts": "Warstwa graniczna"
		},
		"B. Layer": {
			"map menu wind": "Warstwa graniczna"
		},
		"Boundary layer": {
			"map menu wind": "Warstwa graniczna"
		},
		"Boundary Layer": {
			"map menu updrafts": "Warstwa graniczna",
			"layer legend A": "Warstwa graniczna",
			"layer legend B": "Warstwa graniczna"
		},
		"Ceiling": {
			"map menu updrafts": "Sufit",
			"layer legend B": "Sufit"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Pułap warstwy granicznej"
		},
		"Change password": {
			"settings menu": "Zmień hasło"
		},
		"Clouds": {
			"map menu humidity": "Chmury"
		},
		"Color blind": {
			"settings menu": "Kolor ciemno"
		},
		"debug": {
			"settings menu": "debugować"
		},
		"Delete": {
			"favorites menu": "Kasować"
		},
		"experimental": {
			"settings menu": "eksperymentalny"
		},
		"Experimental features": {
			"settings menu": "Opcje eksperymentalne"
		},
		"Favorites": {
			"menu title": "Ulubione"
		},
		"Ground": {
			"map menu wind": "Ziemia",
			"map menu temperature": "Ziemia"
		},
		"Help us translate!": {
			"settings menu": "Pomóż nam przetłumaczyć!"
		},
		"High": {
			"map menu humidity": "Wysoki"
		},
		"Humidity": {
			"map menu humidity": "Wilgotność"
		},
		"Interpolation": {
			"toggle menu": "Interpolacja"
		},
		"Language": {
			"settings menu": "Język"
		},
		"Login": {
			"login menu": "Zaloguj Się"
		},
		"Logout": {
			"settings menu": "Wyloguj się"
		},
		"Low": {
			"map menu humidity": "Nieskie"
		},
		"Medium": {
			"map menu humidity": "Średnie"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Przejdź na górę"
		},
		"News": {
			"news menu": "Aktualności"
		},
		"News!": {
			"news menu": "Aktualności!"
		},
		"No data for this place": {
			"windgram view": "Brak danych dla tego miejsca"
		},
		"Open": {
			"favorites menu": "Otwórz"
		},
		"Pressure": {
			"map menu wind": "Ciśnienie",
			"layer legend A": "Ciśnienie"
		},
		"Rain": {
			"map menu humidity": "Deszcz"
		},
		"Rename": {
			"favorites menu": "Zmień nazwę"
		},
		"Reset all settings": {
			"settings menu": "Zresetuj wszystkie ustawienia"
		},
		"Sea level": {
			"map menu wind": "Poziom morza"
		},
		"Set as homepage": {
			"favorites menu": "Ustaw jako stronę domową"
		},
		"Settings": {
			"settings menu": "Ustawienia"
		},
		"Shearing": {
			"map menu updrafts": "Udostępnianie",
			"layer legend B": "Udział"
		},
		"Sounding": {
			"windgram tab": "Sounding"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termika",
			"layer legend A": "Termika"
		},
		"Thickness": {
			"map menu updrafts": "Grubość",
			"layer legend B": "Grubość"
		},
		"Updrafts": {
			"map menu updrafts": "Prądy wstępujące"
		},
		"Velocity": {
			"map menu updrafts": "Prędkość",
			"layer legend B": "Prędkość"
		},
		"Vertical motion": {
			"map menu updrafts": "Ruch pionowy",
			"": "Ruch pionowy"
		},
		"Wind": {
			"map menu wind": "Wiatr",
			"layer legend A": "Wiatr"
		},
		"Wind Shear": {
			"map menu wind": "Udział wiatru",
			"layer legend A": "Udział wiatru"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Bezwymiarowy"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Powierzchnia"
		},
		"Ceiling of BL": {
			"layer legend B": "Wysokość warstwy granicznej"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Zachmurzenie"
		},
		"Low altitude": {
			"layer legend B": "Niska wysokość"
		},
		"High altitude": {
			"layer legend B": "Wysoki pułap"
		},
		"Medium altitude": {
			"layer legend B": "Średnia wysokość"
		},
		"All altitudes": {
			"layer legend B": "Na wszystkich wysokościach"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2 m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Pionowe Ruchu"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Opady"
		},
		"1 hour": {
			"layer legend B": "1 godzina"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Średni na poziomie morza"
		},
		"Enter a name": {
			"new favorite prompt": "Wprowadź nazwę"
		},
		"Enter the new name": {
			"new favorite prompt": "Wprowadź nową nazwę"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Nadpisz ulubione \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Usuń ulubiony \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Czy na pewno chcesz zresetować wszystko?\nWSZYSTKIE USTAWIENIA I ULUBIONE BĘDĄ UTRACONE NA ZAWSZE!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Prognozy pogody | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Pomoc / Kontakt / O nas"
		},
		"Install now": {
			"version check": "Zainstaluj teraz"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Gwałtowne prognozy pogody"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente wymaga aktualizacji."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente jest teraz mobilne!\nPrognozy pogody specjalnie opracowane dla lotów i paralotniarstwa."
		},
		"Mobile app": "Aplikacja mobilna",
		"No internet connexion": "Brak połączenia z Internetem",
		"Community": "Wspólnota",
		"Day selection": "Wybór dnia",
		"knots": "węzły",
		"mph": "mph",
		"Radiation": "Promieniowanie",
		"Sun": "Sun",
		"Update": "Aktualizacja",
		"Wind unit": "Jednostka wiatrowa",
		"An error has occured. Please try again.": {
			"popup": "Wystąpił błąd. Proszę spróbować ponownie."
		},
		"Click here to renew.": {
			"login popup": "Kliknij tutaj, aby odnowić umowę."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kliknij łącze znajdujące się w wiadomości e-mail, aby zmienić swoje hasło."
		},
		"Close": {
			"popup": "Zamknij",
			"general": "Zamknij"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Wiadomości e-mail nie są takie same lub są nieważne"
		},
		"Error! Bad login or password": {
			"login popup": "Błąd! Zły login lub hasło"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Błąd! Twój dostęp wygasł w dniu %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Jeśli jesteś osobą, która wniosła swój wkład, otrzymasz wiadomość e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Ostatni krok..."
		},
		"Passwords must be the same": {
			"password popup": "Hasła muszą być takie same"
		},
		"Please log-in": {
			"login popup": "Zaloguj się"
		},
		"Private device − stay connected": {
			"login popup": "Urządzenie prywatne - pozostań w kontakcie"
		},
		"Read more…": {
			"contribute popup": "Czytaj dalej..."
		},
		"Reset your password": {
			"password popup": "Zresetuj swoje hasło"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Niektórzy operatorzy, tacy jak Orange, GMX i Hotmail, czasami blokują nasze e-maile. Jeśli nie otrzymujesz żadnych wiadomości, skontaktuj się z support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Witaj!"
		},
		"Same as device": {
			"timezone menu": "Tak jak urządzenie"
		},
		"Timezone": {
			"settings menu": "Strefa czasowa"
		},
		"XC Planner": {
			"toggle menu": "Planista XC"
		},
		"Multiplier": {
			"xc planner": "Mnożnik"
		},
		"Points": {
			"xc planner": "Punkty"
		},
		"Duration": {
			"xc planner": "Czas trwania"
		},
		"Speed": {
			"xc planner": "Prędkość"
		},
		"Close flight": {
			"xc planner": "Lot z bliska"
		},
		"Share": {
			"xc planner": "Udostępnij"
		},
		"Download": {
			"xc planner": "Pobierz",
			"general": "Pobierz"
		},
		"Preferences": {
			"xc planner": "Preferencje"
		},
		"Reset": {
			"xc planner": "Resetuj",
			"general": "Resetuj"
		},
		"About": {
			"xc planner": "O stronie"
		},
		"Exit Fullscreen": {
			"toggle menu": "Wyjdź z trybu pełnoekranowego"
		},
		"Fullscreen": {
			"toggle menu": "Fullscreen"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner jest funkcją eksperymentalną.\nJest ona dostępna tylko z komputera, na stronie meteo-parapente.com"
		},
		"Cancel": {
			"general": "Anuluj"
		},
		"Yes": {
			"general": "Tak"
		},
		"No": {
			"general": "Nr"
		},
		"Save": {
			"general": "Zapisz"
		},
		"Continue": {
			"general": "Kontynuuj"
		},
		"Original version": {
			"xc planner": "Wersja oryginalna"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Mocno zhakowane, aby działało w Meteo-Parapente, z autoryzacją Toma. Dziękuję!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Jednostki odległości"
		},
		"Altitude units": {
			"xc planner": "Jednostki wysokości"
		},
		"Coordinates format": {
			"xc planner": "Format współrzędnych"
		},
		"Turnpoint details": {
			"xc planner": "Szczegóły dotyczące punktów zwrotnych"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nazwa trasy"
		},
		"Waypoint prefix": {
			"xc planner": "Prefiks punktu trasy"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Wklej łącze do wiadomości e-mail lub komunikatora"
		},
		"Static image": {
			"xc planner": "Obraz statyczny"
		},
		"Open with XCTrack": {
			"xc planner": "Otwórz za pomocą XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Udostępnij w LocToMe: ustaw jako trasę domyślną"
		},
		"Go to": {
			"general": "Przejdź do"
		},
		"Error! Please try again later": {
			"update modal": "Błąd! Proszę spróbować ponownie później"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Naciśnij przycisk Resetuj, aby trwale zresetować trasę, lub naciśnij przycisk Anuluj, aby zachować trasę."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Oto Twój kod dostępu. Proszę go bezpiecznie przechowywać."
		},
		"Password:": {
			"contribute popup": "Hasło:"
		},
		"Thank you!": {
			"contribute popup": "Dziękuję!"
		},
		"Username:": {
			"contribute popup": "Nazwa użytkownika:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 miesięcy Standard - %{currency} %{pricing} / miesiąc"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 miesięcy Student - %{currency} %{pricing} / miesiąc"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "Kibic 12 miesięcy - %{currency} %{pricing} / miesiąc"
		},
		"Tour of Europe": {
			"tab": "Podróż po Europie"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Ciesz się najlepszymi prognozami każdego dnia. Meteo-Parapente może istnieć dzięki Tobie!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Uzyskaj bezpłatny wstęp na lokalne szkolenia pogodowe i spotkania użytkowników."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Dołącz do klubu współpracowników Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Spotykaj się ze mną raz w miesiącu, aby omówić nowe funkcje i ulepszenia."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente może istnieć dzięki Wam!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Moim celem jest dostarczenie wysokiej jakości narzędzia dostępnego dla każdego pilota."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Wspieranie rozwoju narzędzia jakości dostępnego dla wszystkich pilotów."
		},
		"and to the": {
			"startup terms": "i do"
		},
		"By using this application, you agree to the": {
			"startup terms": "Korzystając z tej aplikacji, użytkownik wyraża zgodę na"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Jeśli problem będzie się powtarzał, skontaktuj się z support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente nie używa plików cookie śledzących."
		},
		"privacy policy": {
			"startup terms": "polityka prywatności"
		},
		"terms of use": {
			"startup": "warunki użytkowania"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nie można połączyć się z serwerami Meteo-Parapente. Sprawdź swoje połączenie."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dni w tygodniu są zarezerwowane dla członków"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Jesteś już użytkownikiem? Kliknij, aby zresetować swoje hasło"
		},
		"Become a member": {
			"contribute menu": "Zostań członkiem",
			"popup": "Zostań członkiem"
		},
		"Click here to learn the details": {
			"contest": "Kliknij tutaj, aby poznać szczegóły"
		},
		"I am already a member": {
			"popup": "Jestem już członkiem"
		},
		"Learn more": {
			"contest": "Dowiedz się więcej"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente obchodzi 10-lecie istnienia."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Nie jesteś jeszcze członkiem? Kliknij, aby otrzymać kod dostępu"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Z tej okazji organizujemy wyjątkowy konkurs"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Jeden zwycięzca zostanie wylosowany spośród wszystkich osób, które zakupiły lub odnowiły prenumeratę w okresie od września ubiegłego roku do 30 marca przyszłego roku."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Do wygrania: WYBRANE PRZEZ CIEBIE SKRZYDŁO PARALOTNI!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Aby zobaczyć %{ date }, zaloguj się lub zostań członkiem."
		},
		"Win a paraglider!": {
			"contribute menu": "Wygraj paralotnię!"
		}
	},
	"pt": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Parapente"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Adicionar novo"
		},
		"Airspace": {
			"toggle menu": "Espaço aéreo"
		},
		"All": {
			"map menu humidity": "Tudo"
		},
		"B. layer": {
			"map menu updrafts": "Camada.B"
		},
		"B. Layer": {
			"map menu wind": "Camada.B"
		},
		"Boundary layer": {
			"map menu wind": "Camada limite"
		},
		"Boundary Layer": {
			"map menu updrafts": "Camada limite",
			"layer legend A": "Camada limite",
			"layer legend B": "Camada limite"
		},
		"Ceiling": {
			"map menu updrafts": "Tecto",
			"layer legend B": "Tecto"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Tecto da camada b."
		},
		"Change password": {
			"settings menu": "Mudar a palavra-chave"
		},
		"Clouds": {
			"map menu humidity": "Nuvens"
		},
		"Color blind": {
			"settings menu": "Daltónico"
		},
		"debug": {
			"settings menu": "depurar"
		},
		"Delete": {
			"favorites menu": "Apagar"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Funcionalidades experimentais"
		},
		"Favorites": {
			"menu title": "Favoritos"
		},
		"Ground": {
			"map menu wind": "Solo",
			"map menu temperature": "Solo"
		},
		"Help us translate!": {
			"settings menu": "Ajude-nos a traduzir!"
		},
		"High": {
			"map menu humidity": "Alto"
		},
		"Humidity": {
			"map menu humidity": "Humidade"
		},
		"Interpolation": {
			"toggle menu": "Interpolação"
		},
		"Language": {
			"settings menu": "Idioma"
		},
		"Login": {
			"login menu": "Entrar"
		},
		"Logout": {
			"settings menu": "Sair"
		},
		"Low": {
			"map menu humidity": "Baixo"
		},
		"Medium": {
			"map menu humidity": "Médio"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Mover para o topo"
		},
		"News": {
			"news menu": "Notícias"
		},
		"News!": {
			"news menu": "Notícias!"
		},
		"No data for this place": {
			"windgram view": "Sem dados para este local"
		},
		"Open": {
			"favorites menu": "Abrir"
		},
		"Pressure": {
			"map menu wind": "Pressão",
			"layer legend A": "Pressão"
		},
		"Rain": {
			"map menu humidity": "Chuva"
		},
		"Rename": {
			"favorites menu": "Renomear"
		},
		"Reset all settings": {
			"settings menu": "Reinicializar todos os parâmetros"
		},
		"Sea level": {
			"map menu wind": "Nível do mar"
		},
		"Set as homepage": {
			"favorites menu": "Definir como página inicial"
		},
		"Settings": {
			"settings menu": "Parâmetros"
		},
		"Shearing": {
			"map menu updrafts": "Corte",
			"layer legend B": "Corte"
		},
		"Sounding": {
			"windgram tab": "Sondagem"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Térmicas",
			"layer legend A": "Térmicas"
		},
		"Thickness": {
			"map menu updrafts": "Espessura",
			"layer legend B": "Espessura"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendentes"
		},
		"Velocity": {
			"map menu updrafts": "Velocidade",
			"layer legend B": "Velocidade"
		},
		"Vertical motion": {
			"map menu updrafts": "Movimento vertical",
			"": "Movimento vertical"
		},
		"Wind": {
			"map menu wind": "Vento",
			"layer legend A": "Vento"
		},
		"Wind Shear": {
			"map menu wind": "Cisalhamento do vento",
			"layer legend A": "Cisalhamento do vento"
		},
		"Windgram": {
			"windgram tab": "Diagrama do vento"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Modelo"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "adimensional"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superfície"
		},
		"Ceiling of BL": {
			"layer legend B": "Tecto de BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Cobertura de nuvens"
		},
		"Low altitude": {
			"layer legend B": "Baixa altitude"
		},
		"High altitude": {
			"layer legend B": "Altitude alta"
		},
		"Medium altitude": {
			"layer legend B": " Altitude média"
		},
		"All altitudes": {
			"layer legend B": "Todas as altitudes"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Movimento vertical"
		},
		"mm/h": {
			"layer unit": "\n mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitações"
		},
		"1 hour": {
			"layer legend B": "1 hora"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Nível médio do mar"
		},
		"Enter a name": {
			"new favorite prompt": "Digite um nome"
		},
		"Enter the new name": {
			"new favorite prompt": "Digite o novo nome"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Reescrever favorito \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Apagar favorito \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Tem certeza que quer reinicializar tudo ?\nTODOS OS SEUS PARÂMETROS E FAVORITOS SERÃO PERMANENTEMENTE APAGADOS!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Previsões meteorológicas | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ajuda / Contacto / Sobre"
		},
		"Install now": {
			"version check": "Instalar agora"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Previsão do tempo"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente requer uma actualização"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente é agora móvel!\nPrevisões meteorológicas especialmente projetadas para vôo em parapente."
		},
		"Mobile app": "Aplicação móvel",
		"No internet connexion": "Sem conexão à internet",
		"Community": "Comunidade",
		"Day selection": "Selecção de dia",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Radiação",
		"Sun": "Sol",
		"Update": "Actualizar",
		"Wind unit": "Unidade do vento",
		"An error has occured. Please try again.": {
			"popup": "Aconteceu um erro. Por favor tente de novo."
		},
		"Click here to renew.": {
			"login popup": "Clique aqui para renovar"
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Clique no atalho no e-mail para alterar a sua palavra-passe."
		},
		"Close": {
			"popup": "Fechar",
			"general": "Fechar"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Emails diferentes ou inválidos"
		},
		"Error! Bad login or password": {
			"login popup": "Erro! nome de utilizador ou palavra-passe errada"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "\n Erro! O seu acesso expirou em %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Se você é um contribuidor irá perceber um e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Um último passo..."
		},
		"Passwords must be the same": {
			"password popup": "Palavras-passe devem ser as mesmas"
		},
		"Please log-in": {
			"login popup": "Por favor entregar"
		},
		"Private device − stay connected": {
			"login popup": "Dispositivo  privado - permanecer conectado"
		},
		"Read more…": {
			"contribute popup": "Ler mais..."
		},
		"Reset your password": {
			"password popup": "Reinicializar a sua palavra-passe"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Alguns fornecedores tais como a Orange, GMX e Hotmail às vezes bloqueiam os nossos e-mails. Se não receber nada, por favor contacte support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bem-vindo!"
		},
		"Same as device": {
			"timezone menu": "Igual ao dispositivo"
		},
		"Timezone": {
			"settings menu": "Fuso horário"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiplicador"
		},
		"Points": {
			"xc planner": "Pontos"
		},
		"Duration": {
			"xc planner": "Duracão"
		},
		"Speed": {
			"xc planner": "Velocidade"
		},
		"Close flight": {
			"xc planner": "Fechar vôo"
		},
		"Share": {
			"xc planner": "Partilhar"
		},
		"Download": {
			"xc planner": "Descarregar",
			"general": "Descarregar"
		},
		"Preferences": {
			"xc planner": "Preferências"
		},
		"Reset": {
			"xc planner": "Reinicializar",
			"general": "Reinicializar"
		},
		"About": {
			"xc planner": "Sobre"
		},
		"Exit Fullscreen": {
			"toggle menu": "Sair do ecrã completo"
		},
		"Fullscreen": {
			"toggle menu": "Ecrã completo"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner é uma funcionalidade experimental.\nEla só está disponível num computador, em meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancelar"
		},
		"Yes": {
			"general": "Sim"
		},
		"No": {
			"general": "Não"
		},
		"Save": {
			"general": "Guardar"
		},
		"Continue": {
			"general": "Continuar"
		},
		"Original version": {
			"xc planner": "Versão original"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Fortemente hackeado para trabalhar em Meteo-Parapente, com autorização do Tom. Obrigado!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Unidades de distância"
		},
		"Altitude units": {
			"xc planner": "Unidades de altitude"
		},
		"Coordinates format": {
			"xc planner": "Formato das coordenadas"
		},
		"Turnpoint details": {
			"xc planner": "Detalhe da baliza"
		},
		"Format": {
			"xc planner": "Formato"
		},
		"Route name": {
			"xc planner": "Nome da rota"
		},
		"Waypoint prefix": {
			"xc planner": "Prefixo da baliza"
		},
		"Lien": {
			"xc planner": "Atalho"
		},
		"Paste link in email or IM": {
			"xc planner": "Cole o atalho no e-mail ou IM"
		},
		"Static image": {
			"xc planner": "Imagem estática"
		},
		"Open with XCTrack": {
			"xc planner": "Abrir com o XCTrsck"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Partilhar com o LocToMe: definir como rota por omissão."
		},
		"Go to": {
			"general": "Ir para"
		},
		"Error! Please try again later": {
			"update modal": "Erro! Tente mais tarde, pf"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Pressione Reiniciar para redefinir sua rota permanentemente, pressione Cancelar para manter sua rota."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Este é o seu código de acesso. Por favor, mantenha-o seguro."
		},
		"Password:": {
			"contribute popup": "Senha:"
		},
		"Thank you!": {
			"contribute popup": "Obrigado!"
		},
		"Username:": {
			"contribute popup": "Utilizador:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Standard － %{currency} %{pricing} / mês"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Estudante－ %{currency} %{pricing} / mês"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Patrocinador － %{currency} %{pricing} / mês"
		},
		"Tour of Europe": {
			"tab": "Volta à Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Disfrute das melhores previsões todos os dias. Meteo-Parapente existe graças a si!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Participe gratis em formações meteo e reuniões entre utilizadores."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Junta-te aos contribuintes do Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Encontro mensal para discutir novas funções e melhorias."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Mete-Parapente existe graças a si!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "O meu objectivo é fornecer uma ferramenta de qualidade acessível a todos os pilotos."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Apoie o desenvolvimento de uma ferramenta de qualidade acessivel a todos os pilotos"
		},
		"and to the": {
			"startup terms": "e para o"
		},
		"By using this application, you agree to the": {
			"startup terms": "Ao utilizar a aplicação, concorda com"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Se o problema persisitir, contacte support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente não usa cookies de rastreio."
		},
		"privacy policy": {
			"startup terms": "politica de privacidade"
		},
		"terms of use": {
			"startup": "regras de utilização"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Impossivel ligar aos servidores Meteo-Parapente. Por favor, verifique a sua ligação."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dias por semana são reservados aos membros"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Já é um membro? Clique para redefinir sua senha"
		},
		"Become a member": {
			"contribute menu": "Torne-se um membro",
			"popup": "Torne-se um membro"
		},
		"Click here to learn the details": {
			"contest": "Clique aqui para saber os detalhes"
		},
		"I am already a member": {
			"popup": "Eu já sou um membro"
		},
		"Learn more": {
			"contest": "Saiba mais"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "O Meteo-Parapente celebra o seu 10º aniversário."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Ainda não é um membro? Clique para obter um código de acesso"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Nesta ocasião, estamos a organizar um concurso excepcional"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Um vencedor será sorteado de todos aqueles que compraram ou renovaram uma assinatura entre setembro passado e 30 de março próximo."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Para ser ganho: A ALA PARAPENTE DA SUA ESCOLHA!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Para ver %{ date }, por favor faça o login ou torne-se membro."
		},
		"Win a paraglider!": {
			"contribute menu": "Ganhe um parapente!"
		}
	},
	"ro": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Zbor cu parapanta"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Adaugă nou... "
		},
		"Airspace": {
			"toggle menu": "Spațiu aerian"
		},
		"All": {
			"map menu humidity": "Tot"
		},
		"B. layer": {
			"map menu updrafts": "Strat convectiv"
		},
		"B. Layer": {
			"map menu wind": "Strat convectiv"
		},
		"Boundary layer": {
			"map menu wind": "Strat convectiv"
		},
		"Boundary Layer": {
			"map menu updrafts": "Strat convectiv",
			"layer legend A": "Strat convectiv",
			"layer legend B": "Strat convectiv"
		},
		"Ceiling": {
			"map menu updrafts": "Plafon",
			"layer legend B": "Plafon"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Plafon strat convectiv"
		},
		"Change password": {
			"settings menu": "Schimbare parolă"
		},
		"Clouds": {
			"map menu humidity": "Nori"
		},
		"Color blind": {
			"settings menu": "Daltonism"
		},
		"debug": {
			"settings menu": "Depanare"
		},
		"Delete": {
			"favorites menu": "Șterge"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Funcții experimentale"
		},
		"Favorites": {
			"menu title": "Preferate"
		},
		"Ground": {
			"map menu wind": "Sol",
			"map menu temperature": "Sol"
		},
		"Help us translate!": {
			"settings menu": "Ajutați-ne să traducem!"
		},
		"High": {
			"map menu humidity": "Înalt"
		},
		"Humidity": {
			"map menu humidity": "Umiditate"
		},
		"Interpolation": {
			"toggle menu": "Interpolare"
		},
		"Language": {
			"settings menu": "Limba"
		},
		"Login": {
			"login menu": "Login"
		},
		"Logout": {
			"settings menu": "Logout"
		},
		"Low": {
			"map menu humidity": "Jos"
		},
		"Medium": {
			"map menu humidity": "Mediu"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapantă"
		},
		"Move to top": {
			"favorites menu": "Intoarce-ți-vă sus"
		},
		"News": {
			"news menu": "Știri"
		},
		"News!": {
			"news menu": "Știri!"
		},
		"No data for this place": {
			"windgram view": "Nu sunt date pt. această locație"
		},
		"Open": {
			"favorites menu": "Deschide"
		},
		"Pressure": {
			"map menu wind": "Presiune",
			"layer legend A": "Presiune"
		},
		"Rain": {
			"map menu humidity": "Ploaie"
		},
		"Rename": {
			"favorites menu": "Redenumiți"
		},
		"Reset all settings": {
			"settings menu": "Resetați toate reglajele"
		},
		"Sea level": {
			"map menu wind": "Nivelul mării"
		},
		"Set as homepage": {
			"favorites menu": "Setați ca Acasă"
		},
		"Settings": {
			"settings menu": "Setări"
		},
		"Shearing": {
			"map menu updrafts": "Forfecare",
			"layer legend B": "Forfecare"
		},
		"Sounding": {
			"windgram tab": "Gradient termic"
		},
		"Temperature": {
			"map menu temperature": "Temperatură",
			"layer legend A": "Temperatură"
		},
		"Thermals": {
			"map menu updrafts": "Ascendențe termice",
			"layer legend A": "Ascendențe termice"
		},
		"Thickness": {
			"map menu updrafts": "Grosime",
			"layer legend B": "Grosime"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendențe"
		},
		"Velocity": {
			"map menu updrafts": "Viteză",
			"layer legend B": "Viteza"
		},
		"Vertical motion": {
			"map menu updrafts": "Mișcare verticală",
			"": "Mișcare verticală "
		},
		"Wind": {
			"map menu wind": "Vânt",
			"layer legend A": "Vânt"
		},
		"Wind Shear": {
			"map menu wind": "Vânt de forfecare",
			"layer legend A": "Vânt de forfecare"
		},
		"Windgram": {
			"windgram tab": "Grafic vânt"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "adimensional"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Suprafață"
		},
		"Ceiling of BL": {
			"layer legend B": "Plafon Strat Conv. "
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Acoperire nori"
		},
		"Low altitude": {
			"layer legend B": "Altitudine joasă"
		},
		"High altitude": {
			"layer legend B": "Altitudine înaltă"
		},
		"Medium altitude": {
			"layer legend B": "Altitudine medie"
		},
		"All altitudes": {
			"layer legend B": "Toate altitudinile"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Mișcare verticală"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitații"
		},
		"1 hour": {
			"layer legend B": "1 oră"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Deasupra Nivelului Mării"
		},
		"Enter a name": {
			"new favorite prompt": "Introduceți un nume"
		},
		"Enter the new name": {
			"new favorite prompt": "Introduceți un nou nume"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Rescrieți preferat \"%{ nume }\"? "
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Ștergeți preferat \"%{ nume }\"? "
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Sunteți sigur ca vreți sa resetați tot?\nTOATE SETĂRILE DUMNEAVOASTRĂ ȘI PREFERATELE VOR FI ȘTERSE PERMANENT! "
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Predicții meteo pentru zbor liber | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ajutor / Contactați-ne / Despre"
		},
		"Install now": {
			"version check": "Instalați acum"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Predicții Meteo Zbor liber"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente necesită actualizare."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente este acum mobil! Predicții meteo pentru zbor liber. "
		},
		"Mobile app": "Mobile app",
		"No internet connexion": "Fără conexiune la internet",
		"Community": "Comunitate",
		"Day selection": "Selectați ziua",
		"knots": "noduri",
		"mph": "mph",
		"Radiation": "Radiație",
		"Sun": "Soare",
		"Update": "Actualizare",
		"Wind unit": "Unitate vânt",
		"An error has occured. Please try again.": {
			"popup": "A apărut o eroare. Vă rugăm reîncărcați. "
		},
		"Click here to renew.": {
			"login popup": "Click pentru reînnoire. "
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Click per link-ul din e-mail pentru a va schimba parola. "
		},
		"Close": {
			"popup": "Închide",
			"general": "Închideți"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-mailurile nu coincid sau invalide. "
		},
		"Error! Bad login or password": {
			"login popup": "Eroare! Nume utilizator sau parola greșite. "
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Eroare! Accesul dumneavoastră a expirat în %{ expirationDate }. "
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Dacă sunteți contribuitor, o sa primiți un mail. "
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Ultimul pas... "
		},
		"Passwords must be the same": {
			"password popup": "Parola trebuie sa fie aceeași "
		},
		"Please log-in": {
			"login popup": "Va rugam sa va autentificați "
		},
		"Private device − stay connected": {
			"login popup": "Dispozitiv privat - rămâneți conectat"
		},
		"Read more…": {
			"contribute popup": "Citiți mai multe... "
		},
		"Reset your password": {
			"password popup": "Resetați parola"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Câțiva furnizori (gmail, yahoo, etc) câteodată blochează E-mailurile. Dacă nu primiți nimic contactați support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bine ați venit! "
		},
		"Same as device": {
			"timezone menu": "La fel ca dispozitivul"
		},
		"Timezone": {
			"settings menu": "Fus orar"
		},
		"XC Planner": {
			"toggle menu": "Planificator XC"
		},
		"Multiplier": {
			"xc planner": "Coeficient "
		},
		"Points": {
			"xc planner": "Puncte"
		},
		"Duration": {
			"xc planner": "Durată"
		},
		"Speed": {
			"xc planner": "Viteză "
		},
		"Close flight": {
			"xc planner": "Închideți zbor"
		},
		"Share": {
			"xc planner": "Împărtășiți "
		},
		"Download": {
			"xc planner": "Descărcați ",
			"general": "Descărcați"
		},
		"Preferences": {
			"xc planner": "Preferințe "
		},
		"Reset": {
			"xc planner": "Resetați ",
			"general": "Reset"
		},
		"About": {
			"xc planner": "Despre"
		},
		"Exit Fullscreen": {
			"toggle menu": "Ieșiți din ecran complet"
		},
		"Fullscreen": {
			"toggle menu": "Ecran complet"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planer este o funcție experimentală. Este disponibilă doar pe PC pe meteo-Parapente.com"
		},
		"Cancel": {
			"general": "Anulați"
		},
		"Yes": {
			"general": "Da"
		},
		"No": {
			"general": "Nu"
		},
		"Save": {
			"general": "Salvați"
		},
		"Continue": {
			"general": "Continuați"
		},
		"Original version": {
			"xc planner": "Versiune originală"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!"
		},
		"League": {
			"xc planner": "Ligă"
		},
		"Distance units": {
			"xc planner": "Unități distanță"
		},
		"Altitude units": {
			"xc planner": "Unități altitudine"
		},
		"Coordinates format": {
			"xc planner": "Format coordinate"
		},
		"Turnpoint details": {
			"xc planner": "Detalii punct de trecere"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nume rută "
		},
		"Waypoint prefix": {
			"xc planner": "Prefix pct trecere"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Lipiți link-ul în email sai IM"
		},
		"Static image": {
			"xc planner": "Imagine statica"
		},
		"Open with XCTrack": {
			"xc planner": "Deschideți cu XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Distribuiti cu LocToMe: setați ca rută implicită"
		},
		"Go to": {
			"general": "Mergeți la"
		},
		"Error! Please try again later": {
			"update modal": "Eroare! Vă rugăm încercați mai târziu. "
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Apăsați Reset pentru a reseta permanent ruta dv., apăsați Anulați ca să păstrați ruta dv. "
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Iată codul de acces. Vă rugăm să îl păstrați în siguranță."
		},
		"Password:": {
			"contribute popup": "Parola:"
		},
		"Thank you!": {
			"contribute popup": "Vă mulțumesc!"
		},
		"Username:": {
			"contribute popup": "Nume de utilizator:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 luni Standard - %{currency} %{pricing} / lună"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 luni Student - %{currency} %{pricing} / lună"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 luni Supporter - %{currency} %{pricing} / lună"
		},
		"Tour of Europe": {
			"tab": "Turul Europei"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Bucurați-vă de cele mai bune prognoze în fiecare zi. Meteo-Parapente poate exista datorită dumneavoastră!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Obțineți acces gratuit la cursuri de formare și întâlniri ale utilizatorilor de vreme locală."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Înscrieți-vă în clubul contribuitorilor Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Întâlniți-vă cu mine o dată pe lună pentru a discuta despre noile caracteristici și îmbunătățiri."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente poate exista datorită vouă!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Scopul meu este de a oferi un instrument de calitate accesibil tuturor piloților."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Sprijinirea dezvoltării unui instrument de calitate accesibil tuturor piloților."
		},
		"and to the": {
			"startup terms": "și la"
		},
		"By using this application, you agree to the": {
			"startup terms": "Prin utilizarea acestei aplicații, sunteți de acord cu"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Dacă problema persistă, contactați support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente nu utilizează cookie-uri de urmărire"
		},
		"privacy policy": {
			"startup terms": "politica de confidențialitate"
		},
		"terms of use": {
			"startup": "termeni de utilizare"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nu se poate ajunge la serverele Meteo-Parapente. Vă rugăm să vă verificați conexiunea."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 zile pe săptămână sunt rezervate membrilor"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Sunteți deja membru? Faceți clic pentru a vă reseta parola"
		},
		"Become a member": {
			"contribute menu": "Deveniți membru",
			"popup": "Deveniți membru"
		},
		"Click here to learn the details": {
			"contest": "Click aici pentru a afla detalii"
		},
		"I am already a member": {
			"popup": "Sunt deja membru"
		},
		"Learn more": {
			"contest": "Aflați mai multe"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente sărbătorește a 10-a aniversare."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Nu sunteți încă membru? Faceți clic pentru a obține un cod de acces"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Cu această ocazie, organizăm un concurs de excepție"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Se va extrage un câștigător dintre toți cei care au cumpărat sau reînnoit un abonament între septembrie și 30 martie anul viitor."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Pentru a fi câștigat: ARIPA DE PARAPANTĂ LA ALEGERE!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Pentru a vedea %{ date }, vă rugăm să vă conectați sau să deveniți membru."
		},
		"Win a paraglider!": {
			"contribute menu": "Câștigă un parapantă!"
		}
	},
	"ru": {
		"(Kitesurf)": {
			"search result": "(Кайтсерфинг)"
		},
		"(Paragliding)": {
			"search result": "(Парапланеризм)"
		},
		"1h": {
			"map menu humidity": "1ч"
		},
		"Add new…": {
			"favorites menu": "Добавить новый..."
		},
		"Airspace": {
			"toggle menu": "Воздушное пространство"
		},
		"All": {
			"map menu humidity": "Все"
		},
		"B. layer": {
			"map menu updrafts": "Слой"
		},
		"B. Layer": {
			"map menu wind": "Слой"
		},
		"Boundary layer": {
			"map menu wind": "Пограничный слой"
		},
		"Boundary Layer": {
			"map menu updrafts": "Пограничный слой",
			"layer legend A": "Пограничный слой",
			"layer legend B": "Пограничный слой"
		},
		"Ceiling": {
			"map menu updrafts": "Потолок",
			"layer legend B": "Потолок"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Потолок слоя b."
		},
		"Change password": {
			"settings menu": "Сменить пароль"
		},
		"Clouds": {
			"map menu humidity": "Облака"
		},
		"Color blind": {
			"settings menu": "Дальтоник"
		},
		"debug": {
			"settings menu": "отладка"
		},
		"Delete": {
			"favorites menu": "Удалить"
		},
		"experimental": {
			"settings menu": "экспериментальный"
		},
		"Experimental features": {
			"settings menu": "Экспериментальные характеристики"
		},
		"Favorites": {
			"menu title": "Избранное"
		},
		"Ground": {
			"map menu wind": "Земля",
			"map menu temperature": "Земля"
		},
		"Help us translate!": {
			"settings menu": "Помогите с переводом"
		},
		"High": {
			"map menu humidity": "Высокий"
		},
		"Humidity": {
			"map menu humidity": "Влажность"
		},
		"Interpolation": {
			"toggle menu": "Интерполяция"
		},
		"Language": {
			"settings menu": "Язык"
		},
		"Login": {
			"login menu": "Войти"
		},
		"Logout": {
			"settings menu": "Выйти"
		},
		"Low": {
			"map menu humidity": "Низкий"
		},
		"Medium": {
			"map menu humidity": "Средний"
		},
		"Meteo Parapente": {
			"menu title": "Метеопарапенте"
		},
		"Move to top": {
			"favorites menu": "Наверх"
		},
		"News": {
			"news menu": "Новости"
		},
		"News!": {
			"news menu": "Новости!"
		},
		"No data for this place": {
			"windgram view": "Нет данных для этой местности"
		},
		"Open": {
			"favorites menu": "Открыть"
		},
		"Pressure": {
			"map menu wind": "Давление",
			"layer legend A": "Давление"
		},
		"Rain": {
			"map menu humidity": "Дождь"
		},
		"Rename": {
			"favorites menu": "Переименовать"
		},
		"Reset all settings": {
			"settings menu": "Сброс всех настроек"
		},
		"Sea level": {
			"map menu wind": "Уровень моря"
		},
		"Set as homepage": {
			"favorites menu": "Установить в качестве домашней страницы"
		},
		"Settings": {
			"settings menu": "Настройки"
		},
		"Shearing": {
			"map menu updrafts": "Стрижка",
			"layer legend B": "Сдвиг"
		},
		"Sounding": {
			"windgram tab": "Аэрологическая диаграмма"
		},
		"Temperature": {
			"map menu temperature": "Температура",
			"layer legend A": "Температура"
		},
		"Thermals": {
			"map menu updrafts": "Восходящие потоки",
			"layer legend A": "Восходящие потоки"
		},
		"Thickness": {
			"map menu updrafts": "Толщина",
			"layer legend B": "Толщина"
		},
		"Updrafts": {
			"map menu updrafts": "Апдрафт"
		},
		"Velocity": {
			"map menu updrafts": "Скорость",
			"layer legend B": "Скорость"
		},
		"Vertical motion": {
			"map menu updrafts": "Вертикальное движение",
			"": "Вертикальное движение"
		},
		"Wind": {
			"map menu wind": "Ветер",
			"layer legend A": "Ветер"
		},
		"Wind Shear": {
			"map menu wind": "сдвиг ветра",
			"layer legend A": "Сдвиг ветра"
		},
		"Windgram": {
			"windgram tab": "График ветра"
		},
		"m MSL": {
			"layer unit": "м MSL"
		},
		"m AGL": {
			"layer unit": "м AGL"
		},
		"Topography": {
			"layer legend A": "Топография"
		},
		"Model": {
			"layer legend B": "Модель"
		},
		"m/s": {
			"layer unit": "м/с",
			"": "м/с"
		},
		"dimensionless": {
			"layer unit": "безразмерный"
		},
		"km/h": {
			"layer unit": "км/ч",
			"": "км/ч"
		},
		"Surface": {
			"layer legend B": "Поверхность"
		},
		"Ceiling of BL": {
			"layer legend B": "Потолок BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Облачность"
		},
		"Low altitude": {
			"layer legend B": "Малая высота"
		},
		"High altitude": {
			"layer legend B": "Большая высота"
		},
		"Medium altitude": {
			"layer legend B": "Средняя высота"
		},
		"All altitudes": {
			"layer legend B": "Все высоты"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2м AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Вертикальное движение"
		},
		"mm/h": {
			"layer unit": "мм/ч"
		},
		"Precipitations": {
			"layer legend A": "Осадки"
		},
		"1 hour": {
			"layer legend B": "1 час"
		},
		"hPa": {
			"layer unit": "гПа"
		},
		"Mean Sea Level": {
			"layer legend B": "Уровень моря"
		},
		"Enter a name": {
			"new favorite prompt": "Введите имя"
		},
		"Enter the new name": {
			"new favorite prompt": "Введите новое имя"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Перезаписать \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Удалить \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Вы уверены, что хотите сбросить все настройки?\nВСЕ ВАШИ НАСТРОЙКИ И ИЗБРАННОЕ БУДЕТ ПОТЕРЯНО НАВСЕГДА"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Парящие прогнозы погоды | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Помощь / Контакты / О сайте"
		},
		"Install now": {
			"version check": "Установить"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Повышение прогнозов погоды"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente требует обновления."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente теперь в мобильном!\nПрогнозы парящей погоды, специально разработанные для полетов и парапланеризма."
		},
		"Mobile app": "Мобильное приложение",
		"No internet connexion": "Отсутствие подключения к Интернету",
		"Community": "Сообщество",
		"Day selection": "Выбор дня",
		"knots": "узлы",
		"mph": "mph",
		"Radiation": "Излучение",
		"Sun": "Солнце",
		"Update": "Обновление",
		"Wind unit": "Единица скорости ветра",
		"An error has occured. Please try again.": {
			"popup": "Произошла ошибка. Пожалуйста, попробуйте еще раз."
		},
		"Click here to renew.": {
			"login popup": "Нажмите здесь, чтобы продлить."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Нажмите на ссылку в письме, чтобы изменить пароль."
		},
		"Close": {
			"popup": "Закрыть",
			"general": "Закрыть"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Электронные письма не одинаковы и недействительны"
		},
		"Error! Bad login or password": {
			"login popup": "Ошибка! Плохой логин или пароль"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Ошибка! Ваш доступ истек в %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Если вы являетесь вкладчиком, вы получите электронное письмо."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Последний шаг..."
		},
		"Passwords must be the same": {
			"password popup": "Пароли должны быть одинаковыми"
		},
		"Please log-in": {
			"login popup": "Пожалуйста, войдите в систему"
		},
		"Private device − stay connected": {
			"login popup": "Личное устройство - оставайтесь на связи"
		},
		"Read more…": {
			"contribute popup": "Читать далее..."
		},
		"Reset your password": {
			"password popup": "Сброс пароля"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Некоторые провайдеры, такие как Orange, GMX и Hotmail, иногда блокируют нашу электронную почту. Если вы ничего не получаете, пожалуйста, свяжитесь с support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Добро пожаловать!"
		},
		"Same as device": {
			"timezone menu": "То же, что и устройство"
		},
		"Timezone": {
			"settings menu": "Часовой пояс"
		},
		"XC Planner": {
			"toggle menu": "Планировщик XC"
		},
		"Multiplier": {
			"xc planner": "Множитель"
		},
		"Points": {
			"xc planner": "Баллы"
		},
		"Duration": {
			"xc planner": "Продолжительность"
		},
		"Speed": {
			"xc planner": "Скорость"
		},
		"Close flight": {
			"xc planner": "Близкий полет"
		},
		"Share": {
			"xc planner": "Поделиться"
		},
		"Download": {
			"xc planner": "Скачать",
			"general": "Скачать"
		},
		"Preferences": {
			"xc planner": "Предпочтения"
		},
		"Reset": {
			"xc planner": "Сброс",
			"general": "Сброс"
		},
		"About": {
			"xc planner": "О сайте"
		},
		"Exit Fullscreen": {
			"toggle menu": "Выход из полноэкранного режима"
		},
		"Fullscreen": {
			"toggle menu": "Полный экран"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner - это экспериментальная функция.\nОна доступна только с компьютера, на сайте meteo-parapente.com"
		},
		"Cancel": {
			"general": "Отмена"
		},
		"Yes": {
			"general": "Да"
		},
		"No": {
			"general": "Нет"
		},
		"Save": {
			"general": "Сохранить"
		},
		"Continue": {
			"general": "Продолжить"
		},
		"Original version": {
			"xc planner": "Оригинальная версия"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Сильно взломан для работы в Meteo-Parapente, с разрешения Тома. Спасибо!"
		},
		"League": {
			"xc planner": "Лига"
		},
		"Distance units": {
			"xc planner": "Единицы измерения расстояния"
		},
		"Altitude units": {
			"xc planner": "Единицы измерения высоты"
		},
		"Coordinates format": {
			"xc planner": "Формат координат"
		},
		"Turnpoint details": {
			"xc planner": "Детали поворотного пункта"
		},
		"Format": {
			"xc planner": "Формат"
		},
		"Route name": {
			"xc planner": "Название маршрута"
		},
		"Waypoint prefix": {
			"xc planner": "Префикс путевой точки"
		},
		"Lien": {
			"xc planner": "Ссылка"
		},
		"Paste link in email or IM": {
			"xc planner": "Вставьте ссылку в сообщение электронной почты или IM"
		},
		"Static image": {
			"xc planner": "Статичное изображение"
		},
		"Open with XCTrack": {
			"xc planner": "Открыть с помощью XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Совместное использование с LocToMe: установить в качестве маршрута по умолчанию"
		},
		"Go to": {
			"general": "Перейти к"
		},
		"Error! Please try again later": {
			"update modal": "Ошибка! Пожалуйста, повторите попытку позже"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Нажмите Сброс, чтобы навсегда сбросить маршрут, нажмите Отмена, чтобы сохранить маршрут."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Здесь находится ваш код доступа. Пожалуйста, храните его в безопасности."
		},
		"Password:": {
			"contribute popup": "Пароль:"
		},
		"Thank you!": {
			"contribute popup": "Спасибо!"
		},
		"Username:": {
			"contribute popup": "Имя пользователя:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 месяцев Стандарт - %{currency} %{pricing} / месяц"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 месяцев Студент - %{currency} %{pricing} / месяц"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 месяцев Сторонник - %{currency} %{pricing} / месяц"
		},
		"Tour of Europe": {
			"tab": "Тур по Европе"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Наслаждайтесь лучшими прогнозами каждый день. Meteo-Parapente может существовать благодаря вам!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Получите бесплатный вход на тренинги по местной погоде и встречи пользователей."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Вступить в клуб вкладчиков Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Встречайтесь со мной раз в месяц для обсуждения новых функций и улучшений."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente может существовать благодаря вам!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Моя цель - предоставить качественный инструмент, доступный каждому пилоту."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Поддержите разработку инструмента качества, доступного каждому пилоту."
		},
		"and to the": {
			"startup terms": "и к"
		},
		"By using this application, you agree to the": {
			"startup terms": "Используя данное приложение, вы соглашаетесь с"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Если проблема сохраняется, обратитесь по адресу support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente не использует отслеживающие файлы cookie"
		},
		"privacy policy": {
			"startup terms": "политика конфиденциальности"
		},
		"terms of use": {
			"startup": "условия использования"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Невозможно связаться с серверами Meteo-Parapente. Пожалуйста, проверьте ваше соединение."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 дня в неделю зарезервированы для членов клуба"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Уже зарегистрированы? Нажмите, чтобы сбросить пароль"
		},
		"Become a member": {
			"contribute menu": "Стать участником",
			"popup": "Стать участником"
		},
		"Click here to learn the details": {
			"contest": "Нажмите здесь, чтобы узнать подробности"
		},
		"I am already a member": {
			"popup": "Я уже являюсь членом клуба"
		},
		"Learn more": {
			"contest": "Узнать больше"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente празднует 10-летний юбилей."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Еще не зарегистрированы? Нажмите, чтобы получить код доступа"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "По этому случаю мы организуем исключительный конкурс"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Один победитель будет выбран из числа тех, кто приобрел или продлил подписку в период с сентября прошлого года по 30 марта следующего года."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Выиграть можно: КРЫЛО ДЛЯ ПАРАПЛАНА НА ВАШ ВЫБОР!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Чтобы увидеть %{ date }, пожалуйста, войдите в систему или станьте участником."
		},
		"Win a paraglider!": {
			"contribute menu": "Выиграйте параплан!"
		}
	},
	"sl": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Padalstvo"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Dodaj..."
		},
		"Airspace": {
			"toggle menu": "Zračni prostor"
		},
		"All": {
			"map menu humidity": "Vse"
		},
		"B. layer": {
			"map menu updrafts": "B. plast"
		},
		"B. Layer": {
			"map menu wind": "B. plast"
		},
		"Boundary layer": {
			"map menu wind": "Spodnja plast"
		},
		"Boundary Layer": {
			"map menu updrafts": "Spodnja plast",
			"layer legend A": "Mejna plast",
			"layer legend B": "Spodnja meja"
		},
		"Ceiling": {
			"map menu updrafts": "Strop",
			"layer legend B": "Strop"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Zgornja meja"
		},
		"Change password": {
			"settings menu": "Spremeni geslo"
		},
		"Clouds": {
			"map menu humidity": "Oblaki"
		},
		"Color blind": {
			"settings menu": "Barvno slep"
		},
		"debug": {
			"settings menu": "Hrošč"
		},
		"Delete": {
			"favorites menu": "Izbriši"
		},
		"experimental": {
			"settings menu": "eksperimentalno"
		},
		"Experimental features": {
			"settings menu": "eksperiment. lastnost"
		},
		"Favorites": {
			"menu title": "Priljubljene"
		},
		"Ground": {
			"map menu wind": "Tla",
			"map menu temperature": "Zemlja"
		},
		"Help us translate!": {
			"settings menu": "Pomagaj nam prevajati!"
		},
		"High": {
			"map menu humidity": "Visok"
		},
		"Humidity": {
			"map menu humidity": "Vlaga"
		},
		"Interpolation": {
			"toggle menu": "Inverzija"
		},
		"Language": {
			"settings menu": "Jezik"
		},
		"Login": {
			"login menu": "Vpis"
		},
		"Logout": {
			"settings menu": "Izpis"
		},
		"Low": {
			"map menu humidity": "Nizko"
		},
		"Medium": {
			"map menu humidity": "Srednje"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Premakni na vrh"
		},
		"News": {
			"news menu": "Novice"
		},
		"News!": {
			"news menu": "Novice!"
		},
		"No data for this place": {
			"windgram view": "Ni podatkov za ta prostor"
		},
		"Open": {
			"favorites menu": "Odpri"
		},
		"Pressure": {
			"map menu wind": "Pritisk",
			"layer legend A": "Tlak"
		},
		"Rain": {
			"map menu humidity": "Dež"
		},
		"Rename": {
			"favorites menu": "Preimenuj"
		},
		"Reset all settings": {
			"settings menu": "Resetiraj natavitve"
		},
		"Sea level": {
			"map menu wind": "Gladina morja"
		},
		"Set as homepage": {
			"favorites menu": "Nastavi kot domačo stran"
		},
		"Settings": {
			"settings menu": "Nastavitve"
		},
		"Shearing": {
			"map menu updrafts": "Deljenje",
			"layer legend B": "Deljenje"
		},
		"Sounding": {
			"windgram tab": "Oglasitev"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termika",
			"layer legend A": "Termika"
		},
		"Thickness": {
			"map menu updrafts": "Debelina",
			"layer legend B": "Debelina"
		},
		"Updrafts": {
			"map menu updrafts": "Posodobitve"
		},
		"Velocity": {
			"map menu updrafts": "Hitrost",
			"layer legend B": "Hitrost"
		},
		"Vertical motion": {
			"map menu updrafts": "Dviganje",
			"": "Navpično gibanje"
		},
		"Wind": {
			"map menu wind": "Veter",
			"layer legend A": "Veter"
		},
		"Wind Shear": {
			"map menu wind": "Rotor",
			"layer legend A": "Rotor"
		},
		"Windgram": {
			"windgram tab": "Prikaz"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografija"
		},
		"Model": {
			"layer legend B": "Shema"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Dimenziranje"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Površina"
		},
		"Ceiling of BL": {
			"layer legend B": "Strop od BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Pokritos z oblaki"
		},
		"Low altitude": {
			"layer legend B": "Nizko"
		},
		"High altitude": {
			"layer legend B": "Visoko"
		},
		"Medium altitude": {
			"layer legend B": "Srednja višina"
		},
		"All altitudes": {
			"layer legend B": "Vse višine"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m nad tlemi"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikalno gibanje"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Padavine"
		},
		"1 hour": {
			"layer legend B": "1 uro"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Povprečna gladina morja"
		},
		"Enter a name": {
			"new favorite prompt": "Poimenuj"
		},
		"Enter the new name": {
			"new favorite prompt": "Poimenuj z novim imenom"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Prepiši najljubše ime?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Izbriši najljubše ime?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Ste prepričani, da želite ponastaviti vse?\nVSE VAŠE NASTAVITVE IN PRILJUBLJENI BODO IZBRANI!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Hitrejše vremenske napovedi | \nMeteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Pomoč"
		},
		"Install now": {
			"version check": "Naloži"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Hitrejše vremenske napovedi"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente zahteva posodobitev"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente je sedaj mobilna!\nHitrejše vremenske napovedi, posebej zasnovane za letenje in jadralno padalstvo."
		},
		"Mobile app": "Mobilna aplikacija",
		"No internet connexion": "Brez internetne povezave",
		"Community": "Skupnost",
		"Day selection": "Izberi dan",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Sevanje",
		"Sun": "Sonce",
		"Update": "Posodobitev",
		"Wind unit": "Moč vetra",
		"An error has occured. Please try again.": {
			"popup": "Zgodila se je napaka. Poskusite znova."
		},
		"Click here to renew.": {
			"login popup": "Kliknite tukaj za obnovitev"
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kliknite povezavo znotraj e-poštnega naslova, da spremenite geslo."
		},
		"Close": {
			"popup": "Zapri",
			"general": "Zapri"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-naslov se ne ujema ali je napačn"
		},
		"Error! Bad login or password": {
			"login popup": "Nepravilno ime ali geslo!"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Napaka! Potekla vam je možnost dostopa. "
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Če ste uporabnik, boste prejeli e-pošto. "
		},
		"OK": {
			"popup": "OK",
			"general": "V REDU"
		},
		"One last step...": {
			"password popup": "Zadnji korak ..."
		},
		"Passwords must be the same": {
			"password popup": "Gesla morajo biti ista. "
		},
		"Please log-in": {
			"login popup": "Prijavite se"
		},
		"Private device − stay connected": {
			"login popup": "Zasebna naprava-ostanite povezani. "
		},
		"Read more…": {
			"contribute popup": "Preberi več"
		},
		"Reset your password": {
			"password popup": "Obnovi geslo"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Nekateri ponudniki, kot so Orange, GMX in Hotmail, včasih blokirajo naša e-poštna sporočila. Če ne boste prejeli ničesar, se obrnite na podporo @ meteo & # paramount"
		},
		"Welcome!": {
			"login popup": "Dobrodošli"
		},
		"Same as device": {
			"timezone menu": "Enako kot naprava"
		},
		"Timezone": {
			"settings menu": "Časovni pas"
		},
		"XC Planner": {
			"toggle menu": "Načrtovalec XC"
		},
		"Multiplier": {
			"xc planner": "Multiplikator"
		},
		"Points": {
			"xc planner": "Točke"
		},
		"Duration": {
			"xc planner": "Trajanje"
		},
		"Speed": {
			"xc planner": "Hitrost"
		},
		"Close flight": {
			"xc planner": "Bližnji let"
		},
		"Share": {
			"xc planner": "Delite"
		},
		"Download": {
			"xc planner": "Prenesi",
			"general": "Prenesi"
		},
		"Preferences": {
			"xc planner": "Nastavitve"
		},
		"Reset": {
			"xc planner": "Ponastavitev",
			"general": "Ponastavitev"
		},
		"About": {
			"xc planner": "O"
		},
		"Exit Fullscreen": {
			"toggle menu": "Izhod za celozaslonsko prikazovanje"
		},
		"Fullscreen": {
			"toggle menu": "Celozaslonski zaslon"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Načrtovalnik XC je eksperimentalna funkcija.\nNa voljo je samo z računalnika na spletni strani meteo-parapente.com."
		},
		"Cancel": {
			"general": "Prekliči"
		},
		"Yes": {
			"general": "Da"
		},
		"No": {
			"general": "Ne"
		},
		"Save": {
			"general": "Shrani"
		},
		"Continue": {
			"general": "Nadaljuj"
		},
		"Original version": {
			"xc planner": "Izvirna različica"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "S Tomovim dovoljenjem je bil močno spremenjen, da deluje v Meteo-Parapente. Hvala!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Enote razdalje"
		},
		"Altitude units": {
			"xc planner": "Enote nadmorske višine"
		},
		"Coordinates format": {
			"xc planner": "Oblika koordinat"
		},
		"Turnpoint details": {
			"xc planner": "Podrobnosti o točki obrata"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Ime poti"
		},
		"Waypoint prefix": {
			"xc planner": "Predpona točke poti"
		},
		"Lien": {
			"xc planner": "Povezava"
		},
		"Paste link in email or IM": {
			"xc planner": "Prilepite povezavo v e-pošto ali IM"
		},
		"Static image": {
			"xc planner": "Statična slika"
		},
		"Open with XCTrack": {
			"xc planner": "Odprite s programom XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Skupna raba z LocToMe: nastavite kot privzeto pot"
		},
		"Go to": {
			"general": "Pojdi na"
		},
		"Error! Please try again later": {
			"update modal": "Napaka! Prosimo, poskusite znova pozneje"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Pritisnite Ponastavi, če želite trajno ponastaviti svojo pot, pritisnite Prekliči, če želite ohraniti svojo pot."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Tukaj je vaša koda za dostop. Prosimo, da jo varno shranite."
		},
		"Password:": {
			"contribute popup": "Geslo:"
		},
		"Thank you!": {
			"contribute popup": "Hvala!"
		},
		"Username:": {
			"contribute popup": "Uporabniško ime:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesecev Standard - %{currency} %{pricing} / mesec"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesecev Študent - %{currency} %{pricing} / mesec"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesecev Podpornik - %{currency} %{pricing} / mesec"
		},
		"Tour of Europe": {
			"tab": "Turneja po Evropi"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Vsak dan uživajte v najboljših napovedih. Meteo-Parapente lahko obstaja zaradi vas!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Pridobite brezplačen vstop na lokalna vremenska usposabljanja in srečanja uporabnikov."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Pridružite se klubu sodelavcev Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Enkrat na mesec se srečamo in se pogovorimo o novih funkcijah in izboljšavah."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente lahko obstaja po vaši zaslugi!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Moj cilj je zagotoviti kakovostno orodje, ki bo dostopno vsem pilotom."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Podprite razvoj orodja kakovosti, ki bo na voljo vsem pilotom."
		},
		"and to the": {
			"startup terms": "in na"
		},
		"By using this application, you agree to the": {
			"startup terms": "Z uporabo te aplikacije se strinjate z"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Če se težava nadaljuje, se obrnite na support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente ne uporablja piškotkov za sledenje"
		},
		"privacy policy": {
			"startup terms": "politika zasebnosti"
		},
		"terms of use": {
			"startup": "pogoji uporabe"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Ni mogoče doseči strežnikov Meteo-Parapente. Preverite povezavo."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dneva na teden sta rezervirana za člane"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Ste že član? Kliknite za ponastavitev gesla"
		},
		"Become a member": {
			"contribute menu": "Postanite član",
			"popup": "Postanite član"
		},
		"Click here to learn the details": {
			"contest": "Kliknite tukaj in se seznanite s podrobnostmi"
		},
		"I am already a member": {
			"popup": "Že sem član"
		},
		"Learn more": {
			"contest": "Preberite več"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente praznuje 10. obletnico delovanja."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Še niste član? Kliknite in pridobite kodo za dostop"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Ob tej priložnosti organiziramo izjemno tekmovanje"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Izmed vseh, ki so med lanskim septembrom in 30. marcem kupili ali podaljšali naročnino, bomo izžrebali enega zmagovalca."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Za zmago: KRILO JADRALNEGA PADALA PO LASTNI IZBIRI!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Če si želite ogledati %{ date }, se prijavite ali postanite član."
		},
		"Win a paraglider!": {
			"contribute menu": "Osvojite jadralno padalo!"
		}
	},
	"zh-hk": {
		"(Kitesurf)": {
			"search result": "(風箏滑水)"
		},
		"(Paragliding)": {
			"search result": "(滑翔傘)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "新增..."
		},
		"Airspace": {
			"toggle menu": "空域"
		},
		"All": {
			"map menu humidity": "所有"
		},
		"B. layer": {
			"map menu updrafts": "邊界層"
		},
		"B. Layer": {
			"map menu wind": "邊界層"
		},
		"Boundary layer": {
			"map menu wind": "邊界層"
		},
		"Boundary Layer": {
			"map menu updrafts": "邊界層",
			"layer legend A": "邊界層",
			"layer legend B": "邊界層"
		},
		"Ceiling": {
			"map menu updrafts": "頂部",
			"layer legend B": "頂部"
		},
		"Ceiling of b. layer": {
			"map menu wind": "邊界層頂部"
		},
		"Change password": {
			"settings menu": "更改密碼"
		},
		"Clouds": {
			"map menu humidity": "雲"
		},
		"Color blind": {
			"settings menu": "顏色"
		},
		"debug": {
			"settings menu": "除錯"
		},
		"Delete": {
			"favorites menu": "刪除"
		},
		"experimental": {
			"settings menu": "測試"
		},
		"Experimental features": {
			"settings menu": "測試功能"
		},
		"Favorites": {
			"menu title": "喜愛"
		},
		"Ground": {
			"map menu wind": "地面",
			"map menu temperature": "地面"
		},
		"Help us translate!": {
			"settings menu": "幫助我們翻譯！"
		},
		"High": {
			"map menu humidity": "高"
		},
		"Humidity": {
			"map menu humidity": "濕度"
		},
		"Interpolation": {
			"toggle menu": "插值"
		},
		"Language": {
			"settings menu": "語言"
		},
		"Login": {
			"login menu": "登入"
		},
		"Logout": {
			"settings menu": "登出"
		},
		"Low": {
			"map menu humidity": "低"
		},
		"Medium": {
			"map menu humidity": "中"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "移到頂部"
		},
		"News": {
			"news menu": "新聞"
		},
		"News!": {
			"news menu": "新聞！"
		},
		"No data for this place": {
			"windgram view": "這裡沒有數據"
		},
		"Open": {
			"favorites menu": "打開"
		},
		"Pressure": {
			"map menu wind": "壓力",
			"layer legend A": "壓力"
		},
		"Rain": {
			"map menu humidity": "雨"
		},
		"Rename": {
			"favorites menu": "重新命名"
		},
		"Reset all settings": {
			"settings menu": "還原所有設定"
		},
		"Sea level": {
			"map menu wind": "海平面"
		},
		"Set as homepage": {
			"favorites menu": "設為首頁"
		},
		"Settings": {
			"settings menu": "設定"
		},
		"Shearing": {
			"map menu updrafts": "風切變",
			"layer legend B": "風切變"
		},
		"Sounding": {
			"windgram tab": "高空氣象觀測"
		},
		"Temperature": {
			"map menu temperature": "溫度",
			"layer legend A": "溫度"
		},
		"Thermals": {
			"map menu updrafts": "熱氣流",
			"layer legend A": "熱氣流"
		},
		"Thickness": {
			"map menu updrafts": "厚度",
			"layer legend B": "厚度"
		},
		"Updrafts": {
			"map menu updrafts": "更新的草案"
		},
		"Velocity": {
			"map menu updrafts": "速率",
			"layer legend B": "速率"
		},
		"Vertical motion": {
			"map menu updrafts": "垂直運動",
			"": "垂直運動"
		},
		"Wind": {
			"map menu wind": "風",
			"layer legend A": "風"
		},
		"Wind Shear": {
			"map menu wind": "風切變",
			"layer legend A": "風切變"
		},
		"Windgram": {
			"windgram tab": "風向圖"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "地形圖"
		},
		"Model": {
			"layer legend B": "模式"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "无尺寸"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "地面"
		},
		"Ceiling of BL": {
			"layer legend B": "邊界層頂部"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "雲覆蓋"
		},
		"Low altitude": {
			"layer legend B": "低"
		},
		"High altitude": {
			"layer legend B": "中"
		},
		"Medium altitude": {
			"layer legend B": "高"
		},
		"All altitudes": {
			"layer legend B": "所有高度"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "垂直運動"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "降雨"
		},
		"1 hour": {
			"layer legend B": "1小時"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "平均海平面"
		},
		"Enter a name": {
			"new favorite prompt": "輸入"
		},
		"Enter the new name": {
			"new favorite prompt": "输入新的名称"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "覆盖最喜欢的\"%{ name }\"？"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "删除喜爱的\"%{ name }\"？"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "你确定要重置一切吗？\n你的所有设置和收藏夹都将永远消失"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Soaring weather forecasts | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "幫助/聯絡/關於"
		},
		"Install now": {
			"version check": "立即安裝"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "天氣預測"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente需要更新"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente现在是移动的!\n专为飞行和滑翔伞运动设计的翱翔天气预报。"
		},
		"Mobile app": "流動App",
		"No internet connexion": "沒有網絡",
		"Community": "社群",
		"Day selection": "選擇日子",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "辐射",
		"Sun": "太陽",
		"Update": "更新",
		"Wind unit": "單位(風)",
		"An error has occured. Please try again.": {
			"popup": "发生了一个错误。请再试一次。"
		},
		"Click here to renew.": {
			"login popup": "点击这里更新。"
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "点击邮件内的链接来更改密码。"
		},
		"Close": {
			"popup": "关闭",
			"general": "关闭"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "电子邮件是不一样的或无效的"
		},
		"Error! Bad login or password": {
			"login popup": "错误!登录名或密码错误"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "错误!您的访问权限已于%{过期日期}过期。"
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "如果你是贡献者，你会收到一封电子邮件。"
		},
		"OK": {
			"popup": "认可",
			"general": "认可"
		},
		"One last step...": {
			"password popup": "最后一步..."
		},
		"Passwords must be the same": {
			"password popup": "密码必须是相同的"
		},
		"Please log-in": {
			"login popup": "请登录"
		},
		"Private device − stay connected": {
			"login popup": "私人设备--保持连接"
		},
		"Read more…": {
			"contribute popup": "阅读更多..."
		},
		"Reset your password": {
			"password popup": "重置您的密码"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "一些供应商，如Orange、GMX和Hotmail有时会阻止我们的电子邮件。如果你确实没有收到，请联系support@meteo&#x2011;parapente.com。"
		},
		"Welcome!": {
			"login popup": "欢迎你!"
		},
		"Same as device": {
			"timezone menu": "与设备相同"
		},
		"Timezone": {
			"settings menu": "时区"
		},
		"XC Planner": {
			"toggle menu": "XC规划师"
		},
		"Multiplier": {
			"xc planner": "乘法器"
		},
		"Points": {
			"xc planner": "积分"
		},
		"Duration": {
			"xc planner": "时间"
		},
		"Speed": {
			"xc planner": "速度"
		},
		"Close flight": {
			"xc planner": "近距离飞行"
		},
		"Share": {
			"xc planner": "分享"
		},
		"Download": {
			"xc planner": "下载",
			"general": "下载"
		},
		"Preferences": {
			"xc planner": "首选项"
		},
		"Reset": {
			"xc planner": "复位",
			"general": "复位"
		},
		"About": {
			"xc planner": "关于"
		},
		"Exit Fullscreen": {
			"toggle menu": "退出全屏"
		},
		"Fullscreen": {
			"toggle menu": "全屏"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner是一个实验性的功能。\n它只能在电脑上使用，在meteo-parapente.com上使用。"
		},
		"Cancel": {
			"general": "取消"
		},
		"Yes": {
			"general": "是"
		},
		"No": {
			"general": "没有"
		},
		"Save": {
			"general": "拯救"
		},
		"Continue": {
			"general": "继续"
		},
		"Original version": {
			"xc planner": "原始版本"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "在汤姆的授权下，为了在Meteo-Parapente中工作，进行了大量的黑客攻击。谢谢你!"
		},
		"League": {
			"xc planner": "联盟"
		},
		"Distance units": {
			"xc planner": "距离单位"
		},
		"Altitude units": {
			"xc planner": "海拔单位"
		},
		"Coordinates format": {
			"xc planner": "坐标格式"
		},
		"Turnpoint details": {
			"xc planner": "转折点详情"
		},
		"Format": {
			"xc planner": "格式"
		},
		"Route name": {
			"xc planner": "路线名称"
		},
		"Waypoint prefix": {
			"xc planner": "航点前缀"
		},
		"Lien": {
			"xc planner": "链接"
		},
		"Paste link in email or IM": {
			"xc planner": "在电子邮件或即时消息中粘贴链接"
		},
		"Static image": {
			"xc planner": "静态图像"
		},
		"Open with XCTrack": {
			"xc planner": "用XCTrack打开"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "与LocToMe共享：设置为默认路线"
		},
		"Go to": {
			"general": "转到"
		},
		"Error! Please try again later": {
			"update modal": "错误!请稍后再试"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "按 \"重设 \"可以永久地重设你的路线，按 \"取消 \"可以保留你的路线。"
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "这是你的访问代码。请安全地保存它。"
		},
		"Password:": {
			"contribute popup": "密码。"
		},
		"Thank you!": {
			"contribute popup": "谢谢你!"
		},
		"Username:": {
			"contribute popup": "用户名。"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12个月标准 -%{currency}%{pricing}。/月"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12个月学生 -%{currency}%{pricing}。/月"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12个月的支持者 -%{currency}%{pricing}。/月"
		},
		"Tour of Europe": {
			"tab": "欧洲之行"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "享受每天的最佳预报。Meteo-Parapente能够存在，要感谢你!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "免费参加当地的气象培训和用户见面会。"
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "加入Meteo-Parapente贡献者俱乐部"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "每月与我见面一次，讨论新的功能和改进。"
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente能够存在，多亏了你!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "我的目标是提供一个每个飞行员都能使用的优质工具。"
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "支持开发一个每个飞行员都能使用的质量工具。"
		},
		"and to the": {
			"startup terms": "并对"
		},
		"By using this application, you agree to the": {
			"startup terms": "通过使用本应用程序，你同意"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "如果问题仍然存在，请联系 support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente不使用追踪cookies。"
		},
		"privacy policy": {
			"startup terms": "隐私政策"
		},
		"terms of use": {
			"startup": "使用条款"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "无法访问Meteo-Parapente服务器。请检查您的连接。"
		},
		"2 days a week are reserved to members": {
			"private popup": "每周有2天是为会员保留的"
		},
		"Already a member? Click to reset your password": {
			"login popup": "已经是会员了吗？点击重置密码"
		},
		"Become a member": {
			"contribute menu": "成为会员",
			"popup": "成为会员"
		},
		"Click here to learn the details": {
			"contest": "点击这里了解详情"
		},
		"I am already a member": {
			"popup": "我已经是一个会员了"
		},
		"Learn more": {
			"contest": "了解更多"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente庆祝其10周年。"
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "还不是会员？点击获取访问代码"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "值此之际，我们将组织一次特殊的比赛"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "将从所有在去年9月至明年3月30日期间购买或续订的人中抽取一名获奖者。"
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "将会赢得。您所选择的滑翔伞机翼！！。"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "要查看%{date}，请登录或成为会员。"
		},
		"Win a paraglider!": {
			"contribute menu": "赢取滑翔伞!"
		}
	}
};

/***/ }),
/* 361 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(160);


/***/ })
],[362]);


// WEBPACK FOOTER //
// client.aeaeee20.js